import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Upload: { input: File; output: File; }
};

export enum AccountType {
  Bank = 'BANK',
  MobileWallet = 'MOBILE_WALLET'
}

export type ActivateUserInput = {
  consent: InputMaybe<ConsentInput>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: InputMaybe<Scalars['String']['input']>;
  twoFactorCode: Scalars['String']['input'];
};

export type ActivateUserResponse = Error | Success;

export type AddBillingDiagnosisInput = {
  billRef: Scalars['String']['input'];
  presentOnAdmission: InputMaybe<BillDiagnosisPresentOnAdmission>;
  product: BillProductInput;
  type: BillDiagnosisType;
};

export type AddBillingDocumentDetailsInput = {
  billRef: Scalars['String']['input'];
  type: BillDocumentType;
};

export type AddClaimCommentResponse = Error | Success;

export type AddClaimItemInput = {
  baseItemInput: BaseItemInput;
  externalCode: InputMaybe<ExternalCodeInput>;
  identifiers: InputMaybe<Array<InputMaybe<IdentifierInput>>>;
  notes: InputMaybe<Array<InputMaybe<CreateItemNoteInput>>>;
  preAuthorizationReference: InputMaybe<Scalars['String']['input']>;
};

export type AddDiagnosisInput = {
  extraInfos: InputMaybe<Array<InputMaybe<ClaimDiagnosisExtraInfoInput>>>;
  product: InputMaybe<ClaimMedicalProductInput>;
  type: InputMaybe<DiagnosisType>;
};

export type AddDiagnosisResponse = Error | Success;

export type AddInvoiceInput = {
  billRef: Scalars['String']['input'];
  externalReference: Scalars['String']['input'];
  taxNumber: InputMaybe<Scalars['String']['input']>;
};

export type AddInvoiceItemInput = {
  billRef: Scalars['String']['input'];
  invoiceRef: Scalars['String']['input'];
  patientShares: InputMaybe<Array<BillPatientShareInput>>;
  preAuthorizationRequired: InputMaybe<Scalars['Boolean']['input']>;
  price: MonetaryAmountInput;
  product: BillProductInput;
  quantity: Scalars['Int']['input'];
};

export type AddItemResponse = Error | Success;

export type AddPreAuthorizationItemResponse = Error | Success;

export type Adjudication = {
  __typename?: 'Adjudication';
  action: Maybe<AdjudicationAction>;
  approvedAmount: Maybe<MonetaryAmount>;
  createdBy: Maybe<User>;
  createdDate: Maybe<Scalars['String']['output']>;
  denialReasons: Maybe<Array<ClaimDenialReason>>;
  discount: Maybe<Scalars['Float']['output']>;
  exGratiaAmount: Maybe<MonetaryAmount>;
  note: Maybe<Scalars['String']['output']>;
  overdraftComment: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  quantityCountBalance: Maybe<Scalars['Float']['output']>;
  recoverableAmount: Maybe<MonetaryAmount>;
  requiredPatientShare: Maybe<MonetaryAmount>;
  status: AdjudicationStatus;
  tierLevel: Maybe<Scalars['Int']['output']>;
  unitPrice: Maybe<MonetaryAmount>;
};

export enum AdjudicationAction {
  Approve = 'APPROVE',
  Confirm = 'CONFIRM',
  PartiallyApprove = 'PARTIALLY_APPROVE',
  Refer = 'REFER',
  Reject = 'REJECT'
}

export type AdjudicationConfirmationResponse = Error | Success;

export enum AdjudicationStatus {
  Approved = 'APPROVED',
  PartiallyApproved = 'PARTIALLY_APPROVED',
  Pending = 'PENDING',
  Referred = 'REFERRED',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED'
}

export type Affiliation = {
  __typename?: 'Affiliation';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AffiliationFilter = {
  /** @deprecated Use: 'codes' instead */
  code: InputMaybe<Scalars['String']['input']>;
  codes: InputMaybe<Array<Scalars['String']['input']>>;
  name: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
};

export type AffiliationPage = CarePage & {
  __typename?: 'AffiliationPage';
  data: Maybe<Array<Affiliation>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum AgeCalculationMethod {
  AsPerLastBirthday = 'AS_PER_LAST_BIRTHDAY',
  AsPerNextBirthday = 'AS_PER_NEXT_BIRTHDAY',
  ClosestYear = 'CLOSEST_YEAR'
}

export type AllowedEndorsementActions = {
  __typename?: 'AllowedEndorsementActions';
  actionType: EndorsementType;
  isAutoAppliedOnFamily: Scalars['Boolean']['output'];
};

export type AmountTierMapping = {
  __typename?: 'AmountTierMapping';
  amountTierMappingEntries: Array<AmountTierMappingEntry>;
  contextName: Scalars['String']['output'];
  contextReference: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
};

export type AmountTierMappingEntry = {
  __typename?: 'AmountTierMappingEntry';
  amount: Scalars['Float']['output'];
  benefitType: Scalars['String']['output'];
  tier: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type AmountTierMappingFilter = {
  contexts: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  serviceNames: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AmountTierMappingPage = CarePage & {
  __typename?: 'AmountTierMappingPage';
  data: Maybe<Array<AmountTierMapping>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum AmountType {
  Boolean = 'BOOLEAN',
  Monetary = 'MONETARY',
  Percent = 'PERCENT'
}

export type AnnualMedicalLimit = {
  __typename?: 'AnnualMedicalLimit';
  annualLimit: Maybe<MonetaryAmount>;
  baseRateCorrectionPercentage: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  defaultOption: Scalars['Boolean']['output'];
  type: AnnualMedicalLimitType;
};

export type AnnualMedicalLimitDeleteResponse = Error | Success;

export type AnnualMedicalLimitPage = CarePage & {
  __typename?: 'AnnualMedicalLimitPage';
  data: Array<AnnualMedicalLimit>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type AnnualMedicalLimitResponse = AnnualMedicalLimit | Error;

export enum AnnualMedicalLimitType {
  Limited = 'LIMITED',
  Unlimited = 'UNLIMITED'
}

export type ApprovalClaimItem = {
  exGratiaAmount: InputMaybe<MonetaryAmountInput>;
  overdraftComment: InputMaybe<Scalars['String']['input']>;
  quantityCountBalance: InputMaybe<Scalars['Float']['input']>;
  recoverableAmount: InputMaybe<MonetaryAmountInput>;
};

export type ApprovalRule = {
  __typename?: 'ApprovalRule';
  category: ApprovalRuleCategory;
  code: Scalars['String']['output'];
  comparisonOperator: Maybe<ComparisonOperator>;
  comparisonValue: Maybe<Scalars['Float']['output']>;
  eventTrigger: ApprovalRuleEventTrigger;
  requiredRole: ApprovalRuleReviewUserRole;
  type: ApprovalRuleType;
};

export enum ApprovalRuleCategory {
  ProductActivationRequest = 'PRODUCT_ACTIVATION_REQUEST',
  QuotationAdditionalLoadingPercentage = 'QUOTATION_ADDITIONAL_LOADING_PERCENTAGE',
  QuotationBeneficiaryCount = 'QUOTATION_BENEFICIARY_COUNT',
  QuotationDiscountPercentage = 'QUOTATION_DISCOUNT_PERCENTAGE',
  QuotationExclusionModified = 'QUOTATION_EXCLUSION_MODIFIED',
  QuotationPremiumAmount = 'QUOTATION_PREMIUM_AMOUNT',
  QuotationPreExistingConditionApply = 'QUOTATION_PRE_EXISTING_CONDITION_APPLY'
}

export enum ApprovalRuleEventTrigger {
  ProductSubmission = 'PRODUCT_SUBMISSION',
  QuotationSubmission = 'QUOTATION_SUBMISSION'
}

export type ApprovalRuleInput = {
  category: ApprovalRuleCategory;
  comparisonOperator: InputMaybe<ComparisonOperator>;
  comparisonValue: InputMaybe<Scalars['Float']['input']>;
  eventTrigger: ApprovalRuleEventTrigger;
  requiredRole: ApprovalRuleReviewUserRole;
  type: ApprovalRuleType;
};

export enum ApprovalRuleReviewUserRole {
  PayerChiefExecutiveOfficer = 'PAYER_CHIEF_EXECUTIVE_OFFICER',
  PayerReinsurerAnalyst = 'PAYER_REINSURER_ANALYST',
  PayerUnderwriter = 'PAYER_UNDERWRITER',
  PayerUnderwriterManager = 'PAYER_UNDERWRITER_MANAGER',
  PayerUnderwriterSupervisor = 'PAYER_UNDERWRITER_SUPERVISOR'
}

export enum ApprovalRuleType {
  Conditional = 'CONDITIONAL',
  NonConditional = 'NON_CONDITIONAL'
}

export type ApprovalRules = {
  __typename?: 'ApprovalRules';
  data: Array<ApprovalRule>;
};

export type ApprovalRulesInput = {
  approvalRules: Array<ApprovalRuleInput>;
};

export type ApprovalRulesResponse = ApprovalRules | Error;

export type ApproveClaimItemResponse = Error | Success;

export type ApproveNote = {
  note: InputMaybe<Scalars['String']['input']>;
};

export type ApprovePreAuthorization = {
  note: InputMaybe<Scalars['String']['input']>;
  validityEndDate: Scalars['String']['input'];
  validityStartDate: Scalars['String']['input'];
};

export type ApproveProductResponse = Error | Success;

export type ApproveQuotationResponse = Error | Success;

export type AssignBenefitToItemResponse = Error | Success;

export type AssignMedicalTagsResponse = Error | MedicalCodes;

export type AssignUserRef = {
  id: Scalars['String']['input'];
};

export type AssignUserToAdjudicationResponse = Error | Success;

export type AsyncChangeBatchResponse = {
  __typename?: 'AsyncChangeBatchResponse';
  requestId: Scalars['String']['output'];
};

export type AsyncPaymentInstructionResponse = {
  __typename?: 'AsyncPaymentInstructionResponse';
  requestIds: Maybe<Array<Scalars['String']['output']>>;
};

export enum AsyncPremiumCalculationStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export type AuditEvent = {
  __typename?: 'AuditEvent';
  createdBy: Maybe<User>;
  createdDate: Scalars['String']['output'];
  event: PreAuthAuditEventType;
  status: Maybe<Scalars['String']['output']>;
  tier: Maybe<Scalars['String']['output']>;
  version: Maybe<Scalars['String']['output']>;
};

export type AvailableBalance = {
  __typename?: 'AvailableBalance';
  amount: Maybe<MonetaryAmount>;
};

export type BalanceCorrection = {
  __typename?: 'BalanceCorrection';
  benefit: Benefit;
  correctionAmount: MonetaryAmount;
  correctionType: CorrectionType;
};

export type BalanceCorrectionInput = {
  benefitId: Scalars['String']['input'];
  correctionAmount: MonetaryAmountInput;
};

export type BalanceOverview = {
  __typename?: 'BalanceOverview';
  asAt: Maybe<Scalars['String']['output']>;
  availableBalance: Maybe<AvailableBalance>;
  corrections: Maybe<MonetaryAmount>;
  deductible: Maybe<MonetaryAmount>;
  preAuthLimitAvailableBalance: Maybe<MonetaryAmount>;
  reference: Maybe<Scalars['String']['output']>;
  termBalance: Maybe<TermBalance>;
  utilisations: Maybe<Array<Maybe<Utilisation>>>;
};

export type BaseItemInput = {
  benefitReference: InputMaybe<Scalars['String']['input']>;
  clinicianReference: InputMaybe<Scalars['String']['input']>;
  collectedPatientShare: InputMaybe<MonetaryAmountInput>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  product: InputMaybe<ClaimMedicalProductInput>;
  quantity: InputMaybe<Scalars['Float']['input']>;
  requestedAmount: InputMaybe<MonetaryAmountInput>;
  startDate: InputMaybe<Scalars['String']['input']>;
  taxInvoiceNumber: InputMaybe<Scalars['String']['input']>;
  unitPrice: InputMaybe<MonetaryAmountInput>;
};

export type BaseParty = GroupParty | IndividualParty;

export type BaseRate = {
  ageFrom: Scalars['Int']['output'];
  ageTo: Scalars['Int']['output'];
  type: BaseRateType;
};

export enum BaseRateCorrectionType {
  Amount = 'AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type BaseRatePage = {
  __typename?: 'BaseRatePage';
  data: Array<DefaultBaseRate | GenderBaseRate>;
};

export enum BaseRateType {
  Default = 'DEFAULT',
  Gender = 'GENDER'
}

export type BaseRatesDeleteResponse = Error | Success;

export type BaseRatesResponse = BaseRatePage | Error;

export type BatchAggregate = {
  __typename?: 'BatchAggregate';
  bankRef: Maybe<Scalars['String']['output']>;
  batchBooking: Scalars['Boolean']['output'];
  batchedPaymentAggregates: Maybe<BatchedPaymentAggregatePage>;
  counterPartyAccountAlias: Scalars['String']['output'];
  counterPartyAccountInternalRef: Scalars['String']['output'];
  counterPartyAccountNumber: Scalars['String']['output'];
  createdBy: Maybe<User>;
  dataInitiationFiles: Maybe<Array<DataInitiationFile>>;
  firstCreated: Maybe<Scalars['String']['output']>;
  internalRef: Scalars['String']['output'];
  orderingPartyAccountAlias: Scalars['String']['output'];
  orderingPartyAccountInternalRef: Scalars['String']['output'];
  orderingPartyAccountNumber: Scalars['String']['output'];
  plannedApprovalDate: Scalars['String']['output'];
  plannedApprovalExpirationDate: Maybe<Scalars['String']['output']>;
  plannedExecutionDate: Scalars['String']['output'];
  processingSchemeInternalRef: Scalars['String']['output'];
  status: BatchStatus;
  statusCreatedAt: Scalars['String']['output'];
  statusDescription: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  totalNumberOfPayments: Scalars['Int']['output'];
  transactionId: Maybe<Scalars['Int']['output']>;
  type: BatchType;
};


export type BatchAggregateBatchedPaymentAggregatesArgs = {
  filter: InputMaybe<BatchedPaymentAggregateFilter>;
};

export type BatchAggregateFilter = {
  bankRefs: InputMaybe<Array<Scalars['String']['input']>>;
  batchApprovalDateFrom: InputMaybe<Scalars['String']['input']>;
  batchApprovalDateTo: InputMaybe<Scalars['String']['input']>;
  batchType: InputMaybe<BatchType>;
  counterPartyAccountAliases: InputMaybe<Array<Scalars['String']['input']>>;
  counterPartyAccountInternalRef: InputMaybe<Scalars['String']['input']>;
  counterPartyAccountNumber: InputMaybe<Scalars['String']['input']>;
  executionDateFrom: InputMaybe<Scalars['String']['input']>;
  executionDateTo: InputMaybe<Scalars['String']['input']>;
  internalRefs: InputMaybe<Array<Scalars['String']['input']>>;
  orderingPartyAccountAliases: InputMaybe<Array<Scalars['String']['input']>>;
  orderingPartyAccountInternalRef: InputMaybe<Scalars['String']['input']>;
  orderingPartyAccountNumber: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
  plannedApprovalExpirationDateFrom: InputMaybe<Scalars['String']['input']>;
  plannedApprovalExpirationDateTo: InputMaybe<Scalars['String']['input']>;
  plannedExecutionDateFrom: InputMaybe<Scalars['String']['input']>;
  plannedExecutionDateTo: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<BatchStatus>>>;
};

export type BatchAggregateFilterOptions = {
  alias: InputMaybe<Scalars['String']['input']>;
  partyType: InputMaybe<PaymentPartyType>;
};

export type BatchAggregateInput = {
  batchBooking: Scalars['Boolean']['input'];
  counterPartyAccountAlias: Scalars['String']['input'];
  counterPartyAccountInternalRef: Scalars['String']['input'];
  counterPartyAccountNumber: Scalars['String']['input'];
  internalRef: Scalars['String']['input'];
  orderingPartyAccountAlias: Scalars['String']['input'];
  orderingPartyAccountInternalRef: Scalars['String']['input'];
  orderingPartyAccountNumber: Scalars['String']['input'];
  plannedApprovalDate: Scalars['String']['input'];
  plannedApprovalExpirationDate: InputMaybe<Scalars['String']['input']>;
  plannedExecutionDate: Scalars['String']['input'];
  processingSchemeInternalRef: Scalars['String']['input'];
  status: BatchStatus;
  statusCreatedAt: Scalars['String']['input'];
  statusDescription: Scalars['String']['input'];
  totalAmount: Scalars['Float']['input'];
  totalNumberOfPayments: Scalars['Int']['input'];
  transactionId: InputMaybe<Scalars['Int']['input']>;
  type: BatchType;
};

export type BatchAggregatesPage = CarePage & {
  __typename?: 'BatchAggregatesPage';
  data: Maybe<Array<Maybe<BatchAggregate>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum BatchStatus {
  Approved = 'APPROVED',
  Collecting = 'COLLECTING',
  Created = 'CREATED',
  Executed = 'EXECUTED',
  Executing = 'EXECUTING',
  Intervened = 'INTERVENED',
  Rejected = 'REJECTED',
  Released = 'RELEASED',
  Suspended = 'SUSPENDED'
}

export enum BatchType {
  Collection = 'COLLECTION',
  Payout = 'PAYOUT',
  Pobo = 'POBO'
}

export type BatchedPaymentAggregate = {
  __typename?: 'BatchedPaymentAggregate';
  amount: Maybe<MonetaryAmount>;
  batchInternalRef: Maybe<Scalars['String']['output']>;
  paymentInternalRef: Maybe<Scalars['String']['output']>;
  processingSchemeInternalRef: Maybe<Scalars['String']['output']>;
  remittanceAggregate: RemittanceAggregate;
  status: Maybe<BatchedPaymentStatus>;
  statusCreatedAt: Maybe<Scalars['String']['output']>;
  statusDescription: Maybe<Scalars['String']['output']>;
  transactionId: Maybe<Scalars['Int']['output']>;
};

export type BatchedPaymentAggregateFilter = {
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  externalRef: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
  paymentInternalRef: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<BatchedPaymentStatus>;
  statuses: InputMaybe<Array<BatchedPaymentStatus>>;
};

export type BatchedPaymentAggregatePage = CarePage & {
  __typename?: 'BatchedPaymentAggregatePage';
  data: Maybe<Array<BatchedPaymentAggregate>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum BatchedPaymentStatus {
  Approved = 'APPROVED',
  Collected = 'COLLECTED',
  Executed = 'EXECUTED',
  Executing = 'EXECUTING',
  Rejected = 'REJECTED',
  Released = 'RELEASED',
  Suspended = 'SUSPENDED'
}

export type BedCapacity = {
  __typename?: 'BedCapacity';
  capacity: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  type: BedType;
};

export type BedCapacityDeleteResponse = Error | Success;

export type BedCapacityResponse = BedCapacity | Error;

export enum BedType {
  CcuBeds = 'CCU_BEDS',
  EmergencyWardBeds = 'EMERGENCY_WARD_BEDS',
  IcuBeds = 'ICU_BEDS',
  MinorOperationTheatre = 'MINOR_OPERATION_THEATRE',
  NicuBeds = 'NICU_BEDS',
  OperationTheatre = 'OPERATION_THEATRE',
  PicuBeds = 'PICU_BEDS',
  TotalBeds = 'TOTAL_BEDS'
}

export type BeneficiariesPolicyValidity = {
  __typename?: 'BeneficiariesPolicyValidity';
  beneficiaries: Scalars['Boolean']['output'];
  hasIntegrationErrors: Scalars['Boolean']['output'];
};

export type Beneficiary = {
  __typename?: 'Beneficiary';
  beneficiaryType: Maybe<Scalars['String']['output']>;
  bmi: Maybe<Scalars['Float']['output']>;
  customMemberInfo1: Maybe<Scalars['String']['output']>;
  customMemberInfo2: Maybe<Scalars['String']['output']>;
  dateOfBirth: Scalars['String']['output'];
  dateOfDeath: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  employment: Maybe<Employment>;
  firstName: Scalars['String']['output'];
  gender: Gender;
  height: Maybe<Scalars['Float']['output']>;
  identification: Array<Identification>;
  lastName: Scalars['String']['output'];
  maritalStatus: Maybe<MaritalStatus>;
  middleName: Maybe<Scalars['String']['output']>;
  nationality: Maybe<Scalars['String']['output']>;
  occupation: Maybe<Occupation>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  remarks: Maybe<Scalars['String']['output']>;
  residentialCountry: Maybe<Country>;
  residentialCounty: Maybe<GeolocationLevelOne>;
  residentialLocation: Maybe<GeolocationLevelTwo>;
  title: Maybe<Title>;
  visaPlaceOfIssue: Maybe<GeolocationLevelOne>;
  weight: Maybe<Scalars['Float']['output']>;
};

export enum BeneficiaryCalculationType {
  Addition = 'ADDITION',
  AddNewPrimary = 'ADD_NEW_PRIMARY',
  CategoryChange = 'CATEGORY_CHANGE',
  CoverageChange = 'COVERAGE_CHANGE',
  Deceased = 'DECEASED',
  Extension = 'EXTENSION',
  Kyc = 'KYC',
  LiftSuspension = 'LIFT_SUSPENSION',
  NewPolicy = 'NEW_POLICY',
  None = 'NONE',
  Other = 'OTHER',
  PolicyholderChange = 'POLICYHOLDER_CHANGE',
  PolicyCancellation = 'POLICY_CANCELLATION',
  PolicyDetailsChange = 'POLICY_DETAILS_CHANGE',
  PolicyRenewal = 'POLICY_RENEWAL',
  Reinstatement = 'REINSTATEMENT',
  Suspension = 'SUSPENSION',
  Termination = 'TERMINATION'
}

export type BeneficiaryCategoryGrouping = {
  __typename?: 'BeneficiaryCategoryGrouping';
  beneficiaryPremiumCalculations: Maybe<Array<BeneficiaryPremiumCalculation>>;
  category: Category;
  categoryTotalPremium: Scalars['Float']['output'];
  numberOfBeneficiaries: Scalars['Int']['output'];
  plan: Plan;
};

export type BeneficiaryCategoryGroupingSummary = {
  __typename?: 'BeneficiaryCategoryGroupingSummary';
  category: Category;
  categoryTotalPremium: Scalars['Float']['output'];
  numberOfBeneficiaries: Scalars['Int']['output'];
  plan: Plan;
};

export type BeneficiaryCoverage = {
  __typename?: 'BeneficiaryCoverage';
  benefit: Benefit;
  medicalTagsExcluded: Maybe<Array<MedicalTag>>;
  medicalTagsIncluded: Maybe<Array<MedicalTag>>;
  waitingPeriodInDays: Maybe<Scalars['Int']['output']>;
};

export type BeneficiaryDocument = {
  __typename?: 'BeneficiaryDocument';
  description: Maybe<Scalars['String']['output']>;
  documentKey: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  type: BeneficiaryDocumentType;
};

export enum BeneficiaryDocumentType {
  BirthCertificate = 'BIRTH_CERTIFICATE',
  DeathCertificate = 'DEATH_CERTIFICATE',
  MarriageCertificate = 'MARRIAGE_CERTIFICATE',
  MedicalApplicationForm = 'MEDICAL_APPLICATION_FORM',
  NationalId = 'NATIONAL_ID',
  Other = 'OTHER',
  Passport = 'PASSPORT',
  Photo = 'PHOTO'
}

export type BeneficiaryDocumentsResponse = BeneficiaryDocument | Error;

export type BeneficiaryExternalMemberId = {
  __typename?: 'BeneficiaryExternalMemberId';
  externalMemberId: Scalars['String']['output'];
  systemCode: Scalars['String']['output'];
};

export type BeneficiaryInput = {
  acceptedTermsAndCondition: InputMaybe<Scalars['Boolean']['input']>;
  beneficiaryType: InputMaybe<Scalars['String']['input']>;
  bmi: InputMaybe<Scalars['Float']['input']>;
  categoryId: Scalars['String']['input'];
  customMemberInfo1: InputMaybe<Scalars['String']['input']>;
  customMemberInfo2: InputMaybe<Scalars['String']['input']>;
  dateOfBirth: Scalars['String']['input'];
  dateOfEnrollment: InputMaybe<Scalars['String']['input']>;
  document: InputMaybe<DocumentInput>;
  email: InputMaybe<Scalars['String']['input']>;
  employment: InputMaybe<EmploymentInput>;
  endDate: InputMaybe<Scalars['String']['input']>;
  familyIdentifier: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender: Gender;
  height: InputMaybe<Scalars['Float']['input']>;
  identification: Array<IdentificationInput>;
  insuranceMemberId: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  maritalStatus: InputMaybe<MaritalStatus>;
  membershipNumber: InputMaybe<Scalars['String']['input']>;
  middleName: InputMaybe<Scalars['String']['input']>;
  nationality: InputMaybe<Scalars['String']['input']>;
  nextOfKin: InputMaybe<NextOfKinInput>;
  occupation: InputMaybe<Occupation>;
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  policyId: Scalars['String']['input'];
  policyholderId: InputMaybe<Scalars['String']['input']>;
  preferredProviderRef: InputMaybe<Scalars['String']['input']>;
  primaryPolicyId: InputMaybe<Scalars['String']['input']>;
  relationship: PolicyRelationship;
  remarks: InputMaybe<Scalars['String']['input']>;
  residentialCountryCode: InputMaybe<Scalars['String']['input']>;
  residentialCountyCode: InputMaybe<Scalars['String']['input']>;
  residentialLocationCode: InputMaybe<Scalars['String']['input']>;
  specialTier: InputMaybe<SpecialTier>;
  startDate: Scalars['String']['input'];
  title: InputMaybe<Title>;
  visaPlaceOfIssueCode: InputMaybe<Scalars['String']['input']>;
  weight: InputMaybe<Scalars['Float']['input']>;
};

export type BeneficiaryIntegrationError = {
  __typename?: 'BeneficiaryIntegrationError';
  beneficiaryPolicy: BeneficiaryPolicy;
  errors: Array<Scalars['String']['output']>;
  systemCode: Scalars['String']['output'];
};

export type BeneficiaryIntegrationErrorFilter = {
  page: InputMaybe<CarePageable>;
  policyId: Scalars['String']['input'];
};

export type BeneficiaryIntegrationErrorPage = CarePage & {
  __typename?: 'BeneficiaryIntegrationErrorPage';
  data: Array<BeneficiaryIntegrationError>;
  hasNext: Scalars['Boolean']['output'];
  length: Scalars['Int']['output'];
};

export type BeneficiaryOverview = {
  __typename?: 'BeneficiaryOverview';
  dateOfBirth: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender: Gender;
  identification: Maybe<Array<Identification>>;
  lastName: Scalars['String']['output'];
  middleName: Maybe<Scalars['String']['output']>;
  title: Maybe<Title>;
};

export type BeneficiaryPolicy = {
  __typename?: 'BeneficiaryPolicy';
  acceptedTermsAndConditionDate: Scalars['String']['output'];
  ageAtEnrollment: Scalars['Int']['output'];
  allowedEndorsementActions: Array<AllowedEndorsementActions>;
  balanceCorrections: Maybe<Array<BalanceCorrection>>;
  beneficiary: Beneficiary;
  beneficiaryCoverages: Maybe<Array<BeneficiaryCoverage>>;
  beneficiaryFamily: Array<BeneficiaryPolicy>;
  benefits: Array<Benefit>;
  category: Category;
  combinedEndorsement: Maybe<BeneficiaryPolicyEndorsement>;
  createdByUser: User;
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  dateOfEnrollment: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  externalMemberId: Maybe<Scalars['String']['output']>;
  externalMemberIds: Maybe<Array<BeneficiaryExternalMemberId>>;
  id: Scalars['String']['output'];
  insuranceMemberId: Maybe<Scalars['String']['output']>;
  lastActionDate: Maybe<Scalars['String']['output']>;
  lastActionReason: Maybe<Scalars['String']['output']>;
  lastActionReasonType: Maybe<Scalars['String']['output']>;
  medicalApplicationForm: Maybe<MedicalApplicationForm>;
  membershipNumber: Scalars['String']['output'];
  modifiedByUser: Maybe<User>;
  nextOfKin: Maybe<NextOfKin>;
  policy: Policy;
  policyholder: Maybe<GroupParty>;
  preferredProvider: Maybe<EmpaneledProvider>;
  primaryMembershipNumber: Scalars['String']['output'];
  relationship: PolicyRelationship;
  specialTier: Maybe<SpecialTier>;
  startDate: Scalars['String']['output'];
  status: BeneficiaryPolicyStatus;
};


export type BeneficiaryPolicyBeneficiaryFamilyArgs = {
  filter: InputMaybe<BeneficiaryPolicyFilter>;
};

export type BeneficiaryPolicyEndorsement = {
  __typename?: 'BeneficiaryPolicyEndorsement';
  beneficiaryPolicy: BeneficiaryPolicy;
  endorsementRemark: Maybe<Scalars['String']['output']>;
  endorsementStatus: EndorsementStatus;
  endorsementType: Maybe<EndorsementType>;
  originalBeneficiaryPolicy: Maybe<BeneficiaryPolicy>;
  premium: Maybe<BeneficiaryPremiumCalculation>;
};

export type BeneficiaryPolicyEndorsementFilter = {
  beneficiaryIds: InputMaybe<Array<Scalars['String']['input']>>;
  endorsementIds: InputMaybe<Array<Scalars['String']['input']>>;
  endorsementStatuses: InputMaybe<Array<EndorsementStatus>>;
  endorsementTypes: InputMaybe<Array<EndorsementType>>;
  identificationNumber: InputMaybe<Array<Scalars['String']['input']>>;
  membershipNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  policyId: Scalars['String']['input'];
  primaryMembershipNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  search: InputMaybe<Scalars['String']['input']>;
};

export type BeneficiaryPolicyEndorsementOverview = {
  __typename?: 'BeneficiaryPolicyEndorsementOverview';
  createdByUser: User;
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  endorsementId: Scalars['String']['output'];
  endorsementRemark: Maybe<Scalars['String']['output']>;
  endorsementStatus: EndorsementStatus;
  endorsementType: Maybe<EndorsementType>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  middleName: Maybe<Scalars['String']['output']>;
  modifiedByUser: Maybe<User>;
  title: Maybe<Scalars['String']['output']>;
};

export type BeneficiaryPolicyEndorsementOverviewFilter = {
  beneficiaryIds: InputMaybe<Array<Scalars['String']['input']>>;
  dateOfBirth: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  endorsementIds: InputMaybe<Array<Scalars['String']['input']>>;
  endorsementStatuses: InputMaybe<Array<EndorsementStatus>>;
  endorsementTypes: InputMaybe<Array<EndorsementType>>;
  firstName: InputMaybe<Scalars['String']['input']>;
  identificationNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  lastName: InputMaybe<Scalars['String']['input']>;
  membershipNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  policyId: Scalars['String']['input'];
  primaryMembershipNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  search: InputMaybe<Scalars['String']['input']>;
};

export type BeneficiaryPolicyEndorsementOverviewPage = CarePage & {
  __typename?: 'BeneficiaryPolicyEndorsementOverviewPage';
  data: Array<BeneficiaryPolicyEndorsementOverview>;
  hasNext: Scalars['Boolean']['output'];
  length: Scalars['Int']['output'];
};

export type BeneficiaryPolicyEndorsementPage = CarePage & {
  __typename?: 'BeneficiaryPolicyEndorsementPage';
  data: Array<BeneficiaryPolicyEndorsement>;
  hasNext: Scalars['Boolean']['output'];
  length: Scalars['Int']['output'];
};

export type BeneficiaryPolicyEndorsementResult = {
  __typename?: 'BeneficiaryPolicyEndorsementResult';
  results: Array<BeneficiaryPolicyEndorsement>;
};

export type BeneficiaryPolicyFilter = {
  categoryIds: InputMaybe<Array<Scalars['String']['input']>>;
  dateOfBirth: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  externalMemberIds: InputMaybe<Array<Scalars['String']['input']>>;
  firstName: InputMaybe<Scalars['String']['input']>;
  genders: InputMaybe<Array<Gender>>;
  identificationNumber: InputMaybe<Array<Scalars['String']['input']>>;
  ids: InputMaybe<Array<Scalars['String']['input']>>;
  insuranceMemberIds: InputMaybe<Array<Scalars['String']['input']>>;
  lastName: InputMaybe<Scalars['String']['input']>;
  membershipNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  payerIds: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  policyIds: InputMaybe<Array<Scalars['String']['input']>>;
  primaryMembershipNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  relationships: InputMaybe<Array<PolicyRelationship>>;
  search: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<BeneficiaryPolicyStatus>>;
};

export type BeneficiaryPolicyLookups = {
  __typename?: 'BeneficiaryPolicyLookups';
  memberTypes: Array<Scalars['String']['output']>;
  salaryRanges: Array<Scalars['String']['output']>;
};

export type BeneficiaryPolicyOverview = {
  __typename?: 'BeneficiaryPolicyOverview';
  allowedEndorsementActions: Array<AllowedEndorsementActions>;
  beneficiary: BeneficiaryOverview;
  category: Category;
  combinedEndorsement: Maybe<BeneficiaryPolicyEndorsement>;
  endDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastActionDate: Maybe<Scalars['String']['output']>;
  membershipNumber: Scalars['String']['output'];
  policy: Policy;
  primaryMembershipNumber: Scalars['String']['output'];
  relationship: PolicyRelationship;
  specialTier: Maybe<SpecialTier>;
  startDate: Scalars['String']['output'];
  status: BeneficiaryPolicyStatus;
};

export type BeneficiaryPolicyOverviewPage = CarePage & {
  __typename?: 'BeneficiaryPolicyOverviewPage';
  data: Array<BeneficiaryPolicyOverview>;
  hasNext: Scalars['Boolean']['output'];
  length: Scalars['Int']['output'];
};

export type BeneficiaryPolicyPage = CarePage & {
  __typename?: 'BeneficiaryPolicyPage';
  data: Array<BeneficiaryPolicy>;
  hasNext: Scalars['Boolean']['output'];
  length: Scalars['Int']['output'];
};

export type BeneficiaryPolicyReinstatementInfo = {
  beneficiaryPolicyId: Scalars['String']['input'];
  reinstatementInfo: ReinstatementInfo;
  relationship: PolicyRelationship;
};

export type BeneficiaryPolicyResponse = BeneficiaryPolicy | BeneficiaryPolicyEndorsement | Error;

export enum BeneficiaryPolicyStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Deceased = 'DECEASED',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE',
  Removed = 'REMOVED',
  Scheduled = 'SCHEDULED',
  Suspended = 'SUSPENDED',
  Terminated = 'TERMINATED'
}

export type BeneficiaryPremiumCalculation = {
  __typename?: 'BeneficiaryPremiumCalculation';
  beneficiaryCalculationType: BeneficiaryCalculationType;
  beneficiaryEndorsement: Maybe<BeneficiaryPolicy>;
  beneficiaryPolicy: Maybe<BeneficiaryPolicy>;
  categoryId: Scalars['String']['output'];
  dateOfEnrollment: Scalars['String']['output'];
  dateOfSuspension: Scalars['String']['output'];
  endorsementId: Maybe<Scalars['String']['output']>;
  gender: Gender;
  maritalStatus: Maybe<MaritalStatus>;
  occupation: Maybe<Occupation>;
  originalPremium: Maybe<Scalars['Float']['output']>;
  premium: Scalars['Float']['output'];
  reason: Maybe<Scalars['String']['output']>;
  relationship: PolicyRelationship;
};

export type BeneficiaryPremiumCalculationChange = {
  __typename?: 'BeneficiaryPremiumCalculationChange';
  beneficiaryPremiumChanges: Array<BeneficiaryPremiumChangeInformation>;
  policyId: Scalars['String']['output'];
};

export type BeneficiaryPremiumCalculationChangeInput = {
  beneficiaryPremiumChanges: Array<BeneficiaryPremiumChangeInput>;
  policyId: Scalars['String']['input'];
};

export type BeneficiaryPremiumCalculationPage = CarePage & {
  __typename?: 'BeneficiaryPremiumCalculationPage';
  data: Maybe<Array<BeneficiaryPremiumCalculation>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type BeneficiaryPremiumCalculationsFilter = {
  beneficiaryIds: InputMaybe<Array<Scalars['String']['input']>>;
  categoryIds: InputMaybe<Array<Scalars['String']['input']>>;
  endorsementIds: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  policyIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BeneficiaryPremiumChangeInformation = {
  __typename?: 'BeneficiaryPremiumChangeInformation';
  beneficiaryId: Scalars['String']['output'];
  newPremium: Scalars['Float']['output'];
  originalPremium: Scalars['Float']['output'];
  reason: Scalars['String']['output'];
};

export type BeneficiaryPremiumChangeInput = {
  beneficiaryId: Scalars['String']['input'];
  newPremium: Scalars['Float']['input'];
  originalPremium: Scalars['Float']['input'];
  reason: Scalars['String']['input'];
};

export type BeneficiaryPremiumChangeResponse = BeneficiaryPremiumCalculationChange | Error;

export type Benefit = {
  __typename?: 'Benefit';
  balance: Maybe<BalanceOverview>;
  beneficiaryCoverage: Maybe<Coverage>;
  category: Category;
  coverage: Maybe<Coverage>;
  dateCreated: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isOptional: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  number: Maybe<Scalars['String']['output']>;
  status: PolicyDomainStatus;
  subBenefits: Maybe<Array<Benefit>>;
  types: Array<BenefitType>;
};


export type BenefitBalanceArgs = {
  beneficiaryPolicyId: Scalars['String']['input'];
};


export type BenefitBeneficiaryCoverageArgs = {
  beneficiaryPolicyId: Scalars['String']['input'];
};

export type BenefitCoverageInput = {
  chargeType: InputMaybe<ChargeType>;
  claimType: InputMaybe<PolicyClaimType>;
  coinsurance: InputMaybe<CoverageCoinsuranceInput>;
  copay: InputMaybe<CoverageCopayInput>;
  deductible: InputMaybe<CoverageDeductibleInput>;
  familyComposition: InputMaybe<FamilyCompositionInput>;
  isCovered: Scalars['Boolean']['input'];
  isFamilyShared: Scalars['Boolean']['input'];
  limit: CoverageLimitInput;
  medicalCodeTagIdsExcluded: InputMaybe<Array<Scalars['String']['input']>>;
  medicalCodeTagIdsIncluded: InputMaybe<Array<Scalars['String']['input']>>;
  medicalCodesExcluded: InputMaybe<Array<CoverageMedicalCodeInput>>;
  medicalCodesIncluded: InputMaybe<Array<CoverageMedicalCodeInput>>;
  onCosmetic: InputMaybe<Scalars['Boolean']['input']>;
  onEmergencyOnly: InputMaybe<Scalars['Boolean']['input']>;
  preAuthorisationLimit: InputMaybe<MonetaryAmountInput>;
  providerPanels: InputMaybe<Array<Scalars['String']['input']>>;
  reasonableAndCustomaryCharges: InputMaybe<Array<Scalars['String']['input']>>;
  territoriesExcluded: InputMaybe<TerritoryInput>;
  territoriesIncluded: InputMaybe<TerritoryInput>;
  waitingPeriodInDays: InputMaybe<Scalars['Int']['input']>;
};

export type BenefitFilter = {
  benefitTypeCodes: InputMaybe<Array<Scalars['String']['input']>>;
  codes: InputMaybe<Array<Scalars['String']['input']>>;
  discriminator: InputMaybe<ProductBenefitOption>;
  page: InputMaybe<CarePageable>;
};

export type BenefitInput = {
  coverage: BenefitCoverageInput;
  description: InputMaybe<Scalars['String']['input']>;
  isOptional: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  number: InputMaybe<Scalars['String']['input']>;
  types: Array<BenefitType>;
};

export type BenefitMapping = {
  __typename?: 'BenefitMapping';
  sourceBenefitCoverage: Coverage;
  targetBenefitCoverage: Coverage;
};

export type BenefitMappingInput = {
  sourceBenefitId: Scalars['String']['input'];
  targetBenefitId: Scalars['String']['input'];
};

export type BenefitPage = CarePage & {
  __typename?: 'BenefitPage';
  data: Maybe<Array<Benefit>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum BenefitPreAuthorizationType {
  NotRequired = 'NOT_REQUIRED',
  Required = 'REQUIRED',
  RequiredWithAmount = 'REQUIRED_WITH_AMOUNT'
}

export type BenefitResponse = Benefit | Error;

export enum BenefitType {
  Additional = 'ADDITIONAL',
  Alternative = 'ALTERNATIVE',
  Chronic = 'CHRONIC',
  Consultation = 'CONSULTATION',
  Critical = 'CRITICAL',
  Death = 'DEATH',
  Dental = 'DENTAL',
  ExcessOfLoss = 'EXCESS_OF_LOSS',
  HospitalCash = 'HOSPITAL_CASH',
  Inpatient = 'INPATIENT',
  LastExpense = 'LAST_EXPENSE',
  Maternity = 'MATERNITY',
  Optical = 'OPTICAL',
  Optional = 'OPTIONAL',
  Other = 'OTHER',
  Outpatient = 'OUTPATIENT',
  PersonalAccident = 'PERSONAL_ACCIDENT',
  Pharmacy = 'PHARMACY',
  PoliticalViolenceTerrorism = 'POLITICAL_VIOLENCE_TERRORISM',
  Psychiatric = 'PSYCHIATRIC'
}

export type BenefitTypeFilter = {
  codes: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
};

export type BenefitTypePatientShare = {
  __typename?: 'BenefitTypePatientShare';
  baseRateCorrectionPercentage: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  defaultOption: Scalars['Boolean']['output'];
  limits: Maybe<Array<PatientShareLimit>>;
  patientShareAmount: Maybe<MonetaryAmount>;
  patientSharePercentage: Maybe<Scalars['Float']['output']>;
  type: PatientShareType;
};

export type BenefitTypePatientShareInput = {
  baseRateCorrectionPercentage: Scalars['Float']['input'];
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  limits: InputMaybe<Array<PatientShareLimitInput>>;
  patientShareAmount: InputMaybe<MonetaryAmountInput>;
  patientSharePercentage: InputMaybe<Scalars['Float']['input']>;
  type: PatientShareType;
};

export type BenefitTypeWaitingPeriod = {
  __typename?: 'BenefitTypeWaitingPeriod';
  baseRateCorrectionPercentage: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  defaultOption: Scalars['Boolean']['output'];
  numberOfDays: Scalars['Int']['output'];
};

export type BenefitTypeWaitingPeriodInput = {
  baseRateCorrectionPercentage: Scalars['Float']['input'];
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  numberOfDays: Scalars['Int']['input'];
};

export type BenefitsFilter = {
  benefitIds: InputMaybe<Array<Scalars['String']['input']>>;
  benefitTypes: InputMaybe<Array<BenefitType>>;
  categoryIds: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  search: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<PolicyDomainStatus>>;
};

export type Bill = {
  __typename?: 'Bill';
  diagnoses: Array<BillDiagnosis>;
  documents: Array<BillDocument>;
  invoices: Maybe<Array<BillInvoice>>;
  notes: Array<BillNote>;
  reference: Scalars['String']['output'];
  status: BillStatus;
  totalAmount: MonetaryAmount;
  totalNetAmount: MonetaryAmount;
  totalPatientShare: MonetaryAmount;
  visitRef: Scalars['String']['output'];
};

export type BillDiagnosis = {
  __typename?: 'BillDiagnosis';
  presentOnAdmission: Maybe<BillDiagnosisPresentOnAdmission>;
  product: MedicalProduct;
  reference: Scalars['String']['output'];
  type: BillDiagnosisType;
};

export enum BillDiagnosisPresentOnAdmission {
  ClinicallyUndetermined = 'CLINICALLY_UNDETERMINED',
  False = 'FALSE',
  OutpatientClaim = 'OUTPATIENT_CLAIM',
  True = 'TRUE',
  Unknown = 'UNKNOWN',
  UnreportedNotUsed = 'UNREPORTED_NOT_USED'
}

export enum BillDiagnosisType {
  Admitting = 'ADMITTING',
  Principal = 'PRINCIPAL',
  Secondary = 'SECONDARY'
}

export type BillDocument = {
  __typename?: 'BillDocument';
  name: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  type: BillDocumentType;
};

export type BillDocumentLocation = {
  __typename?: 'BillDocumentLocation';
  url: Scalars['String']['output'];
};

export enum BillDocumentType {
  ClaimForm = 'CLAIM_FORM',
  CopyOfSignedBill = 'COPY_OF_SIGNED_BILL',
  IdsNotificationsCertificates = 'IDS_NOTIFICATIONS_CERTIFICATES',
  LetterOfUndertaking = 'LETTER_OF_UNDERTAKING',
  MedicalDoctorRadiologyInvestigationReport = 'MEDICAL_DOCTOR_RADIOLOGY_INVESTIGATION_REPORT',
  Other = 'OTHER',
  PreauthorizationForm = 'PREAUTHORIZATION_FORM'
}

export type BillFilter = {
  invoiceExternalReferences: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  preAuthorizationReferences: InputMaybe<Array<Scalars['String']['input']>>;
  status: InputMaybe<BillStatus>;
  visitRefs: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BillInvoice = {
  __typename?: 'BillInvoice';
  externalReference: Maybe<Scalars['String']['output']>;
  items: Array<BillInvoiceItem>;
  reference: Scalars['String']['output'];
  taxNumber: Maybe<Scalars['String']['output']>;
  totalAmount: MonetaryAmount;
  totalNetPrice: MonetaryAmount;
  totalPatientShare: MonetaryAmount;
};

export type BillInvoiceItem = {
  __typename?: 'BillInvoiceItem';
  claimItem: Maybe<ClaimItem>;
  netPrice: MonetaryAmount;
  patientShare: Maybe<MonetaryAmount>;
  patientShares: Maybe<Array<BillPatientShares>>;
  preAuthorization: Maybe<PreAuthorization>;
  preAuthorizationItem: Maybe<PreAuthorizationItem>;
  preAuthorizationRequired: Maybe<Scalars['Boolean']['output']>;
  price: MonetaryAmount;
  product: MedicalProduct;
  quantity: Scalars['Float']['output'];
  reference: Scalars['String']['output'];
  status: BillInvoiceItemStatus;
  totalGrossPrice: MonetaryAmount;
  totalPatientShare: Maybe<MonetaryAmount>;
};

export enum BillInvoiceItemStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Rejected = 'REJECTED'
}

export type BillNote = {
  __typename?: 'BillNote';
  content: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export type BillPage = CarePage & {
  __typename?: 'BillPage';
  data: Array<Bill>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type BillPatientShareInput = {
  amount: MonetaryAmountInput;
  type: BillPatientShareType;
};

export enum BillPatientShareType {
  AdditionalPatientShare = 'ADDITIONAL_PATIENT_SHARE',
  Coinsurance = 'COINSURANCE',
  Copay = 'COPAY',
  Deductible = 'DEDUCTIBLE',
  Refer = 'REFER',
  Reject = 'REJECT'
}

export type BillPatientShares = {
  __typename?: 'BillPatientShares';
  amount: MonetaryAmount;
  type: BillPatientShareType;
};

export type BillProductInput = {
  code: Scalars['String']['input'];
  codingSystem: Scalars['String']['input'];
};

export enum BillStatus {
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Opened = 'OPENED'
}

export type BroadcastRequest = {
  content: InputMaybe<Scalars['String']['input']>;
  subject: InputMaybe<Scalars['String']['input']>;
  template: InputMaybe<Scalars['String']['input']>;
  type: MessageType;
};

export type BroadcastToAllMembersResponse = Error | Success;

export type BulkApproveClaimItemsInput = {
  claimItemInternalRefs: Array<Scalars['String']['input']>;
};

export type BulkApproveClaimItemsResponse = Error | Success;

export type BulkApprovePreAuthorizationItemsInput = {
  preAuthorizationItemInternalRefs: Array<Scalars['String']['input']>;
};

export type BulkApprovePreAuthorizationItemsResponse = Error | Success;

export type BulkMessageRequest = {
  content: InputMaybe<Scalars['String']['input']>;
  promotional: Scalars['Boolean']['input'];
  subject: InputMaybe<Scalars['String']['input']>;
  template: InputMaybe<Scalars['String']['input']>;
  type: MessageType;
};

export type BulkRejectClaimItemsInput = {
  claimItemInternalRefs: Array<Scalars['String']['input']>;
  denialReason: ClaimItemDenialReasonInput;
};

export type BulkRejectClaimItemsResponse = Error | Success;

export type BulkRejectPreAuthorizationItemsInput = {
  denialReason: PreAuthorizationItemDenialReasonInput;
  preAuthorizationItemInternalRefs: Array<Scalars['String']['input']>;
};

export type BulkRejectPreAuthorizationItemsResponse = Error | Success;

export type BulkSendResponse = Error | Success;

export type BulkUploadDetails = {
  __typename?: 'BulkUploadDetails';
  bulkId: Scalars['String']['output'];
};

export type BulkUploadDetailsResponse = BulkUploadDetails | Error;

export type BulkUploadPresignedUrl = {
  __typename?: 'BulkUploadPresignedUrl';
  bulkId: Scalars['String']['output'];
  presignedUrl: Scalars['String']['output'];
};

export type BulkUploadProgress = {
  __typename?: 'BulkUploadProgress';
  bulkId: Maybe<Scalars['String']['output']>;
  dateCreated: Maybe<Scalars['String']['output']>;
  errors: Maybe<Scalars['Int']['output']>;
  file: Maybe<DocumentDownload>;
  isUploadInitiator: Maybe<Scalars['Boolean']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  skipped: Maybe<Scalars['Int']['output']>;
  status: Maybe<BulkUploadStatus>;
  successes: Maybe<Scalars['Int']['output']>;
  total: Maybe<Scalars['Int']['output']>;
  type: Maybe<BulkUploadType>;
};

export enum BulkUploadStatus {
  Done = 'DONE',
  Downloaded = 'DOWNLOADED',
  FailedStart = 'FAILED_START',
  InProgress = 'IN_PROGRESS'
}

export enum BulkUploadType {
  Coverage = 'COVERAGE',
  EndorsementAction = 'ENDORSEMENT_ACTION',
  Enrollment = 'ENROLLMENT'
}

export type BusinessPropertiesResponse = Error | Success;

export type BusinessProperty = {
  __typename?: 'BusinessProperty';
  contextName: Scalars['String']['output'];
  contextReference: Scalars['String']['output'];
  description: Scalars['String']['output'];
  propertyName: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BusinessPropertyFilter = {
  contexts: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  propertyNames: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BusinessPropertyInput = {
  contextName: Scalars['String']['input'];
  contextReference: Scalars['String']['input'];
  description: Scalars['String']['input'];
  propertyName: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type BusinessPropertyPage = CarePage & {
  __typename?: 'BusinessPropertyPage';
  data: Maybe<Array<Maybe<BusinessProperty>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type CalculateClaimApprovalAmount = {
  __typename?: 'CalculateClaimApprovalAmount';
  approvedAmount: MonetaryAmount;
  discount: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  requiredPatientShare: Maybe<MonetaryAmount>;
  unitPrice: MonetaryAmount;
};

export type CalculateClaimApprovalAmountRequest = {
  discount: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Float']['input'];
  requiredPatientShare: InputMaybe<MonetaryAmountInput>;
  unitPrice: MonetaryAmountInput;
};

export type CancelPreAuthorizationResponse = Error | Success;

export type CarePage = {
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type CarePageable = {
  by: InputMaybe<Scalars['String']['input']>;
  direction: InputMaybe<Scalars['String']['input']>;
  number: InputMaybe<Scalars['Int']['input']>;
  size: InputMaybe<Scalars['Int']['input']>;
};

export type Case = {
  __typename?: 'Case';
  assignees: Maybe<Array<Scalars['String']['output']>>;
  beneficiaryPolicyReference: Maybe<Scalars['String']['output']>;
  categoryReference: Maybe<Scalars['String']['output']>;
  comments: Maybe<Array<PreAuthorizationComment>>;
  memberReference: Maybe<Scalars['String']['output']>;
  payerReference: Maybe<Scalars['String']['output']>;
  preAuthorizationReferences: Maybe<Array<Scalars['String']['output']>>;
  providerReference: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  submittedDate: Maybe<Scalars['String']['output']>;
};

export type CaseCreationResponse = Error | ResourceCreated;

export type CaseFilter = {
  assignees: InputMaybe<Array<Scalars['String']['input']>>;
  beneficiaryPolicyReferences: InputMaybe<Array<Scalars['String']['input']>>;
  categoryReferences: InputMaybe<Array<Scalars['String']['input']>>;
  memberReferences: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  patientReferences: InputMaybe<Array<Scalars['String']['input']>>;
  payerReferences: InputMaybe<Array<Scalars['String']['input']>>;
  preAuthorizationReferences: InputMaybe<Array<Scalars['String']['input']>>;
  providerReferences: InputMaybe<Array<Scalars['String']['input']>>;
  references: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CasePage = CarePage & {
  __typename?: 'CasePage';
  data: Maybe<Array<Case>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type Category = {
  __typename?: 'Category';
  balance: Maybe<BalanceOverview>;
  beneficiariesCount: Maybe<Scalars['Int']['output']>;
  benefits: Maybe<Array<Maybe<Benefit>>>;
  coverage: Maybe<Coverage>;
  createdBy: Maybe<Scalars['String']['output']>;
  dateCreated: Maybe<Scalars['String']['output']>;
  dateModified: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  modifiedBy: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['String']['output']>;
  plan: Plan;
  premiumTableEntries: Maybe<PremiumTableEntryPage>;
  status: Maybe<PolicyDomainStatus>;
};


export type CategoryBalanceArgs = {
  beneficiaryPolicyId: Scalars['String']['input'];
};


export type CategoryPremiumTableEntriesArgs = {
  filter: InputMaybe<CarePageable>;
};

export type CategoryChangeEndorsementResponse = BeneficiaryPolicyEndorsementResult | Error;

export type CategoryChangeInput = {
  balanceCorrections: InputMaybe<Array<BalanceCorrectionInput>>;
  beneficiaryPolicyId: Scalars['String']['input'];
  sourceCategoryId: Scalars['String']['input'];
  targetCategoryId: Scalars['String']['input'];
};

export type CategoryCoverageInput = {
  chargeType: InputMaybe<ChargeType>;
  claimType: InputMaybe<PolicyClaimType>;
  coinsurance: InputMaybe<CoverageCoinsuranceInput>;
  copay: InputMaybe<CoverageCopayInput>;
  deductible: InputMaybe<CoverageDeductibleInput>;
  familyComposition: InputMaybe<FamilyCompositionInput>;
  isCovered: Scalars['Boolean']['input'];
  limit: CoverageLimitInput;
  medicalCodeTagIdsExcluded: InputMaybe<Array<Scalars['String']['input']>>;
  medicalCodeTagIdsIncluded: InputMaybe<Array<Scalars['String']['input']>>;
  medicalCodesExcluded: InputMaybe<Array<CoverageMedicalCodeInput>>;
  medicalCodesIncluded: InputMaybe<Array<CoverageMedicalCodeInput>>;
  onCosmetic: InputMaybe<Scalars['Boolean']['input']>;
  onEmergencyOnly: InputMaybe<Scalars['Boolean']['input']>;
  preAuthorisationLimit: InputMaybe<MonetaryAmountInput>;
  providerPanels: InputMaybe<Array<Scalars['String']['input']>>;
  reasonableAndCustomaryCharges: InputMaybe<Array<Scalars['String']['input']>>;
  territoriesExcluded: InputMaybe<TerritoryInput>;
  territoriesIncluded: InputMaybe<TerritoryInput>;
  waitingPeriodInDays: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryMapping = {
  __typename?: 'CategoryMapping';
  mappedBenefits: Maybe<Array<BenefitMapping>>;
  sourceCategoryId: Scalars['String']['output'];
  targetCategoryId: Scalars['String']['output'];
  unmappedSourceBenefitIds: Maybe<Array<Scalars['String']['output']>>;
};

export type CategoryMappingInput = {
  benefitMappings: InputMaybe<Array<BenefitMappingInput>>;
  sourceCategoryId: Scalars['String']['input'];
  targetCategoryId: Scalars['String']['input'];
};

export type CategoryMappingResponse = CategoryMapping | Error;

export type CategoryPremiumAmountBreakdown = {
  __typename?: 'CategoryPremiumAmountBreakdown';
  administrativeLoad: Maybe<PremiumPercentageAndAmount>;
  netPremium: MonetaryAmount;
  numberOfEntries: Scalars['Int']['output'];
  salesCommission: Maybe<PremiumPercentageAndAmount>;
  thirdPartyAdministratorFee: Maybe<PremiumPercentageAndAmount>;
};

export type CategoryPremiumOverview = {
  __typename?: 'CategoryPremiumOverview';
  categoryCode: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  premium: CategoryPremiumAmountBreakdown;
  premiumPerAgeBand: Maybe<Array<PremiumPerAgeBand>>;
  premiumPerType: PremiumPerType;
  productName: Maybe<Scalars['String']['output']>;
};

export type CategoryResponse = Category | Error;

export type CensusEntriesPerCategory = {
  __typename?: 'CensusEntriesPerCategory';
  categoryName: Scalars['String']['output'];
  numberOfEntries: Scalars['Int']['output'];
};

export type CensusEntriesPerDependentType = {
  __typename?: 'CensusEntriesPerDependentType';
  dependentType: Maybe<DependentType>;
  rows: Array<Maybe<CensusEntriesPerCategory>>;
};

export type CensusEntriesPerGender = {
  __typename?: 'CensusEntriesPerGender';
  gender: Maybe<QuotationGenderType>;
  rows: Array<Maybe<CensusEntriesPerCategory>>;
};

export type CensusEntriesSummary = {
  __typename?: 'CensusEntriesSummary';
  entriesPerCategory: Array<Maybe<CensusEntriesPerCategory>>;
  entriesPerDependentType: Array<Maybe<CensusEntriesPerDependentType>>;
  entriesPerGender: Array<Maybe<CensusEntriesPerGender>>;
  totalEntries: Scalars['Int']['output'];
};

export type CensusEntry = {
  __typename?: 'CensusEntry';
  categoryName: Scalars['String']['output'];
  code: Scalars['String']['output'];
  dateOfBirth: Scalars['String']['output'];
  dependentType: Maybe<DependentType>;
  gender: Maybe<QuotationGenderType>;
};

export type CensusEntryPage = CarePage & {
  __typename?: 'CensusEntryPage';
  data: Array<CensusEntry>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type CensusUploadResponse = Error | Success;

export type CensusUploadStatus = {
  __typename?: 'CensusUploadStatus';
  errorFileUrl: Maybe<Scalars['String']['output']>;
  status: QuotationCensusUploadStatusType;
  uploadedFileUrl: Maybe<Scalars['String']['output']>;
};

export type ChangeBatchInput = {
  batchAggregateInput: BatchAggregateInput;
  previousBatchInternalRef: Scalars['String']['input'];
};

export type ChangeBatchResponse = AsyncChangeBatchResponse | Error;

export type ChangeRequest = {
  __typename?: 'ChangeRequest';
  code: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  details: Maybe<ChangeRequestDetails>;
  employee: Maybe<Employee>;
  provider: Maybe<Provider>;
  status: ChangeRequestStatus;
  type: ChangeRequestType;
};

export enum ChangeRequestApprovalStatus {
  Approved = 'APPROVED',
  CreatePending = 'CREATE_PENDING',
  CreateRejected = 'CREATE_REJECTED',
  CreateWithdrawn = 'CREATE_WITHDRAWN',
  DeletePending = 'DELETE_PENDING'
}

export type ChangeRequestDetails = Employee | EmployeeLicense | Provider | ProviderLicense;

export type ChangeRequestFilter = {
  changeRequestCodes: InputMaybe<Array<Scalars['String']['input']>>;
  employeeCodes: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  providerCodes: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<ChangeRequestStatus>>;
  types: InputMaybe<Array<ChangeRequestType>>;
};

export type ChangeRequestPage = CarePage & {
  __typename?: 'ChangeRequestPage';
  data: Maybe<Array<ChangeRequest>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum ChangeRequestStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Withdrawn = 'WITHDRAWN'
}

export type ChangeRequestStatusResponse = Error | Success;

export enum ChangeRequestType {
  CreateClinician = 'CREATE_CLINICIAN',
  CreateContact = 'CREATE_CONTACT',
  CreateProviderLicense = 'CREATE_PROVIDER_LICENSE',
  DeleteClinician = 'DELETE_CLINICIAN',
  DeleteContact = 'DELETE_CONTACT',
  DeleteProviderLicense = 'DELETE_PROVIDER_LICENSE',
  UpdateClinician = 'UPDATE_CLINICIAN',
  UpdateClinicianLicense = 'UPDATE_CLINICIAN_LICENSE',
  UpdateContact = 'UPDATE_CONTACT',
  UpdateProviderDetails = 'UPDATE_PROVIDER_DETAILS',
  UpdateProviderLicense = 'UPDATE_PROVIDER_LICENSE'
}

export enum ChargeType {
  Actual = 'ACTUAL',
  Rnc = 'RNC'
}

export type CheckPermissionInput = {
  permission: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
};

export type CheckPermissionOutput = {
  __typename?: 'CheckPermissionOutput';
  authorized: Scalars['Boolean']['output'];
  permission: Scalars['String']['output'];
  resourceId: Scalars['String']['output'];
  resourceType: Scalars['String']['output'];
  subjectId: Scalars['String']['output'];
  subjectType: Scalars['String']['output'];
};

export type CheckResourceInput = {
  permission: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
};

export type CheckResourceOutput = {
  __typename?: 'CheckResourceOutput';
  authorized: Scalars['Boolean']['output'];
  permission: Scalars['String']['output'];
  resourceType: Scalars['String']['output'];
  subjectId: Scalars['String']['output'];
  subjectType: Scalars['String']['output'];
};

export type Claim = {
  __typename?: 'Claim';
  adjudications: Maybe<Array<Adjudication>>;
  approvedAmount: Maybe<MonetaryAmount>;
  assignedTierLevel: Maybe<Scalars['Int']['output']>;
  batchNumber: Maybe<Scalars['String']['output']>;
  beneficiaryPolicy: Maybe<BeneficiaryPolicy>;
  benefit: Maybe<Benefit>;
  billablePeriod: Maybe<DateRange>;
  claimAudit: Maybe<Array<ClaimAudit>>;
  code: Scalars['String']['output'];
  comments: Maybe<Array<Maybe<ClaimComment>>>;
  countryCode: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<User>;
  createdDate: Scalars['String']['output'];
  defaultCurrency: Scalars['String']['output'];
  diagnoses: Maybe<Array<Maybe<Diagnosis>>>;
  documents: Maybe<Array<Maybe<ClaimDocument>>>;
  externalCode: Maybe<ClaimExternalCode>;
  faults: Maybe<Array<Maybe<ClaimFault>>>;
  historyList: Maybe<Array<Claim>>;
  initialProviderName: Maybe<Scalars['String']['output']>;
  invoicePaymentDate: Maybe<Scalars['String']['output']>;
  invoices: Maybe<Array<ClaimInvoice>>;
  items: Maybe<Array<Maybe<ClaimItem>>>;
  lastAdjudicatedAmount: Maybe<MonetaryAmount>;
  lastAdjudicatedTotalDeductions: Maybe<MonetaryAmount>;
  memberRef: Maybe<Scalars['String']['output']>;
  memberRequestedAmount: Maybe<MonetaryAmount>;
  notes: Maybe<Array<Maybe<ClaimNote>>>;
  patientShares: Maybe<Array<Maybe<PatientShare>>>;
  payee: Maybe<PayeeType>;
  payer: Maybe<Payer>;
  paymentReference: Maybe<Scalars['String']['output']>;
  paymentTerm: Maybe<PaymentTerm>;
  payoutMethod: Maybe<PayoutMethod>;
  preAuthorizationRef: Maybe<Scalars['String']['output']>;
  priorityFlags: Maybe<PriorityFlags>;
  provider: Maybe<Provider>;
  reimbursementType: Maybe<ReimbursementType>;
  /** @deprecated Use remittances instead */
  remittance: Maybe<Remittance>;
  remittanceExecutionDate: Maybe<Scalars['String']['output']>;
  remittanceStatus: Maybe<RemittanceStatus>;
  remittances: Maybe<Array<Remittance>>;
  reopened: Maybe<Scalars['Boolean']['output']>;
  reopenedReason: Maybe<Scalars['String']['output']>;
  requestedAmount: Maybe<MonetaryAmount>;
  requestedPaymentDate: Maybe<Scalars['String']['output']>;
  requiredTierLevel: Scalars['Int']['output'];
  resubmission: Maybe<Resubmission>;
  status: Maybe<ClaimStatus>;
  submittedDate: Scalars['String']['output'];
  tierRoles: Maybe<Array<ClaimTierRole>>;
  totalDiscount: Maybe<MonetaryAmount>;
  totalProviderCollectedPatientShare: Maybe<MonetaryAmount>;
  totalRequiredPatientShare: Maybe<MonetaryAmount>;
  type: Maybe<ClaimType>;
  version: Scalars['Int']['output'];
  visit: Maybe<Visit>;
  visitEndDate: Maybe<Scalars['String']['output']>;
  visitStartDate: Maybe<Scalars['String']['output']>;
};

export type ClaimAudit = {
  __typename?: 'ClaimAudit';
  createdBy: Maybe<User>;
  createdDate: Scalars['String']['output'];
  event: Scalars['String']['output'];
  status: ClaimStatus;
  tier: Maybe<Scalars['Int']['output']>;
};

export type ClaimBulkUploadResponse = Error | Success;

export type ClaimComment = {
  __typename?: 'ClaimComment';
  content: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<User>;
  createdDate: Maybe<Scalars['String']['output']>;
};

export enum ClaimDateType {
  ClaimApprovalDate = 'CLAIM_APPROVAL_DATE',
  ClaimSubmittedDate = 'CLAIM_SUBMITTED_DATE'
}

export enum ClaimDelayType {
  EndOfMonth = 'END_OF_MONTH',
  Immediate = 'IMMEDIATE'
}

export type ClaimDenialReason = {
  __typename?: 'ClaimDenialReason';
  code: Scalars['String']['output'];
  denialCodes: Maybe<Array<BusinessProperty>>;
  description: Maybe<Scalars['String']['output']>;
  entityReferences: Maybe<Scalars['String']['output']>;
};

export type ClaimDiagnosesFilter = {
  claimCode: Scalars['String']['input'];
  claimVersion: Scalars['Int']['input'];
  multiSortCarePage: InputMaybe<MultiSortCarePageable>;
  poa: InputMaybe<ExtraInfoValue>;
  productReferences: InputMaybe<Array<Scalars['String']['input']>>;
  types: InputMaybe<Array<DiagnosisType>>;
};

export type ClaimDiagnosisExtraInfoInput = {
  type: InputMaybe<ExtraInfoType>;
  value: InputMaybe<ClaimDiagnosisExtraInfoValue>;
};

export enum ClaimDiagnosisExtraInfoValue {
  Invalid = 'INVALID',
  N = 'N',
  One = 'ONE',
  Op = 'OP',
  U = 'U',
  W = 'W',
  Y = 'Y'
}

export type ClaimDocument = {
  __typename?: 'ClaimDocument';
  code: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<User>;
  createdDate: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  link: Maybe<Scalars['String']['output']>;
  type: Maybe<DocumentType>;
};

export type ClaimDocumentLocation = {
  __typename?: 'ClaimDocumentLocation';
  url: Scalars['String']['output'];
};

export type ClaimExternalCode = {
  __typename?: 'ClaimExternalCode';
  reference: Maybe<Scalars['String']['output']>;
  source: Maybe<Scalars['String']['output']>;
};

export type ClaimFault = {
  __typename?: 'ClaimFault';
  code: Maybe<Scalars['String']['output']>;
  createdDate: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  status: Maybe<FaultStatus>;
};

export type ClaimFilter = {
  batchNumber: InputMaybe<Scalars['String']['input']>;
  batchNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  benefitIds: InputMaybe<Array<Scalars['String']['input']>>;
  code: InputMaybe<Scalars['String']['input']>;
  createdBy: InputMaybe<Scalars['String']['input']>;
  dayCase: InputMaybe<Scalars['Boolean']['input']>;
  emergency: InputMaybe<Scalars['Boolean']['input']>;
  externalCode: InputMaybe<Scalars['String']['input']>;
  externalCodeSources: InputMaybe<Array<Scalars['String']['input']>>;
  inpatient: InputMaybe<Scalars['Boolean']['input']>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  multiSortCarePage: InputMaybe<MultiSortCarePageable>;
  outpatient: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use multiSortCarePage instead */
  page: InputMaybe<CarePageable>;
  patientIds: InputMaybe<Array<Scalars['String']['input']>>;
  payeeTypes: InputMaybe<Array<PayeeType>>;
  payerIds: InputMaybe<Array<Scalars['String']['input']>>;
  pharmacy: InputMaybe<Scalars['Boolean']['input']>;
  providerIds: InputMaybe<Array<Scalars['String']['input']>>;
  remittanceStatuses: InputMaybe<Array<InputMaybe<RemittanceStatus>>>;
  requestedAmountFrom: InputMaybe<Scalars['Float']['input']>;
  requestedAmountTo: InputMaybe<Scalars['Float']['input']>;
  resubmissionTypes: InputMaybe<Array<ResubmissionType>>;
  statuses: InputMaybe<Array<ClaimStatus>>;
  submittedDateFrom: InputMaybe<Scalars['String']['input']>;
  submittedDateTo: InputMaybe<Scalars['String']['input']>;
  vip: InputMaybe<Scalars['Boolean']['input']>;
  visitIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ClaimFilterOptions = {
  __typename?: 'ClaimFilterOptions';
  payers: Maybe<Array<Scalars['String']['output']>>;
  providers: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ClaimHistoryFilter = {
  claimCode: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type ClaimInvoice = {
  __typename?: 'ClaimInvoice';
  invoiceNumber: Maybe<Scalars['String']['output']>;
  items: Maybe<Array<ClaimItem>>;
  subTotalApprovedAmount: MonetaryAmount;
  subTotalDeductions: Maybe<MonetaryAmount>;
  subTotalDiscount: MonetaryAmount;
  subTotalPatientShare: MonetaryAmount;
  subTotalRequestedAmount: MonetaryAmount;
  taxInvoiceNumber: Maybe<Scalars['String']['output']>;
};

export type ClaimInvoiceFilter = {
  claimCode: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type ClaimItem = {
  __typename?: 'ClaimItem';
  adjudications: Maybe<Array<Adjudication>>;
  approvedAmount: Maybe<MonetaryAmount>;
  approvedQuantity: Maybe<Scalars['Float']['output']>;
  approvedUnitPrice: Maybe<MonetaryAmount>;
  benefit: Maybe<Benefit>;
  claimMedicalProduct: Maybe<ClaimMedicalProduct>;
  clinician: Maybe<Employee>;
  code: Scalars['String']['output'];
  collectedPatientShare: Maybe<MonetaryAmount>;
  discount: Maybe<Scalars['Float']['output']>;
  documents: Maybe<Array<ClaimDocument>>;
  exGratiaAmount: Maybe<MonetaryAmount>;
  externalCode: Maybe<ClaimExternalCode>;
  faults: Maybe<Array<Maybe<ClaimFault>>>;
  foreignRequestedAmount: Maybe<MonetaryAmount>;
  foreignUnitPrice: Maybe<MonetaryAmount>;
  internalRef: Scalars['String']['output'];
  invoiceNumber: Maybe<Scalars['String']['output']>;
  lastAdjudicatedAmount: Maybe<MonetaryAmount>;
  lastAdjudicatedPatientShare: Maybe<MonetaryAmount>;
  lastAdjudicatedQuantity: Maybe<Scalars['Float']['output']>;
  lastAdjudicatedUnitPrice: Maybe<MonetaryAmount>;
  notes: Maybe<Array<ClaimItemNote>>;
  preAuthorization: Maybe<PreAuthorization>;
  preAuthorizationRef: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  quantityCountBalance: Maybe<Scalars['Float']['output']>;
  recoverableAmount: Maybe<MonetaryAmount>;
  requestedAmount: Maybe<MonetaryAmount>;
  requiredPatientShare: Maybe<MonetaryAmount>;
  startDate: Maybe<Scalars['String']['output']>;
  status: Maybe<ItemStatus>;
  taxInvoiceNumber: Maybe<Scalars['String']['output']>;
  unitPrice: Maybe<MonetaryAmount>;
};

export type ClaimItemDenialReasonInput = {
  code: Scalars['String']['input'];
  description: InputMaybe<Scalars['String']['input']>;
  note: InputMaybe<Scalars['String']['input']>;
};

export type ClaimItemFilter = {
  benefitReferences: InputMaybe<Array<Scalars['String']['input']>>;
  claimCode: Scalars['String']['input'];
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  multiSortCarePage: InputMaybe<MultiSortCarePageable>;
  productCodingSystems: InputMaybe<Array<Scalars['String']['input']>>;
  productReferences: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<ItemStatus>>;
  version: Scalars['Int']['input'];
};

export type ClaimItemNote = {
  __typename?: 'ClaimItemNote';
  code: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  createdDate: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  valueType: Maybe<Scalars['String']['output']>;
};

export type ClaimItemPage = CarePage & {
  __typename?: 'ClaimItemPage';
  data: Maybe<Array<Maybe<ClaimItem>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ClaimMedicalProduct = {
  __typename?: 'ClaimMedicalProduct';
  codingSystem: Maybe<Scalars['String']['output']>;
  externalCode: Maybe<Scalars['String']['output']>;
  medicalProducts: Maybe<Array<MedicalProduct>>;
  reference: Maybe<Scalars['String']['output']>;
};

export type ClaimMedicalProductInput = {
  codingSystem: InputMaybe<Scalars['String']['input']>;
  externalCode: InputMaybe<Scalars['String']['input']>;
  reference: InputMaybe<Scalars['String']['input']>;
};

export type ClaimNote = {
  __typename?: 'ClaimNote';
  createdBy: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
};

export type ClaimPage = CarePage & {
  __typename?: 'ClaimPage';
  data: Maybe<Array<Maybe<Claim>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ClaimReversalResponse = Error | Success;

export enum ClaimStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  PartiallyApproved = 'PARTIALLY_APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Reversed = 'REVERSED'
}

export type ClaimTierRole = {
  __typename?: 'ClaimTierRole';
  roles: Maybe<Array<Scalars['String']['output']>>;
  tierLevel: Scalars['Int']['output'];
};

export enum ClaimType {
  Medical = 'MEDICAL'
}

export type ClaimUploadErrorFileDownload = {
  __typename?: 'ClaimUploadErrorFileDownload';
  url: Maybe<Scalars['String']['output']>;
};

export type ClaimUploadErrorSummary = {
  __typename?: 'ClaimUploadErrorSummary';
  fileName: Maybe<Scalars['String']['output']>;
  uploadInternalReference: Maybe<Scalars['String']['output']>;
  uploadedClaimsCount: Maybe<Scalars['Int']['output']>;
  uploadedDate: Maybe<Scalars['String']['output']>;
};

export type ClaimUploadErrorSummaryFilter = {
  page: InputMaybe<CarePageable>;
  payerRef: Scalars['String']['input'];
  uploadedDateFrom: InputMaybe<Scalars['String']['input']>;
  uploadedDateTo: InputMaybe<Scalars['String']['input']>;
};

export type ClaimUploadErrorSummaryPage = CarePage & {
  __typename?: 'ClaimUploadErrorSummaryPage';
  data: Array<ClaimUploadErrorSummary>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type Classification = {
  __typename?: 'Classification';
  name: Maybe<Scalars['String']['output']>;
};

export type ClassificationFilter = {
  name: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
};

export type ClassificationPage = CarePage & {
  __typename?: 'ClassificationPage';
  data: Maybe<Array<Maybe<Classification>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ClientDetails = {
  addressLineOne: InputMaybe<Scalars['String']['input']>;
  addressLineTwo: InputMaybe<Scalars['String']['input']>;
  companyRegistrationNumber: InputMaybe<Scalars['String']['input']>;
  countryRef: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  geolocationOneRef: InputMaybe<Scalars['String']['input']>;
  geolocationTwoRef: InputMaybe<Scalars['String']['input']>;
  industryRef: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  previousInsurer: InputMaybe<Scalars['String']['input']>;
  previousPolicyExpiryDate: InputMaybe<Scalars['String']['input']>;
  vatNumber: InputMaybe<Scalars['String']['input']>;
  zipCode: InputMaybe<Scalars['String']['input']>;
};

export enum ClientType {
  Group = 'GROUP',
  Retail = 'RETAIL'
}

export type CloseVisitResponse = Error | Success;

export type CodingSystem = {
  __typename?: 'CodingSystem';
  category: Maybe<CodingSystemCategory>;
  description: Maybe<Scalars['String']['output']>;
  effectiveDate: Maybe<Scalars['String']['output']>;
  expiryDate: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  latestVersion: Maybe<Scalars['String']['output']>;
  medicalCodesUploadedCount: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export enum CodingSystemCategory {
  Dental = 'DENTAL',
  Diagnosis = 'DIAGNOSIS',
  Drugs = 'DRUGS',
  Hmis = 'HMIS',
  Packages = 'PACKAGES',
  Procedures = 'PROCEDURES',
  SuppliesConsumables = 'SUPPLIES_CONSUMABLES'
}

export type CollectiveModifier = {
  __typename?: 'CollectiveModifier';
  modifierType: Maybe<CollectiveModifierType>;
  modifierValue: Maybe<Scalars['Float']['output']>;
  priceAgreementId: Maybe<Scalars['String']['output']>;
  priceList: Maybe<PriceList>;
  priceListId: Maybe<Scalars['String']['output']>;
};

export type CollectiveModifierInput = {
  modifierType: CollectiveModifierType;
  modifierValue: Scalars['Float']['input'];
  priceListId: Scalars['String']['input'];
};

export type CollectiveModifierResponse = CollectiveModifier | Error;

export enum CollectiveModifierType {
  Factor = 'FACTOR',
  None = 'NONE',
  Percent = 'PERCENT'
}

export type CommentPage = CarePage & {
  __typename?: 'CommentPage';
  data: Array<QuotationComment>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type CommunicationDetails = {
  __typename?: 'CommunicationDetails';
  /** @deprecated Use piiObjectId to detokenize */
  email: Maybe<Scalars['String']['output']>;
  memberId: Maybe<Scalars['String']['output']>;
  /** @deprecated Use piiObjectId to detokenize */
  phoneNumber: Maybe<Scalars['String']['output']>;
  piiObjectId: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
  userKey: Maybe<Scalars['String']['output']>;
};

export type CommunicationSearchFilter = {
  beneficiaryPolicyId: InputMaybe<Scalars['String']['input']>;
  memberId: InputMaybe<Scalars['String']['input']>;
};

export enum ComparisonOperator {
  EqualOrGreaterThan = 'EQUAL_OR_GREATER_THAN'
}

export type Condition = {
  __typename?: 'Condition';
  answer: Scalars['Boolean']['output'];
  answerDetails: Maybe<Scalars['String']['output']>;
  medicalCodes: Maybe<Array<CoverageMedicalCode>>;
  premiumImpact: Maybe<Scalars['Float']['output']>;
  question: Scalars['String']['output'];
};

export type ConfirmAdjudication = {
  note: InputMaybe<Scalars['String']['input']>;
  validityEndDate: InputMaybe<Scalars['String']['input']>;
  validityStartDate: InputMaybe<Scalars['String']['input']>;
};

export type ConsentInput = {
  channel: Scalars['String']['input'];
  documents: Array<Scalars['String']['input']>;
};

export type ConvertedAmount = {
  __typename?: 'ConvertedAmount';
  base: Scalars['Float']['output'];
  quote: Scalars['Float']['output'];
};

export type CopayItem = {
  carepayCode: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['String']['input']>;
  tagIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum CopayType {
  Item = 'ITEM',
  Visit = 'VISIT'
}

export type CopyPriceAgreementInput = {
  description: InputMaybe<Scalars['String']['input']>;
  networkId: InputMaybe<Scalars['String']['input']>;
  payerId: Scalars['String']['input'];
  policyProductCategoryCode: InputMaybe<Scalars['String']['input']>;
  policyProductId: InputMaybe<Scalars['String']['input']>;
  validFrom: Scalars['String']['input'];
  validTo: InputMaybe<Scalars['String']['input']>;
};

export type CopyPricingSetupInput = {
  priceAgreementId: Scalars['String']['input'];
  providerCodes: Array<Scalars['String']['input']>;
  validFrom: Scalars['String']['input'];
  validTo: InputMaybe<Scalars['String']['input']>;
};

export type CopyPricingStatus = {
  __typename?: 'CopyPricingStatus';
  errors: Maybe<Array<CopyPricingStatusError>>;
  operationId: Scalars['String']['output'];
  processedProviders: Scalars['Int']['output'];
  status: FileStatus;
  totalProviders: Scalars['Int']['output'];
};

export type CopyPricingStatusError = {
  __typename?: 'CopyPricingStatusError';
  error: Maybe<Scalars['String']['output']>;
  providerCode: Scalars['String']['output'];
};

export type CopyPricingStatusInput = {
  operationId: Scalars['String']['input'];
  withErrors: InputMaybe<Scalars['Boolean']['input']>;
};

export type CopyPricingStatusResponse = CopyPricingStatus | Error;

export enum CorrectionType {
  Deduction = 'DEDUCTION',
  Topup = 'TOPUP'
}

export type Country = {
  __typename?: 'Country';
  code: Maybe<Scalars['String']['output']>;
  geolocationLevelOnes: Maybe<GeolocationLevelOnePage>;
  locationCodes: Maybe<Array<LocationCode>>;
  name: Maybe<Scalars['String']['output']>;
  regions: Maybe<Array<GeolocationRegion>>;
};


export type CountryGeolocationLevelOnesArgs = {
  filter: InputMaybe<CarePageable>;
};

export type CountryFilter = {
  countryCodes: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  regionCodes: InputMaybe<Array<Scalars['String']['input']>>;
  search: InputMaybe<Scalars['String']['input']>;
};

export type CountryPage = CarePage & {
  __typename?: 'CountryPage';
  data: Maybe<Array<Country>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type Coverage = {
  __typename?: 'Coverage';
  benefitId: Maybe<Scalars['String']['output']>;
  chargeType: Maybe<ChargeType>;
  claimType: Maybe<PolicyClaimType>;
  coinsurance: Maybe<CoverageCoinsurance>;
  copay: Maybe<CoverageCopay>;
  deductible: Maybe<CoverageDeductible>;
  familyComposition: Maybe<FamilyComposition>;
  isCovered: Scalars['Boolean']['output'];
  isFamilyShared: Scalars['Boolean']['output'];
  limit: CoverageLimit;
  medicalCodesExcluded: Maybe<Array<CoverageMedicalCode>>;
  medicalCodesIncluded: Maybe<Array<CoverageMedicalCode>>;
  medicalTagsExcluded: Maybe<Array<MedicalTag>>;
  medicalTagsIncluded: Maybe<Array<MedicalTag>>;
  name: Maybe<Scalars['String']['output']>;
  onCosmetic: Maybe<Scalars['Boolean']['output']>;
  onEmergencyOnly: Maybe<Scalars['Boolean']['output']>;
  preAuthorisationLimit: Maybe<MonetaryAmount>;
  providerNetworks: Maybe<Array<CustomNetwork | StandardNetwork>>;
  reasonableAndCustomaryCharges: Maybe<Array<Scalars['String']['output']>>;
  territoryExcluded: Maybe<Territory>;
  territoryIncluded: Maybe<Territory>;
  waitingPeriodInDays: Maybe<Scalars['Int']['output']>;
};

export enum CoverageCivilStatus {
  Any = 'ANY',
  Divorced = 'DIVORCED',
  Married = 'MARRIED',
  Single = 'SINGLE',
  Widowed = 'WIDOWED'
}

export type CoverageCoinsurance = {
  __typename?: 'CoverageCoinsurance';
  max: Maybe<MonetaryAmount>;
  percentage: Scalars['Float']['output'];
};

export type CoverageCoinsuranceInput = {
  max: InputMaybe<MonetaryAmountInput>;
  percentage: Scalars['Float']['input'];
};

export type CoverageCopay = {
  __typename?: 'CoverageCopay';
  amount: MonetaryAmount;
  max: Maybe<MonetaryAmount>;
};

export type CoverageCopayInput = {
  amount: MonetaryAmountInput;
  max: InputMaybe<MonetaryAmountInput>;
};

export type CoverageCountLimit = {
  __typename?: 'CoverageCountLimit';
  baseCount: Maybe<Scalars['Int']['output']>;
  baseTerm: Maybe<CoverageTerm>;
  displayText: Maybe<Scalars['String']['output']>;
  maxCount: Maybe<Scalars['Int']['output']>;
  maxTerm: Maybe<CoverageTerm>;
  type: CoverageCountType;
};

export type CoverageCountLimitInput = {
  baseCount: InputMaybe<Scalars['Int']['input']>;
  baseTerm: InputMaybe<CoverageTerm>;
  displayText: InputMaybe<Scalars['String']['input']>;
  maxCount: InputMaybe<Scalars['Int']['input']>;
  maxTerm: InputMaybe<CoverageTerm>;
  type: CoverageCountType;
};

export enum CoverageCountType {
  Product = 'PRODUCT',
  Term = 'TERM',
  Visit = 'VISIT'
}

export type CoverageDeductible = {
  __typename?: 'CoverageDeductible';
  amount: MonetaryAmount;
  term: CoverageTerm;
};

export type CoverageDeductibleInput = {
  amount: MonetaryAmountInput;
  term: CoverageTerm;
};

export enum CoverageGender {
  Any = 'ANY',
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

export type CoverageLimit = {
  __typename?: 'CoverageLimit';
  count: Maybe<CoverageCountLimit>;
  money: Maybe<CoverageMoneyLimit>;
  text: Maybe<Scalars['String']['output']>;
  type: CoverageLimitType;
};

export type CoverageLimitInput = {
  count: InputMaybe<CoverageCountLimitInput>;
  money: InputMaybe<CoverageMoneyLimitInput>;
  text: InputMaybe<Scalars['String']['input']>;
  type: CoverageLimitType;
};

export enum CoverageLimitType {
  Independent = 'INDEPENDENT',
  Inherited = 'INHERITED',
  Limited = 'LIMITED',
  Text = 'TEXT',
  Unlimited = 'UNLIMITED'
}

export type CoverageMedicalCode = {
  __typename?: 'CoverageMedicalCode';
  code: Scalars['String']['output'];
  codingStandard: Scalars['String']['output'];
};

export type CoverageMedicalCodeInput = {
  code: Scalars['String']['input'];
  codingStandard: Scalars['String']['input'];
};

export type CoverageMoneyLimit = {
  __typename?: 'CoverageMoneyLimit';
  baseAmount: Maybe<MonetaryAmount>;
  baseTerm: Maybe<CoverageTerm>;
  maxAmount: Maybe<MonetaryAmount>;
  maxTerm: Maybe<CoverageTerm>;
};

export type CoverageMoneyLimitInput = {
  baseAmount: InputMaybe<MonetaryAmountInput>;
  baseTerm: InputMaybe<CoverageTerm>;
  maxAmount: InputMaybe<MonetaryAmountInput>;
  maxTerm: InputMaybe<CoverageTerm>;
};

export enum CoverageOccupation {
  Any = 'ANY',
  Employed = 'EMPLOYED',
  Student = 'STUDENT',
  Unemployed = 'UNEMPLOYED'
}

export enum CoverageRegionType {
  Domestic = 'DOMESTIC',
  International = 'INTERNATIONAL'
}

export enum CoverageRelationship {
  AnyDependent = 'ANY_DEPENDENT',
  Child = 'CHILD',
  Grandparent = 'GRANDPARENT',
  Parent = 'PARENT',
  Primary = 'PRIMARY',
  SpecialCondition = 'SPECIAL_CONDITION',
  Spouse = 'SPOUSE'
}

export enum CoverageTerm {
  Day = 'DAY',
  Month = 'MONTH',
  Night = 'NIGHT',
  Visit = 'VISIT',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type CreateAnnualMedicalLimitInput = {
  annualLimit: InputMaybe<MonetaryAmountInput>;
  baseRateCorrectionPercentage: Scalars['Float']['input'];
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  type: AnnualMedicalLimitType;
};

export type CreateBedCapacityInput = {
  capacity: Scalars['Int']['input'];
  type: BedType;
};

export type CreateCase = {
  assignees: InputMaybe<Array<Scalars['String']['input']>>;
  beneficiaryPolicyReference: InputMaybe<Scalars['String']['input']>;
  categoryReference: InputMaybe<Scalars['String']['input']>;
  memberReference: InputMaybe<Scalars['String']['input']>;
  payerReference: InputMaybe<Scalars['String']['input']>;
  preAuthorizationReferences: Array<Scalars['String']['input']>;
  providerReference: InputMaybe<Scalars['String']['input']>;
  submittedDate: InputMaybe<Scalars['String']['input']>;
};

export type CreateComment = {
  message: Scalars['String']['input'];
};

export type CreateDirectSettlementClaim = {
  allowedResubmissions: InputMaybe<Scalars['Int']['input']>;
  batchNumber: InputMaybe<Scalars['String']['input']>;
  benefitReference: InputMaybe<Scalars['String']['input']>;
  billablePeriod: InputMaybe<DateRangeInput>;
  diagnosis: InputMaybe<Array<InputMaybe<DiagnosisInput>>>;
  externalCode: InputMaybe<ExternalCodeInput>;
  items: InputMaybe<Array<InputMaybe<AddClaimItemInput>>>;
  medicalNotes: InputMaybe<Array<InputMaybe<MedicalNoteInput>>>;
  patientReference: Scalars['String']['input'];
  patientShares: InputMaybe<Array<InputMaybe<PatientShareInput>>>;
  patientSpecialTier: InputMaybe<SpecialTier>;
  payerReference: Scalars['String']['input'];
  providerReference: InputMaybe<Scalars['String']['input']>;
  providerType: InputMaybe<ProviderType>;
  submittedDate: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
  visitReference: InputMaybe<Scalars['String']['input']>;
  visitType: InputMaybe<VisitType>;
};

export type CreateFamilyCompositionInput = {
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  familyMemberTypes: InputMaybe<Array<FamilyMemberTypeInput>>;
  maxFamilySize: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type CreateIntermediaryInput = {
  email: Scalars['String']['input'];
  firstName: InputMaybe<Scalars['String']['input']>;
  identification: Scalars['String']['input'];
  identificationType: IntermediaryIdentificationType;
  lastName: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  taxRegistrationNumber: Scalars['String']['input'];
  type: IntermediaryType;
};

export type CreateItemNoteInput = {
  code: InputMaybe<Scalars['String']['input']>;
  message: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
  valueType: InputMaybe<Scalars['String']['input']>;
};

export type CreateMedicalCodeResponse = Error | MedicalCode;

export type CreatePayerAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  poBox: InputMaybe<Scalars['String']['input']>;
  state: InputMaybe<Scalars['String']['input']>;
  type: PayerAddressType;
  zipCode: InputMaybe<Scalars['String']['input']>;
};

export type CreatePayerBankAccountInput = {
  accountHolderName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  bankBic: InputMaybe<Scalars['String']['input']>;
  bankBranchCode: InputMaybe<Scalars['String']['input']>;
  bankBranchName: InputMaybe<Scalars['String']['input']>;
  bankCode: InputMaybe<Scalars['String']['input']>;
  bankName: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  responsibleForPayout: InputMaybe<Scalars['String']['input']>;
  type: PayerBankAccountType;
};

export type CreatePayerContactInput = {
  designation: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: InputMaybe<Scalars['String']['input']>;
};

export type CreatePayerInput = {
  category: InputMaybe<PayerCategory>;
  defaultCurrency: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  licenseNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  taxRegistrationNumber: Scalars['String']['input'];
  type: PayerType;
};

export type CreatePaymentContractInput = {
  counterParty: MinimalPartyInput;
  orderingParty: MinimalPartyInput;
  paymentTerms: PaymentTermsInput;
};

export type CreatePecCoverageInput = {
  baseRateCorrectionPercentage: Scalars['Float']['input'];
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  maximumAmlPercentage: Scalars['Float']['input'];
};

export type CreatePreAuthDiagnosis = {
  code: InputMaybe<Scalars['String']['input']>;
  extraInfos: InputMaybe<Array<CreatePreAuthorizationDiagnosisExtraInfo>>;
  medicalProduct: InputMaybe<CreatePreAuthMedicalProduct>;
  type: InputMaybe<DiagnosisType>;
};

export type CreatePreAuthMedicalProduct = {
  codingSystem: InputMaybe<Scalars['String']['input']>;
  externalCode: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
};

export type CreatePreAuthorization = {
  benefitRef: InputMaybe<Scalars['String']['input']>;
  countryCode: InputMaybe<Scalars['String']['input']>;
  diagnoses: InputMaybe<Array<CreatePreAuthDiagnosis>>;
  externalCode: InputMaybe<CreatePreAuthorizationExternalCode>;
  externalMemberReference: InputMaybe<Scalars['String']['input']>;
  hasDocs: InputMaybe<Scalars['Boolean']['input']>;
  initialProvider: InputMaybe<Scalars['String']['input']>;
  items: InputMaybe<Array<CreatePreAuthorizationItem>>;
  medicalType: InputMaybe<PreAuthorizationMedicalType>;
  memberRef: Scalars['String']['input'];
  orderedDate: InputMaybe<Scalars['String']['input']>;
  patientRef: Scalars['String']['input'];
  patientSpecialTier: InputMaybe<SpecialTier>;
  payerRef: Scalars['String']['input'];
  prescriptionRef: InputMaybe<Scalars['String']['input']>;
  providerRef: InputMaybe<Scalars['String']['input']>;
  providerType: InputMaybe<ProviderType>;
  submissionSource: InputMaybe<PreAuthorizationSubmissionSource>;
  submittedDate: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<PreAuthorizationType>;
  visitRef: InputMaybe<Scalars['String']['input']>;
  visitType: InputMaybe<VisitType>;
};

export type CreatePreAuthorizationComment = {
  message: Scalars['String']['input'];
};

export type CreatePreAuthorizationDiagnosisExtraInfo = {
  type: InputMaybe<ExtraInfoType>;
  value: InputMaybe<ExtraInfoValue>;
};

export type CreatePreAuthorizationExternalCode = {
  reference: InputMaybe<Scalars['String']['input']>;
  source: InputMaybe<Scalars['String']['input']>;
};

export type CreatePreAuthorizationItem = {
  benefitRef: InputMaybe<Scalars['String']['input']>;
  clinicianRef: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  collectedPatientShare: InputMaybe<MonetaryAmountInput>;
  duration: InputMaybe<Scalars['Float']['input']>;
  externalCode: InputMaybe<Scalars['String']['input']>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  itemNotes: InputMaybe<Array<CreatePreAuthorizationItemNote>>;
  location: InputMaybe<Scalars['String']['input']>;
  medicalProduct: InputMaybe<CreatePreAuthMedicalProduct>;
  prescriptionRef: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  requestedAmount: InputMaybe<MonetaryAmountInput>;
  startDate: Scalars['String']['input'];
  unit: InputMaybe<Scalars['Float']['input']>;
  unitPrice: MonetaryAmountInput;
};

export type CreatePreAuthorizationItemNote = {
  code: InputMaybe<Scalars['String']['input']>;
  message: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};

export type CreatePreAuthorizationOverride = {
  items: InputMaybe<Array<PreAuthorizationItemOverrideInput>>;
  preAuthorizationReference: Scalars['String']['input'];
};

export type CreatePreAuthorizationOverrideResponse = Error | ResourceCreated;

export type CreatePriceAgreementInput = {
  description: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  networkId: InputMaybe<Scalars['String']['input']>;
  overrideDates: Scalars['Boolean']['input'];
  payerId: Scalars['String']['input'];
  policyProductCategoryCode: InputMaybe<Scalars['String']['input']>;
  policyProductId: InputMaybe<Scalars['String']['input']>;
  providerCode: Scalars['String']['input'];
  validFrom: Scalars['String']['input'];
  validTo: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductBenefitInput = {
  baseLimitAmount: InputMaybe<MonetaryAmountInput>;
  baseLimitCount: InputMaybe<Scalars['Int']['input']>;
  baseLimitDescription: InputMaybe<Scalars['String']['input']>;
  baseLimitTerm: InputMaybe<ProductCoverageTerm>;
  baseRateCorrectionAmount: InputMaybe<MonetaryAmountInput>;
  baseRateCorrectionPercentage: InputMaybe<Scalars['Float']['input']>;
  baseRateCorrectionType: BaseRateCorrectionType;
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  isFamilyShared: Scalars['Boolean']['input'];
  limitType: ProductBenefitLimitType;
  maxLimitAmount: InputMaybe<MonetaryAmountInput>;
  maxLimitCount: InputMaybe<Scalars['Int']['input']>;
  maxLimitDescription: InputMaybe<Scalars['String']['input']>;
  maxLimitTerm: InputMaybe<ProductCoverageTerm>;
  medicalTagInclusionRefs: InputMaybe<Array<Scalars['String']['input']>>;
  preAuthorizationAmount: InputMaybe<MonetaryAmountInput>;
  preAuthorizationType: BenefitPreAuthorizationType;
  providerNetworkExternalRef: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductBenefitTypeInput = {
  description: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  patientShares: InputMaybe<Array<BenefitTypePatientShareInput>>;
  type: ProductBenefitTypeOption;
  waitingPeriods: InputMaybe<Array<BenefitTypeWaitingPeriodInput>>;
};

export type CreateProductInput = {
  currency: Scalars['String']['input'];
  endDate: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  payerRef: Scalars['String']['input'];
  startDate: InputMaybe<Scalars['String']['input']>;
  type: ClientType;
};

export type CreateProductProviderNetworkInput = {
  baseRateCorrectionPercentage: Scalars['Float']['input'];
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  externalRef: Scalars['String']['input'];
};

export type CreateProductSubBenefitInput = {
  baseLimitAmount: InputMaybe<MonetaryAmountInput>;
  baseLimitCount: InputMaybe<Scalars['Int']['input']>;
  baseLimitDescription: InputMaybe<Scalars['String']['input']>;
  baseLimitTerm: InputMaybe<ProductCoverageTerm>;
  baseRateCorrectionAmount: InputMaybe<MonetaryAmountInput>;
  baseRateCorrectionPercentage: InputMaybe<Scalars['Float']['input']>;
  baseRateCorrectionType: BaseRateCorrectionType;
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  isFamilyShared: Scalars['Boolean']['input'];
  limitType: ProductBenefitLimitType;
  maxLimitAmount: InputMaybe<MonetaryAmountInput>;
  maxLimitCount: InputMaybe<Scalars['Int']['input']>;
  maxLimitDescription: InputMaybe<Scalars['String']['input']>;
  maxLimitTerm: InputMaybe<ProductCoverageTerm>;
  medicalTagInclusionRefs: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  preAuthorizationAmount: InputMaybe<MonetaryAmountInput>;
  preAuthorizationType: BenefitPreAuthorizationType;
  providerNetworkExternalRef: InputMaybe<Scalars['String']['input']>;
  type: ProductBenefitTypeOption;
};

export type CreateProviderInput = {
  name: Scalars['String']['input'];
  parentProviderCode: Scalars['String']['input'];
  providerType: InputMaybe<ProviderType>;
  registrationCode: InputMaybe<Scalars['String']['input']>;
};

export type CreateQuotationInput = {
  clientType: ClientType;
  payerRef: Scalars['String']['input'];
};

export type CreateReimbursementInput = {
  memberReference: InputMaybe<Scalars['String']['input']>;
  patientReference: Scalars['String']['input'];
  patientSpecialTier: InputMaybe<SpecialTier>;
  payerReference: Scalars['String']['input'];
  payoutMethod: InputMaybe<PayoutMethod>;
  preAuthorizationReference: InputMaybe<Scalars['String']['input']>;
  providerReference: InputMaybe<Scalars['String']['input']>;
  providerType: InputMaybe<ProviderType>;
  reimbursementDetails: InputMaybe<ReimbursementDetailsInput>;
  reimbursementVisit: InputMaybe<ReimbursementVisitInput>;
  requestedAmount: MonetaryAmountInput;
};

export type CreateRoomTypeInput = {
  baseRateCorrectionPercentage: Scalars['Float']['input'];
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  type: RoomTypeOption;
};

export type CreateStaticVisitInput = {
  destinationProvider: InputMaybe<Scalars['String']['input']>;
  endDate: InputMaybe<Scalars['String']['input']>;
  endType: InputMaybe<VisitEndType>;
  externalCode: InputMaybe<VisitExternalCodeInput>;
  patientRef: InputMaybe<Scalars['String']['input']>;
  payerRef: InputMaybe<Scalars['String']['input']>;
  planRef: InputMaybe<Scalars['String']['input']>;
  providerRef: InputMaybe<Scalars['String']['input']>;
  sourceProvider: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  startType: InputMaybe<VisitStartType>;
  type: InputMaybe<VisitType>;
};

export type CreateTerritorialCoverageInput = {
  baseRateCorrectionPercentage: Scalars['Float']['input'];
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  excludedCountryRefs: InputMaybe<Array<Scalars['String']['input']>>;
  expenseType: ExpenseType;
  includedRegionRefs: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  url: InputMaybe<Scalars['String']['input']>;
  userRole: ProviderRole;
};

export type CreateVisitInput = {
  benefitRef: Scalars['String']['input'];
  externalCode: InputMaybe<VisitExternalCodeInput>;
  patientRef: Scalars['String']['input'];
  planRef: Scalars['String']['input'];
  providerRef: Scalars['String']['input'];
  startDate: InputMaybe<Scalars['String']['input']>;
  startType: InputMaybe<VisitStartType>;
  type: InputMaybe<VisitType>;
};

export type CurrencyConversionRequest = {
  __typename?: 'CurrencyConversionRequest';
  amounts: Maybe<Array<ConvertedAmount>>;
  base: Scalars['String']['output'];
  date: Scalars['String']['output'];
  externalRef: Maybe<Scalars['String']['output']>;
  firstCreated: Scalars['String']['output'];
  internalRef: Scalars['String']['output'];
  quote: Scalars['String']['output'];
  rates: ExchangeRates;
  requestId: Scalars['String']['output'];
};

export type CustomNetwork = ProviderNetwork & {
  __typename?: 'CustomNetwork';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  exclusions: Maybe<CustomNetworkAdditionPage>;
  inclusions: Maybe<CustomNetworkAdditionPage>;
  linkedNetwork: Maybe<StandardNetwork>;
  name: Scalars['String']['output'];
  payer: Payer;
  type: ProviderNetworkType;
  utilizer: Maybe<Payer>;
};


export type CustomNetworkExclusionsArgs = {
  filter: InputMaybe<CustomNetworkAdditionFilter>;
};


export type CustomNetworkInclusionsArgs = {
  filter: InputMaybe<CustomNetworkAdditionFilter>;
};

export type CustomNetworkAddition = {
  __typename?: 'CustomNetworkAddition';
  empaneledProvider: EmpaneledProvider;
  empaneledProviderReference: Scalars['String']['output'];
};

export type CustomNetworkAdditionFilter = {
  activeAtDate: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
};

export type CustomNetworkAdditionPage = CarePage & {
  __typename?: 'CustomNetworkAdditionPage';
  data: Maybe<Array<Maybe<CustomNetworkAddition>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type CustomNetworkLinkedNetworkDeleteResponse = Error | Success;

export type CustomProviderNetworkInput = {
  description: Scalars['String']['input'];
  linkedNetwork: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  payer: Scalars['String']['input'];
  utilizer: InputMaybe<Scalars['String']['input']>;
};

export type CustomProviderNetworkResponse = CustomNetwork | Error;

export type DataInitiationFile = {
  __typename?: 'DataInitiationFile';
  bankRef: Maybe<Scalars['String']['output']>;
  batchInternalRef: Scalars['String']['output'];
  fileName: Maybe<Scalars['String']['output']>;
  requestId: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  settlementInstructionInternalRef: Scalars['String']['output'];
  status: DataInitiationFileStatus;
  statusCreatedAt: Scalars['String']['output'];
  statusDescription: Maybe<Scalars['String']['output']>;
};

export enum DataInitiationFileStatus {
  Created = 'CREATED',
  Executed = 'EXECUTED'
}

export type DateRange = {
  __typename?: 'DateRange';
  end: Maybe<Scalars['String']['output']>;
  start: Maybe<Scalars['String']['output']>;
};

export type DateRangeInput = {
  end: InputMaybe<Scalars['String']['input']>;
  start: InputMaybe<Scalars['String']['input']>;
};

export enum DateType {
  ApprovalDate = 'APPROVAL_DATE',
  SubmitDate = 'SUBMIT_DATE',
  TreatmentDate = 'TREATMENT_DATE'
}

export type DefaultBaseRate = BaseRate & {
  __typename?: 'DefaultBaseRate';
  ageFrom: Scalars['Int']['output'];
  ageTo: Scalars['Int']['output'];
  memberRates: Array<MemberRate>;
  ratePrimary: MonetaryAmount;
  type: BaseRateType;
};

export type DefaultBaseRateInput = {
  ageFrom: Scalars['Int']['input'];
  ageTo: Scalars['Int']['input'];
  memberRates: InputMaybe<Array<MemberRatesInput>>;
  ratePrimary: MonetaryAmountInput;
};

export type DefaultBaseRatesInput = {
  rates: Array<DefaultBaseRateInput>;
};

export enum DefaultNetworkCategory {
  Hierarchy = 'HIERARCHY',
  NonHierarchy = 'NON_HIERARCHY'
}

export enum DelayType {
  EndOfMonth = 'END_OF_MONTH',
  Immediate = 'IMMEDIATE'
}

export type DeleteBeneficiariesResponse = Error | Success;

export type DeleteBeneficiaryDocumentResponse = Error | Success;

export type DeleteBenefitResponse = Error | Success;

export type DeleteBillingDiagnosisInput = {
  billRef: Scalars['String']['input'];
  diagnosisCode: Scalars['String']['input'];
};

export type DeleteBillingDocumentInput = {
  billRef: Scalars['String']['input'];
  documentRef: Scalars['String']['input'];
};

export type DeleteClaimsDiagnosisResponse = Error | Success;

export type DeleteClaimsItemResponse = Error | Success;

export type DeleteDiagnosisResponse = Error | Success;

export type DeleteDocumentResponse = Error | Success;

export type DeleteEmpaneledProviderContractResponse = Error | Success;

export type DeleteEmpaneledProviderResponse = Error | Success;

export type DeleteEndorsementDocumentResponse = Error | Success;

export type DeleteEndorsementResponse = Error | Success;

export type DeleteIntermediaryLicenseResponse = Error | Success;

export type DeleteIntermediaryResponse = Error | Success;

export type DeleteIntermediaryUserResponse = Error | Success;

export type DeletePayerResponse = Error | Success;

export type DeletePayerUserResponse = Error | Success;

export type DeletePlatformUserResponse = Error | Success;

export type DeletePreAuthorizationOverride = {
  overrideInternalReference: Scalars['String']['input'];
  preAuthorizationReference: Scalars['String']['input'];
};

export type DeletePreAuthorizationOverrideResponse = Error | Success;

export type DeletePriceAgreementResponse = Error | Success;

export type DeleteProviderUserResponse = Error | Success;

export type DeleteVisitResponse = Error | Success;

export enum DepartmentType {
  Finance = 'FINANCE',
  Insurance = 'INSURANCE',
  Other = 'OTHER'
}

export enum DependentType {
  Dependent_1 = 'DEPENDENT_1',
  Dependent_2 = 'DEPENDENT_2',
  Dependent_3 = 'DEPENDENT_3',
  Dependent_4 = 'DEPENDENT_4',
  Dependent_5 = 'DEPENDENT_5',
  Dependent_6 = 'DEPENDENT_6',
  Dependent_7 = 'DEPENDENT_7',
  Primary = 'PRIMARY'
}

export type Diagnosis = {
  __typename?: 'Diagnosis';
  claimMedicalProduct: Maybe<ClaimMedicalProduct>;
  extraInfos: Maybe<Array<Maybe<ExtraInfo>>>;
  internalRef: Maybe<Scalars['String']['output']>;
  type: Maybe<DiagnosisType>;
};

export type DiagnosisAddedResponse = Error | Success;

export type DiagnosisExtraInfo = {
  __typename?: 'DiagnosisExtraInfo';
  type: Maybe<DiagnosisExtraInfoType>;
  value: Maybe<DiagnosisExtraInfoValue>;
};

export enum DiagnosisExtraInfoType {
  Poa = 'POA',
  Unknown = 'UNKNOWN'
}

export enum DiagnosisExtraInfoValue {
  ClinicallyUndetermined = 'CLINICALLY_UNDETERMINED',
  False = 'FALSE',
  Invalid = 'INVALID',
  OutpatientClaim = 'OUTPATIENT_CLAIM',
  True = 'TRUE',
  Unknown = 'UNKNOWN',
  UnreportedNotUsed = 'UNREPORTED_NOT_USED'
}

export type DiagnosisFilter = {
  carepayCodes: InputMaybe<Array<Scalars['String']['input']>>;
  codingSystemName: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  externalCode: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  nameOrExternalCode: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
  tagIds: InputMaybe<Array<Scalars['String']['input']>>;
  tagTypeIds: InputMaybe<Array<Scalars['String']['input']>>;
  tags: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DiagnosisInput = {
  extraInfos: InputMaybe<Array<InputMaybe<ExtraInfoInput>>>;
  product: InputMaybe<ClaimMedicalProductInput>;
  type: InputMaybe<DiagnosisType>;
};

export type DiagnosisPage = CarePage & {
  __typename?: 'DiagnosisPage';
  data: Maybe<Array<Maybe<Diagnosis>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum DiagnosisType {
  Admitting = 'ADMITTING',
  Invalid = 'INVALID',
  Principal = 'PRINCIPAL',
  Secondary = 'SECONDARY'
}

export type DirectSettlementClaim = {
  __typename?: 'DirectSettlementClaim';
  code: Scalars['String']['output'];
  faults: Array<ClaimFault>;
};

export type DirectSettlementClaimResponse = DirectSettlementClaim | Error;

export type DispenseRequest = {
  __typename?: 'DispenseRequest';
  expectedSupplyDuration: Maybe<Scalars['Int']['output']>;
  numberOfRepeats: Maybe<Scalars['Int']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
};

export type DocumentAddedResponse = Error | Success;

export type DocumentDetails = {
  description: InputMaybe<Scalars['String']['input']>;
  type: PreAuthorizationDocumentType;
};

export type DocumentDetailsInput = {
  description: InputMaybe<Scalars['String']['input']>;
  type: DocumentType;
};

export type DocumentDownload = {
  __typename?: 'DocumentDownload';
  url: Scalars['String']['output'];
};

export type DocumentInput = {
  documentLocation: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
};

export enum DocumentType {
  ClaimForm = 'CLAIM_FORM',
  CopyOfSignedBill = 'COPY_OF_SIGNED_BILL',
  IdsNotificationsCertificates = 'IDS_NOTIFICATIONS_CERTIFICATES',
  Invoice = 'INVOICE',
  LetterOfUndertaking = 'LETTER_OF_UNDERTAKING',
  MedicalDoctorRadiologyInvestigationReport = 'MEDICAL_DOCTOR_RADIOLOGY_INVESTIGATION_REPORT',
  Other = 'OTHER',
  PreauthorizationForm = 'PREAUTHORIZATION_FORM'
}

export type Dosage = {
  __typename?: 'Dosage';
  frequencyType: Maybe<FrequencyType>;
  frequencyUnit: Maybe<Scalars['Float']['output']>;
  frequencyValue: Maybe<Scalars['Int']['output']>;
  internalRef: Scalars['String']['output'];
  routeOfAdmin: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type DraftPreAuthorizationFinalizedResponse = Error | ResourceUpdated;

export type Drug = {
  __typename?: 'Drug';
  brandName: Maybe<Scalars['String']['output']>;
  carepayCode: Maybe<Scalars['String']['output']>;
  category: MedicalProductCategory;
  description: Maybe<Scalars['String']['output']>;
  formulation: Maybe<Scalars['String']['output']>;
  generic: Maybe<Scalars['String']['output']>;
  genericCode: Maybe<Scalars['String']['output']>;
  lastUpdated: Maybe<Scalars['String']['output']>;
  medicalCodes: MedicalCodePage;
  name: Maybe<Scalars['String']['output']>;
  packageType: Maybe<Scalars['String']['output']>;
  strength: Maybe<Scalars['String']['output']>;
  tier: Maybe<Scalars['String']['output']>;
  unit: Maybe<Scalars['Float']['output']>;
};


export type DrugMedicalCodesArgs = {
  filter: InputMaybe<CarePageable>;
};

export type DrugFilter = {
  carepayCode: InputMaybe<Scalars['String']['input']>;
  codingSystemName: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  externalCode: InputMaybe<Scalars['String']['input']>;
  formulation: InputMaybe<Scalars['String']['input']>;
  generic: InputMaybe<Scalars['String']['input']>;
  genericCode: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  nameOrExternalCode: InputMaybe<Scalars['String']['input']>;
  packageType: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
  strength: InputMaybe<Scalars['String']['input']>;
  tagIds: InputMaybe<Array<Scalars['String']['input']>>;
  tagTypeIds: InputMaybe<Array<Scalars['String']['input']>>;
  tags: InputMaybe<Array<Scalars['String']['input']>>;
  tier: InputMaybe<Scalars['String']['input']>;
};

export type DrugPage = CarePage & {
  __typename?: 'DrugPage';
  data: Maybe<Array<Drug>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum DrugTier {
  Branded = 'BRANDED',
  Generic = 'GENERIC'
}

export type EmpaneledProvider = {
  __typename?: 'EmpaneledProvider';
  claimsAccount: Scalars['String']['output'];
  code: Scalars['String']['output'];
  contracts: Maybe<EmpaneledProviderContractPage>;
  defaultNetwork: StandardNetwork;
  empaneledDate: Scalars['String']['output'];
  expirationDate: Maybe<Scalars['String']['output']>;
  loansAccount: Maybe<Scalars['String']['output']>;
  nextVersion: Maybe<EmpaneledProvider>;
  payer: Payer;
  provider: Provider;
  status: EmpaneledProviderStatus;
  suspensionDate: Maybe<Scalars['String']['output']>;
  suspensionReason: Maybe<Scalars['String']['output']>;
  terms: PaymentContract;
};


export type EmpaneledProviderContractsArgs = {
  filter: InputMaybe<EmpaneledProviderContractFilter>;
};

export type EmpaneledProviderContract = {
  __typename?: 'EmpaneledProviderContract';
  code: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type EmpaneledProviderContractFilter = {
  codes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
};

export type EmpaneledProviderContractPage = CarePage & {
  __typename?: 'EmpaneledProviderContractPage';
  data: Maybe<Array<Maybe<EmpaneledProviderContract>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type EmpaneledProviderFilter = {
  activeAtDate: InputMaybe<Scalars['String']['input']>;
  codes: InputMaybe<Array<Scalars['String']['input']>>;
  includeParent: InputMaybe<Scalars['Boolean']['input']>;
  networkCodes: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  payerKeys: InputMaybe<Array<Scalars['String']['input']>>;
  paymentAccountCodes: InputMaybe<Array<Scalars['String']['input']>>;
  providerCodes: InputMaybe<Array<Scalars['String']['input']>>;
  providerName: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<EmpaneledProviderStatus>;
};

export type EmpaneledProviderInput = {
  claimsAccount: Scalars['String']['input'];
  defaultNetwork: Scalars['String']['input'];
  empaneledDate: Scalars['String']['input'];
  expirationDate: InputMaybe<Scalars['String']['input']>;
  loansAccount: InputMaybe<Scalars['String']['input']>;
  payer: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  status: EmpaneledProviderStatus;
  terms: InputMaybe<EmpaneledProviderTermsInput>;
};

export type EmpaneledProviderPage = CarePage & {
  __typename?: 'EmpaneledProviderPage';
  data: Maybe<Array<Maybe<EmpaneledProvider>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type EmpaneledProviderResponse = EmpaneledProvider | Error;

export enum EmpaneledProviderStatus {
  Enabled = 'ENABLED',
  Expired = 'EXPIRED',
  Scheduled = 'SCHEDULED',
  Suspended = 'SUSPENDED'
}

export type EmpaneledProviderTermsInput = {
  dateType: DateType;
  delay: Scalars['Int']['input'];
  delayType: DelayType;
};

export type Employee = {
  __typename?: 'Employee';
  activeLicense: Maybe<EmployeeLicense>;
  employeeCode: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  jobRole: JobRole;
  lastName: Scalars['String']['output'];
  pendingVersion: Maybe<Employee>;
  speciality: Maybe<Scalars['String']['output']>;
  status: EmployeeStatus;
};

export type EmployeeFilter = {
  employeeCodes: InputMaybe<Array<Scalars['String']['input']>>;
  firstName: InputMaybe<Scalars['String']['input']>;
  jobRoles: InputMaybe<Array<JobRole>>;
  lastName: InputMaybe<Scalars['String']['input']>;
  licenseNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  providerCodes: InputMaybe<Array<Scalars['String']['input']>>;
  search: InputMaybe<Scalars['String']['input']>;
  specialities: InputMaybe<Array<Scalars['String']['input']>>;
  status: InputMaybe<EmployeeStatus>;
};

export type EmployeeLicense = {
  __typename?: 'EmployeeLicense';
  employeeLicenseCode: Scalars['String']['output'];
  licenseNumber: Scalars['String']['output'];
  pendingVersion: Maybe<EmployeeLicense>;
  validFrom: Scalars['String']['output'];
  validTo: Scalars['String']['output'];
};

export type EmployeeLicenseResponse = EmployeeLicense | Error;

export type EmployeePage = CarePage & {
  __typename?: 'EmployeePage';
  data: Maybe<Array<Maybe<Employee>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type EmployeeSpeciality = {
  __typename?: 'EmployeeSpeciality';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EmployeeSpecialityFilter = {
  code: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
};

export type EmployeeSpecialityPage = CarePage & {
  __typename?: 'EmployeeSpecialityPage';
  data: Maybe<Array<Maybe<EmployeeSpeciality>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum EmployeeStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type EmployeeStatusResponse = Error | Success;

export type EmployeeTemplate = {
  __typename?: 'EmployeeTemplate';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Employment = {
  __typename?: 'Employment';
  commission: Maybe<Scalars['Boolean']['output']>;
  department: Maybe<Scalars['String']['output']>;
  employeeCode: Maybe<Scalars['String']['output']>;
  profession: Maybe<Scalars['String']['output']>;
  salary: Maybe<Scalars['String']['output']>;
  workCountry: Maybe<Country>;
  workCounty: Maybe<GeolocationLevelOne>;
  workLocation: Maybe<GeolocationLevelTwo>;
};

export type EmploymentInput = {
  commission: InputMaybe<Scalars['Boolean']['input']>;
  department: InputMaybe<Scalars['String']['input']>;
  employeeCode: InputMaybe<Scalars['String']['input']>;
  profession: InputMaybe<Scalars['String']['input']>;
  salary: InputMaybe<Scalars['String']['input']>;
  workCountryCode: InputMaybe<Scalars['String']['input']>;
  workCountyCode: InputMaybe<Scalars['String']['input']>;
  workLocationCode: InputMaybe<Scalars['String']['input']>;
};

export type EndorsementAction = {
  actionType: EndorsementActionType;
  date: Scalars['String']['input'];
  dependentIds: InputMaybe<Array<Scalars['String']['input']>>;
  reason: InputMaybe<Scalars['String']['input']>;
};

export enum EndorsementActionType {
  Decease = 'DECEASE',
  LiftSuspension = 'LIFT_SUSPENSION',
  Suspend = 'SUSPEND',
  Terminate = 'TERMINATE'
}

export type EndorsementActionValidationDetails = {
  __typename?: 'EndorsementActionValidationDetails';
  endDateRange: Maybe<Scalars['String']['output']>;
  errorCode: Maybe<Scalars['String']['output']>;
  startDateRange: Maybe<Scalars['String']['output']>;
};

export type EndorsementActionWithReason = {
  endorsementAction: EndorsementAction;
  reasonType: InputMaybe<Scalars['String']['input']>;
};

export type EndorsementBeneficiaryCategoryGrouping = {
  __typename?: 'EndorsementBeneficiaryCategoryGrouping';
  beneficiaryPremiumCalculations: Maybe<Array<EndorsementBeneficiaryPremiumCalculation>>;
  category: Category;
  categoryTotalPremium: Scalars['Float']['output'];
  endorsementCategoryTotalPremium: Scalars['Float']['output'];
  numberOfBeneficiaries: Scalars['Int']['output'];
  plan: Plan;
};

export type EndorsementBeneficiaryPremiumCalculation = {
  __typename?: 'EndorsementBeneficiaryPremiumCalculation';
  beneficiaryPremiumCalculation: Maybe<BeneficiaryPremiumCalculation>;
  endorsementPremium: Scalars['Float']['output'];
};

export type EndorsementDocument = {
  __typename?: 'EndorsementDocument';
  description: Maybe<Scalars['String']['output']>;
  documentKey: Scalars['String']['output'];
  type: BeneficiaryDocumentType;
};

export type EndorsementPremiumCalculation = {
  __typename?: 'EndorsementPremiumCalculation';
  beneficiaryCategoryGroupings: Maybe<Array<EndorsementBeneficiaryCategoryGrouping>>;
  calculationErrors: Maybe<Array<PremiumCalculationError>>;
  currency: Scalars['String']['output'];
  discount: Scalars['Float']['output'];
  endorsementGrossTotalPremium: Scalars['Float']['output'];
  endorsementNetTotalPremium: Scalars['Float']['output'];
  fees: Maybe<Array<PremiumCalculationFee>>;
  grossTotalPremium: Scalars['Float']['output'];
  intermediary: Maybe<Scalars['String']['output']>;
  netTotalPremium: Scalars['Float']['output'];
  paymentFrequency: PremiumPaymentFrequency;
  policy: Policy;
  premiumTableVersion: Scalars['String']['output'];
  totalInsuranceLevy: Scalars['Float']['output'];
  vat: Scalars['Float']['output'];
  vatPercentage: Scalars['Float']['output'];
};

export enum EndorsementStatus {
  Approved = 'APPROVED',
  Open = 'OPEN',
  PendingApproval = 'PENDING_APPROVAL',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

export enum EndorsementType {
  Addition = 'ADDITION',
  CategoryChange = 'CATEGORY_CHANGE',
  CoverageChange = 'COVERAGE_CHANGE',
  Deceased = 'DECEASED',
  Extension = 'EXTENSION',
  Kyc = 'KYC',
  LiftSuspension = 'LIFT_SUSPENSION',
  PolicyholderChange = 'POLICYHOLDER_CHANGE',
  PolicyDetailsChange = 'POLICY_DETAILS_CHANGE',
  Reinstatement = 'REINSTATEMENT',
  Suspension = 'SUSPENSION',
  Termination = 'TERMINATION'
}

export enum EndorsementWorkflowAction {
  Approve = 'APPROVE',
  Reject = 'REJECT',
  Reopen = 'REOPEN',
  Request = 'REQUEST'
}

export type EndorsementWorkflowActionInput = {
  action: EndorsementWorkflowAction;
  endorsementIds: Array<Scalars['String']['input']>;
  policyId: Scalars['String']['input'];
  reason: InputMaybe<Scalars['String']['input']>;
};

export type EndorsementWorkflowActionLog = {
  __typename?: 'EndorsementWorkflowActionLog';
  createdBy: User;
  dateCreated: Scalars['String']['output'];
  role: Scalars['String']['output'];
  status: EndorsementStatus;
  tier: Scalars['Int']['output'];
};

export type EndorsementWorkflowActions = {
  __typename?: 'EndorsementWorkflowActions';
  allowedActions: Maybe<Array<EndorsementWorkflowAction>>;
  lastAction: Maybe<EndorsementWorkflowActionLog>;
};

export type Error = {
  __typename?: 'Error';
  message: Scalars['String']['output'];
  params: Maybe<Array<Maybe<ErrorParam>>>;
};

export type ErrorParam = {
  __typename?: 'ErrorParam';
  param: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type EvaluateEndorsementPremiumsInput = {
  actionDate: InputMaybe<Scalars['String']['input']>;
  beneficiaryPolicyIds: InputMaybe<Array<Scalars['String']['input']>>;
  policyChangeType: InputMaybe<PremiumCalculationPolicyChangeType>;
  policyId: Scalars['String']['input'];
};

export type EvaluatedEndorsementResponse = EndorsementPremiumCalculation | Error;

export type ExchangeRates = {
  __typename?: 'ExchangeRates';
  ask: Maybe<Scalars['Float']['output']>;
  bid: Maybe<Scalars['Float']['output']>;
  mid: Maybe<Scalars['Float']['output']>;
};

export type Exclusion = {
  __typename?: 'Exclusion';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type ExclusionPage = CarePage & {
  __typename?: 'ExclusionPage';
  data: Array<Exclusion>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum ExpenseType {
  Actual = 'ACTUAL',
  ReasonableAndCustomary = 'REASONABLE_AND_CUSTOMARY'
}

export type ExternalCodeInput = {
  reference: InputMaybe<Scalars['String']['input']>;
  source: InputMaybe<Scalars['String']['input']>;
};

export type ExternalCommunication = {
  documentReferences: InputMaybe<Array<Scalars['String']['input']>>;
  emailAddress: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type ExtraInfo = {
  __typename?: 'ExtraInfo';
  type: Maybe<ExtraInfoType>;
  value: Maybe<ExtraInfoValue>;
};

export type ExtraInfoInput = {
  type: InputMaybe<ExtraInfoType>;
  value: InputMaybe<ExtraInfoValue>;
};

export enum ExtraInfoType {
  Poa = 'POA',
  Unknown = 'UNKNOWN'
}

export enum ExtraInfoValue {
  ClinicallyUndetermined = 'CLINICALLY_UNDETERMINED',
  False = 'FALSE',
  Invalid = 'INVALID',
  OutpatientClaim = 'OUTPATIENT_CLAIM',
  True = 'TRUE',
  Unknown = 'UNKNOWN',
  UnreportedNotUsed = 'UNREPORTED_NOT_USED'
}

export type FamilyComposition = {
  __typename?: 'FamilyComposition';
  familyMemberTypes: Maybe<Array<FamilyMemberType>>;
  maxFamilySize: Maybe<Scalars['Int']['output']>;
};

export type FamilyCompositionInput = {
  familyMemberTypes: InputMaybe<Array<FamilyMemberTypeInput>>;
  maxFamilySize: InputMaybe<Scalars['Int']['input']>;
};

export type FamilyCompositionPage = CarePage & {
  __typename?: 'FamilyCompositionPage';
  data: Maybe<Array<ProductFamilyComposition>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type FamilyCompositionResponse = Error | ProductFamilyComposition;

export type FamilyMemberType = {
  __typename?: 'FamilyMemberType';
  ageFrom: Maybe<Scalars['Int']['output']>;
  ageTo: Maybe<Scalars['Int']['output']>;
  civilStatus: Maybe<Array<CoverageCivilStatus>>;
  genders: Maybe<Array<CoverageGender>>;
  maxCount: Maybe<Scalars['Int']['output']>;
  occupations: Maybe<Array<CoverageOccupation>>;
  relationship: Maybe<CoverageRelationship>;
};

export type FamilyMemberTypeInput = {
  ageFrom: InputMaybe<Scalars['Int']['input']>;
  ageTo: InputMaybe<Scalars['Int']['input']>;
  civilStatus: InputMaybe<Array<CoverageCivilStatus>>;
  genders: InputMaybe<Array<CoverageGender>>;
  maxCount: InputMaybe<Scalars['Int']['input']>;
  occupations: InputMaybe<Array<CoverageOccupation>>;
  relationship: InputMaybe<CoverageRelationship>;
};

export type FaultRequest = {
  code: Scalars['String']['input'];
  description: InputMaybe<Scalars['String']['input']>;
};

export enum FaultStatus {
  Applicable = 'APPLICABLE',
  NotApplicable = 'NOT_APPLICABLE'
}

export type FileDownload = {
  __typename?: 'FileDownload';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FileLink = {
  __typename?: 'FileLink';
  errorFileLink: Maybe<Scalars['String']['output']>;
  errorFilename: Maybe<Scalars['String']['output']>;
  initialFileLink: Maybe<Scalars['String']['output']>;
  initialFilename: Maybe<Scalars['String']['output']>;
};

export enum FileProcessingStatus {
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum FileStatus {
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type FileUpload = {
  __typename?: 'FileUpload';
  fileId: Scalars['String']['output'];
  status: FileStatus;
};

export type FileUploadResponse = Error | FileUpload;

export type FilterParty = {
  __typename?: 'FilterParty';
  accountNumber: Maybe<Scalars['String']['output']>;
  alias: Maybe<Scalars['String']['output']>;
};

export type FinalizeClaimResponse = Error | Success;

export type FinalizeDraftPreAuthorization = {
  diagnoses: Array<CreatePreAuthDiagnosis>;
  items: Array<CreatePreAuthorizationItem>;
};

export enum FingerType {
  IndexLeft = 'INDEX_LEFT',
  IndexRight = 'INDEX_RIGHT',
  LittleLeft = 'LITTLE_LEFT',
  LittleRight = 'LITTLE_RIGHT',
  MiddleLeft = 'MIDDLE_LEFT',
  MiddleRight = 'MIDDLE_RIGHT',
  RingLeft = 'RING_LEFT',
  RingRight = 'RING_RIGHT',
  ThumbLeft = 'THUMB_LEFT',
  ThumbRight = 'THUMB_RIGHT'
}

export type FingerprintCreated = {
  __typename?: 'FingerprintCreated';
  createdAt: Scalars['String']['output'];
  finger: FingerType;
};

export type FingerprintCreatedResponse = Error | FingerprintCreated;

export type FingerprintPerson = {
  __typename?: 'FingerprintPerson';
  fingerprintStatus: FingerprintStatus;
  fingerprints: Maybe<Array<Maybe<PersonFingerprint>>>;
  personRef: Scalars['String']['output'];
};

export type FingerprintPersonResponse = Error | FingerprintPerson;

export type FingerprintResetResponse = Error | Success;

export enum FingerprintStatus {
  Incomplete = 'INCOMPLETE',
  Valid = 'VALID'
}

export type FingerprintVerificationResponse = Error | FingerprintVerified;

export type FingerprintVerified = {
  __typename?: 'FingerprintVerified';
  createdAt: Maybe<Scalars['String']['output']>;
  match: Maybe<Scalars['Boolean']['output']>;
  score: Maybe<Scalars['Float']['output']>;
  verificationRef: Maybe<Scalars['String']['output']>;
};

export type Formulation = {
  __typename?: 'Formulation';
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type FormulationsFilter = {
  name: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
};

export type FormulationsPage = CarePage & {
  __typename?: 'FormulationsPage';
  data: Maybe<Array<Formulation>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum FrequencyType {
  Day = 'DAY',
  Hour = 'HOUR',
  Once = 'ONCE',
  Other = 'OTHER',
  Week = 'WEEK'
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

export type GenderBaseRate = BaseRate & {
  __typename?: 'GenderBaseRate';
  ageFrom: Scalars['Int']['output'];
  ageTo: Scalars['Int']['output'];
  rateFemale: MonetaryAmount;
  rateMale: MonetaryAmount;
  type: BaseRateType;
};

export type GenderBaseRateInput = {
  ageFrom: Scalars['Int']['input'];
  ageTo: Scalars['Int']['input'];
  rateFemale: MonetaryAmountInput;
  rateMale: MonetaryAmountInput;
};

export type GenderBaseRatesInput = {
  rates: Array<GenderBaseRateInput>;
};

export type GeolocationLevelOne = {
  __typename?: 'GeolocationLevelOne';
  code: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  geolocationLevelTwos: Maybe<GeolocationLevelTwoPage>;
  name: Maybe<Scalars['String']['output']>;
};


export type GeolocationLevelOneGeolocationLevelTwosArgs = {
  filter: InputMaybe<CarePageable>;
};

export type GeolocationLevelOneFilter = {
  countryCodes: InputMaybe<Array<Scalars['String']['input']>>;
  levelOneCodes: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  search: InputMaybe<Scalars['String']['input']>;
};

export type GeolocationLevelOnePage = CarePage & {
  __typename?: 'GeolocationLevelOnePage';
  data: Maybe<Array<GeolocationLevelOne>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type GeolocationLevelTwo = {
  __typename?: 'GeolocationLevelTwo';
  code: Maybe<Scalars['String']['output']>;
  geolocationLevelOne: Maybe<GeolocationLevelOne>;
  locationCodes: Maybe<Array<LocationCode>>;
  name: Maybe<Scalars['String']['output']>;
};

export type GeolocationLevelTwoFilter = {
  levelOneCodes: InputMaybe<Array<Scalars['String']['input']>>;
  levelTwoCodes: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  search: InputMaybe<Scalars['String']['input']>;
};

export type GeolocationLevelTwoPage = CarePage & {
  __typename?: 'GeolocationLevelTwoPage';
  data: Maybe<Array<GeolocationLevelTwo>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type GeolocationRegion = {
  __typename?: 'GeolocationRegion';
  code: Scalars['String']['output'];
  countries: Maybe<Array<Country>>;
  name: Scalars['String']['output'];
};

export type GeolocationRegionPage = CarePage & {
  __typename?: 'GeolocationRegionPage';
  data: Maybe<Array<GeolocationRegion>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type GroupParty = {
  __typename?: 'GroupParty';
  addresses: Maybe<Array<PolicyholderAddress>>;
  companyEstablishmentCardNumber: Maybe<Scalars['String']['output']>;
  companyIncorporationCountry: Maybe<Region>;
  companyName: Maybe<Scalars['String']['output']>;
  documents: Maybe<Array<PolicyholderDocument>>;
  establishmentType: Maybe<Scalars['String']['output']>;
  externalReferences: Maybe<Array<PolicyholderExternalReference>>;
  financialDetails: Maybe<PolicyholderBankAccount>;
  industry: Maybe<Industry>;
  parentPolicyholder: Maybe<GroupParty>;
  partyAdmin: Maybe<PartyAdmin>;
  partySubtype: PartySubtype;
  partyType: PartyType;
  payerKeys: Maybe<Array<Scalars['String']['output']>>;
  policyHolderId: Scalars['String']['output'];
  risk: Maybe<PartyRisk>;
  taxRegistrationNumber: Maybe<Scalars['String']['output']>;
  tradeLicenseNumber: Maybe<Scalars['String']['output']>;
  vatNumber: Maybe<Scalars['String']['output']>;
};

export type GroupPartyFilter = {
  page: InputMaybe<CarePageable>;
  parentPolicyholderIds: InputMaybe<Array<Scalars['String']['input']>>;
  payerIds: InputMaybe<Array<Scalars['String']['input']>>;
  policyHolderRelation: InputMaybe<PolicyHolderRelationEnum>;
  policyIds: InputMaybe<Array<Scalars['String']['input']>>;
  policyholderIds: InputMaybe<Array<Scalars['String']['input']>>;
  search: InputMaybe<Scalars['String']['input']>;
};

export type GroupPartyInput = {
  addresses: InputMaybe<Array<PolicyholderAddressInput>>;
  companyEstablishmentCardNumber: InputMaybe<Scalars['String']['input']>;
  companyIncorporationCountryCode: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  establishmentType: InputMaybe<Scalars['String']['input']>;
  externalReferences: InputMaybe<Array<PolicyholderExternalReferenceInput>>;
  financialDetails: InputMaybe<PolicyholderBankAccountInput>;
  industryId: InputMaybe<Scalars['Int']['input']>;
  parentPolicyholderId: InputMaybe<Scalars['String']['input']>;
  partyAdmin: InputMaybe<PartyAdminInput>;
  risk: InputMaybe<PartyRiskInput>;
  taxRegistrationNumber: InputMaybe<Scalars['String']['input']>;
  tradeLicenseNumber: InputMaybe<Scalars['String']['input']>;
  vatNumber: InputMaybe<Scalars['String']['input']>;
};

export type GroupPartyPage = CarePage & {
  __typename?: 'GroupPartyPage';
  data: Maybe<Array<GroupParty>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type GroupPartyResponse = Error | GroupParty;

export type HealthcareService = {
  __typename?: 'HealthcareService';
  name: Scalars['String']['output'];
};

export type HealthcareServicePage = CarePage & {
  __typename?: 'HealthcareServicePage';
  data: Maybe<Array<HealthcareService>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type HealthcareServicesFilter = {
  name: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
};

export type HealthcareSpeciality = {
  __typename?: 'HealthcareSpeciality';
  name: Scalars['String']['output'];
};

export type HealthcareSpecialityFilter = {
  name: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
};

export type HealthcareSpecialityPage = CarePage & {
  __typename?: 'HealthcareSpecialityPage';
  data: Maybe<Array<HealthcareSpeciality>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type Identification = {
  __typename?: 'Identification';
  number: Scalars['String']['output'];
  type: IdentificationType;
};

export type IdentificationInput = {
  number: Scalars['String']['input'];
  type: IdentificationType;
};

export enum IdentificationMethod {
  Fingerprint = 'FINGERPRINT',
  None = 'NONE',
  Otp = 'OTP'
}

export enum IdentificationType {
  BirthCertificateId = 'BIRTH_CERTIFICATE_ID',
  NationalId = 'NATIONAL_ID',
  Passport = 'PASSPORT',
  ResidentId = 'RESIDENT_ID',
  VisaFileNumber = 'VISA_FILE_NUMBER'
}

export type IdentifierInput = {
  reference: Scalars['String']['input'];
  source: InputMaybe<Scalars['String']['input']>;
};

export type Inclusion = {
  __typename?: 'Inclusion';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type InclusionExclusionFilter = {
  page: InputMaybe<CarePageable>;
  policyId: Scalars['String']['input'];
};

export type InclusionPage = CarePage & {
  __typename?: 'InclusionPage';
  data: Array<Inclusion>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type IndividualParty = {
  __typename?: 'IndividualParty';
  address: Maybe<PolicyholderAddress>;
  documents: Maybe<Array<PolicyholderDocument>>;
  entityId: Maybe<Scalars['String']['output']>;
  entityType: Maybe<PolicyholderEntityType>;
  externalReferences: Maybe<Array<PolicyholderExternalReference>>;
  identification: Maybe<PolicyholderIdentification>;
  name: Scalars['String']['output'];
  partySubtype: PartySubtype;
  partyType: PartyType;
  policyHolderId: Scalars['String']['output'];
  primaryBeneficiary: Maybe<BeneficiaryPolicy>;
  risk: Maybe<PartyRisk>;
  sponsor: Maybe<SponsorParty>;
  taxRegistrationNumber: Maybe<Scalars['String']['output']>;
};

export type IndividualPartyInput = {
  address: InputMaybe<PolicyholderAddressInput>;
  entityId: InputMaybe<Scalars['String']['input']>;
  entityType: InputMaybe<PolicyholderEntityType>;
  externalReferences: InputMaybe<Array<PolicyholderExternalReferenceInput>>;
  identification: InputMaybe<PolicyholderIdentificationInput>;
  name: Scalars['String']['input'];
  risk: InputMaybe<PartyRiskInput>;
  sponsor: InputMaybe<SponsorPartyInput>;
  taxRegistrationNumber: InputMaybe<Scalars['String']['input']>;
};

export type IndividualPartyResponse = Error | IndividualParty;

export type Industry = {
  __typename?: 'Industry';
  industryId: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type IndustryFilter = {
  page: InputMaybe<CarePageable>;
  search: InputMaybe<Scalars['String']['input']>;
};

export type IndustryPage = CarePage & {
  __typename?: 'IndustryPage';
  data: Maybe<Array<Maybe<Industry>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum InstallmentSurchargePaymentTerm {
  Monthly = 'MONTHLY',
  Once = 'ONCE',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  Yearly = 'YEARLY'
}

export type Instalment = {
  __typename?: 'Instalment';
  instalmentAmount: Maybe<MonetaryAmount>;
  instalmentPercentage: Maybe<Scalars['Float']['output']>;
  paymentTerm: InstallmentSurchargePaymentTerm;
  policyType: InstalmentPolicyType;
};

export type InstalmentFilter = {
  policyType: InputMaybe<InstalmentPolicyType>;
};

export type InstalmentInput = {
  instalmentAmount: InputMaybe<MonetaryAmountInput>;
  instalmentPercentage: InputMaybe<Scalars['Float']['input']>;
  paymentTerm: InstallmentSurchargePaymentTerm;
  policyType: InstalmentPolicyType;
};

export enum InstalmentPolicyType {
  Group = 'GROUP',
  Retail = 'RETAIL',
  Sme = 'SME'
}

export type Instalments = {
  __typename?: 'Instalments';
  data: Array<Instalment>;
};

export type InstalmentsInput = {
  instalments: InputMaybe<Array<InstalmentInput>>;
};

export type InstalmentsResponse = Error | Instalments;

export type Intermediary = {
  __typename?: 'Intermediary';
  addresses: Maybe<Array<PayerAddress>>;
  bankAccounts: Maybe<Array<PayerBankAccount>>;
  contacts: Maybe<Array<PayerContact>>;
  createdBy: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  documents: Maybe<Array<PayerDocument>>;
  email: Scalars['String']['output'];
  externalCodes: Maybe<Array<PayerExternalCode>>;
  firstName: Maybe<Scalars['String']['output']>;
  identification: Scalars['String']['output'];
  identificationType: IntermediaryIdentificationType;
  key: Scalars['String']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  payers: Maybe<IntermediaryContractsPage>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  status: IntermediaryStatus;
  taxRegistrationNumber: Maybe<Scalars['String']['output']>;
  type: IntermediaryType;
  users: Maybe<IntermediaryUserPage>;
};


export type IntermediaryPayersArgs = {
  filter: InputMaybe<PayerContractFilter>;
};


export type IntermediaryUsersArgs = {
  filter: InputMaybe<IntermediaryUserFilter>;
};

export type IntermediaryContract = {
  __typename?: 'IntermediaryContract';
  createdBy: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  intermediary: Intermediary;
  modifiedBy: Maybe<Scalars['String']['output']>;
  payer: Payer;
  status: IntermediaryContractStatus;
};

export type IntermediaryContractFilter = {
  intermediaryKeys: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  search: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<IntermediaryContractStatus>>;
};

export enum IntermediaryContractStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type IntermediaryContractsPage = CarePage & {
  __typename?: 'IntermediaryContractsPage';
  data: Maybe<Array<IntermediaryContract>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type IntermediaryDeleteResponse = Error | Success;

export type IntermediaryFilter = {
  codes: InputMaybe<Array<Scalars['String']['input']>>;
  keys: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  search: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<IntermediaryStatus>>;
  systems: InputMaybe<Array<Scalars['String']['input']>>;
  types: InputMaybe<Array<IntermediaryType>>;
};

export enum IntermediaryIdentificationType {
  LicenseNumber = 'LICENSE_NUMBER',
  NationalId = 'NATIONAL_ID',
  StaffNumber = 'STAFF_NUMBER'
}

export type IntermediaryLicense = {
  __typename?: 'IntermediaryLicense';
  createdBy: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  generatedFileName: Scalars['String']['output'];
  licenseIssuer: Scalars['String']['output'];
  licenseKey: Scalars['String']['output'];
  licenseNumber: Scalars['String']['output'];
  licenseType: Scalars['String']['output'];
  modifiedBy: Maybe<Scalars['String']['output']>;
  originalFileName: Scalars['String']['output'];
  registeredDate: Maybe<Scalars['String']['output']>;
  registeredName: Scalars['String']['output'];
  status: IntermediaryLicenseStatus;
  validFrom: Scalars['String']['output'];
  validTo: Scalars['String']['output'];
};

export type IntermediaryLicenseFilter = {
  licenseKeys: InputMaybe<Array<Scalars['String']['input']>>;
  licenseNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  licenseTypes: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  statuses: InputMaybe<Array<IntermediaryLicenseStatus>>;
};

export type IntermediaryLicenseInput = {
  licenseIssuer: Scalars['String']['input'];
  licenseNumber: Scalars['String']['input'];
  licenseType: Scalars['String']['input'];
  registeredDate: InputMaybe<Scalars['String']['input']>;
  registeredName: Scalars['String']['input'];
  validFrom: Scalars['String']['input'];
  validTo: Scalars['String']['input'];
};

export type IntermediaryLicenseResponse = Error | IntermediaryLicense;

export enum IntermediaryLicenseStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Scheduled = 'SCHEDULED'
}

export type IntermediaryLicensesPage = CarePage & {
  __typename?: 'IntermediaryLicensesPage';
  data: Maybe<Array<IntermediaryLicense>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type IntermediaryPage = CarePage & {
  __typename?: 'IntermediaryPage';
  data: Maybe<Array<Intermediary>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type IntermediaryResponse = Error | Intermediary;

export enum IntermediaryRole {
  IntermediaryAdmin = 'INTERMEDIARY_ADMIN',
  IntermediaryBrokerAgent = 'INTERMEDIARY_BROKER_AGENT',
  IntermediaryBrokerUnderwriter = 'INTERMEDIARY_BROKER_UNDERWRITER',
  IntermediaryDirectAgent = 'INTERMEDIARY_DIRECT_AGENT',
  IntermediaryIndependentAgent = 'INTERMEDIARY_INDEPENDENT_AGENT'
}

export enum IntermediaryStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Pending = 'PENDING',
  Suspended = 'SUSPENDED'
}

export enum IntermediaryType {
  Bancassurance = 'BANCASSURANCE',
  Broker = 'BROKER',
  Direct = 'DIRECT',
  Independent = 'INDEPENDENT'
}

export type IntermediaryUser = {
  __typename?: 'IntermediaryUser';
  intermediary: Intermediary;
  roles: Array<IntermediaryUserRole>;
  user: User;
};

export type IntermediaryUserFilter = {
  page: InputMaybe<CarePageable>;
  roles: InputMaybe<Array<IntermediaryRole>>;
  userKeys: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IntermediaryUserPage = CarePage & {
  __typename?: 'IntermediaryUserPage';
  data: Maybe<Array<IntermediaryUser>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type IntermediaryUserResponse = Error | IntermediaryUser;

export type IntermediaryUserRole = {
  __typename?: 'IntermediaryUserRole';
  createdBy: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Scalars['String']['output']>;
  role: IntermediaryRole;
};

export type InviteIntermediaryUserInput = {
  email: Scalars['String']['input'];
  role: IntermediaryRole;
  url: InputMaybe<Scalars['String']['input']>;
};

export type InvitePayerUserInput = {
  email: Scalars['String']['input'];
  role: PayerRole;
  url: InputMaybe<Scalars['String']['input']>;
};

export type InviteUserResponse = Error | User;

export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Float']['output'];
  calculationCode: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dueDate: Scalars['String']['output'];
  invoiceCode: Scalars['String']['output'];
  invoiceNumber: Scalars['Float']['output'];
  invoiceType: PremiumInvoiceType;
  paymentFrequency: PremiumPaymentFrequency;
  policyId: Scalars['String']['output'];
  status: PremiumInvoiceStatus;
};

export type InvoiceAddedResponse = Error | Success;

export type InvoiceFilter = {
  dueDate: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
  policyId: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<PremiumInvoiceStatus>;
};

export type InvoiceItemAddedResponse = Error | Success;

export type InvoiceItemRemovedResponse = Error | Success;

export type InvoicePage = CarePage & {
  __typename?: 'InvoicePage';
  data: Maybe<Array<Invoice>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum IsiroPaymentStatus {
  Approved = 'APPROVED',
  Created = 'CREATED',
  Executed = 'EXECUTED',
  Executing = 'EXECUTING',
  Rejected = 'REJECTED',
  Suspended = 'SUSPENDED'
}

export enum IsiroPaymentType {
  Cashless = 'CASHLESS',
  Creditnote = 'CREDITNOTE',
  Debitnote = 'DEBITNOTE',
  DirectSettlement = 'DIRECT_SETTLEMENT',
  Reimbursement = 'REIMBURSEMENT'
}

export enum IssuingAuthority {
  Amacl = 'AMACL',
  Coc = 'COC',
  Ded = 'DED',
  Dha = 'DHA',
  Doh = 'DOH',
  Ed = 'ED',
  Kenra = 'KENRA',
  Kmlttb = 'KMLTTB',
  Kmpdc = 'KMPDC',
  Kndi = 'KNDI',
  Kra = 'KRA',
  Moh = 'MOH',
  Mpdc = 'MPDC',
  Municipality = 'MUNICIPALITY',
  Nck = 'NCK',
  Nqcl = 'NQCL',
  Otck = 'OTCK',
  Pck = 'PCK',
  Ppb = 'PPB',
  Roc = 'ROC',
  Rpb = 'RPB'
}

export enum ItemOverrideReason {
  ExceedingMaximumDosage = 'EXCEEDING_MAXIMUM_DOSAGE',
  Other = 'OTHER'
}

export type ItemPriceAdjustment = {
  id: Scalars['String']['input'];
  modifierAmount: InputMaybe<Scalars['Float']['input']>;
  modifierType: InputMaybe<ModifierType>;
};

export type ItemPricing = {
  __typename?: 'ItemPricing';
  basePrice: Maybe<MonetaryAmount>;
  discount: Maybe<ModifierType>;
  discountValue: Maybe<Scalars['Float']['output']>;
  negotiatedPrice: Maybe<MonetaryAmount>;
  productCode: Maybe<Scalars['String']['output']>;
  regulatoryPrice: Maybe<MonetaryAmount>;
};

export enum ItemStatus {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  PartiallyApproved = 'PARTIALLY_APPROVED',
  Rejected = 'REJECTED',
  Resubmitted = 'RESUBMITTED',
  Submitted = 'SUBMITTED'
}

export type ItemsPricingFilter = {
  beneficiaryReference: InputMaybe<Scalars['String']['input']>;
  claimReference: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  payerReference: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use policyProductReference instead */
  planReference: InputMaybe<Scalars['String']['input']>;
  policyProductCategoryReference: InputMaybe<Scalars['String']['input']>;
  policyProductReference: InputMaybe<Scalars['String']['input']>;
  productCodes: InputMaybe<Array<Scalars['String']['input']>>;
  providerReference: Scalars['String']['input'];
  source: InputMaybe<Scalars['String']['input']>;
  visitType: InputMaybe<VisitStartType>;
};

export enum JobRole {
  Clinician = 'CLINICIAN'
}

export type LastBulkUploadStatusFilter = {
  policyId: InputMaybe<Scalars['String']['input']>;
  types: Array<BulkUploadType>;
};

export type Levy = {
  __typename?: 'Levy';
  levyAmount: Maybe<MonetaryAmount>;
  levyPercentage: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  type: LevyType;
};

export type LevyAmountAndPercentage = {
  __typename?: 'LevyAmountAndPercentage';
  levy: PremiumPercentageAndAmount;
  name: Scalars['String']['output'];
};

export type LevyInput = {
  levyAmount: InputMaybe<MonetaryAmountInput>;
  levyPercentage: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  type: LevyType;
};

export enum LevyType {
  FlatAmount = 'FLAT_AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type Loading = {
  __typename?: 'Loading';
  levies: Maybe<Array<Levy>>;
  vat: Maybe<Scalars['Float']['output']>;
};

export type LoadingInput = {
  levies: InputMaybe<Array<LevyInput>>;
  vat: InputMaybe<Scalars['Float']['input']>;
};

export type LoadingResponse = Error | Loading;

export type LocationCode = {
  __typename?: 'LocationCode';
  code: Scalars['String']['output'];
  system: Scalars['String']['output'];
};

export type MappedMedicalCodeResponse = Error | MedicalCode;

export enum MaritalStatus {
  Divorced = 'DIVORCED',
  Married = 'MARRIED',
  Single = 'SINGLE',
  Widowed = 'WIDOWED'
}

export type MedicalApplicationForm = {
  __typename?: 'MedicalApplicationForm';
  conditions: Maybe<Array<Condition>>;
  signatureDate: Scalars['String']['output'];
};

export type MedicalCode = {
  __typename?: 'MedicalCode';
  /** @deprecated use medicalProduct instead */
  carepayCode: Maybe<Scalars['String']['output']>;
  codingSystem: CodingSystem;
  comment: Maybe<Scalars['String']['output']>;
  dateCreated: Maybe<Scalars['String']['output']>;
  drug: Maybe<Drug>;
  effectiveDate: Maybe<Scalars['String']['output']>;
  expiryDate: Maybe<Scalars['String']['output']>;
  externalCode: Maybe<Scalars['String']['output']>;
  externalDescription: Maybe<Scalars['String']['output']>;
  externalDescriptionLong: Maybe<Scalars['String']['output']>;
  externalName: Maybe<Scalars['String']['output']>;
  group: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isChronic: Maybe<Scalars['Boolean']['output']>;
  isControlled: Maybe<Scalars['Boolean']['output']>;
  lastUpdated: Maybe<Scalars['String']['output']>;
  medicalProduct: Maybe<MedicalProduct>;
  tags: Maybe<Array<MedicalTag>>;
  terminationDate: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type MedicalCodeAndProductRequest = {
  carepayCode: InputMaybe<Scalars['String']['input']>;
  category: MedicalProductCategory;
  codingSystemId: Scalars['String']['input'];
  effectiveDate: Scalars['String']['input'];
  expiryDate: InputMaybe<Scalars['String']['input']>;
  externalCode: Scalars['String']['input'];
  externalDescription: Scalars['String']['input'];
  externalName: Scalars['String']['input'];
  formulationId: InputMaybe<Scalars['String']['input']>;
  generic: InputMaybe<Scalars['String']['input']>;
  genericCode: InputMaybe<Scalars['String']['input']>;
  isChronic: InputMaybe<Scalars['Boolean']['input']>;
  isControlled: InputMaybe<Scalars['Boolean']['input']>;
  packageTypeId: InputMaybe<Scalars['String']['input']>;
  strengthId: InputMaybe<Scalars['String']['input']>;
  tier: InputMaybe<DrugTier>;
  unit: InputMaybe<Scalars['Float']['input']>;
};

export type MedicalCodeFilter = {
  activeAtDate: InputMaybe<Scalars['String']['input']>;
  carepayCodes: InputMaybe<Array<Scalars['String']['input']>>;
  codingSystemId: InputMaybe<Scalars['String']['input']>;
  codingSystemName: InputMaybe<Scalars['String']['input']>;
  externalCode: InputMaybe<Scalars['String']['input']>;
  externalDescription: InputMaybe<Scalars['String']['input']>;
  externalName: InputMaybe<Scalars['String']['input']>;
  externalNameOrExternalCode: InputMaybe<Scalars['String']['input']>;
  isChronic: InputMaybe<Scalars['Boolean']['input']>;
  isControlled: InputMaybe<Scalars['Boolean']['input']>;
  page: InputMaybe<CarePageable>;
  tagIds: InputMaybe<Array<Scalars['String']['input']>>;
  tagTypeIds: InputMaybe<Array<Scalars['String']['input']>>;
  tags: InputMaybe<Array<Scalars['String']['input']>>;
  unmapped: InputMaybe<Scalars['Boolean']['input']>;
};

export type MedicalCodePage = CarePage & {
  __typename?: 'MedicalCodePage';
  data: Maybe<Array<MedicalCode>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type MedicalCodeUpdateInput = {
  effectiveDate: InputMaybe<Scalars['String']['input']>;
  expiryDate: InputMaybe<Scalars['String']['input']>;
  externalDescription: InputMaybe<Scalars['String']['input']>;
  externalName: InputMaybe<Scalars['String']['input']>;
  isChronic: InputMaybe<Scalars['Boolean']['input']>;
  isControlled: InputMaybe<Scalars['Boolean']['input']>;
};

export type MedicalCodes = {
  __typename?: 'MedicalCodes';
  data: Maybe<Array<MedicalCode>>;
};

export type MedicalNoteInput = {
  message: InputMaybe<Scalars['String']['input']>;
};

export type MedicalProduct = {
  __typename?: 'MedicalProduct';
  carepayCode: Maybe<Scalars['String']['output']>;
  category: MedicalProductCategory;
  description: Maybe<Scalars['String']['output']>;
  medicalCodes: MedicalCodePage;
  name: Maybe<Scalars['String']['output']>;
};


export type MedicalProductMedicalCodesArgs = {
  filter: InputMaybe<CarePageable>;
};

export enum MedicalProductCategory {
  Dental = 'DENTAL',
  Diagnosis = 'DIAGNOSIS',
  Drugs = 'DRUGS',
  None = 'NONE',
  Packages = 'PACKAGES',
  Procedures = 'PROCEDURES',
  SuppliesConsumables = 'SUPPLIES_CONSUMABLES'
}

export enum MedicalProductFileProcessingStatus {
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type MedicalProductFileStatus = {
  __typename?: 'MedicalProductFileStatus';
  errorFileLink: Maybe<Scalars['String']['output']>;
  errorFileName: Maybe<Scalars['String']['output']>;
  fileStatusCode: Scalars['String']['output'];
  initialFileLink: Scalars['String']['output'];
  initialFileName: Scalars['String']['output'];
  status: MedicalProductFileProcessingStatus;
};

export type MedicalProductFilter = {
  carepayCodes: InputMaybe<Array<Scalars['String']['input']>>;
  category: InputMaybe<Scalars['String']['input']>;
  codingSystemName: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  externalCode: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  nameOrExternalCode: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
  tagIds: InputMaybe<Array<Scalars['String']['input']>>;
  tagTypeIds: InputMaybe<Array<Scalars['String']['input']>>;
  tags: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MedicalProductPage = CarePage & {
  __typename?: 'MedicalProductPage';
  data: Maybe<Array<MedicalProduct>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type MedicalProductUrl = {
  __typename?: 'MedicalProductUrl';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MedicalTag = {
  __typename?: 'MedicalTag';
  codingSystemName: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  tagId: Maybe<Scalars['String']['output']>;
  typeId: Maybe<Scalars['String']['output']>;
  typeName: Maybe<Scalars['String']['output']>;
};

export type MedicalTagFilter = {
  /** @deprecated use tagIds instead */
  id: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
  tagIds: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated use tagTypeIds instead */
  tagTypeId: InputMaybe<Scalars['String']['input']>;
  tagTypeIds: InputMaybe<Array<Scalars['String']['input']>>;
  tagTypeName: InputMaybe<Scalars['String']['input']>;
};

export type MedicalTagPage = CarePage & {
  __typename?: 'MedicalTagPage';
  data: Maybe<Array<MedicalTag>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type MedicalTagType = {
  __typename?: 'MedicalTagType';
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type MedicalTagTypeFilter = {
  page: InputMaybe<CarePageable>;
  tagTypeId: InputMaybe<Scalars['String']['input']>;
  tagTypeName: InputMaybe<Scalars['String']['input']>;
};

export type MedicalTagTypePage = CarePage & {
  __typename?: 'MedicalTagTypePage';
  data: Maybe<Array<MedicalTagType>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type MedicalTagsInput = {
  medicalCodeIds: Array<Scalars['String']['input']>;
  tagIds: Array<Scalars['String']['input']>;
};

export type Medication = {
  __typename?: 'Medication';
  authoredDate: Maybe<Scalars['String']['output']>;
  dispenseRequest: Maybe<DispenseRequest>;
  dosages: Array<Dosage>;
  externalRef: Maybe<Scalars['String']['output']>;
  groupIdentifier: Maybe<Scalars['String']['output']>;
  intent: Maybe<Scalars['String']['output']>;
  internalRef: Scalars['String']['output'];
  notes: Array<MedicationNote>;
  product: Maybe<PrescriptionMedicalProduct>;
  status: Maybe<MedicationStatus>;
  type: Maybe<MedicationType>;
};

export type MedicationNote = {
  __typename?: 'MedicationNote';
  code: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
  valueType: Maybe<Scalars['String']['output']>;
};

export enum MedicationStatus {
  Active = 'ACTIVE'
}

export enum MedicationType {
  Cpt = 'CPT',
  Dental = 'DENTAL',
  Drg = 'DRG',
  Drug = 'DRUG',
  Hcpcs = 'HCPCS',
  Other = 'OTHER',
  ScientificCode = 'SCIENTIFIC_CODE',
  ServiceCode = 'SERVICE_CODE'
}

export type Member = {
  __typename?: 'Member';
  beneficiaryPolicies: Maybe<Array<BeneficiaryPolicy>>;
  communicationDetails: Maybe<CommunicationDetails>;
  id: Maybe<Scalars['String']['output']>;
  kyc: Maybe<MemberKyc>;
  profileComplete: Maybe<Scalars['Boolean']['output']>;
};

export type MemberDeleteResponse = Error | Success;

export enum MemberDocumentType {
  NationalId = 'NATIONAL_ID',
  Passport = 'PASSPORT'
}

export type MemberInput = {
  country: InputMaybe<Scalars['String']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType: InputMaybe<MemberDocumentType>;
  firstName: Scalars['String']['input'];
  idDocumentNumber: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
};

export type MemberKyc = {
  __typename?: 'MemberKyc';
  country: Maybe<Scalars['String']['output']>;
  dateOfBirth: Scalars['String']['output'];
  documentType: Maybe<MemberDocumentType>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  idDocumentNumber: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  memberRegistrationChannel: Maybe<MemberRegistrationChannel>;
  memberRegistrationType: MemberRegistrationType;
  phoneNumber: Maybe<Scalars['String']['output']>;
  userKey: Maybe<Scalars['String']['output']>;
};

export type MemberRate = {
  __typename?: 'MemberRate';
  number: Scalars['Int']['output'];
  rate: MonetaryAmount;
};

export type MemberRatesInput = {
  number: Scalars['Int']['input'];
  rate: MonetaryAmountInput;
};

export enum MemberRegistrationChannel {
  App = 'APP',
  Ussd = 'USSD'
}

export enum MemberRegistrationType {
  Email = 'EMAIL',
  PhoneNumber = 'PHONE_NUMBER'
}

export type MemberResponse = Error | Member;

export type MembersPage = CarePage & {
  __typename?: 'MembersPage';
  data: Array<Member>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type Message = {
  __typename?: 'Message';
  body: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  messageKey: Maybe<Scalars['String']['output']>;
  subject: Maybe<Scalars['String']['output']>;
  type: MessageType;
  userKey: Scalars['String']['output'];
};

export type MessageFilter = {
  page: InputMaybe<CarePageable>;
  userKey: Scalars['String']['input'];
};

export type MessagePage = CarePage & {
  __typename?: 'MessagePage';
  data: Maybe<Array<Message>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum MessageType {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type MinimalParty = {
  __typename?: 'MinimalParty';
  ownerRef: Scalars['String']['output'];
  ownerType: OwnerType;
};

export type MinimalPartyInput = {
  ownerRef: Scalars['String']['input'];
  ownerType: OwnerType;
};

export type MinimalProvider = {
  __typename?: 'MinimalProvider';
  code: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum ModifierType {
  Factor = 'FACTOR',
  Flat = 'FLAT',
  NetPrice = 'NET_PRICE',
  None = 'NONE',
  Percent = 'PERCENT'
}

export type ModifyPreAuthorizationValidityDates = {
  validityEndDate: InputMaybe<Scalars['String']['input']>;
  validityStartDate: InputMaybe<Scalars['String']['input']>;
};

export type MonetaryAmount = {
  __typename?: 'MonetaryAmount';
  amount: Maybe<Scalars['Float']['output']>;
  currency: Scalars['String']['output'];
};

export type MonetaryAmountInput = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
};

export type MultiSortCarePageable = {
  number: InputMaybe<Scalars['Int']['input']>;
  size: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<Sortable>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateUser: Maybe<ActivateUserResponse>;
  addBenefit: Maybe<BenefitResponse>;
  addClaimComment: Maybe<AddClaimCommentResponse>;
  addClaimDiagnosis: Maybe<AddDiagnosisResponse>;
  addClaimItem: Maybe<AddItemResponse>;
  addDiagnosis: Maybe<DiagnosisAddedResponse>;
  addDocument: Maybe<DocumentAddedResponse>;
  addIntermediaryAddress: Maybe<IntermediaryResponse>;
  addIntermediaryBankAccount: Maybe<IntermediaryResponse>;
  addIntermediaryContact: Maybe<IntermediaryResponse>;
  addIntermediaryExternalCodes: Maybe<IntermediaryResponse>;
  addInvoice: Maybe<InvoiceAddedResponse>;
  addInvoiceItem: Maybe<InvoiceItemAddedResponse>;
  addOrUpdatePolicyFee: Maybe<PolicyFeeResponse>;
  addPayerAddress: Maybe<PayerResponse>;
  addPayerBankAccount: Maybe<PayerResponse>;
  addPayerContact: Maybe<PayerResponse>;
  addPayerExternalCodes: Maybe<PayerResponse>;
  addPayerLogo: Maybe<PayerResponse>;
  addPersonFingerprint: Maybe<FingerprintCreatedResponse>;
  addPreAuthorizationItem: Maybe<AddPreAuthorizationItemResponse>;
  addSubBenefit: Maybe<BenefitResponse>;
  adjustItemPrice: Maybe<PriceItemResponse>;
  amendPolicyDates: Maybe<PolicyResponse>;
  approveClaimItem: Maybe<ApproveClaimItemResponse>;
  approvePolicy: Maybe<PolicyResponse>;
  approvePreAuthorization: Maybe<PreAuthorizationApprovalResponse>;
  approvePreAuthorizationItem: Maybe<PreAuthorizationItemApprovalResponse>;
  approveProduct: Maybe<ApproveProductResponse>;
  approveQuotation: Maybe<ApproveQuotationResponse>;
  assignBenefitToItem: Maybe<AssignBenefitToItemResponse>;
  assignMedicalTags: Maybe<AssignMedicalTagsResponse>;
  assignUserToAdjudication: Maybe<AssignUserToAdjudicationResponse>;
  asyncCreatePremiumCalculation: Maybe<PremiumCalculationAsyncResponse>;
  broadcastToAllMembers: Maybe<BroadcastToAllMembersResponse>;
  bulkApproveClaimItems: Maybe<BulkApproveClaimItemsResponse>;
  bulkApprovePreAuthorizationItems: Maybe<BulkApprovePreAuthorizationItemsResponse>;
  bulkRejectClaimItems: Maybe<BulkRejectClaimItemsResponse>;
  bulkRejectPreAuthorizationItems: Maybe<BulkRejectPreAuthorizationItemsResponse>;
  bulkUpdateRuleEngineRules: Maybe<UpdateRuleEngineRulesResponse>;
  bulksend: Maybe<BulkSendResponse>;
  calculateProviderProgress: Maybe<ProviderProgressResponse>;
  cancelPolicy: Maybe<PolicyResponse>;
  cancelPreAuthorization: Maybe<CancelPreAuthorizationResponse>;
  captureBeneficiaryPremiumChanges: Maybe<BeneficiaryPremiumChangeResponse>;
  changeBatch: Maybe<ChangeBatchResponse>;
  changeCategory: Maybe<CategoryChangeEndorsementResponse>;
  claimBulkUpload: Maybe<ClaimBulkUploadResponse>;
  closeVisit: Maybe<CloseVisitResponse>;
  confirmAdjudication: Maybe<AdjudicationConfirmationResponse>;
  /** @deprecated Use confirmAdjudication instead */
  confirmPreAuthorization: Maybe<PreAuthorizationConfirmationResponse>;
  copyPriceAgreement: Maybe<PriceAgreementResponse>;
  copyPricingSetup: Maybe<CopyPricingStatusResponse>;
  createAnnualMedicalLimit: Maybe<AnnualMedicalLimitResponse>;
  createBedCapacity: Maybe<BedCapacityResponse>;
  createBeneficiary: Maybe<BeneficiaryPolicyResponse>;
  createBusinessProperties: Maybe<BusinessPropertiesResponse>;
  createCase: Maybe<CaseCreationResponse>;
  createCaseComment: Maybe<PreAuthorizationCommentCreationResponse>;
  createCategoryMapping: Maybe<Array<CategoryMappingResponse>>;
  createCustomNetworkExclusions: Maybe<NetworkAdditionResponse>;
  createCustomNetworkInclusions: Maybe<NetworkAdditionResponse>;
  createCustomProviderNetwork: Maybe<CustomProviderNetworkResponse>;
  createDirectSettlementClaim: Maybe<DirectSettlementClaimResponse>;
  createEmpaneledProvider: Maybe<EmpaneledProviderResponse>;
  createFamilyComposition: Maybe<FamilyCompositionResponse>;
  createGroupParty: Maybe<GroupPartyResponse>;
  createIntermediary: Maybe<IntermediaryResponse>;
  createMedicalCodeAndProduct: Maybe<CreateMedicalCodeResponse>;
  createOrUpdatePremiumTables: Maybe<PremiumTableCreatedResponse>;
  createPayer: Maybe<PayerResponse>;
  createPayerCopayRule: Maybe<PayerCopayRuleResponse>;
  createPaymentContract: Maybe<PaymentContractResponse>;
  createPecCoverage: Maybe<PecCoverageResponse>;
  createPreAuthorization: Maybe<PreAuthorizationCreationResponse>;
  createPreAuthorizationComment: Maybe<PreAuthorizationCommentCreationResponse>;
  createPreAuthorizationOverride: Maybe<CreatePreAuthorizationOverrideResponse>;
  createPremiumCalculation: Maybe<PremiumCalculationResponse>;
  createPriceAgreement: Maybe<PriceAgreementResponse>;
  createPriceAgreementItem: Maybe<PriceAgreementItemResponse>;
  createPriceAgreementVersion: Maybe<PriceAgreementResponse>;
  createPriceListVersion: Maybe<PriceListResponse>;
  createProduct: Maybe<ProductResponse>;
  createProductBenefit: Maybe<ProductBenefitResponse>;
  createProductBenefitType: Maybe<ProductBenefitTypeResponse>;
  createProductIntermediary: Maybe<ProductIntermediaryResponse>;
  createProductProviderNetwork: Maybe<ProductProviderNetworkResponse>;
  createProductSubBenefit: Maybe<ProductSubBenefitResponse>;
  createProvider: Maybe<ProviderResponse>;
  createProviderBankAccount: Maybe<ProviderBankAccountResponse>;
  createProviderContact: Maybe<ProviderContactResponse>;
  createProviderExternalCode: Maybe<ProviderExternalCodeResponse>;
  createProviderLicense: Maybe<ProviderLicenseResponse>;
  createProviderMobileWalletAccount: Maybe<ProviderMobileWalletAccountResponse>;
  createQuotation: Maybe<QuotationResponse>;
  createQuotationComment: Maybe<QuotationCommentResponse>;
  createRegulatedPriceListVersion: Maybe<PriceListResponse>;
  createReimbursementClaim: Maybe<ReimbursementClaimResponse>;
  createRoomType: Maybe<RoomTypeResponse>;
  createScheduledNetworkChange: Maybe<EmpaneledProviderResponse>;
  createStandardProviderNetwork: Maybe<StandardProviderNetworkResponse>;
  createStaticVisit: Maybe<StaticVisitResponse>;
  createTerritorialCoverage: Maybe<TerritorialCoverageResponse>;
  createVisit: Maybe<VisitCreatedResponse>;
  deleteAnnualMedicalLimit: Maybe<AnnualMedicalLimitDeleteResponse>;
  deleteBaseRates: Maybe<BaseRatesDeleteResponse>;
  deleteBedCapacity: Maybe<BedCapacityDeleteResponse>;
  deleteBeneficiariesFromPolicy: Maybe<DeleteBeneficiariesResponse>;
  deleteBeneficiaryDocument: Maybe<DeleteBeneficiaryDocumentResponse>;
  deleteBenefit: Maybe<DeleteBenefitResponse>;
  deleteClaimDiagnosis: Maybe<DeleteClaimsDiagnosisResponse>;
  deleteClaimItem: Maybe<DeleteClaimsItemResponse>;
  deleteCustomNetworkExclusions: Maybe<NetworkAdditionResponse>;
  deleteCustomNetworkInclusions: Maybe<NetworkAdditionResponse>;
  deleteCustomNetworkLinkedNetwork: Maybe<CustomNetworkLinkedNetworkDeleteResponse>;
  deleteDiagnosis: Maybe<DeleteDiagnosisResponse>;
  deleteDocument: Maybe<DeleteDocumentResponse>;
  deleteEmpaneledProvider: Maybe<DeleteEmpaneledProviderResponse>;
  deleteEmpaneledProviderContract: Maybe<DeleteEmpaneledProviderContractResponse>;
  deleteEndorsementDocument: Maybe<DeleteEndorsementDocumentResponse>;
  deleteEndorsements: Maybe<DeleteEndorsementResponse>;
  deleteIntermediary: Maybe<DeleteIntermediaryResponse>;
  deleteIntermediaryAddress: Maybe<IntermediaryResponse>;
  deleteIntermediaryContact: Maybe<IntermediaryResponse>;
  deleteIntermediaryContract: Maybe<PayerResponse>;
  deleteIntermediaryDocument: Maybe<IntermediaryResponse>;
  deleteIntermediaryLicense: Maybe<DeleteIntermediaryLicenseResponse>;
  deleteIntermediaryUser: Maybe<DeleteIntermediaryUserResponse>;
  deleteMember: Maybe<MemberDeleteResponse>;
  deletePayer: Maybe<DeletePayerResponse>;
  deletePayerAddress: Maybe<PayerResponse>;
  deletePayerBankAccount: Maybe<PayerResponse>;
  deletePayerContact: Maybe<PayerResponse>;
  deletePayerDocument: Maybe<PayerResponse>;
  deletePayerUser: Maybe<DeletePayerUserResponse>;
  deletePecCoverage: Maybe<PecCoverageDeleteResponse>;
  deletePlatformUser: Maybe<DeletePlatformUserResponse>;
  deletePolicyholderDocument: Maybe<PolicyholderDocumentDeleteResponse>;
  deletePreAuthorizationOverride: Maybe<DeletePreAuthorizationOverrideResponse>;
  deletePriceAgreement: Maybe<DeletePriceAgreementResponse>;
  deleteProduct: Maybe<ProductDeleteResponse>;
  deleteProductBenefit: Maybe<ProductBenefitDeleteResponse>;
  deleteProductBenefitType: Maybe<ProductBenefitTypeDeleteResponse>;
  deleteProductIntermediary: Maybe<IntermediaryDeleteResponse>;
  deleteProductProviderNetwork: Maybe<ProductProviderNetworkDeleteResponse>;
  deleteProductSubBenefit: Maybe<ProductSubBenefitDeleteResponse>;
  deleteProviderContact: Maybe<ProviderContactDeleteResponse>;
  deleteProviderExternalCode: Maybe<ProviderExternalCodeDeleteResponse>;
  deleteProviderLicense: Maybe<ProviderLicenseDeleteResponse>;
  deleteProviderLicenseDocument: Maybe<ProviderLicenseDocumentDeleteResponse>;
  deleteProviderPaymentAccount: Maybe<ProviderPaymentDeleteResponse>;
  deleteProviderUser: Maybe<DeleteProviderUserResponse>;
  deleteQuotation: Maybe<QuotationDeleteResponse>;
  deleteQuotationDocument: Maybe<QuotationDocumentDeleteResponse>;
  deleteReinsurerContract: Maybe<PayerResponse>;
  deleteRoomType: Maybe<RoomTypeDeleteResponse>;
  deleteTerritorialCoverage: Maybe<TerritorialCoverageDeleteResponse>;
  deleteVisit: Maybe<DeleteVisitResponse>;
  disablePromotions: Maybe<PromotionsResponse>;
  discardPolicy: Maybe<PolicyResponse>;
  duplicateProduct: Maybe<ProductResponse>;
  duplicateQuotation: Maybe<QuotationResponse>;
  enablePromotions: Maybe<PromotionsResponse>;
  enrichPreAuthorization: Maybe<PreAuthorizationEnrichedResponse>;
  evaluateEndorsementPremiumImpact: Maybe<EvaluatedEndorsementResponse>;
  extendPolicy: Maybe<PolicyResponse>;
  finalizeClaim: Maybe<FinalizeClaimResponse>;
  finalizeDraftPreAuthorization: Maybe<DraftPreAuthorizationFinalizedResponse>;
  initiateBulkUpload: Maybe<BulkUploadProgress>;
  inviteIntermediaryUser: Maybe<IntermediaryUserResponse>;
  invitePayerUser: Maybe<PayerUserResponse>;
  invitePlatformUser: Maybe<InviteUserResponse>;
  inviteProviderUser: Maybe<ProviderUserResponse>;
  linkIntermediary: Maybe<PayerResponse>;
  linkPreAuthorization: Maybe<PreAuthorizationLinkResponse>;
  linkReinsurer: Maybe<PayerResponse>;
  mapMedicalCode: Maybe<MappedMedicalCodeResponse>;
  overridePreAuthorization: Maybe<OverridePreAuthorizationResponse>;
  overridePreAuthorizationItem: Maybe<OverridePreAuthorizationItemResponse>;
  partiallyApproveClaimItem: Maybe<PartiallyApproveClaimItemResponse>;
  partiallyApprovePreAuthorizationItem: Maybe<PreAuthorizationItemPartialApprovalResponse>;
  patchVisit: Maybe<PatchVisitResponse>;
  paymentInstruction: Maybe<PaymentInstructionResponse>;
  performEndorsementAction: Maybe<BeneficiaryPolicyResponse>;
  performEndorsementWorkflowAction: Maybe<PerformEndorsementWorkflowActionResponse>;
  performReinstateEndorsementAction: Maybe<BeneficiaryPolicyResponse>;
  preAuthorizationBulkUpload: Maybe<PreAuthorizationBulkUploadResponse>;
  publishQuotation: Maybe<PublishQuotationResponse>;
  reactivateEmpaneledProvider: Maybe<EmpaneledProviderResponse>;
  reactivatePolicy: Maybe<PolicyResponse>;
  rejectPolicy: Maybe<PolicyResponse>;
  rejectPreAuthorization: Maybe<PreAuthorizationRejectionResponse>;
  rejectPreAuthorizationItem: Maybe<PreAuthorizationItemRejectionResponse>;
  rejectProduct: Maybe<RejectProductResponse>;
  rejectQuotation: Maybe<RejectQuotationResponse>;
  removeInvoiceItem: Maybe<InvoiceItemRemovedResponse>;
  removeMedicalTags: Maybe<RemoveMedicalTagsResponse>;
  removePriceAgreementItems: Maybe<RemovePriceAgreementItemsResponse>;
  removePriceListItems: Maybe<RemovePriceListItemsResponse>;
  removeRegulatedPriceListItems: Maybe<RemovePriceListItemsResponse>;
  renewPolicy: Maybe<RenewedPolicyResponse>;
  reopenClaim: Maybe<ReopenClaimResponse>;
  reopenPreAuthorization: Maybe<PreAuthorizationReopenResponse>;
  resetFingerprintPerson: Maybe<FingerprintResetResponse>;
  resubmitPreAuthorization: Maybe<PreAuthorizationCreationResponse>;
  reverseClaim: Maybe<ClaimReversalResponse>;
  revertProductToDraft: Maybe<RevertProductToDraftResponse>;
  revertQuotationToDraft: Maybe<RevertQuotationToDraftResponse>;
  sendExternalCommunication: Maybe<SendExternalCommunicationResponse>;
  sendPersonOTP: Maybe<PersonOtpResponse>;
  sendPolicyForApproval: Maybe<PolicyResponse>;
  setApprovalRules: Maybe<ApprovalRulesResponse>;
  setDefaultBaseRates: Maybe<BaseRatesResponse>;
  setGenderBaseRates: Maybe<BaseRatesResponse>;
  setInstalments: Maybe<InstalmentsResponse>;
  setLoading: Maybe<LoadingResponse>;
  setQuotationPremium: Maybe<QuotationPremiumResponse>;
  setReimbursementRules: Maybe<ReimbursementRulesResponse>;
  submitPreAuthorizations: Maybe<SubmitPreAuthorizationsResponse>;
  submitProductForReview: Maybe<SubmitProductForReviewResponse>;
  submitQuotationForReview: Maybe<SubmitQuotationForReviewResponse>;
  submitRemittanceRequest: Maybe<RemittanceRequestResponse>;
  suspendEmpaneledProvider: Maybe<EmpaneledProviderResponse>;
  suspendPolicy: Maybe<PolicyResponse>;
  togglePremiumInstalmentIsPaid: Maybe<TogglePremiumInstalmentIsPaidResponse>;
  unlinkPreAuthorization: Maybe<PreAuthorizationUnlinkResponse>;
  updateAnnualMedicalLimit: Maybe<AnnualMedicalLimitResponse>;
  updateBedCapacity: Maybe<BedCapacityResponse>;
  updateBeneficiary: Maybe<BeneficiaryPolicyResponse>;
  updateBenefit: Maybe<BenefitResponse>;
  updateBillInvoice: Maybe<UpdateBillInvoiceResponse>;
  updateBillNote: Maybe<UpdateBillNoteResponse>;
  updateBusinessProperties: Maybe<BusinessPropertiesResponse>;
  updateCategory: Maybe<CategoryResponse>;
  updateCategoryFamilyComposition: Maybe<UpdateCategoryFamilyCompositionResponse>;
  updateChangeRequestStatus: Maybe<ChangeRequestStatusResponse>;
  updateClaimDiagnosis: Maybe<UpdateDiagnosisResponse>;
  updateClaimItem: Maybe<UpdateItemResponse>;
  updateCollectiveModifier: Maybe<CollectiveModifierResponse>;
  updateCustomProviderNetwork: Maybe<CustomProviderNetworkResponse>;
  updateEmpaneledProvider: Maybe<EmpaneledProviderResponse>;
  updateEmployeeLicense: Maybe<EmployeeLicenseResponse>;
  updateEndorsement: Maybe<BeneficiaryPolicyResponse>;
  updateExternalMedicalCode: Maybe<UpdateExternalCodeResponse>;
  updateGroupParty: Maybe<GroupPartyResponse>;
  updateGroupSubParty: Maybe<GroupPartyResponse>;
  updateIndividualParty: Maybe<IndividualPartyResponse>;
  updateIntermediary: Maybe<IntermediaryResponse>;
  updateIntermediaryAddress: Maybe<IntermediaryResponse>;
  updateIntermediaryBankAccount: Maybe<IntermediaryResponse>;
  updateIntermediaryContact: Maybe<IntermediaryResponse>;
  updateIntermediaryContract: Maybe<PayerResponse>;
  updateIntermediaryExternalCodes: Maybe<IntermediaryResponse>;
  updateIntermediaryLicense: Maybe<IntermediaryLicenseResponse>;
  updateIntermediaryStatus: Maybe<IntermediaryResponse>;
  updateIntermediaryUser: Maybe<IntermediaryUserResponse>;
  updateMember: Maybe<MemberResponse>;
  updatePayerAddress: Maybe<PayerResponse>;
  updatePayerBankAccount: Maybe<PayerResponse>;
  updatePayerContact: Maybe<PayerResponse>;
  updatePayerCopayRule: Maybe<PayerCopayRuleResponse>;
  updatePayerCopayRuleScope: Maybe<PayerCopayRuleScopeResponse>;
  updatePayerDetails: Maybe<PayerResponse>;
  updatePayerExternalCodes: Maybe<PayerResponse>;
  updatePayerLogo: Maybe<PayerResponse>;
  updatePayerStatus: Maybe<PayerResponse>;
  updatePayerUser: Maybe<PayerUserResponse>;
  updatePaymentContract: Maybe<PaymentContractResponse>;
  updatePecCoverage: Maybe<PecCoverageResponse>;
  updatePlanFamilyComposition: Maybe<UpdatePlanFamilyCompositionResponse>;
  updatePlatformUserRoles: Maybe<UpdatePlatformUserResponse>;
  updatePolicy: Maybe<PolicyResponse>;
  updatePreAuthorizationOverride: Maybe<UpdatePreAuthorizationOverrideResponse>;
  updatePreAuthorizationValidityDates: Maybe<PreAuthorizationAdjudicationUpdateResponse>;
  updatePriceAgreement: Maybe<PriceAgreementResponse>;
  updateProduct: Maybe<ProductResponse>;
  updateProductBenefit: Maybe<ProductBenefitResponse>;
  updateProductBenefitType: Maybe<ProductBenefitTypeResponse>;
  updateProductProviderNetwork: Maybe<ProductProviderNetworkResponse>;
  updateProductSubBenefit: Maybe<ProductSubBenefitResponse>;
  updateProvider: Maybe<ProviderResponse>;
  updateProviderBankAccount: Maybe<ProviderBankAccountResponse>;
  updateProviderContact: Maybe<ProviderContactResponse>;
  updateProviderEmployee: Maybe<ProviderEmployeeResponse>;
  updateProviderEmployeeStatus: Maybe<EmployeeStatusResponse>;
  updateProviderLicense: Maybe<ProviderLicenseResponse>;
  updateProviderMobileWalletAccount: Maybe<ProviderMobileWalletAccountResponse>;
  updateProviderStatus: Maybe<ProviderStatusResponse>;
  updateProviderUser: Maybe<ProviderUserResponse>;
  updateQuotation: Maybe<QuotationResponse>;
  updateQuotationCategory: Maybe<QuotationCategoryResponse>;
  updateReinsurerContract: Maybe<PayerResponse>;
  updateRoomType: Maybe<RoomTypeResponse>;
  updateRuleEngineRules: Maybe<UpdateRuleEngineRulesResponse>;
  updateStandardProviderNetwork: Maybe<StandardProviderNetworkResponse>;
  updateTerritorialCoverage: Maybe<TerritorialCoverageResponse>;
  updateTierToRoleMappings: Maybe<TierToRoleMappingResponse>;
  uploadBeneficiaries: Maybe<BulkUploadDetailsResponse>;
  uploadBeneficiaryDocument: Maybe<UploadBeneficiaryDocumentResponse>;
  uploadCensusEntries: Maybe<CensusUploadResponse>;
  uploadClaimDocument: Maybe<UploadClaimDocumentResponse>;
  uploadDocument: Maybe<PayerResponse>;
  uploadEmpaneledProviderContract: Maybe<UploadEmpaneledProviderContractResponse>;
  uploadEmployees: Maybe<UploadEmployeesResponse>;
  uploadEndorsementDocument: Maybe<UploadEndorsementDocumentResponse>;
  uploadIntermediaryDocument: Maybe<IntermediaryResponse>;
  uploadIntermediaryLicense: Maybe<IntermediaryLicenseResponse>;
  uploadMedicalCodes: Maybe<UploadMedicalCodesResponse>;
  uploadPolicy: Maybe<PolicyResponse>;
  uploadPolicyholderDocument: Maybe<PolicyholderDocumentResponse>;
  uploadPreAuthorizationDocuments: Maybe<UploadPreAuthorizationDocumentResponse>;
  uploadPreAuthorizationItemDocument: Maybe<UploadPreAuthorizationDocumentResponse>;
  uploadPriceAgreementFile: Maybe<FileUploadResponse>;
  uploadPriceListFile: Maybe<FileUploadResponse>;
  uploadProviderLicenseDocument: Maybe<UploadProviderLicenseDocumentResponse>;
  uploadQuotationDocument: Maybe<QuotationDocumentResponse>;
  uploadRegulatedPriceListFile: Maybe<FileUploadResponse>;
  verifyFingerprint: Maybe<FingerprintVerificationResponse>;
  verifyPersonOTP: Maybe<PersonOtpVerificationResponse>;
};


export type MutationActivateUserArgs = {
  activateInput: ActivateUserInput;
  externalKey: Scalars['String']['input'];
};


export type MutationAddBenefitArgs = {
  benefit: BenefitInput;
  categoryId: Scalars['String']['input'];
};


export type MutationAddClaimCommentArgs = {
  claimCode: Scalars['String']['input'];
  comment: CreateComment;
};


export type MutationAddClaimDiagnosisArgs = {
  addDiagnosisInput: InputMaybe<AddDiagnosisInput>;
  claimCode: Scalars['String']['input'];
};


export type MutationAddClaimItemArgs = {
  claimCode: Scalars['String']['input'];
  createItem: AddClaimItemInput;
};


export type MutationAddDiagnosisArgs = {
  diagnosis: AddBillingDiagnosisInput;
};


export type MutationAddDocumentArgs = {
  document: Scalars['Upload']['input'];
  documentDetails: AddBillingDocumentDetailsInput;
};


export type MutationAddIntermediaryAddressArgs = {
  address: CreatePayerAddressInput;
  intermediaryKey: Scalars['String']['input'];
};


export type MutationAddIntermediaryBankAccountArgs = {
  bankAccount: CreatePayerBankAccountInput;
  intermediaryKey: Scalars['String']['input'];
};


export type MutationAddIntermediaryContactArgs = {
  contact: CreatePayerContactInput;
  intermediaryKey: Scalars['String']['input'];
};


export type MutationAddIntermediaryExternalCodesArgs = {
  intermediaryExternalCodes: Array<PayerExternalCodeInput>;
  intermediaryKey: Scalars['String']['input'];
};


export type MutationAddInvoiceArgs = {
  invoice: AddInvoiceInput;
};


export type MutationAddInvoiceItemArgs = {
  invoiceItem: AddInvoiceItemInput;
};


export type MutationAddOrUpdatePolicyFeeArgs = {
  policyFee: PolicyFeeInput;
  policyId: Scalars['String']['input'];
};


export type MutationAddPayerAddressArgs = {
  address: CreatePayerAddressInput;
  payerKey: Scalars['String']['input'];
};


export type MutationAddPayerBankAccountArgs = {
  bankAccount: CreatePayerBankAccountInput;
  payerKey: Scalars['String']['input'];
};


export type MutationAddPayerContactArgs = {
  contact: CreatePayerContactInput;
  payerKey: Scalars['String']['input'];
};


export type MutationAddPayerExternalCodesArgs = {
  payerExternalCodes: Array<PayerExternalCodeInput>;
  payerKey: Scalars['String']['input'];
};


export type MutationAddPayerLogoArgs = {
  logo: Scalars['Upload']['input'];
  payerKey: Scalars['String']['input'];
};


export type MutationAddPersonFingerprintArgs = {
  fingerType: FingerType;
  fingerprint: Scalars['Upload']['input'];
  personRef: Scalars['String']['input'];
};


export type MutationAddPreAuthorizationItemArgs = {
  createItem: CreatePreAuthorizationItem;
  preAuthorizationReference: Scalars['String']['input'];
};


export type MutationAddSubBenefitArgs = {
  benefit: BenefitInput;
  parentBenefitId: Scalars['String']['input'];
};


export type MutationAdjustItemPriceArgs = {
  itemPriceAdjustment: ItemPriceAdjustment;
};


export type MutationAmendPolicyDatesArgs = {
  endDate: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationApproveClaimItemArgs = {
  approvalInput: InputMaybe<ApprovalClaimItem>;
  claimCode: Scalars['String']['input'];
  itemCode: Scalars['String']['input'];
};


export type MutationApprovePolicyArgs = {
  policyId: Scalars['String']['input'];
};


export type MutationApprovePreAuthorizationArgs = {
  reference: Scalars['String']['input'];
  request: InputMaybe<ApprovePreAuthorization>;
};


export type MutationApprovePreAuthorizationItemArgs = {
  approval: InputMaybe<PreAuthorizationItemApproval>;
  itemReference: Scalars['String']['input'];
  preAuthorizationReference: Scalars['String']['input'];
};


export type MutationApproveProductArgs = {
  productCode: Scalars['String']['input'];
};


export type MutationApproveQuotationArgs = {
  quotationCode: Scalars['String']['input'];
};


export type MutationAssignBenefitToItemArgs = {
  benefit: PreAuthorizationEnrichment;
  itemReference: Scalars['String']['input'];
  preauthReference: Scalars['String']['input'];
};


export type MutationAssignMedicalTagsArgs = {
  assignTagsRequest: MedicalTagsInput;
};


export type MutationAssignUserToAdjudicationArgs = {
  adjudicationReference: Scalars['String']['input'];
  userRef: AssignUserRef;
};


export type MutationAsyncCreatePremiumCalculationArgs = {
  premiumCalculation: PremiumCalculationInput;
};


export type MutationBroadcastToAllMembersArgs = {
  request: BroadcastRequest;
};


export type MutationBulkApproveClaimItemsArgs = {
  bulkApproveClaimItems: BulkApproveClaimItemsInput;
  claimCode: Scalars['String']['input'];
};


export type MutationBulkApprovePreAuthorizationItemsArgs = {
  bulkApprovePreAuthorizationItems: BulkApprovePreAuthorizationItemsInput;
  preAuthorizationReference: Scalars['String']['input'];
};


export type MutationBulkRejectClaimItemsArgs = {
  bulkRejectClaimItems: BulkRejectClaimItemsInput;
  claimCode: Scalars['String']['input'];
};


export type MutationBulkRejectPreAuthorizationItemsArgs = {
  bulkRejectPreAuthorizationItems: BulkRejectPreAuthorizationItemsInput;
  preAuthorizationReference: Scalars['String']['input'];
};


export type MutationBulkUpdateRuleEngineRulesArgs = {
  forExternalRule: InputMaybe<Scalars['Boolean']['input']>;
  input: RuleEngineRuleBulkInput;
  payerKey: Scalars['String']['input'];
};


export type MutationBulksendArgs = {
  file: Scalars['Upload']['input'];
  request: BulkMessageRequest;
};


export type MutationCalculateProviderProgressArgs = {
  providerCode: Scalars['String']['input'];
};


export type MutationCancelPolicyArgs = {
  policyId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationCancelPreAuthorizationArgs = {
  reference: Scalars['String']['input'];
};


export type MutationCaptureBeneficiaryPremiumChangesArgs = {
  beneficiaryPremiumChangesRequest: BeneficiaryPremiumCalculationChangeInput;
};


export type MutationChangeBatchArgs = {
  changeBatchInput: ChangeBatchInput;
  paymentInternalRef: Scalars['String']['input'];
};


export type MutationChangeCategoryArgs = {
  categoryChangeInput: Array<CategoryChangeInput>;
};


export type MutationClaimBulkUploadArgs = {
  file: Scalars['Upload']['input'];
  payerRef: Scalars['String']['input'];
};


export type MutationCloseVisitArgs = {
  visitCode: Scalars['String']['input'];
};


export type MutationConfirmAdjudicationArgs = {
  confirm: ConfirmAdjudication;
  reference: Scalars['String']['input'];
};


export type MutationConfirmPreAuthorizationArgs = {
  reference: Scalars['String']['input'];
};


export type MutationCopyPriceAgreementArgs = {
  copyPriceAgreementInput: CopyPriceAgreementInput;
  priceAgreementId: Scalars['String']['input'];
};


export type MutationCopyPricingSetupArgs = {
  copyPricingSetup: CopyPricingSetupInput;
};


export type MutationCreateAnnualMedicalLimitArgs = {
  annualMedicalLimit: CreateAnnualMedicalLimitInput;
  productCode: Scalars['String']['input'];
};


export type MutationCreateBedCapacityArgs = {
  bed: CreateBedCapacityInput;
  providerCode: Scalars['String']['input'];
};


export type MutationCreateBeneficiaryArgs = {
  beneficiaryInput: BeneficiaryInput;
};


export type MutationCreateBusinessPropertiesArgs = {
  businessProperties: InputMaybe<Array<BusinessPropertyInput>>;
};


export type MutationCreateCaseArgs = {
  case: CreateCase;
};


export type MutationCreateCaseCommentArgs = {
  comment: CreatePreAuthorizationComment;
  reference: Scalars['String']['input'];
};


export type MutationCreateCategoryMappingArgs = {
  categoryMappingsInput: InputMaybe<Array<CategoryMappingInput>>;
};


export type MutationCreateCustomNetworkExclusionsArgs = {
  empaneledProviderCodes: Array<Scalars['String']['input']>;
  networkCode: Scalars['String']['input'];
};


export type MutationCreateCustomNetworkInclusionsArgs = {
  empaneledProviderCodes: Array<Scalars['String']['input']>;
  networkCode: Scalars['String']['input'];
};


export type MutationCreateCustomProviderNetworkArgs = {
  providerNetwork: CustomProviderNetworkInput;
};


export type MutationCreateDirectSettlementClaimArgs = {
  claim: CreateDirectSettlementClaim;
};


export type MutationCreateEmpaneledProviderArgs = {
  empaneledProvider: EmpaneledProviderInput;
};


export type MutationCreateFamilyCompositionArgs = {
  familyComposition: CreateFamilyCompositionInput;
  productCode: Scalars['String']['input'];
};


export type MutationCreateGroupPartyArgs = {
  groupPartyInput: GroupPartyInput;
};


export type MutationCreateIntermediaryArgs = {
  intermediary: CreateIntermediaryInput;
  payerKey: Scalars['String']['input'];
};


export type MutationCreateMedicalCodeAndProductArgs = {
  medicalCodeAndProductRequest: MedicalCodeAndProductRequest;
};


export type MutationCreateOrUpdatePremiumTablesArgs = {
  premiumTableRequests: Array<PremiumTableInput>;
};


export type MutationCreatePayerArgs = {
  parentKey: Scalars['String']['input'];
  payer: CreatePayerInput;
};


export type MutationCreatePayerCopayRuleArgs = {
  payerCopayRule: PayerCopayRuleInput;
  payerKey: Scalars['String']['input'];
};


export type MutationCreatePaymentContractArgs = {
  paymentContractInput: CreatePaymentContractInput;
};


export type MutationCreatePecCoverageArgs = {
  pecCoverage: CreatePecCoverageInput;
  productCode: Scalars['String']['input'];
};


export type MutationCreatePreAuthorizationArgs = {
  preAuthorization: CreatePreAuthorization;
};


export type MutationCreatePreAuthorizationCommentArgs = {
  comment: CreatePreAuthorizationComment;
  reference: Scalars['String']['input'];
};


export type MutationCreatePreAuthorizationOverrideArgs = {
  createPreAuthorizationOverride: CreatePreAuthorizationOverride;
};


export type MutationCreatePremiumCalculationArgs = {
  premiumCalculation: PremiumCalculationInput;
};


export type MutationCreatePriceAgreementArgs = {
  priceAgreement: CreatePriceAgreementInput;
};


export type MutationCreatePriceAgreementItemArgs = {
  priceAgreementId: Scalars['String']['input'];
  priceAgreementItemInput: PriceAgreementItemInput;
};


export type MutationCreatePriceAgreementVersionArgs = {
  priceAgreementVersion: PriceAgreementVersionInput;
};


export type MutationCreatePriceListVersionArgs = {
  priceListNewVersion: PriceListNewVersion;
};


export type MutationCreateProductArgs = {
  product: CreateProductInput;
};


export type MutationCreateProductBenefitArgs = {
  productBenefit: CreateProductBenefitInput;
  productBenefitTypeCode: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};


export type MutationCreateProductBenefitTypeArgs = {
  productBenefitType: CreateProductBenefitTypeInput;
  productCode: Scalars['String']['input'];
};


export type MutationCreateProductIntermediaryArgs = {
  intermediaryRef: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};


export type MutationCreateProductProviderNetworkArgs = {
  productCode: Scalars['String']['input'];
  productProviderNetwork: CreateProductProviderNetworkInput;
};


export type MutationCreateProductSubBenefitArgs = {
  productBenefitTypeCode: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
  productSubBenefit: CreateProductSubBenefitInput;
};


export type MutationCreateProviderArgs = {
  provider: CreateProviderInput;
};


export type MutationCreateProviderBankAccountArgs = {
  providerBankAccount: ProviderBankAccountInput;
  providerCode: Scalars['String']['input'];
};


export type MutationCreateProviderContactArgs = {
  providerCode: Scalars['String']['input'];
  providerContact: ProviderContactInput;
};


export type MutationCreateProviderExternalCodeArgs = {
  providerCode: Scalars['String']['input'];
  providerExternalCode: ProviderExternalCodeInput;
};


export type MutationCreateProviderLicenseArgs = {
  providerCode: Scalars['String']['input'];
  providerLicense: ProviderLicenseInput;
};


export type MutationCreateProviderMobileWalletAccountArgs = {
  providerCode: Scalars['String']['input'];
  providerMobileWalletAccount: ProviderMobileWalletAccountInput;
};


export type MutationCreateQuotationArgs = {
  quotation: CreateQuotationInput;
};


export type MutationCreateQuotationCommentArgs = {
  content: Scalars['String']['input'];
  quotationCode: Scalars['String']['input'];
};


export type MutationCreateRegulatedPriceListVersionArgs = {
  priceListNewVersion: PriceListNewVersion;
};


export type MutationCreateReimbursementClaimArgs = {
  claimForm: InputMaybe<Scalars['Upload']['input']>;
  invoice: InputMaybe<Scalars['Upload']['input']>;
  otherDocuments: InputMaybe<Array<Scalars['Upload']['input']>>;
  reimbursementClaim: CreateReimbursementInput;
};


export type MutationCreateRoomTypeArgs = {
  productCode: Scalars['String']['input'];
  roomType: CreateRoomTypeInput;
};


export type MutationCreateScheduledNetworkChangeArgs = {
  empaneledProviderCode: Scalars['String']['input'];
  scheduledNetworkChange: ScheduledNetworkChangeInput;
};


export type MutationCreateStandardProviderNetworkArgs = {
  providerNetwork: StandardProviderNetworkInput;
};


export type MutationCreateStaticVisitArgs = {
  staticVisit: CreateStaticVisitInput;
};


export type MutationCreateTerritorialCoverageArgs = {
  productCode: Scalars['String']['input'];
  territorialCoverage: CreateTerritorialCoverageInput;
};


export type MutationCreateVisitArgs = {
  visit: CreateVisitInput;
};


export type MutationDeleteAnnualMedicalLimitArgs = {
  annualMedicalLimitCode: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};


export type MutationDeleteBaseRatesArgs = {
  productCode: Scalars['String']['input'];
};


export type MutationDeleteBedCapacityArgs = {
  bedCode: Scalars['String']['input'];
  providerCode: Scalars['String']['input'];
};


export type MutationDeleteBeneficiariesFromPolicyArgs = {
  beneficiaryPolicyIds: Array<Scalars['String']['input']>;
  policyId: Scalars['String']['input'];
};


export type MutationDeleteBeneficiaryDocumentArgs = {
  beneficiaryPolicyId: Scalars['String']['input'];
  documentKey: Scalars['String']['input'];
};


export type MutationDeleteBenefitArgs = {
  benefitId: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
};


export type MutationDeleteClaimDiagnosisArgs = {
  claimCode: Scalars['String']['input'];
  diagnosisInternalRef: Scalars['String']['input'];
};


export type MutationDeleteClaimItemArgs = {
  claimCode: Scalars['String']['input'];
  itemInternalRef: Scalars['String']['input'];
};


export type MutationDeleteCustomNetworkExclusionsArgs = {
  empaneledProviderCodes: Array<Scalars['String']['input']>;
  networkCode: Scalars['String']['input'];
};


export type MutationDeleteCustomNetworkInclusionsArgs = {
  empaneledProviderCodes: Array<Scalars['String']['input']>;
  networkCode: Scalars['String']['input'];
};


export type MutationDeleteCustomNetworkLinkedNetworkArgs = {
  networkCode: Scalars['String']['input'];
};


export type MutationDeleteDiagnosisArgs = {
  diagnosis: DeleteBillingDiagnosisInput;
};


export type MutationDeleteDocumentArgs = {
  document: DeleteBillingDocumentInput;
};


export type MutationDeleteEmpaneledProviderArgs = {
  empaneledProviderCode: Scalars['String']['input'];
};


export type MutationDeleteEmpaneledProviderContractArgs = {
  contractCode: Scalars['String']['input'];
  empaneledProviderCode: Scalars['String']['input'];
};


export type MutationDeleteEndorsementDocumentArgs = {
  documentKey: Scalars['String']['input'];
  endorsementId: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
};


export type MutationDeleteEndorsementsArgs = {
  endorsementIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteIntermediaryArgs = {
  intermediaryKey: Scalars['String']['input'];
};


export type MutationDeleteIntermediaryAddressArgs = {
  addressType: PayerAddressType;
  intermediaryKey: Scalars['String']['input'];
};


export type MutationDeleteIntermediaryContactArgs = {
  contactKey: Scalars['String']['input'];
  intermediaryKey: Scalars['String']['input'];
};


export type MutationDeleteIntermediaryContractArgs = {
  intermediaryKey: Scalars['String']['input'];
  payerKey: Scalars['String']['input'];
};


export type MutationDeleteIntermediaryDocumentArgs = {
  documentKey: Scalars['String']['input'];
  intermediaryKey: Scalars['String']['input'];
};


export type MutationDeleteIntermediaryLicenseArgs = {
  intermediaryKey: Scalars['String']['input'];
  intermediaryLicenseKey: Scalars['String']['input'];
};


export type MutationDeleteIntermediaryUserArgs = {
  intermediaryKey: Scalars['String']['input'];
  userKey: Scalars['String']['input'];
};


export type MutationDeleteMemberArgs = {
  memberId: Scalars['String']['input'];
};


export type MutationDeletePayerArgs = {
  payerKey: Scalars['String']['input'];
};


export type MutationDeletePayerAddressArgs = {
  addressType: PayerAddressType;
  payerKey: Scalars['String']['input'];
};


export type MutationDeletePayerBankAccountArgs = {
  bankAccountType: PayerBankAccountType;
  payerKey: Scalars['String']['input'];
};


export type MutationDeletePayerContactArgs = {
  contactKey: Scalars['String']['input'];
  payerKey: Scalars['String']['input'];
};


export type MutationDeletePayerDocumentArgs = {
  documentKey: Scalars['String']['input'];
  payerKey: Scalars['String']['input'];
};


export type MutationDeletePayerUserArgs = {
  payerKey: Scalars['String']['input'];
  userKey: Scalars['String']['input'];
};


export type MutationDeletePecCoverageArgs = {
  pecCoverageCode: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};


export type MutationDeletePlatformUserArgs = {
  externalKey: Scalars['String']['input'];
};


export type MutationDeletePolicyholderDocumentArgs = {
  documentId: Scalars['String']['input'];
  policyholderId: Scalars['String']['input'];
};


export type MutationDeletePreAuthorizationOverrideArgs = {
  deletePreAuthorizationOverride: DeletePreAuthorizationOverride;
};


export type MutationDeletePriceAgreementArgs = {
  deleteAllVersions: Scalars['Boolean']['input'];
  priceAgreementId: Scalars['String']['input'];
};


export type MutationDeleteProductArgs = {
  productCode: Scalars['String']['input'];
};


export type MutationDeleteProductBenefitArgs = {
  productBenefitCode: Scalars['String']['input'];
  productBenefitTypeCode: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};


export type MutationDeleteProductBenefitTypeArgs = {
  productBenefitTypeCode: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};


export type MutationDeleteProductIntermediaryArgs = {
  intermediaryRef: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};


export type MutationDeleteProductProviderNetworkArgs = {
  productCode: Scalars['String']['input'];
  productProviderNetworkCode: Scalars['String']['input'];
};


export type MutationDeleteProductSubBenefitArgs = {
  productBenefitTypeCode: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
  productSubBenefitCode: Scalars['String']['input'];
};


export type MutationDeleteProviderContactArgs = {
  contactCode: Scalars['String']['input'];
  providerCode: Scalars['String']['input'];
};


export type MutationDeleteProviderExternalCodeArgs = {
  providerExternalCode: Scalars['String']['input'];
};


export type MutationDeleteProviderLicenseArgs = {
  providerCode: Scalars['String']['input'];
  providerLicenseCode: Scalars['String']['input'];
};


export type MutationDeleteProviderLicenseDocumentArgs = {
  providerCode: Scalars['String']['input'];
  providerLicenseCode: Scalars['String']['input'];
  providerLicenseDocumentCode: Scalars['String']['input'];
};


export type MutationDeleteProviderPaymentAccountArgs = {
  accountCode: Scalars['String']['input'];
  providerCode: Scalars['String']['input'];
};


export type MutationDeleteProviderUserArgs = {
  providerCode: Scalars['String']['input'];
  userCode: Scalars['String']['input'];
};


export type MutationDeleteQuotationArgs = {
  quotationCode: Scalars['String']['input'];
};


export type MutationDeleteQuotationDocumentArgs = {
  quotationCode: Scalars['String']['input'];
  quotationDocumentCode: Scalars['String']['input'];
};


export type MutationDeleteReinsurerContractArgs = {
  payerKey: Scalars['String']['input'];
  reinsurerKey: Scalars['String']['input'];
};


export type MutationDeleteRoomTypeArgs = {
  productCode: Scalars['String']['input'];
  roomTypeCode: Scalars['String']['input'];
};


export type MutationDeleteTerritorialCoverageArgs = {
  productCode: Scalars['String']['input'];
  territorialCoverageCode: Scalars['String']['input'];
};


export type MutationDeleteVisitArgs = {
  deleteReason: InputMaybe<Scalars['String']['input']>;
  visitCode: Scalars['String']['input'];
};


export type MutationDisablePromotionsArgs = {
  userKey: Scalars['String']['input'];
};


export type MutationDiscardPolicyArgs = {
  policyId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationDuplicateProductArgs = {
  productCode: Scalars['String']['input'];
  productName: Scalars['String']['input'];
};


export type MutationDuplicateQuotationArgs = {
  quotationCode: Scalars['String']['input'];
};


export type MutationEnablePromotionsArgs = {
  userKey: Scalars['String']['input'];
};


export type MutationEnrichPreAuthorizationArgs = {
  enrichment: PreAuthorizationEnrichment;
  reference: Scalars['String']['input'];
};


export type MutationEvaluateEndorsementPremiumImpactArgs = {
  evaluateEndorsementRequest: EvaluateEndorsementPremiumsInput;
};


export type MutationExtendPolicyArgs = {
  endDate: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationFinalizeClaimArgs = {
  claimCode: Scalars['String']['input'];
};


export type MutationFinalizeDraftPreAuthorizationArgs = {
  finalize: InputMaybe<FinalizeDraftPreAuthorization>;
  reference: Scalars['String']['input'];
};


export type MutationInitiateBulkUploadArgs = {
  bulkId: Scalars['String']['input'];
  policyId: InputMaybe<Scalars['String']['input']>;
  type: BulkUploadType;
};


export type MutationInviteIntermediaryUserArgs = {
  intermediaryKey: Scalars['String']['input'];
  user: InviteIntermediaryUserInput;
};


export type MutationInvitePayerUserArgs = {
  payerKey: Scalars['String']['input'];
  user: InvitePayerUserInput;
};


export type MutationInvitePlatformUserArgs = {
  email: Scalars['String']['input'];
  roles: InputMaybe<Array<InputMaybe<PlatformUserRole>>>;
  url: InputMaybe<Scalars['String']['input']>;
};


export type MutationInviteProviderUserArgs = {
  providerCode: Scalars['String']['input'];
  user: CreateUserInput;
};


export type MutationLinkIntermediaryArgs = {
  intermediaryKey: Scalars['String']['input'];
  payerKey: Scalars['String']['input'];
};


export type MutationLinkPreAuthorizationArgs = {
  caseReference: Scalars['String']['input'];
  preAuthReference: Scalars['String']['input'];
};


export type MutationLinkReinsurerArgs = {
  payerKey: Scalars['String']['input'];
  reinsurerKey: Scalars['String']['input'];
};


export type MutationMapMedicalCodeArgs = {
  carepayCode: Scalars['String']['input'];
  medicalCodeId: Scalars['String']['input'];
};


export type MutationOverridePreAuthorizationArgs = {
  overridePreAuthorization: InputMaybe<OverridePreAuthorization>;
  preAuthorizationReference: Scalars['String']['input'];
};


export type MutationOverridePreAuthorizationItemArgs = {
  itemReference: Scalars['String']['input'];
  overridePreAuthorizationItem: InputMaybe<OverridePreAuthorizationItem>;
  preAuthorizationReference: Scalars['String']['input'];
};


export type MutationPartiallyApproveClaimItemArgs = {
  claimCode: Scalars['String']['input'];
  itemCode: Scalars['String']['input'];
  partialApproval: InputMaybe<PartialApprovalClaimItem>;
};


export type MutationPartiallyApprovePreAuthorizationItemArgs = {
  itemReference: Scalars['String']['input'];
  partialApproval: PreAuthorizationPartialApproval;
  preAuthorizationReference: Scalars['String']['input'];
};


export type MutationPatchVisitArgs = {
  patchVisitInput: PatchVisitInput;
};


export type MutationPaymentInstructionArgs = {
  paymentInstructionInputs: Array<PaymentInstructionInput>;
};


export type MutationPerformEndorsementActionArgs = {
  endorsementAction: EndorsementActionWithReason;
  file: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['String']['input'];
};


export type MutationPerformEndorsementWorkflowActionArgs = {
  endorsementWorkflowActionInput: InputMaybe<EndorsementWorkflowActionInput>;
};


export type MutationPerformReinstateEndorsementActionArgs = {
  id: Scalars['String']['input'];
  reinstateEndorsementAction: ReinstateEndorsementActionInput;
};


export type MutationPreAuthorizationBulkUploadArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationPublishQuotationArgs = {
  quotationCode: Scalars['String']['input'];
};


export type MutationReactivateEmpaneledProviderArgs = {
  empaneledProviderCode: Scalars['String']['input'];
};


export type MutationReactivatePolicyArgs = {
  policyId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRejectPolicyArgs = {
  policyId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRejectPreAuthorizationArgs = {
  fields: RejectionFields;
};


export type MutationRejectPreAuthorizationItemArgs = {
  fault: InputMaybe<FaultRequest>;
  itemReference: Scalars['String']['input'];
  motivation: InputMaybe<PreAuthorizationChangeMotivation>;
  preAuthorizationReference: Scalars['String']['input'];
};


export type MutationRejectProductArgs = {
  productCode: Scalars['String']['input'];
};


export type MutationRejectQuotationArgs = {
  quotationCode: Scalars['String']['input'];
};


export type MutationRemoveInvoiceItemArgs = {
  invoiceItem: RemoveInvoiceItemInput;
};


export type MutationRemoveMedicalTagsArgs = {
  removeTagsRequest: MedicalTagsInput;
};


export type MutationRemovePriceAgreementItemsArgs = {
  priceAgreementId: Scalars['String']['input'];
  priceAgreementItemsIds: Array<Scalars['String']['input']>;
};


export type MutationRemovePriceListItemsArgs = {
  priceListId: Scalars['String']['input'];
  priceListItemsIds: Array<Scalars['String']['input']>;
};


export type MutationRemoveRegulatedPriceListItemsArgs = {
  priceListId: Scalars['String']['input'];
  priceListItemsIds: Array<Scalars['String']['input']>;
};


export type MutationRenewPolicyArgs = {
  fromPolicyId: Scalars['String']['input'];
  toPolicyId: Scalars['String']['input'];
};


export type MutationReopenClaimArgs = {
  claimCode: Scalars['String']['input'];
  reopenClaimInput: InputMaybe<ReopenClaimInput>;
};


export type MutationReopenPreAuthorizationArgs = {
  reference: Scalars['String']['input'];
  reopenPreAuthorization: InputMaybe<ReopenPreAuthorization>;
};


export type MutationResetFingerprintPersonArgs = {
  personRef: Scalars['String']['input'];
};


export type MutationResubmitPreAuthorizationArgs = {
  preAuthorization: ResubmitPreAuthorization;
  preAuthorizationReference: Scalars['String']['input'];
};


export type MutationReverseClaimArgs = {
  claimCode: Scalars['String']['input'];
  reverseClaimInput: ReverseClaimInput;
};


export type MutationRevertProductToDraftArgs = {
  productCode: Scalars['String']['input'];
};


export type MutationRevertQuotationToDraftArgs = {
  quotationCode: Scalars['String']['input'];
};


export type MutationSendExternalCommunicationArgs = {
  communication: ExternalCommunication;
  reference: Scalars['String']['input'];
};


export type MutationSendPersonOtpArgs = {
  oneTimePasswordRequest: OneTimePasswordRequest;
  personRef: Scalars['String']['input'];
};


export type MutationSendPolicyForApprovalArgs = {
  policyId: Scalars['String']['input'];
};


export type MutationSetApprovalRulesArgs = {
  approvalRules: ApprovalRulesInput;
  payerKey: Scalars['String']['input'];
};


export type MutationSetDefaultBaseRatesArgs = {
  defaultBaseRates: DefaultBaseRatesInput;
  productCode: Scalars['String']['input'];
};


export type MutationSetGenderBaseRatesArgs = {
  genderBaseRates: GenderBaseRatesInput;
  productCode: Scalars['String']['input'];
};


export type MutationSetInstalmentsArgs = {
  instalments: InstalmentsInput;
  payerKey: Scalars['String']['input'];
};


export type MutationSetLoadingArgs = {
  loading: LoadingInput;
  payerKey: Scalars['String']['input'];
};


export type MutationSetQuotationPremiumArgs = {
  premiumLoadingInput: SetQuotationPremiumLoadingInput;
  quotationCode: Scalars['String']['input'];
};


export type MutationSetReimbursementRulesArgs = {
  productCode: Scalars['String']['input'];
  reimbursementRules: ReimbursementRulesInput;
};


export type MutationSubmitPreAuthorizationsArgs = {
  billRef: Scalars['String']['input'];
  submitPreAuthorizationInput: InputMaybe<SubmitPreAuthorizationInput>;
};


export type MutationSubmitProductForReviewArgs = {
  productCode: Scalars['String']['input'];
};


export type MutationSubmitQuotationForReviewArgs = {
  quotationCode: Scalars['String']['input'];
};


export type MutationSubmitRemittanceRequestArgs = {
  remittanceRequestInput: RemittanceRequestInput;
};


export type MutationSuspendEmpaneledProviderArgs = {
  empaneledProviderCode: Scalars['String']['input'];
  suspendEmpaneledProvider: SuspendEmpaneledProviderInput;
};


export type MutationSuspendPolicyArgs = {
  policyId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationTogglePremiumInstalmentIsPaidArgs = {
  toggleIsPaidRequest: TogglePremiumInstalmentIsPaidInput;
};


export type MutationUnlinkPreAuthorizationArgs = {
  caseReference: Scalars['String']['input'];
  preAuthReference: Scalars['String']['input'];
};


export type MutationUpdateAnnualMedicalLimitArgs = {
  annualMedicalLimit: UpdateAnnualMedicalLimitInput;
  annualMedicalLimitCode: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};


export type MutationUpdateBedCapacityArgs = {
  bed: UpdateBedCapacityInput;
  bedCode: Scalars['String']['input'];
  providerCode: Scalars['String']['input'];
};


export type MutationUpdateBeneficiaryArgs = {
  beneficiaryInput: BeneficiaryInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateBenefitArgs = {
  benefitId: Scalars['String']['input'];
  benefitInput: BenefitInput;
};


export type MutationUpdateBillInvoiceArgs = {
  updateBillInvoice: UpdateBillInvoiceInput;
};


export type MutationUpdateBillNoteArgs = {
  updateBillNote: UpdateBillNoteInput;
};


export type MutationUpdateBusinessPropertiesArgs = {
  businessProperties: InputMaybe<Array<BusinessPropertyInput>>;
};


export type MutationUpdateCategoryArgs = {
  categoryId: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
  updateCategoryInput: UpdateCategoryInput;
};


export type MutationUpdateCategoryFamilyCompositionArgs = {
  categoryId: Scalars['String']['input'];
  familyCompositionInput: FamilyCompositionInput;
  policyId: Scalars['String']['input'];
};


export type MutationUpdateChangeRequestStatusArgs = {
  changeRequestCode: Scalars['String']['input'];
  changeRequestStatus: ChangeRequestStatus;
};


export type MutationUpdateClaimDiagnosisArgs = {
  claimCode: Scalars['String']['input'];
  diagnosisInternalRef: Scalars['String']['input'];
  updateDiagnosisInput: InputMaybe<UpdateDiagnosisInput>;
};


export type MutationUpdateClaimItemArgs = {
  claimCode: Scalars['String']['input'];
  itemInternalRef: Scalars['String']['input'];
  updateClaimItemInput: UpdateClaimItemInput;
};


export type MutationUpdateCollectiveModifierArgs = {
  collectiveModifier: CollectiveModifierInput;
  priceAgreementId: Scalars['String']['input'];
};


export type MutationUpdateCustomProviderNetworkArgs = {
  networkCode: Scalars['String']['input'];
  providerNetwork: CustomProviderNetworkInput;
};


export type MutationUpdateEmpaneledProviderArgs = {
  empaneledProviderCode: Scalars['String']['input'];
  updateEmpaneledProvider: UpdateEmpaneledProviderInput;
};


export type MutationUpdateEmployeeLicenseArgs = {
  employeeLicense: UpdateEmployeeLicenseInput;
  employeeLicenseCode: Scalars['String']['input'];
};


export type MutationUpdateEndorsementArgs = {
  beneficiaryInput: BeneficiaryInput;
  endorsementId: Scalars['String']['input'];
};


export type MutationUpdateExternalMedicalCodeArgs = {
  medicalCodeId: Scalars['String']['input'];
  updateMedicalCodeRequest: MedicalCodeUpdateInput;
};


export type MutationUpdateGroupPartyArgs = {
  groupPartyInput: GroupPartyInput;
  policyholderId: Scalars['String']['input'];
};


export type MutationUpdateGroupSubPartyArgs = {
  groupPartyInput: GroupPartyInput;
  subPolicyholderId: Scalars['String']['input'];
};


export type MutationUpdateIndividualPartyArgs = {
  individualPartyInput: IndividualPartyInput;
  policyholderId: Scalars['String']['input'];
};


export type MutationUpdateIntermediaryArgs = {
  intermediary: UpdateIntermediaryInput;
  intermediaryKey: Scalars['String']['input'];
};


export type MutationUpdateIntermediaryAddressArgs = {
  address: UpdatePayerAddressInput;
  addressType: PayerAddressType;
  intermediaryKey: Scalars['String']['input'];
};


export type MutationUpdateIntermediaryBankAccountArgs = {
  bankAccount: UpdatePayerBankAccountInput;
  intermediaryKey: Scalars['String']['input'];
};


export type MutationUpdateIntermediaryContactArgs = {
  contact: UpdatePayerContactInput;
  contactKey: Scalars['String']['input'];
  intermediaryKey: Scalars['String']['input'];
};


export type MutationUpdateIntermediaryContractArgs = {
  intermediaryKey: Scalars['String']['input'];
  payerKey: Scalars['String']['input'];
  status: IntermediaryContractStatus;
};


export type MutationUpdateIntermediaryExternalCodesArgs = {
  intermediaryExternalCodes: Array<PayerExternalCodeInput>;
  intermediaryKey: Scalars['String']['input'];
};


export type MutationUpdateIntermediaryLicenseArgs = {
  details: IntermediaryLicenseInput;
  file: InputMaybe<Scalars['Upload']['input']>;
  intermediaryKey: Scalars['String']['input'];
  licenseKey: Scalars['String']['input'];
};


export type MutationUpdateIntermediaryStatusArgs = {
  intermediaryKey: Scalars['String']['input'];
  status: IntermediaryStatus;
};


export type MutationUpdateIntermediaryUserArgs = {
  intermediaryKey: Scalars['String']['input'];
  roles: Array<IntermediaryRole>;
  userKey: Scalars['String']['input'];
};


export type MutationUpdateMemberArgs = {
  member: MemberInput;
  memberId: Scalars['String']['input'];
};


export type MutationUpdatePayerAddressArgs = {
  address: UpdatePayerAddressInput;
  addressType: PayerAddressType;
  payerKey: Scalars['String']['input'];
};


export type MutationUpdatePayerBankAccountArgs = {
  bankAccount: UpdatePayerBankAccountInput;
  bankAccountType: PayerBankAccountType;
  payerKey: Scalars['String']['input'];
};


export type MutationUpdatePayerContactArgs = {
  contact: UpdatePayerContactInput;
  contactKey: Scalars['String']['input'];
  payerKey: Scalars['String']['input'];
};


export type MutationUpdatePayerCopayRuleArgs = {
  code: Scalars['String']['input'];
  payerCopayRule: PayerCopayRuleUpdate;
  payerKey: Scalars['String']['input'];
};


export type MutationUpdatePayerCopayRuleScopeArgs = {
  code: Scalars['String']['input'];
  payerCopayRuleScope: PayerCopayRuleScopeInput;
  payerKey: Scalars['String']['input'];
};


export type MutationUpdatePayerDetailsArgs = {
  payer: UpdatePayerInput;
  payerKey: Scalars['String']['input'];
};


export type MutationUpdatePayerExternalCodesArgs = {
  payerExternalCodes: Array<PayerExternalCodeInput>;
  payerKey: Scalars['String']['input'];
};


export type MutationUpdatePayerLogoArgs = {
  logo: Scalars['Upload']['input'];
  payerKey: Scalars['String']['input'];
};


export type MutationUpdatePayerStatusArgs = {
  payerKey: Scalars['String']['input'];
  status: PayerStatus;
};


export type MutationUpdatePayerUserArgs = {
  payerKey: Scalars['String']['input'];
  roles: Array<PayerRole>;
  userKey: Scalars['String']['input'];
};


export type MutationUpdatePaymentContractArgs = {
  internalRef: Scalars['String']['input'];
  updatePaymentContractInput: UpdatePaymentContractInput;
};


export type MutationUpdatePecCoverageArgs = {
  pecCoverage: UpdatePecCoverageInput;
  pecCoverageCode: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};


export type MutationUpdatePlanFamilyCompositionArgs = {
  familyCompositionInput: FamilyCompositionInput;
  planId: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
};


export type MutationUpdatePlatformUserRolesArgs = {
  externalKey: Scalars['String']['input'];
  roles: Array<PlatformUserRole>;
};


export type MutationUpdatePolicyArgs = {
  policyId: Scalars['String']['input'];
  updatePolicyInput: UpdatePolicyInput;
};


export type MutationUpdatePreAuthorizationOverrideArgs = {
  updatePreAuthorizationOverride: UpdatePreAuthorizationOverride;
};


export type MutationUpdatePreAuthorizationValidityDatesArgs = {
  modifyPreAuthorizationValidityDates: ModifyPreAuthorizationValidityDates;
  preAuthorizationAdjudicationReference: Scalars['String']['input'];
  preAuthorizationReference: Scalars['String']['input'];
};


export type MutationUpdatePriceAgreementArgs = {
  priceAgreement: UpdatePriceAgreementInput;
  priceAgreementId: Scalars['String']['input'];
};


export type MutationUpdateProductArgs = {
  product: UpdateProductInput;
  productCode: Scalars['String']['input'];
};


export type MutationUpdateProductBenefitArgs = {
  productBenefit: UpdateProductBenefitInput;
  productBenefitCode: Scalars['String']['input'];
  productBenefitTypeCode: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};


export type MutationUpdateProductBenefitTypeArgs = {
  productBenefitType: UpdateProductBenefitTypeInput;
  productBenefitTypeCode: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};


export type MutationUpdateProductProviderNetworkArgs = {
  productCode: Scalars['String']['input'];
  productProviderNetwork: UpdateProductProviderNetworkInput;
  productProviderNetworkCode: Scalars['String']['input'];
};


export type MutationUpdateProductSubBenefitArgs = {
  productBenefitTypeCode: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
  productSubBenefit: UpdateProductSubBenefitInput;
  productSubBenefitCode: Scalars['String']['input'];
};


export type MutationUpdateProviderArgs = {
  provider: UpdateProviderInput;
  providerCode: Scalars['String']['input'];
};


export type MutationUpdateProviderBankAccountArgs = {
  accountCode: Scalars['String']['input'];
  providerBankAccount: ProviderBankAccountInput;
  providerCode: Scalars['String']['input'];
};


export type MutationUpdateProviderContactArgs = {
  contactCode: Scalars['String']['input'];
  providerCode: Scalars['String']['input'];
  providerContact: ProviderContactInput;
};


export type MutationUpdateProviderEmployeeArgs = {
  employeeCode: Scalars['String']['input'];
  providerEmployee: UpdateProviderEmployeeInput;
};


export type MutationUpdateProviderEmployeeStatusArgs = {
  employeeCode: Scalars['String']['input'];
  employeeStatus: EmployeeStatus;
};


export type MutationUpdateProviderLicenseArgs = {
  providerCode: Scalars['String']['input'];
  providerLicense: ProviderLicenseInput;
  providerLicenseCode: Scalars['String']['input'];
};


export type MutationUpdateProviderMobileWalletAccountArgs = {
  accountCode: Scalars['String']['input'];
  providerCode: Scalars['String']['input'];
  providerMobileWalletAccount: ProviderMobileWalletAccountInput;
};


export type MutationUpdateProviderStatusArgs = {
  providerCode: Scalars['String']['input'];
  providerStatus: ProviderStatus;
};


export type MutationUpdateProviderUserArgs = {
  providerCode: Scalars['String']['input'];
  roles: Array<ProviderRole>;
  userKey: Scalars['String']['input'];
};


export type MutationUpdateQuotationArgs = {
  quotation: UpdateQuotationInput;
  quotationCode: Scalars['String']['input'];
};


export type MutationUpdateQuotationCategoryArgs = {
  categoryCode: Scalars['String']['input'];
  categoryInput: UpdateQuotationCategoryInput;
  quotationCode: Scalars['String']['input'];
};


export type MutationUpdateReinsurerContractArgs = {
  payerKey: Scalars['String']['input'];
  reinsurerKey: Scalars['String']['input'];
  status: ReinsurerContractStatus;
};


export type MutationUpdateRoomTypeArgs = {
  productCode: Scalars['String']['input'];
  roomType: UpdateRoomTypeInput;
  roomTypeCode: Scalars['String']['input'];
};


export type MutationUpdateRuleEngineRulesArgs = {
  payerKey: Scalars['String']['input'];
  rules: InputMaybe<Array<RuleEngineRuleInput>>;
};


export type MutationUpdateStandardProviderNetworkArgs = {
  networkCode: Scalars['String']['input'];
  providerNetwork: StandardProviderNetworkInput;
};


export type MutationUpdateTerritorialCoverageArgs = {
  productCode: Scalars['String']['input'];
  territorialCoverage: UpdateTerritorialCoverageInput;
  territorialCoverageCode: Scalars['String']['input'];
};


export type MutationUpdateTierToRoleMappingsArgs = {
  tierToRoleMappings: InputMaybe<Array<TierToRoleMappingInput>>;
};


export type MutationUploadBeneficiariesArgs = {
  file: Scalars['Upload']['input'];
  policyId: Scalars['String']['input'];
};


export type MutationUploadBeneficiaryDocumentArgs = {
  beneficiaryPolicyId: Scalars['String']['input'];
  description: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  type: BeneficiaryDocumentType;
};


export type MutationUploadCensusEntriesArgs = {
  file: Scalars['Upload']['input'];
  quotationCode: Scalars['String']['input'];
};


export type MutationUploadClaimDocumentArgs = {
  code: Scalars['String']['input'];
  details: DocumentDetailsInput;
  document: Scalars['Upload']['input'];
};


export type MutationUploadDocumentArgs = {
  detail: PayerDocumentInput;
  file: Scalars['Upload']['input'];
  payerKey: Scalars['String']['input'];
};


export type MutationUploadEmpaneledProviderContractArgs = {
  empaneledProviderCode: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationUploadEmployeesArgs = {
  file: Scalars['Upload']['input'];
  jobType: JobRole;
  providerCode: Scalars['String']['input'];
};


export type MutationUploadEndorsementDocumentArgs = {
  description: InputMaybe<Scalars['String']['input']>;
  endorsementId: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
  policyId: Scalars['String']['input'];
  type: BeneficiaryDocumentType;
};


export type MutationUploadIntermediaryDocumentArgs = {
  detail: PayerDocumentInput;
  file: Scalars['Upload']['input'];
  intermediaryKey: Scalars['String']['input'];
};


export type MutationUploadIntermediaryLicenseArgs = {
  details: IntermediaryLicenseInput;
  file: Scalars['Upload']['input'];
  intermediaryKey: Scalars['String']['input'];
};


export type MutationUploadMedicalCodesArgs = {
  category: MedicalProductCategory;
  codingSystemId: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationUploadPolicyArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadPolicyholderDocumentArgs = {
  description: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  policyholderId: Scalars['String']['input'];
  type: PolicyholderDocumentType;
};


export type MutationUploadPreAuthorizationDocumentsArgs = {
  description: InputMaybe<Scalars['String']['input']>;
  docType: PreAuthorizationDocumentType;
  file: Scalars['Upload']['input'];
  reference: Scalars['String']['input'];
};


export type MutationUploadPreAuthorizationItemDocumentArgs = {
  details: InputMaybe<DocumentDetails>;
  file: Scalars['Upload']['input'];
  itemReference: Scalars['String']['input'];
  preAuthReference: Scalars['String']['input'];
};


export type MutationUploadPriceAgreementFileArgs = {
  file: Scalars['Upload']['input'];
  priceAgreementId: Scalars['String']['input'];
};


export type MutationUploadPriceListFileArgs = {
  file: Scalars['Upload']['input'];
  priceListId: Scalars['String']['input'];
};


export type MutationUploadProviderLicenseDocumentArgs = {
  file: Scalars['Upload']['input'];
  providerCode: Scalars['String']['input'];
  providerLicenseCode: Scalars['String']['input'];
};


export type MutationUploadQuotationDocumentArgs = {
  description: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  quotationCode: Scalars['String']['input'];
  type: QuotationDocumentType;
};


export type MutationUploadRegulatedPriceListFileArgs = {
  file: Scalars['Upload']['input'];
  priceListId: Scalars['String']['input'];
};


export type MutationVerifyFingerprintArgs = {
  fingerprint: Scalars['Upload']['input'];
  personRef: Scalars['String']['input'];
};


export type MutationVerifyPersonOtpArgs = {
  otp: Scalars['String']['input'];
  personRef: Scalars['String']['input'];
};

export type NetPremiumAmount = {
  __typename?: 'NetPremiumAmount';
  netPremium: MonetaryAmount;
  numberOfEntries: Scalars['Int']['output'];
};

export type NetworkAdditionResponse = Error | Success;

export type NextOfKin = {
  __typename?: 'NextOfKin';
  name: Scalars['String']['output'];
  otherRelationship: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  relationship: NextOfKinRelationship;
};

export type NextOfKinInput = {
  name: Scalars['String']['input'];
  otherRelationship: InputMaybe<Scalars['String']['input']>;
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  relationship: NextOfKinRelationship;
};

export enum NextOfKinRelationship {
  Child = 'CHILD',
  Grandparent = 'GRANDPARENT',
  Other = 'OTHER',
  Parent = 'PARENT',
  Primary = 'PRIMARY',
  Sibling = 'SIBLING',
  Spouse = 'SPOUSE'
}

export enum Occupation {
  Employed = 'EMPLOYED',
  Student = 'STUDENT',
  Unemployed = 'UNEMPLOYED'
}

export enum OneTimePasswordMethodType {
  Sms = 'SMS'
}

export type OneTimePasswordRequest = {
  method: OneTimePasswordMethodType;
  phoneNumber: Scalars['String']['input'];
};

export type OperatingTime = {
  __typename?: 'OperatingTime';
  closingTime: Scalars['String']['output'];
  dayOfTheWeek: Scalars['Int']['output'];
  openingTime: Scalars['String']['output'];
};

export type OperatingTimeInput = {
  closingTime: Scalars['String']['input'];
  dayOfTheWeek: Scalars['Int']['input'];
  openingTime: Scalars['String']['input'];
};

export type OverridePreAuthorization = {
  reason: PreAuthorizationOverrideReason;
};

export type OverridePreAuthorizationItem = {
  reason: ItemOverrideReason;
};

export type OverridePreAuthorizationItemResponse = Error | Success;

export type OverridePreAuthorizationResponse = Error | Success;

export enum OverrideReason {
  DosageJustified = 'DOSAGE_JUSTIFIED',
  ExceedingMaximumDosage = 'EXCEEDING_MAXIMUM_DOSAGE',
  ExGratia = 'EX_GRATIA',
  IncorrectlyRejectedByPlatform = 'INCORRECTLY_REJECTED_BY_PLATFORM',
  MedicallyJustified = 'MEDICALLY_JUSTIFIED',
  Other = 'OTHER',
  PayerDecision = 'PAYER_DECISION',
  StepUpTherapy = 'STEP_UP_THERAPY',
  TravelRelatedMedicationDispensed = 'TRAVEL_RELATED_MEDICATION_DISPENSED',
  VipMember = 'VIP_MEMBER'
}

export type OverrideValidityPeriod = {
  __typename?: 'OverrideValidityPeriod';
  end: Maybe<Scalars['String']['output']>;
  start: Maybe<Scalars['String']['output']>;
};

export type OverrideValidityPeriodInput = {
  end: InputMaybe<Scalars['String']['input']>;
  start: InputMaybe<Scalars['String']['input']>;
};

export enum OwnerType {
  Participant = 'PARTICIPANT',
  Payer = 'PAYER',
  Provider = 'PROVIDER'
}

export enum Ownership {
  Community = 'COMMUNITY',
  FaithBased = 'FAITH_BASED',
  Government = 'GOVERNMENT',
  Other = 'OTHER',
  Private = 'PRIVATE',
  SemiGovernment = 'SEMI_GOVERNMENT'
}

export type PackageType = {
  __typename?: 'PackageType';
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type PackageTypesFilter = {
  name: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
};

export type PackageTypesPage = CarePage & {
  __typename?: 'PackageTypesPage';
  data: Maybe<Array<PackageType>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PartialApprovalClaimItem = {
  code: Scalars['String']['input'];
  description: InputMaybe<Scalars['String']['input']>;
  discount: InputMaybe<Scalars['Float']['input']>;
  exGratiaAmount: InputMaybe<MonetaryAmountInput>;
  note: InputMaybe<Scalars['String']['input']>;
  overdraftComment: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  quantityCountBalance: InputMaybe<Scalars['Float']['input']>;
  recoverableAmount: InputMaybe<MonetaryAmountInput>;
  requiredPatientShare: InputMaybe<MonetaryAmountInput>;
  unitPrice: MonetaryAmountInput;
};

export type PartiallyApproveClaimItemResponse = Error | Success;

export type PartyAdmin = {
  __typename?: 'PartyAdmin';
  emailAddress: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  surname: Maybe<Scalars['String']['output']>;
  telephoneNumber: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type PartyAdminInput = {
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  surname: Scalars['String']['input'];
  telephoneNumber: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
};

export type PartyAlias = {
  __typename?: 'PartyAlias';
  alias: Maybe<Scalars['String']['output']>;
};

export type PartyRisk = {
  __typename?: 'PartyRisk';
  profile: Maybe<PartyRiskProfile>;
  type: Maybe<PartyRiskType>;
};

export type PartyRiskInput = {
  profile: InputMaybe<PartyRiskProfile>;
  type: InputMaybe<PartyRiskTypeInput>;
};

export enum PartyRiskProfile {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type PartyRiskType = {
  __typename?: 'PartyRiskType';
  aml: Maybe<RiskValue>;
  ofac: Maybe<RiskValue>;
  pep: Maybe<RiskValue>;
};

export type PartyRiskTypeInput = {
  aml: InputMaybe<RiskValueInput>;
  ofac: InputMaybe<RiskValueInput>;
  pep: InputMaybe<RiskValueInput>;
};

export enum PartySubtype {
  Affinity = 'AFFINITY',
  Capitation = 'CAPITATION',
  Corporate = 'CORPORATE',
  Private = 'PRIVATE',
  SelfFunded = 'SELF_FUNDED',
  Sme = 'SME',
  VisitVisa = 'VISIT_VISA'
}

export enum PartyType {
  Group = 'GROUP',
  Individual = 'INDIVIDUAL'
}

export type PatchVisitInput = {
  code: Scalars['String']['input'];
  endDate: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

export type PatchVisitResponse = Error | Success;

export type PatientShare = {
  __typename?: 'PatientShare';
  amount: Maybe<MonetaryAmount>;
  method: Maybe<PaymentType>;
};

export type PatientShareInput = {
  amount: InputMaybe<MonetaryAmountInput>;
  method: InputMaybe<PaymentType>;
};

export type PatientShareLimit = {
  __typename?: 'PatientShareLimit';
  amount: MonetaryAmount;
  term: ProductCoverageTerm;
};

export type PatientShareLimitInput = {
  amount: MonetaryAmountInput;
  term: ProductCoverageTerm;
};

export enum PatientShareType {
  Amount = 'AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type PatientWeight = {
  __typename?: 'PatientWeight';
  unit: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['Float']['output']>;
};

export enum PayeeType {
  Patient = 'PATIENT',
  Provider = 'PROVIDER'
}

export type Payer = {
  __typename?: 'Payer';
  addresses: Maybe<Array<Maybe<PayerAddress>>>;
  approvalRules: Maybe<ApprovalRules>;
  bankAccounts: Maybe<Array<Maybe<PayerBankAccount>>>;
  category: Maybe<PayerCategory>;
  contacts: Maybe<Array<PayerContact>>;
  createdBy: Maybe<Scalars['String']['output']>;
  dateCreated: Maybe<Scalars['String']['output']>;
  dateModified: Maybe<Scalars['String']['output']>;
  defaultCurrency: Maybe<Scalars['String']['output']>;
  documents: Maybe<Array<PayerDocument>>;
  email: Maybe<Scalars['String']['output']>;
  externalCodes: Maybe<Array<PayerExternalCode>>;
  instalments: Maybe<Instalments>;
  intermediaries: Maybe<IntermediaryContractsPage>;
  key: Scalars['String']['output'];
  licenseNumber: Maybe<Scalars['String']['output']>;
  loading: Maybe<Loading>;
  logo: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  parent: Maybe<Payer>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  plans: Maybe<Array<Plan>>;
  reinsurerContracts: Maybe<ReinsurerContractPage>;
  status: Maybe<PayerStatus>;
  taxRegistrationNumber: Maybe<Scalars['String']['output']>;
  type: Maybe<PayerType>;
  users: Maybe<PayerUserPage>;
};


export type PayerInstalmentsArgs = {
  filter: InputMaybe<InstalmentFilter>;
};


export type PayerIntermediariesArgs = {
  filter: InputMaybe<IntermediaryContractFilter>;
};


export type PayerReinsurerContractsArgs = {
  filter: InputMaybe<ReinsurerContractFilter>;
};


export type PayerUsersArgs = {
  filter: InputMaybe<PayerUserFilter>;
};

export type PayerAddress = {
  __typename?: 'PayerAddress';
  addressLine1: Scalars['String']['output'];
  addressLine2: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  poBox: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  type: PayerAddressType;
  zipCode: Maybe<Scalars['String']['output']>;
};

export enum PayerAddressType {
  Billing = 'BILLING',
  Physical = 'PHYSICAL'
}

export type PayerBankAccount = {
  __typename?: 'PayerBankAccount';
  accountHolderName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  alias: Scalars['String']['output'];
  bankBic: Maybe<Scalars['String']['output']>;
  bankBranchCode: Maybe<Scalars['String']['output']>;
  bankBranchName: Maybe<Scalars['String']['output']>;
  bankCode: Maybe<Scalars['String']['output']>;
  bankName: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Scalars['String']['output']>;
  responsibleForPayout: Maybe<Payer>;
  type: PayerBankAccountType;
};

export enum PayerBankAccountType {
  All = 'ALL',
  ClaimPayment = 'CLAIM_PAYMENT',
  PremiumCollection = 'PREMIUM_COLLECTION'
}

export enum PayerCategory {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type PayerChildrenFilter = {
  name: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
  parentPayerKey: Scalars['String']['input'];
};

export type PayerContact = {
  __typename?: 'PayerContact';
  createdBy: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  designation: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  modifiedBy: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
};

export type PayerContractFilter = {
  page: InputMaybe<CarePageable>;
  payerKeys: InputMaybe<Array<Scalars['String']['input']>>;
  search: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<IntermediaryContractStatus>>;
};

export type PayerCopay = {
  __typename?: 'PayerCopay';
  amount: Maybe<MonetaryAmount>;
  booleanValue: Maybe<Scalars['Boolean']['output']>;
  code: Maybe<Scalars['String']['output']>;
  itemId: Maybe<Scalars['String']['output']>;
  percent: Maybe<Scalars['Float']['output']>;
  valueType: Maybe<AmountType>;
};

export type PayerCopayAmountInput = {
  amount: InputMaybe<MonetaryAmountInput>;
  booleanValue: InputMaybe<Scalars['Boolean']['input']>;
  percent: InputMaybe<Scalars['Float']['input']>;
  type: AmountType;
};

export type PayerCopayFilter = {
  activeAtDate: Scalars['String']['input'];
  amountType: InputMaybe<AmountType>;
  benefitId: InputMaybe<Scalars['String']['input']>;
  benefitType: InputMaybe<BenefitType>;
  categoryId: InputMaybe<Scalars['String']['input']>;
  copayItems: InputMaybe<Array<CopayItem>>;
  countryCode: InputMaybe<Scalars['String']['input']>;
  networkCode: InputMaybe<Scalars['String']['input']>;
  planId: InputMaybe<Scalars['String']['input']>;
  policyId: InputMaybe<Scalars['String']['input']>;
  providerAffiliationId: InputMaybe<Scalars['String']['input']>;
  providerCode: InputMaybe<Scalars['String']['input']>;
  providerType: InputMaybe<ProviderType>;
};

export type PayerCopayRule = {
  __typename?: 'PayerCopayRule';
  active: Scalars['Boolean']['output'];
  amount: PayerCopay;
  benefitTypes: Maybe<Array<BenefitType>>;
  benefits: Maybe<BenefitPage>;
  benefitsCount: Scalars['Int']['output'];
  category: Maybe<Category>;
  code: Scalars['String']['output'];
  country: Maybe<Country>;
  createdAt: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['String']['output']>;
  maximumAmount: Maybe<PayerCopay>;
  medicalProducts: Maybe<MedicalProductPage>;
  medicalProductsCount: Scalars['Int']['output'];
  medicalTags: Maybe<MedicalTagPage>;
  medicalTagsCount: Scalars['Int']['output'];
  modifiedAt: Maybe<Scalars['String']['output']>;
  networks: Maybe<ProviderNetworkPage>;
  networksCount: Scalars['Int']['output'];
  payer: Payer;
  plans: Maybe<PlanPage>;
  plansCount: Scalars['Int']['output'];
  policy: Maybe<Policy>;
  providerAffiliations: Maybe<AffiliationPage>;
  providerAffiliationsCount: Scalars['Int']['output'];
  providerTypes: Maybe<Array<ProviderType>>;
  providers: Maybe<ProviderPage>;
  providersCount: Scalars['Int']['output'];
  startDate: Scalars['String']['output'];
  term: Maybe<Term>;
};


export type PayerCopayRuleBenefitsArgs = {
  filter: InputMaybe<BenefitsFilter>;
};


export type PayerCopayRuleMedicalProductsArgs = {
  filter: InputMaybe<MedicalProductFilter>;
};


export type PayerCopayRuleMedicalTagsArgs = {
  filter: InputMaybe<MedicalTagFilter>;
};


export type PayerCopayRuleNetworksArgs = {
  filter: InputMaybe<ProviderNetworkFilter>;
};


export type PayerCopayRulePlansArgs = {
  filter: InputMaybe<PlanFilter>;
};


export type PayerCopayRuleProviderAffiliationsArgs = {
  filter: InputMaybe<AffiliationFilter>;
};


export type PayerCopayRuleProvidersArgs = {
  filter: InputMaybe<ProviderFilter>;
};

export type PayerCopayRuleFilter = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
};

export type PayerCopayRuleInput = {
  amount: PayerCopayAmountInput;
  categoryId: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  endDate: InputMaybe<Scalars['String']['input']>;
  maximumAmount: InputMaybe<PayerCopayAmountInput>;
  policyId: InputMaybe<Scalars['String']['input']>;
  ruleType: RuleType;
  startDate: Scalars['String']['input'];
  term: InputMaybe<Term>;
};

export type PayerCopayRulePage = CarePage & {
  __typename?: 'PayerCopayRulePage';
  data: Maybe<Array<PayerCopayRule>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PayerCopayRuleResponse = Error | Success;

export type PayerCopayRuleScopeInput = {
  items: Array<Scalars['String']['input']>;
  ruleScope: RuleScope;
};

export type PayerCopayRuleScopeResponse = Error | Success;

export type PayerCopayRuleUpdate = {
  active: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayerDocument = {
  __typename?: 'PayerDocument';
  createdBy: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  modifiedBy: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: PayerDocumentType;
};

export type PayerDocumentDownload = {
  __typename?: 'PayerDocumentDownload';
  url: Scalars['String']['output'];
};

export type PayerDocumentDownloadResponse = Error | PayerDocumentDownload;

export type PayerDocumentInput = {
  description: InputMaybe<Scalars['String']['input']>;
  type: PayerDocumentType;
};

export enum PayerDocumentType {
  AuditedFinancialStatements = 'AUDITED_FINANCIAL_STATEMENTS',
  CertificateOfIncorporation = 'CERTIFICATE_OF_INCORPORATION',
  CommercialOrTradeLicense = 'COMMERCIAL_OR_TRADE_LICENSE',
  Other = 'OTHER',
  PolicyTncGroup = 'POLICY_TNC_GROUP',
  PolicyTncRetail = 'POLICY_TNC_RETAIL',
  PrivacyStatement = 'PRIVACY_STATEMENT',
  RegulatoryLicense = 'REGULATORY_LICENSE',
  TermsOfService = 'TERMS_OF_SERVICE'
}

export type PayerExternalCode = {
  __typename?: 'PayerExternalCode';
  code: Scalars['String']['output'];
  system: Scalars['String']['output'];
};

export type PayerExternalCodeInput = {
  code: Scalars['String']['input'];
  system: Scalars['String']['input'];
};

export type PayerFilter = {
  categories: InputMaybe<Array<PayerCategory>>;
  codes: InputMaybe<Array<Scalars['String']['input']>>;
  email: InputMaybe<Scalars['String']['input']>;
  keys: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  licenseNumber: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
  permission: InputMaybe<Scalars['String']['input']>;
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<PayerStatus>>;
  systems: InputMaybe<Array<Scalars['String']['input']>>;
  types: InputMaybe<Array<PayerType>>;
};

export type PayerPage = CarePage & {
  __typename?: 'PayerPage';
  data: Maybe<Array<Maybe<Payer>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PayerParentsFilter = {
  includePayer: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
  payerKey: Scalars['String']['input'];
};

export type PayerResponse = Error | Payer;

export enum PayerRole {
  PayerActuary = 'PAYER_ACTUARY',
  PayerAdmin = 'PAYER_ADMIN',
  PayerAnalyst = 'PAYER_ANALYST',
  PayerCallCenterAgent = 'PAYER_CALL_CENTER_AGENT',
  PayerCallCenterSupervisor = 'PAYER_CALL_CENTER_SUPERVISOR',
  PayerCaseManager = 'PAYER_CASE_MANAGER',
  PayerChiefExecutiveOfficer = 'PAYER_CHIEF_EXECUTIVE_OFFICER',
  PayerChiefMedicalOfficer = 'PAYER_CHIEF_MEDICAL_OFFICER',
  PayerClaimsAuditor = 'PAYER_CLAIMS_AUDITOR',
  PayerClaimsManager = 'PAYER_CLAIMS_MANAGER',
  PayerFinanceManager = 'PAYER_FINANCE_MANAGER',
  PayerJuniorCaseManager = 'PAYER_JUNIOR_CASE_MANAGER',
  PayerJuniorClaimsManager = 'PAYER_JUNIOR_CLAIMS_MANAGER',
  PayerJuniorFinanceManager = 'PAYER_JUNIOR_FINANCE_MANAGER',
  PayerJuniorNetworkManager = 'PAYER_JUNIOR_NETWORK_MANAGER',
  PayerMedicalManager = 'PAYER_MEDICAL_MANAGER',
  PayerNetworkManager = 'PAYER_NETWORK_MANAGER',
  PayerPolicyAdmin = 'PAYER_POLICY_ADMIN',
  PayerReinsurerAnalyst = 'PAYER_REINSURER_ANALYST',
  PayerSeniorCaseManager = 'PAYER_SENIOR_CASE_MANAGER',
  PayerSeniorClaimsManager = 'PAYER_SENIOR_CLAIMS_MANAGER',
  PayerUnderwriter = 'PAYER_UNDERWRITER',
  PayerUnderwriterManager = 'PAYER_UNDERWRITER_MANAGER',
  PayerUnderwriterSupervisor = 'PAYER_UNDERWRITER_SUPERVISOR'
}

export enum PayerStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Pending = 'PENDING',
  Suspended = 'SUSPENDED'
}

export enum PayerType {
  Donor = 'DONOR',
  Hub = 'HUB',
  Insurance = 'INSURANCE',
  Reinsurance = 'REINSURANCE'
}

export type PayerUser = {
  __typename?: 'PayerUser';
  payer: Payer;
  roles: Array<PayerUserRole>;
  user: User;
};

export type PayerUserFilter = {
  page: InputMaybe<CarePageable>;
  roles: InputMaybe<Array<PayerRole>>;
  userKeys: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PayerUserPage = CarePage & {
  __typename?: 'PayerUserPage';
  data: Maybe<Array<PayerUser>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PayerUserResponse = Error | PayerUser;

export type PayerUserRole = {
  __typename?: 'PayerUserRole';
  createdBy: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Scalars['String']['output']>;
  role: PayerRole;
};

export type Payment = {
  __typename?: 'Payment';
  batchedPaymentAggregates: Maybe<BatchedPaymentAggregatePage>;
  firstCreated: Maybe<Scalars['String']['output']>;
  paymentAggregate: Maybe<PaymentAggregate>;
  remittanceAggregate: Maybe<RemittanceAggregate>;
};


export type PaymentBatchedPaymentAggregatesArgs = {
  filter: InputMaybe<BatchedPaymentAggregateFilter>;
};

export type PaymentAggregate = {
  __typename?: 'PaymentAggregate';
  approvalExpirationDate: Maybe<Scalars['String']['output']>;
  bankRef: Maybe<Scalars['String']['output']>;
  counterParty: Maybe<PaymentParty>;
  createdBy: User;
  externalRef: Maybe<Scalars['String']['output']>;
  internalRef: Scalars['String']['output'];
  monetaryAmount: Maybe<MonetaryAmount>;
  orderInternalRef: Maybe<Scalars['String']['output']>;
  orderingParty: Maybe<PaymentParty>;
  paymentType: Maybe<IsiroPaymentType>;
  remittanceInformation: Maybe<Scalars['String']['output']>;
  requestedExecutionDate: Maybe<Scalars['String']['output']>;
  status: Maybe<IsiroPaymentStatus>;
  statusCreatedAt: Maybe<Scalars['String']['output']>;
  statusDescription: Maybe<Scalars['String']['output']>;
};

export type PaymentAggregateFilter = {
  amountFrom: InputMaybe<Scalars['String']['input']>;
  amountTo: InputMaybe<Scalars['String']['input']>;
  approvalExpirationDateFrom: InputMaybe<Scalars['String']['input']>;
  approvalExpirationDateTo: InputMaybe<Scalars['String']['input']>;
  counterPartyAccountNumber: InputMaybe<Scalars['String']['input']>;
  counterPartyAliases: InputMaybe<Array<Scalars['String']['input']>>;
  executionDateFrom: InputMaybe<Scalars['String']['input']>;
  executionDateTo: InputMaybe<Scalars['String']['input']>;
  externalRef: InputMaybe<Scalars['String']['input']>;
  internalRef: InputMaybe<Scalars['String']['input']>;
  orderingPartyAccountNumber: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
  paymentType: InputMaybe<Array<IsiroPaymentType>>;
  status: InputMaybe<Array<IsiroPaymentStatus>>;
  statusCreatedAtFrom: InputMaybe<Scalars['String']['input']>;
  statusCreatedAtTo: InputMaybe<Scalars['String']['input']>;
};

export type PaymentAggregateFilterOptions = {
  alias: InputMaybe<Scalars['String']['input']>;
  partyType: InputMaybe<PaymentPartyType>;
};

export type PaymentAggregatesPage = CarePage & {
  __typename?: 'PaymentAggregatesPage';
  data: Maybe<Array<Maybe<Payment>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PaymentContract = {
  __typename?: 'PaymentContract';
  counterParty: Maybe<MinimalParty>;
  internalRef: Scalars['String']['output'];
  orderingParty: MinimalParty;
  paymentTerms: PaymentTerms;
};

export type PaymentContractFilter = {
  counterPartyOwnerRefs: InputMaybe<Array<Scalars['String']['input']>>;
  counterPartyOwnerType: InputMaybe<OwnerType>;
  internalRefs: InputMaybe<Array<Scalars['String']['input']>>;
  orderingPartyOwnerRefs: InputMaybe<Array<Scalars['String']['input']>>;
  orderingPartyOwnerType: InputMaybe<OwnerType>;
  page: InputMaybe<CarePageable>;
};

export type PaymentContractPage = CarePage & {
  __typename?: 'PaymentContractPage';
  data: Maybe<Array<Maybe<PaymentContract>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PaymentContractResponse = Error | PaymentContract;

export type PaymentInstructionInput = {
  paymentInstruction: Scalars['String']['input'];
  paymentInternalRef: Scalars['String']['input'];
  reason: InputMaybe<Scalars['String']['input']>;
};

export type PaymentInstructionResponse = AsyncPaymentInstructionResponse | Error;

export type PaymentParty = {
  __typename?: 'PaymentParty';
  accountAlias: Maybe<Scalars['String']['output']>;
  accountInternalRef: Scalars['String']['output'];
  accountNumber: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export enum PaymentPartyType {
  Counter = 'COUNTER',
  Ordering = 'ORDERING'
}

export type PaymentTerm = {
  __typename?: 'PaymentTerm';
  dateType: Maybe<ClaimDateType>;
  days: Scalars['Int']['output'];
  delayType: Maybe<ClaimDelayType>;
};

export type PaymentTerms = {
  __typename?: 'PaymentTerms';
  dateType: Maybe<DateType>;
  delay: Maybe<Scalars['Int']['output']>;
  delayType: Maybe<DelayType>;
};

export type PaymentTermsInput = {
  dateType: InputMaybe<DateType>;
  delay: InputMaybe<Scalars['Int']['input']>;
  delayType: InputMaybe<DelayType>;
};

export enum PaymentType {
  Cash = 'CASH',
  Copayment = 'COPAYMENT',
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Discount = 'DISCOUNT',
  MobileMoney = 'MOBILE_MONEY',
  OtherInsurance = 'OTHER_INSURANCE',
  Voucher = 'VOUCHER'
}

export enum PayoutMethod {
  BankTransfer = 'BANK_TRANSFER',
  Cash = 'CASH'
}

export type PecCoverage = {
  __typename?: 'PecCoverage';
  baseRateCorrectionPercentage: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  defaultOption: Scalars['Boolean']['output'];
  maximumAmlPercentage: Scalars['Float']['output'];
};

export type PecCoverageDeleteResponse = Error | Success;

export type PecCoveragePage = CarePage & {
  __typename?: 'PecCoveragePage';
  data: Array<PecCoverage>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PecCoverageResponse = Error | PecCoverage;

export type PerformEndorsementWorkflowActionResponse = BeneficiaryPolicyEndorsementResult | Error;

export type PersonFingerprint = {
  __typename?: 'PersonFingerprint';
  createdAt: Scalars['String']['output'];
  finger: FingerType;
};

export type PersonOtpResponse = Error | Success;

export type PersonOtpVerificationResponse = Error | PersonOtpVerified;

export type PersonOtpVerified = {
  __typename?: 'PersonOTPVerified';
  createdAt: Maybe<Scalars['String']['output']>;
  verificationRef: Maybe<Scalars['String']['output']>;
};

export type Plan = {
  __typename?: 'Plan';
  applicationId: Maybe<Scalars['String']['output']>;
  categories: Maybe<Array<Maybe<Category>>>;
  coverage: Maybe<PlanCoverage>;
  currency: Maybe<Scalars['String']['output']>;
  dateCreated: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  exclusions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  number: Maybe<Scalars['String']['output']>;
  payerId: Maybe<Scalars['String']['output']>;
  policies: Maybe<PolicyPage>;
  status: PolicyDomainStatus;
  type: Maybe<PlanType>;
};


export type PlanPoliciesArgs = {
  filter: InputMaybe<PolicyFilter>;
};

export type PlanCoverage = {
  __typename?: 'PlanCoverage';
  delayedClaimInDays: Maybe<Scalars['Int']['output']>;
  waitingPeriodInDays: Maybe<Scalars['Int']['output']>;
};

export type PlanFilter = {
  page: InputMaybe<CarePageable>;
  payerIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  planIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  planNumbers: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  planTypes: InputMaybe<Array<InputMaybe<PlanType>>>;
  policyIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<InputMaybe<PolicyDomainStatus>>>;
};

export type PlanPage = CarePage & {
  __typename?: 'PlanPage';
  data: Maybe<Array<Maybe<Plan>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum PlanType {
  GroupInsurance = 'GROUP_INSURANCE',
  RetailInsurance = 'RETAIL_INSURANCE'
}

export type PlatformUserPage = CarePage & {
  __typename?: 'PlatformUserPage';
  data: Maybe<Array<User>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum PlatformUserRole {
  ParticipantMember = 'PARTICIPANT_MEMBER',
  PlatformAdmin = 'PLATFORM_ADMIN',
  PlatformAuditor = 'PLATFORM_AUDITOR',
  PlatformClaimsAsyncProcessing = 'PLATFORM_CLAIMS_ASYNC_PROCESSING',
  PlatformIntegration = 'PLATFORM_INTEGRATION',
  PlatformIntegrationMessaging = 'PLATFORM_INTEGRATION_MESSAGING',
  PlatformIntegrationTelehealth = 'PLATFORM_INTEGRATION_TELEHEALTH',
  PlatformMedicalManager = 'PLATFORM_MEDICAL_MANAGER',
  PlatformPayerAdmin = 'PLATFORM_PAYER_ADMIN',
  PlatformPaymentsAsyncProcessing = 'PLATFORM_PAYMENTS_ASYNC_PROCESSING',
  PlatformPolicyCreateValidator = 'PLATFORM_POLICY_CREATE_VALIDATOR',
  PlatformPolicyPremiumStatement = 'PLATFORM_POLICY_PREMIUM_STATEMENT',
  PlatformPolicyUnderwritingIntegration = 'PLATFORM_POLICY_UNDERWRITING_INTEGRATION',
  PlatformPricingAffordability = 'PLATFORM_PRICING_AFFORDABILITY',
  PlatformProviderAdmin = 'PLATFORM_PROVIDER_ADMIN',
  PlatformProviderBulkUpload = 'PLATFORM_PROVIDER_BULK_UPLOAD',
  PlatformProviderLicenseLapse = 'PLATFORM_PROVIDER_LICENSE_LAPSE',
  PlatformRuleEngine = 'PLATFORM_RULE_ENGINE',
  PlatformSupport = 'PLATFORM_SUPPORT',
  PlatformUserOperation = 'PLATFORM_USER_OPERATION',
  VerifiedProspect = 'VERIFIED_PROSPECT'
}

export type Policy = {
  __typename?: 'Policy';
  ageCalculationMethod: AgeCalculationMethod;
  beneficiariesPolicyValidity: Maybe<BeneficiariesPolicyValidity>;
  createdBy: User;
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['String']['output']>;
  endorsementWorkflowActions: Maybe<EndorsementWorkflowActions>;
  /** @deprecated Use `policyExclusions` paged root query instead */
  exclusions: Maybe<Array<Exclusion>>;
  externalPolicyRefs: Array<PolicyExternalReference>;
  hasPremium: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  /** @deprecated Use `policyInclusions` paged root query instead */
  inclusions: Maybe<Array<Inclusion>>;
  intermediary: Maybe<Intermediary>;
  invoiceDueInDays: Maybe<Scalars['Int']['output']>;
  issueDate: Scalars['String']['output'];
  maxMembers: Maybe<Scalars['Int']['output']>;
  minMembers: Maybe<Scalars['Int']['output']>;
  modifiedBy: Maybe<User>;
  name: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['String']['output']>;
  payer: Maybe<Payer>;
  plans: Maybe<Array<Maybe<Plan>>>;
  policyDocumentURL: Maybe<Scalars['String']['output']>;
  policyFees: Maybe<PolicyFeesPage>;
  policyHolder: Maybe<BaseParty>;
  premiumTablePolicyValidity: Maybe<PremiumTablePolicyValidity>;
  previousPolicy: Maybe<Policy>;
  quotedMemberCount: Scalars['Int']['output'];
  quotedPremiumAmount: Scalars['Float']['output'];
  reason: Maybe<Scalars['String']['output']>;
  schemeType: SchemeType;
  startDate: Scalars['String']['output'];
  status: PolicyDomainStatus;
  termsAndConditionsDocumentURL: Maybe<Scalars['String']['output']>;
  type: PolicyType;
  validity: Maybe<PolicyValidity>;
  workflow: Maybe<PolicyWorkflow>;
};


export type PolicyPolicyFeesArgs = {
  filter: PolicyFeeFilter;
};

export enum PolicyClaimType {
  DirectBilling = 'DIRECT_BILLING',
  Reimbursement = 'REIMBURSEMENT'
}

export enum PolicyDomainStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Discarded = 'DISCARDED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  PendingApproval = 'PENDING_APPROVAL',
  Rejected = 'REJECTED',
  Scheduled = 'SCHEDULED',
  Suspended = 'SUSPENDED'
}

export type PolicyExternalReference = {
  __typename?: 'PolicyExternalReference';
  externalRef: Scalars['String']['output'];
  systemCode: Scalars['String']['output'];
};

export type PolicyFee = {
  __typename?: 'PolicyFee';
  feeType: PolicyFeeType;
  value: Scalars['Float']['output'];
  valueType: PolicyFeeValueType;
};

export type PolicyFeeFilter = {
  page: InputMaybe<CarePageable>;
  policyId: Scalars['String']['input'];
};

export type PolicyFeeInput = {
  feeType: PolicyFeeType;
  value: Scalars['Float']['input'];
  valueType: PolicyFeeValueType;
};

export type PolicyFeeResponse = Error | PolicyFee;

export enum PolicyFeeType {
  Basmah = 'BASMAH',
  BookRate = 'BOOK_RATE',
  Brokerage = 'BROKERAGE',
  BrokerFeesGross = 'BROKER_FEES_GROSS',
  BrokerFeesIncurred = 'BROKER_FEES_INCURRED',
  Cancellation = 'CANCELLATION',
  Cession = 'CESSION',
  Credibility = 'CREDIBILITY',
  DiscountHighIpClaim = 'DISCOUNT_HIGH_IP_CLAIM',
  DiscountOs = 'DISCOUNT_OS',
  ExtraPremium = 'EXTRA_PREMIUM',
  ExtraUnderwritingLoading = 'EXTRA_UNDERWRITING_LOADING',
  FinalGrossWrittenPremium = 'FINAL_GROSS_WRITTEN_PREMIUM',
  FinalNetWrittenPremium = 'FINAL_NET_WRITTEN_PREMIUM',
  Hcv = 'HCV',
  Icp = 'ICP',
  InsuranceLevy = 'INSURANCE_LEVY',
  InsurerExpenses = 'INSURER_EXPENSES',
  InsurerShareOfPremium = 'INSURER_SHARE_OF_PREMIUM',
  Loading = 'LOADING',
  MarketingCalls = 'MARKETING_CALLS',
  OtherFeesGross = 'OTHER_FEES_GROSS',
  OtherFeesIncurred = 'OTHER_FEES_INCURRED',
  ReinsuranceShare = 'REINSURANCE_SHARE',
  Retention = 'RETENTION',
  TechnicalPrice = 'TECHNICAL_PRICE',
  TpaFeesGross = 'TPA_FEES_GROSS',
  TpaFeesIncurred = 'TPA_FEES_INCURRED',
  Vat = 'VAT'
}

export enum PolicyFeeValueType {
  FixedAmount = 'FIXED_AMOUNT',
  None = 'NONE',
  Percentage = 'PERCENTAGE'
}

export type PolicyFeesPage = CarePage & {
  __typename?: 'PolicyFeesPage';
  data: Maybe<Array<PolicyFee>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PolicyFilter = {
  page: InputMaybe<CarePageable>;
  payerKeys: InputMaybe<Array<Scalars['String']['input']>>;
  policyHolderIds: InputMaybe<Array<Scalars['String']['input']>>;
  policyIds: InputMaybe<Array<Scalars['String']['input']>>;
  policyTypes: InputMaybe<Array<PolicyType>>;
  schemeTypes: InputMaybe<Array<SchemeType>>;
  search: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<PolicyDomainStatus>>;
};

export enum PolicyHolderRelationEnum {
  Child = 'CHILD',
  Parent = 'PARENT'
}

export type PolicyPage = CarePage & {
  __typename?: 'PolicyPage';
  data: Maybe<Array<Maybe<Policy>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PolicyPremiumCalculationOverview = {
  __typename?: 'PolicyPremiumCalculationOverview';
  beneficiaryCategoryGroupingsSummary: Maybe<Array<BeneficiaryCategoryGroupingSummary>>;
  calculationErrors: Maybe<Array<PremiumCalculationError>>;
  currency: Maybe<Scalars['String']['output']>;
  discount: Maybe<Scalars['Float']['output']>;
  fees: Maybe<Array<PremiumCalculationFee>>;
  grossTotalPremium: Maybe<Scalars['Float']['output']>;
  netTotalPremium: Maybe<Scalars['Float']['output']>;
  paymentFrequency: Maybe<PremiumPaymentFrequency>;
  policy: Maybe<Policy>;
  premiumCalculationCode: Maybe<Scalars['String']['output']>;
  premiumTableVersion: Maybe<Scalars['String']['output']>;
  vat: Maybe<Scalars['Float']['output']>;
  vatPercentage: Maybe<Scalars['Float']['output']>;
};

export type PolicyProduct = {
  __typename?: 'PolicyProduct';
  name: Scalars['String']['output'];
  payerId: Scalars['String']['output'];
  plans: Array<Plan>;
  productCategories: Maybe<Array<PolicyProductCategory>>;
  productId: Scalars['String']['output'];
  type: PolicyType;
};

export type PolicyProductCategory = {
  __typename?: 'PolicyProductCategory';
  categoryCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productId: Scalars['String']['output'];
};

export type PolicyProductFilter = {
  page: InputMaybe<CarePageable>;
  payerIds: InputMaybe<Array<Scalars['String']['input']>>;
  policyTypes: InputMaybe<Array<PolicyType>>;
  productIds: InputMaybe<Array<Scalars['String']['input']>>;
  search: InputMaybe<Scalars['String']['input']>;
};

export type PolicyProductPage = CarePage & {
  __typename?: 'PolicyProductPage';
  data: Array<PolicyProduct>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum PolicyRelationship {
  Child = 'CHILD',
  Grandparent = 'GRANDPARENT',
  Other = 'OTHER',
  Parent = 'PARENT',
  Primary = 'PRIMARY',
  SpecialCondition = 'SPECIAL_CONDITION',
  Spouse = 'SPOUSE'
}

export type PolicyResponse = Error | Policy;

export enum PolicyType {
  Group = 'GROUP',
  Retail = 'RETAIL'
}

export type PolicyValidity = {
  __typename?: 'PolicyValidity';
  benefits: Scalars['Boolean']['output'];
  payer: Scalars['Boolean']['output'];
  policyholder: Scalars['Boolean']['output'];
};

export type PolicyWorkflow = {
  __typename?: 'PolicyWorkflow';
  allowedActions: Maybe<Array<Maybe<PolicyWorkflowActionType>>>;
  lastAction: Maybe<PolicyWorkflowActionLog>;
};

export type PolicyWorkflowActionLog = {
  __typename?: 'PolicyWorkflowActionLog';
  createdBy: User;
  dateCreated: Scalars['String']['output'];
  type: PolicyWorkflowActionType;
};

export enum PolicyWorkflowActionType {
  Amend = 'AMEND',
  Approve = 'APPROVE',
  Cancel = 'CANCEL',
  Discard = 'DISCARD',
  Extend = 'EXTEND',
  Reject = 'REJECT',
  Resume = 'RESUME',
  Submit = 'SUBMIT',
  Suspend = 'SUSPEND'
}

export type PolicyholderAddress = {
  __typename?: 'PolicyholderAddress';
  addressLine1: Scalars['String']['output'];
  addressLine2: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Region;
  postOfficeBox: Maybe<Scalars['String']['output']>;
  state: Maybe<Region>;
  type: PolicyholderAddressType;
  zipCode: Maybe<Scalars['String']['output']>;
};

export type PolicyholderAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  postOfficeBox: InputMaybe<Scalars['String']['input']>;
  stateCode: InputMaybe<Scalars['String']['input']>;
  type: PolicyholderAddressType;
  zipCode: InputMaybe<Scalars['String']['input']>;
};

export enum PolicyholderAddressType {
  Billing = 'BILLING',
  Physical = 'PHYSICAL'
}

export type PolicyholderBankAccount = {
  __typename?: 'PolicyholderBankAccount';
  accountHolderName: Maybe<Scalars['String']['output']>;
  accountNumber: Maybe<Scalars['String']['output']>;
  bankBic: Maybe<Scalars['String']['output']>;
  bankCode: Maybe<Scalars['String']['output']>;
  bankName: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
};

export type PolicyholderBankAccountInput = {
  accountHolderName: InputMaybe<Scalars['String']['input']>;
  accountNumber: InputMaybe<Scalars['String']['input']>;
  bankBic: InputMaybe<Scalars['String']['input']>;
  bankCode: InputMaybe<Scalars['String']['input']>;
  bankName: InputMaybe<Scalars['String']['input']>;
  currency: InputMaybe<Scalars['String']['input']>;
};

export type PolicyholderDocument = {
  __typename?: 'PolicyholderDocument';
  createdBy: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  documentId: Scalars['String']['output'];
  modifiedBy: Maybe<Scalars['String']['output']>;
  originalFileName: Scalars['String']['output'];
  type: PolicyholderDocumentType;
};

export type PolicyholderDocumentDeleteResponse = Error | Success;

export type PolicyholderDocumentResponse = Error | PolicyholderDocument;

export enum PolicyholderDocumentType {
  CertificateOfIncorporation = 'CERTIFICATE_OF_INCORPORATION',
  KycAndDueDiligenceForm = 'KYC_AND_DUE_DILIGENCE_FORM',
  Other = 'OTHER',
  TradeLicenseCertificate = 'TRADE_LICENSE_CERTIFICATE'
}

export enum PolicyholderEntityType {
  Citizen = 'CITIZEN',
  Establishment = 'ESTABLISHMENT',
  InvestorVisa = 'INVESTOR_VISA',
  Other = 'OTHER',
  Resident = 'RESIDENT'
}

export type PolicyholderExternalReference = {
  __typename?: 'PolicyholderExternalReference';
  externalPolicyholderId: Scalars['String']['output'];
  systemCode: Scalars['String']['output'];
};

export type PolicyholderExternalReferenceInput = {
  externalPolicyholderId: Scalars['String']['input'];
  systemCode: Scalars['String']['input'];
};

export type PolicyholderIdentification = {
  __typename?: 'PolicyholderIdentification';
  type: PolicyholderIdentificationType;
  value: Scalars['String']['output'];
};

export type PolicyholderIdentificationInput = {
  type: PolicyholderIdentificationType;
  value: Scalars['String']['input'];
};

export enum PolicyholderIdentificationType {
  NationalId = 'NATIONAL_ID',
  Passport = 'PASSPORT'
}

export type PolicyholderRegionFilter = {
  codes: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  search: InputMaybe<Scalars['String']['input']>;
};

export type PolicyholderRegionPage = CarePage & {
  __typename?: 'PolicyholderRegionPage';
  data: Maybe<Array<Region>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum PreAuthAuditEventType {
  AdjudicationApproved = 'ADJUDICATION_APPROVED',
  AdjudicationPartiallyApproved = 'ADJUDICATION_PARTIALLY_APPROVED',
  AdjudicationRejected = 'ADJUDICATION_REJECTED',
  ExternalCommunicationSent = 'EXTERNAL_COMMUNICATION_SENT',
  PreAuthApproved = 'PRE_AUTH_APPROVED',
  PreAuthApproveActioned = 'PRE_AUTH_APPROVE_ACTIONED',
  PreAuthAssignBenefit = 'PRE_AUTH_ASSIGN_BENEFIT',
  PreAuthAssignBenefitToItem = 'PRE_AUTH_ASSIGN_BENEFIT_TO_ITEM',
  PreAuthCancelled = 'PRE_AUTH_CANCELLED',
  PreAuthConfirmActioned = 'PRE_AUTH_CONFIRM_ACTIONED',
  PreAuthCreated = 'PRE_AUTH_CREATED',
  PreAuthDeleted = 'PRE_AUTH_DELETED',
  PreAuthDocumentAdded = 'PRE_AUTH_DOCUMENT_ADDED',
  PreAuthFinalized = 'PRE_AUTH_FINALIZED',
  PreAuthLinked = 'PRE_AUTH_LINKED',
  PreAuthPartiallyApproved = 'PRE_AUTH_PARTIALLY_APPROVED',
  PreAuthPending = 'PRE_AUTH_PENDING',
  PreAuthReferred = 'PRE_AUTH_REFERRED',
  PreAuthReferActioned = 'PRE_AUTH_REFER_ACTIONED',
  PreAuthRejected = 'PRE_AUTH_REJECTED',
  PreAuthRejectActioned = 'PRE_AUTH_REJECT_ACTIONED',
  PreAuthReopened = 'PRE_AUTH_REOPENED',
  PreAuthResubmitted = 'PRE_AUTH_RESUBMITTED',
  PreAuthUnlinked = 'PRE_AUTH_UNLINKED',
  PreAuthUserAssigned = 'PRE_AUTH_USER_ASSIGNED'
}

export type PreAuthItemDocumentFilter = {
  documentReference: Scalars['String']['input'];
  itemReference: Scalars['String']['input'];
  preAuthReference: Scalars['String']['input'];
};

export type PreAuthMedicalProduct = {
  __typename?: 'PreAuthMedicalProduct';
  codingSystem: Maybe<Scalars['String']['output']>;
  externalCode: Maybe<Scalars['String']['output']>;
  medicalProducts: Maybe<Array<MedicalProduct>>;
  reference: Maybe<Scalars['String']['output']>;
};

export enum PreAuthProcessingSource {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type PreAuthorization = {
  __typename?: 'PreAuthorization';
  adjudications: Maybe<Array<PreAuthorizationAdjudication>>;
  approvedAmount: Maybe<MonetaryAmount>;
  assignedUser: Maybe<Scalars['String']['output']>;
  beneficiaryPolicy: Maybe<BeneficiaryPolicy>;
  benefit: Maybe<Benefit>;
  comments: Maybe<Array<PreAuthorizationComment>>;
  countryCode: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<User>;
  currentTier: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use diagnosisPaged instead */
  diagnoses: Maybe<Array<PreAuthorizationDiagnosis>>;
  diagnosesPaged: Maybe<PreAuthorizationDiagnosisPage>;
  documents: Maybe<Array<PreAuthorizationDocument>>;
  exGratiaAmount: Maybe<MonetaryAmount>;
  externalCode: Maybe<PreAuthorizationExternalCode>;
  /** @deprecated Use adjudication.faults instead */
  faults: Maybe<Array<PreAuthorizationFault>>;
  finalTier: Maybe<Scalars['Int']['output']>;
  historyList: Maybe<Array<PreAuthorization>>;
  initialProvider: Maybe<Scalars['String']['output']>;
  internalRef: Maybe<Scalars['String']['output']>;
  /** @deprecated Use itemPaged instead */
  items: Maybe<Array<PreAuthorizationItem>>;
  itemsPaged: Maybe<PreAuthorizationItemPage>;
  lastAdjudicatedAmount: Maybe<MonetaryAmount>;
  lastAdjudicatedPatientShare: Maybe<MonetaryAmount>;
  lastTotalDeductions: Maybe<MonetaryAmount>;
  medicalType: Maybe<PreAuthorizationMedicalType>;
  minimalProvider: Maybe<MinimalProvider>;
  orderedDate: Maybe<Scalars['String']['output']>;
  override: Maybe<Scalars['Boolean']['output']>;
  overrideReason: Maybe<PreAuthorizationOverrideReason>;
  payer: Maybe<Payer>;
  payerRef: Maybe<Scalars['String']['output']>;
  prescriptionRef: Maybe<Scalars['String']['output']>;
  priorityFlags: Maybe<PriorityFlags>;
  processingSource: Maybe<PreAuthProcessingSource>;
  provider: Maybe<Provider>;
  providerNote: Maybe<Scalars['String']['output']>;
  recoverableAmount: Maybe<MonetaryAmount>;
  reference: Scalars['String']['output'];
  reopened: Maybe<Scalars['Boolean']['output']>;
  reopenedReason: Maybe<Scalars['String']['output']>;
  requestedAmount: Maybe<MonetaryAmount>;
  resubmission: Maybe<PreAuthorizationResubmission>;
  resubmitted: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<PreAuthorizationStatus>;
  submissionSource: Maybe<PreAuthorizationSubmissionSource>;
  submittedDate: Maybe<Scalars['String']['output']>;
  tierRoles: Maybe<Array<PreAuthorizationTierRole>>;
  type: Maybe<PreAuthorizationType>;
  validityEndDate: Maybe<Scalars['String']['output']>;
  validityStartDate: Maybe<Scalars['String']['output']>;
  version: Maybe<Scalars['Int']['output']>;
  /** @deprecated Visit creation not required for pre-auth */
  visit: Maybe<Visit>;
  visitType: Maybe<VisitType>;
};


export type PreAuthorizationDiagnosesPagedArgs = {
  filter: InputMaybe<PreAuthorizationDiagnosisFilter>;
};


export type PreAuthorizationItemsPagedArgs = {
  filter: InputMaybe<PreAuthorizationItemFilter>;
};

export type PreAuthorizationAdjudication = {
  __typename?: 'PreAuthorizationAdjudication';
  action: Maybe<AdjudicationAction>;
  /** @deprecated Field no longer supported */
  advice: Maybe<PreAuthorizationAdjudicationAdvice>;
  assignee: Maybe<User>;
  createdBy: User;
  dateCreated: Scalars['String']['output'];
  /** @deprecated Adjudication now is created at the time of adjudication and instead we need to check dateCreated */
  dateModified: Maybe<Scalars['String']['output']>;
  faults: Maybe<Array<PreAuthorizationFault>>;
  /** @deprecated Adjudication now is created at the time of adjudication and instead we need to check createdBy */
  modifiedBy: Maybe<User>;
  note: Maybe<Scalars['String']['output']>;
  /** @deprecated Use note in preAuthorization instead */
  providerNote: Maybe<Scalars['String']['output']>;
  /** @deprecated Reference is not in share-module and there is no usage */
  reference: Maybe<Scalars['String']['output']>;
  status: AdjudicationStatus;
  tierLevel: Scalars['Int']['output'];
  validityEndDate: Maybe<Scalars['String']['output']>;
  validityStartDate: Maybe<Scalars['String']['output']>;
};

export enum PreAuthorizationAdjudicationAdvice {
  Approved = 'APPROVED',
  Assigned = 'ASSIGNED',
  PartiallyApproved = 'PARTIALLY_APPROVED',
  Refer = 'REFER',
  Rejected = 'REJECTED',
  Skipped = 'SKIPPED'
}

export type PreAuthorizationAdjudicationUpdateResponse = Error | ResourceCreated;

export type PreAuthorizationApprovalResponse = Error | Success;

export type PreAuthorizationAuditFilter = {
  page: InputMaybe<CarePageable>;
  preAuthorizationReferences: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PreAuthorizationAuditPage = CarePage & {
  __typename?: 'PreAuthorizationAuditPage';
  data: Maybe<Array<AuditEvent>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PreAuthorizationBulkUploadResponse = Error | Success;

export type PreAuthorizationCalculateApprovalAmount = {
  __typename?: 'PreAuthorizationCalculateApprovalAmount';
  approvedAmount: MonetaryAmount;
  discount: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  requiredPatientShare: Maybe<MonetaryAmount>;
  unitPrice: MonetaryAmount;
};

export type PreAuthorizationCalculateApprovalAmountRequest = {
  discount: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Float']['input'];
  requiredPatientShare: InputMaybe<MonetaryAmountInput>;
  unitPrice: MonetaryAmountInput;
};

export type PreAuthorizationChangeMotivation = {
  message: Scalars['String']['input'];
  note: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
};

export type PreAuthorizationComment = {
  __typename?: 'PreAuthorizationComment';
  content: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<User>;
  createdDate: Maybe<Scalars['String']['output']>;
  reference: Maybe<Scalars['String']['output']>;
};

export type PreAuthorizationCommentCreationResponse = Error | ResourceCreated;

export type PreAuthorizationConfirmationResponse = Error | Success;

export type PreAuthorizationCreationResponse = Error | ResourceCreated;

export type PreAuthorizationDiagnosis = {
  __typename?: 'PreAuthorizationDiagnosis';
  code: Maybe<Scalars['String']['output']>;
  extraInfos: Maybe<Array<Maybe<DiagnosisExtraInfo>>>;
  preAuthMedicalProduct: Maybe<PreAuthMedicalProduct>;
  type: Maybe<PreAuthorizationDiagnosisType>;
};

export type PreAuthorizationDiagnosisFilter = {
  diagnosisInternalRefs: InputMaybe<Array<Scalars['String']['input']>>;
  diagnosisReferences: InputMaybe<Array<Scalars['String']['input']>>;
  diagnosisType: InputMaybe<Array<DiagnosisType>>;
  medicalProductCodingSystem: InputMaybe<Scalars['String']['input']>;
  medicalProductExternalCodes: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
};

export type PreAuthorizationDiagnosisPage = CarePage & {
  __typename?: 'PreAuthorizationDiagnosisPage';
  data: Maybe<Array<PreAuthorizationDiagnosis>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum PreAuthorizationDiagnosisType {
  Admitting = 'ADMITTING',
  Invalid = 'INVALID',
  Principal = 'PRINCIPAL',
  Secondary = 'SECONDARY'
}

export type PreAuthorizationDocument = {
  __typename?: 'PreAuthorizationDocument';
  createdBy: Maybe<User>;
  createdDate: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  type: PreAuthorizationDocumentType;
};

export type PreAuthorizationDocumentLocation = {
  __typename?: 'PreAuthorizationDocumentLocation';
  url: Scalars['String']['output'];
};

export enum PreAuthorizationDocumentType {
  AuthorizingLetter = 'AUTHORIZING_LETTER',
  ClaimForm = 'CLAIM_FORM',
  CopyOfSignedBill = 'COPY_OF_SIGNED_BILL',
  DecisionLetter = 'DECISION_LETTER',
  GuaranteeOfPayment = 'GUARANTEE_OF_PAYMENT',
  IdsNotificationsCertificates = 'IDS_NOTIFICATIONS_CERTIFICATES',
  LetterOfUndertaking = 'LETTER_OF_UNDERTAKING',
  MedicalDoctorRadiologyInvestigationReport = 'MEDICAL_DOCTOR_RADIOLOGY_INVESTIGATION_REPORT',
  MedicalRecord = 'MEDICAL_RECORD',
  Other = 'OTHER',
  PreAuthForm = 'PRE_AUTH_FORM'
}

export type PreAuthorizationEnrichedResponse = Error | ResourceUpdated;

export type PreAuthorizationEnrichment = {
  benefitRef: InputMaybe<Scalars['String']['input']>;
};

export type PreAuthorizationExternalCode = {
  __typename?: 'PreAuthorizationExternalCode';
  reference: Maybe<Scalars['String']['output']>;
  source: Maybe<Scalars['String']['output']>;
};

export type PreAuthorizationFault = {
  __typename?: 'PreAuthorizationFault';
  code: Scalars['String']['output'];
  denialCodes: Maybe<Array<BusinessProperty>>;
  description: Maybe<Scalars['String']['output']>;
  entityReferences: Maybe<Scalars['String']['output']>;
};

export type PreAuthorizationFilter = {
  assignedUserReferences: InputMaybe<Array<Scalars['String']['input']>>;
  benefitReferences: InputMaybe<Array<Scalars['String']['input']>>;
  dayCase: InputMaybe<Scalars['Boolean']['input']>;
  emergency: InputMaybe<Scalars['Boolean']['input']>;
  externalCodeReferences: InputMaybe<Array<Scalars['String']['input']>>;
  externalCodeSources: InputMaybe<Array<Scalars['String']['input']>>;
  inpatient: InputMaybe<Scalars['Boolean']['input']>;
  isLinkedToCase: InputMaybe<Scalars['Boolean']['input']>;
  outpatient: InputMaybe<Scalars['Boolean']['input']>;
  page: InputMaybe<MultiSortCarePageable>;
  patientReferences: InputMaybe<Array<Scalars['String']['input']>>;
  payerReferences: InputMaybe<Array<Scalars['String']['input']>>;
  pharmacy: InputMaybe<Scalars['Boolean']['input']>;
  processingSources: InputMaybe<Array<PreAuthProcessingSource>>;
  providerReferences: InputMaybe<Array<Scalars['String']['input']>>;
  references: InputMaybe<Array<Scalars['String']['input']>>;
  resubmissionTypes: InputMaybe<Array<PreAuthorizationResubmissionType>>;
  search: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<PreAuthorizationStatus>>;
  submittedDateFrom: InputMaybe<Scalars['String']['input']>;
  submittedDateTo: InputMaybe<Scalars['String']['input']>;
  types: InputMaybe<Array<PreAuthorizationType>>;
  vip: InputMaybe<Scalars['Boolean']['input']>;
};

export type PreAuthorizationFilterOptions = {
  __typename?: 'PreAuthorizationFilterOptions';
  payers: Maybe<Array<Scalars['String']['output']>>;
  providers: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PreAuthorizationHistoryFilter = {
  reference: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type PreAuthorizationItem = {
  __typename?: 'PreAuthorizationItem';
  adjudications: Maybe<Array<PreAuthorizationItemAdjudication>>;
  approvedAmount: Maybe<MonetaryAmount>;
  approvedQuantity: Maybe<Scalars['Float']['output']>;
  approvedUnitPrice: Maybe<MonetaryAmount>;
  benefitRef: Maybe<Scalars['String']['output']>;
  clinician: Maybe<Employee>;
  /** @deprecated Use reference in external code instead */
  code: Maybe<Scalars['String']['output']>;
  collectedPatientShare: Maybe<MonetaryAmount>;
  discount: Maybe<Scalars['Float']['output']>;
  documents: Maybe<Array<PreAuthorizationDocument>>;
  duration: Maybe<Scalars['Float']['output']>;
  exGratiaAmount: Maybe<MonetaryAmount>;
  externalCode: Maybe<Scalars['String']['output']>;
  /** @deprecated Use adjudication.faults instead */
  faults: Maybe<Array<PreAuthorizationFault>>;
  internalRef: Maybe<Scalars['String']['output']>;
  invoiceNumber: Maybe<Scalars['String']['output']>;
  itemNotes: Maybe<Array<PreAuthorizationItemNote>>;
  lastAdjudicatedAmount: Maybe<MonetaryAmount>;
  lastAdjudicatedPatientShare: Maybe<MonetaryAmount>;
  lastAdjudicatedQuantity: Maybe<Scalars['Float']['output']>;
  lastAdjudicatedUnitPrice: Maybe<MonetaryAmount>;
  location: Maybe<Scalars['String']['output']>;
  override: Maybe<Scalars['Boolean']['output']>;
  overrideReason: Maybe<ItemOverrideReason>;
  preAuthMedicalProduct: Maybe<PreAuthMedicalProduct>;
  prescriptionRef: Maybe<Scalars['String']['output']>;
  /** @deprecated Use medicalProduct in preAuthMedicalProduct instead */
  product: MedicalProduct;
  quantity: Scalars['Float']['output'];
  quantityCountBalance: Maybe<Scalars['Float']['output']>;
  recoverableAmount: Maybe<MonetaryAmount>;
  reference: Scalars['String']['output'];
  requestedAmount: Maybe<MonetaryAmount>;
  requiredPatientShare: Maybe<MonetaryAmount>;
  startDate: Scalars['String']['output'];
  status: Maybe<PreAuthorizationItemStatus>;
  unit: Maybe<Scalars['Float']['output']>;
  unitPrice: MonetaryAmount;
};

export type PreAuthorizationItemAdjudication = {
  __typename?: 'PreAuthorizationItemAdjudication';
  action: Maybe<AdjudicationAction>;
  /** @deprecated Use action and status instead */
  advice: Maybe<PreAuthorizationItemAdjudicationAdvice>;
  approvedAmount: Maybe<MonetaryAmount>;
  approvedQuantity: Maybe<Scalars['Float']['output']>;
  approvedUnitPrice: Maybe<MonetaryAmount>;
  createdBy: User;
  dateCreated: Scalars['String']['output'];
  /** @deprecated Adjudication now is created at the time of adjudication and instead we need to check dateCreated */
  dateModified: Maybe<Scalars['String']['output']>;
  discount: Maybe<Scalars['Float']['output']>;
  exGratiaAmount: Maybe<MonetaryAmount>;
  faults: Maybe<Array<PreAuthorizationFault>>;
  /** @deprecated Adjudication now is created at the time of adjudication and instead we need to check createdBy */
  modifiedBy: Maybe<User>;
  note: Maybe<Scalars['String']['output']>;
  quantityCountBalance: Maybe<Scalars['Float']['output']>;
  recoverableAmount: Maybe<MonetaryAmount>;
  requiredPatientShare: Maybe<MonetaryAmount>;
  status: AdjudicationStatus;
  tierLevel: Scalars['Int']['output'];
};

export enum PreAuthorizationItemAdjudicationAdvice {
  Approved = 'APPROVED',
  PartiallyApproved = 'PARTIALLY_APPROVED',
  Refer = 'REFER',
  Rejected = 'REJECTED'
}

export type PreAuthorizationItemApproval = {
  exGratiaAmount: InputMaybe<MonetaryAmountInput>;
  note: InputMaybe<Scalars['String']['input']>;
  overdraftComment: InputMaybe<Scalars['String']['input']>;
  quantityCountBalance: InputMaybe<Scalars['Float']['input']>;
  recoverableAmount: InputMaybe<MonetaryAmountInput>;
};

export type PreAuthorizationItemApprovalResponse = Error | Success;

export type PreAuthorizationItemDenialReasonInput = {
  code: Scalars['String']['input'];
  description: InputMaybe<Scalars['String']['input']>;
  note: InputMaybe<Scalars['String']['input']>;
};

export type PreAuthorizationItemFilter = {
  benefitReferences: InputMaybe<Array<Scalars['String']['input']>>;
  itemInternalRefs: InputMaybe<Array<Scalars['String']['input']>>;
  itemReferences: InputMaybe<Array<Scalars['String']['input']>>;
  medicalProductCodingSystem: InputMaybe<Scalars['String']['input']>;
  medicalProductExternalCodes: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  statuses: InputMaybe<Array<PreAuthorizationItemStatus>>;
};

export type PreAuthorizationItemNote = {
  __typename?: 'PreAuthorizationItemNote';
  code: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  createdDate: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  valueType: Maybe<Scalars['String']['output']>;
};

export type PreAuthorizationItemOverride = {
  __typename?: 'PreAuthorizationItemOverride';
  amount: MonetaryAmount;
  beneficiaryPolicy: BeneficiaryPolicy;
  internalRef: Scalars['String']['output'];
  itemInternalRef: Scalars['String']['output'];
  medicalProduct: MedicalProduct;
  otherReasonDescription: Maybe<Scalars['String']['output']>;
  patientShare: MonetaryAmount;
  payer: Payer;
  prescription: Scalars['String']['output'];
  provider: Provider;
  quantity: Scalars['Float']['output'];
  reason: OverrideReason;
  remainingUses: Scalars['Int']['output'];
  unitPrice: MonetaryAmount;
  utilized: Scalars['Boolean']['output'];
  validityPeriod: OverrideValidityPeriod;
};

export type PreAuthorizationItemOverrideInput = {
  amount: MonetaryAmountInput;
  itemInternalRef: Scalars['String']['input'];
  medicalProductRef: Scalars['String']['input'];
  otherReasonDescription: InputMaybe<Scalars['String']['input']>;
  patientRef: Scalars['String']['input'];
  patientShare: MonetaryAmountInput;
  payerRef: Scalars['String']['input'];
  prescriptionRef: Scalars['String']['input'];
  providerRef: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  reason: OverrideReason;
  remainingUses: Scalars['Int']['input'];
  unitPrice: MonetaryAmountInput;
  validityPeriod: OverrideValidityPeriodInput;
};

export type PreAuthorizationItemPage = CarePage & {
  __typename?: 'PreAuthorizationItemPage';
  data: Array<PreAuthorizationItem>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PreAuthorizationItemPartialApprovalResponse = Error | Success;

export type PreAuthorizationItemRejectionResponse = Error | Success;

export enum PreAuthorizationItemStatus {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  PartiallyApproved = 'PARTIALLY_APPROVED',
  Rejected = 'REJECTED',
  Resubmitted = 'RESUBMITTED',
  Submitted = 'SUBMITTED'
}

export type PreAuthorizationLinkResponse = Error | Success;

export enum PreAuthorizationMedicalType {
  Clinical = 'CLINICAL',
  Pharmacy = 'PHARMACY'
}

export type PreAuthorizationOverride = {
  __typename?: 'PreAuthorizationOverride';
  internalRef: Maybe<Scalars['String']['output']>;
  items: Maybe<Array<PreAuthorizationItemOverride>>;
  preAuthorizationInternalRef: Maybe<Scalars['String']['output']>;
};

export enum PreAuthorizationOverrideReason {
  ExceedingMaximumDosage = 'EXCEEDING_MAXIMUM_DOSAGE',
  Other = 'OTHER'
}

export type PreAuthorizationPage = CarePage & {
  __typename?: 'PreAuthorizationPage';
  data: Maybe<Array<PreAuthorization>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PreAuthorizationPartialApproval = {
  approvedQuantity: Scalars['Float']['input'];
  approvedUnitPrice: MonetaryAmountInput;
  discount: InputMaybe<Scalars['Float']['input']>;
  exGratiaAmount: InputMaybe<MonetaryAmountInput>;
  fault: InputMaybe<FaultRequest>;
  note: InputMaybe<Scalars['String']['input']>;
  overdraftComment: InputMaybe<Scalars['String']['input']>;
  quantityCountBalance: InputMaybe<Scalars['Float']['input']>;
  recoverableAmount: InputMaybe<MonetaryAmountInput>;
  requiredPatientShare: InputMaybe<MonetaryAmountInput>;
};

export type PreAuthorizationRejectionResponse = Error | Success;

export type PreAuthorizationReopenResponse = Error | Success;

export type PreAuthorizationResubmission = {
  __typename?: 'PreAuthorizationResubmission';
  reason: Maybe<Scalars['String']['output']>;
  type: Maybe<PreAuthorizationResubmissionType>;
};

export type PreAuthorizationResubmissionInput = {
  reason: Scalars['String']['input'];
  type: PreAuthorizationResubmissionType;
};

export enum PreAuthorizationResubmissionType {
  Complaint = 'COMPLAINT',
  Correction = 'CORRECTION',
  Reconciliation = 'RECONCILIATION'
}

export enum PreAuthorizationStatus {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  PartiallyApproved = 'PARTIALLY_APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Reversed = 'REVERSED'
}

export enum PreAuthorizationSubmissionSource {
  Manual = 'MANUAL',
  Member = 'MEMBER',
  Provider = 'PROVIDER'
}

export type PreAuthorizationTierRole = {
  __typename?: 'PreAuthorizationTierRole';
  roles: Maybe<Array<Scalars['String']['output']>>;
  tierLevel: Scalars['Int']['output'];
};

export enum PreAuthorizationType {
  DirectBilling = 'DIRECT_BILLING',
  Reimbursed = 'REIMBURSED'
}

export type PreAuthorizationUnlinkResponse = Error | Success;

export type PremiumCalculation = {
  __typename?: 'PremiumCalculation';
  beneficiaryCategoryGroupings: Maybe<Array<BeneficiaryCategoryGrouping>>;
  calculationErrors: Maybe<Array<PremiumCalculationError>>;
  currency: Scalars['String']['output'];
  grossTotalPremium: Scalars['Float']['output'];
  intermediary: Maybe<Scalars['String']['output']>;
  netTotalPremium: Scalars['Float']['output'];
  paymentFrequency: PremiumPaymentFrequency;
  policy: Policy;
  premiumCalculationCode: Scalars['String']['output'];
  premiumTableVersion: Scalars['String']['output'];
  vat: Scalars['Float']['output'];
};

export type PremiumCalculationAsync = {
  __typename?: 'PremiumCalculationAsync';
  asyncCalculationCode: Scalars['String']['output'];
};

export type PremiumCalculationAsyncProcessingStatusResult = {
  __typename?: 'PremiumCalculationAsyncProcessingStatusResult';
  asyncCalculationCode: Scalars['String']['output'];
  premiumCalculationSummary: Maybe<PremiumCalculationSummary>;
  status: AsyncPremiumCalculationStatus;
};

export type PremiumCalculationAsyncResponse = Error | PremiumCalculationAsync;

export enum PremiumCalculationBasisType {
  Family = 'FAMILY',
  Individual = 'INDIVIDUAL',
  None = 'NONE'
}

export type PremiumCalculationError = {
  __typename?: 'PremiumCalculationError';
  beneficiaryEndorsement: Maybe<BeneficiaryPolicy>;
  beneficiaryPolicy: Maybe<BeneficiaryPolicy>;
  details: Scalars['String']['output'];
};

export type PremiumCalculationFee = {
  __typename?: 'PremiumCalculationFee';
  amount: Scalars['Float']['output'];
  feeType: PolicyFeeType;
};

export type PremiumCalculationFilter = {
  page: InputMaybe<CarePageable>;
  policyId: InputMaybe<Scalars['String']['input']>;
};

export type PremiumCalculationInput = {
  policyChangeType: PremiumCalculationPolicyChangeType;
  policyId: Scalars['String']['input'];
};

export type PremiumCalculationPage = CarePage & {
  __typename?: 'PremiumCalculationPage';
  data: Maybe<Array<PremiumCalculation>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum PremiumCalculationPolicyChangeType {
  BeneficiaryEndorsement = 'BENEFICIARY_ENDORSEMENT',
  NewPolicy = 'NEW_POLICY',
  PolicyCancellation = 'POLICY_CANCELLATION',
  PolicyExtension = 'POLICY_EXTENSION',
  PolicyRenewal = 'POLICY_RENEWAL'
}

export type PremiumCalculationResponse = Error | PremiumCalculation;

export type PremiumCalculationSummary = {
  __typename?: 'PremiumCalculationSummary';
  beneficiaryCategoryGroupingsSummary: Maybe<Array<BeneficiaryCategoryGroupingSummary>>;
  calculationErrors: Maybe<Array<PremiumCalculationError>>;
  currency: Scalars['String']['output'];
  discount: Scalars['Float']['output'];
  fees: Maybe<Array<PremiumCalculationFee>>;
  grossTotalPremium: Scalars['Float']['output'];
  netTotalPremium: Scalars['Float']['output'];
  paymentFrequency: PremiumPaymentFrequency;
  policy: Policy;
  premiumCalculationCode: Scalars['String']['output'];
  premiumTableVersion: Scalars['String']['output'];
  totalInsuranceLevy: Scalars['Float']['output'];
  vat: Scalars['Float']['output'];
  vatPercentage: Scalars['Float']['output'];
};

export type PremiumCalculationSummaryPage = CarePage & {
  __typename?: 'PremiumCalculationSummaryPage';
  data: Maybe<Array<PremiumCalculationSummary>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PremiumCalculationsSummaryFilter = {
  page: InputMaybe<CarePageable>;
  policyIds: InputMaybe<Array<Scalars['String']['input']>>;
  premiumCalculationCodes: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PremiumFinancialsPdfLocation = {
  __typename?: 'PremiumFinancialsPdfLocation';
  location: Scalars['String']['output'];
};

export type PremiumInstalment = {
  __typename?: 'PremiumInstalment';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dueDate: Scalars['String']['output'];
  instalmentCode: Scalars['String']['output'];
  invoiceCode: Scalars['String']['output'];
  invoiceNumber: Scalars['Float']['output'];
  isPaid: Scalars['Boolean']['output'];
  policy: Policy;
  startDate: Scalars['String']['output'];
};

export type PremiumInstalmentFilter = {
  invoiceId: InputMaybe<Scalars['String']['input']>;
  isPaid: InputMaybe<Scalars['Boolean']['input']>;
  page: InputMaybe<CarePageable>;
  policyId: InputMaybe<Scalars['String']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
};

export type PremiumInstalmentPage = CarePage & {
  __typename?: 'PremiumInstalmentPage';
  data: Maybe<Array<PremiumInstalment>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum PremiumInvoiceStatus {
  Outstanding = 'OUTSTANDING',
  Overdue = 'OVERDUE',
  Paid = 'PAID'
}

export enum PremiumInvoiceType {
  EndorsementInvoice = 'ENDORSEMENT_INVOICE',
  NewPolicyInvoice = 'NEW_POLICY_INVOICE',
  None = 'NONE',
  Other = 'OTHER',
  PolicyCancellationInvoice = 'POLICY_CANCELLATION_INVOICE',
  PolicyExtensionInvoice = 'POLICY_EXTENSION_INVOICE',
  PolicyRenewalInvoice = 'POLICY_RENEWAL_INVOICE'
}

export enum PremiumPaymentFrequency {
  Monthly = 'MONTHLY',
  Once = 'ONCE',
  Quarterly = 'QUARTERLY',
  Semiannually = 'SEMIANNUALLY',
  Yearly = 'YEARLY'
}

export type PremiumPerAgeBand = {
  __typename?: 'PremiumPerAgeBand';
  ageFrom: Scalars['Int']['output'];
  ageTo: Scalars['Int']['output'];
  premium: NetPremiumAmount;
  premiumFemale: NetPremiumAmount;
  premiumMale: NetPremiumAmount;
};

export type PremiumPerBenefitType = {
  __typename?: 'PremiumPerBenefitType';
  premium: NetPremiumAmount;
  type: BenefitType;
};

export type PremiumPerType = {
  __typename?: 'PremiumPerType';
  basePremium: NetPremiumAmount;
  premiumPerBenefitType: Maybe<Array<PremiumPerBenefitType>>;
};

export type PremiumPercentageAndAmount = {
  __typename?: 'PremiumPercentageAndAmount';
  amount: Maybe<MonetaryAmount>;
  percentage: Maybe<Scalars['Float']['output']>;
};

export enum PremiumProRataTerm {
  Daily = 'DAILY',
  Monthly = 'MONTHLY'
}

export type PremiumStatement = {
  __typename?: 'PremiumStatement';
  currency: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  outstandingBalance: Scalars['Float']['output'];
  policyEndDate: Scalars['String']['output'];
  policyId: Scalars['String']['output'];
  policyStartDate: Scalars['String']['output'];
  premiumPaidAmount: Scalars['Float']['output'];
  premiumStatementCode: Scalars['String']['output'];
  totalPremium: Scalars['Float']['output'];
};

export type PremiumStatementFilter = {
  page: InputMaybe<CarePageable>;
  policyId: InputMaybe<Scalars['String']['input']>;
};

export type PremiumStatementPage = CarePage & {
  __typename?: 'PremiumStatementPage';
  data: Maybe<Array<PremiumStatement>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PremiumTable = {
  __typename?: 'PremiumTable';
  currency: Scalars['String']['output'];
  policyId: Scalars['String']['output'];
  premiumCalculationBasis: PremiumCalculationBasisType;
  premiumProRataTerm: PremiumProRataTerm;
  premiumTableEntries: Maybe<Array<PremiumTableEntry>>;
  premiumTerm: PremiumTerm;
  validFrom: Scalars['String']['output'];
  validTo: Scalars['String']['output'];
  version: Scalars['Float']['output'];
};

export type PremiumTableCreatedResponse = Error | Success;

export type PremiumTableEntry = {
  __typename?: 'PremiumTableEntry';
  ageFrom: Scalars['Int']['output'];
  ageTo: Scalars['Int']['output'];
  category: Category;
  dependentIndex: Maybe<Scalars['Int']['output']>;
  gender: PremiumTableGender;
  includesAdditionalDependents: Maybe<Scalars['Boolean']['output']>;
  maritalStatus: PremiumTableMaritalStatus;
  occupation: Maybe<PremiumTableOccupation>;
  premium: Scalars['Float']['output'];
  relationship: PremiumTableRelationship;
};

export type PremiumTableEntryInput = {
  ageFrom: Scalars['Int']['input'];
  ageTo: Scalars['Int']['input'];
  categoryId: Scalars['String']['input'];
  dependentIndex: InputMaybe<Scalars['Int']['input']>;
  gender: PremiumTableGender;
  includesAdditionalDependents: InputMaybe<Scalars['Boolean']['input']>;
  maritalStatus: PremiumTableMaritalStatus;
  occupation: PremiumTableOccupation;
  premium: Scalars['Float']['input'];
  relationship: PremiumTableRelationship;
};

export type PremiumTableEntryPage = CarePage & {
  __typename?: 'PremiumTableEntryPage';
  data: Array<PremiumTableEntry>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PremiumTableFilter = {
  page: InputMaybe<CarePageable>;
  policyId: InputMaybe<Scalars['String']['input']>;
};

export enum PremiumTableGender {
  Any = 'ANY',
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

export type PremiumTableInput = {
  currency: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
  premiumCalculationBasis: PremiumCalculationBasisType;
  premiumProRataTerm: InputMaybe<PremiumProRataTerm>;
  premiumTableEntries: Array<PremiumTableEntryInput>;
  premiumTerm: PremiumTerm;
  validFrom: Scalars['String']['input'];
  validTo: Scalars['String']['input'];
};

export enum PremiumTableMaritalStatus {
  Any = 'ANY',
  Divorced = 'DIVORCED',
  Married = 'MARRIED',
  Single = 'SINGLE',
  Widowed = 'WIDOWED'
}

export enum PremiumTableOccupation {
  Any = 'ANY',
  Employed = 'EMPLOYED',
  Student = 'STUDENT',
  Unemployed = 'UNEMPLOYED'
}

export type PremiumTablePage = CarePage & {
  __typename?: 'PremiumTablePage';
  data: Maybe<Array<PremiumTable>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PremiumTablePolicyValidity = {
  __typename?: 'PremiumTablePolicyValidity';
  hasPremiumTable: Scalars['Boolean']['output'];
};

export enum PremiumTableRelationship {
  AnyDependent = 'ANY_DEPENDENT',
  Child = 'CHILD',
  Grandparent = 'GRANDPARENT',
  Parent = 'PARENT',
  Primary = 'PRIMARY',
  SpecialCondition = 'SPECIAL_CONDITION',
  Spouse = 'SPOUSE'
}

export enum PremiumTerm {
  Monthly = 'MONTHLY',
  None = 'NONE',
  Once = 'ONCE',
  Quarterly = 'QUARTERLY',
  Semiannually = 'SEMIANNUALLY',
  Yearly = 'YEARLY'
}

export type Prescription = {
  __typename?: 'Prescription';
  clinician: Maybe<Employee>;
  diagnoses: Array<PrescriptionDiagnosis>;
  eRxNumber: Maybe<Scalars['String']['output']>;
  externalFileName: Maybe<Scalars['String']['output']>;
  externalRef: Maybe<Scalars['String']['output']>;
  externalSource: Maybe<Scalars['String']['output']>;
  internalRef: Scalars['String']['output'];
  medications: Array<Medication>;
  patient: Maybe<BeneficiaryPolicy>;
  patientWeight: Maybe<PatientWeight>;
  payer: Payer;
  provider: Maybe<Provider>;
  status: Maybe<PrescriptionStatus>;
  submittedDate: Maybe<Scalars['String']['output']>;
  transactionDate: Maybe<Scalars['String']['output']>;
  type: Maybe<PrescriptionType>;
};

export type PrescriptionDiagnosis = {
  __typename?: 'PrescriptionDiagnosis';
  internalRef: Scalars['String']['output'];
  product: Maybe<PrescriptionMedicalProduct>;
  type: Maybe<PrescriptionDiagnosisType>;
};

export enum PrescriptionDiagnosisType {
  Admitting = 'ADMITTING',
  Invalid = 'INVALID',
  Principal = 'PRINCIPAL',
  Secondary = 'SECONDARY'
}

export type PrescriptionFilter = {
  clinicianReferences: InputMaybe<Array<Scalars['String']['input']>>;
  erxNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  externalReferences: InputMaybe<Array<Scalars['String']['input']>>;
  internalReferences: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  patientReferences: InputMaybe<Array<Scalars['String']['input']>>;
  payerReferences: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<PrescriptionStatus>>;
  submittedDateFrom: InputMaybe<Scalars['String']['input']>;
  submittedDateTo: InputMaybe<Scalars['String']['input']>;
  types: InputMaybe<Array<PrescriptionType>>;
};

export type PrescriptionMedicalProduct = {
  __typename?: 'PrescriptionMedicalProduct';
  codingSystem: Maybe<Scalars['String']['output']>;
  externalCode: Maybe<Scalars['String']['output']>;
  medicalProduct: Maybe<MedicalProduct>;
};

export type PrescriptionPage = CarePage & {
  __typename?: 'PrescriptionPage';
  data: Array<Prescription>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum PrescriptionStatus {
  Active = 'ACTIVE'
}

export enum PrescriptionType {
  Cancellation = 'CANCELLATION',
  Request = 'REQUEST'
}

export type PriceAgreement = {
  __typename?: 'PriceAgreement';
  collectiveModifiers: Maybe<Array<CollectiveModifier>>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  initialAgreementId: Maybe<Scalars['String']['output']>;
  network: Maybe<StandardNetwork>;
  numberOfItems: Maybe<Scalars['Int']['output']>;
  numberOfVersions: Maybe<Scalars['Int']['output']>;
  payer: Maybe<Payer>;
  policyProduct: Maybe<PolicyProduct>;
  policyProductCategory: Maybe<PolicyProductCategory>;
  status: Maybe<PriceAgreementStatus>;
  type: Maybe<PriceAgreementType>;
  validFrom: Maybe<Scalars['String']['output']>;
  validTo: Maybe<Scalars['String']['output']>;
  versionText: Maybe<Scalars['String']['output']>;
  versions: Maybe<Array<PriceAgreement>>;
};

export type PriceAgreementFilter = {
  activeAtDate: InputMaybe<Scalars['String']['input']>;
  networkIds: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  payerIds: InputMaybe<Array<Scalars['String']['input']>>;
  policyProductIds: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<PriceAgreementStatus>>;
};

export type PriceAgreementItem = {
  __typename?: 'PriceAgreementItem';
  basePrice: Maybe<MonetaryAmount>;
  id: Scalars['String']['output'];
  modifierType: Maybe<ModifierType>;
  modifierValue: Maybe<Scalars['Float']['output']>;
  netPrice: Maybe<MonetaryAmount>;
  providerProductInfo: Maybe<ProviderProductInfo>;
};

export type PriceAgreementItemFilter = {
  categories: InputMaybe<Array<MedicalProductCategory>>;
  codingSystemIds: InputMaybe<Array<Scalars['String']['input']>>;
  externalNameOrCode: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
  priceAgreementId: Scalars['String']['input'];
};

export type PriceAgreementItemInput = {
  basePrice: MonetaryAmountInput;
  carepayCode: Scalars['String']['input'];
  codingSystemId: Scalars['String']['input'];
  modifierType: ModifierType;
  modifierValue: InputMaybe<Scalars['Float']['input']>;
};

export type PriceAgreementItemPage = CarePage & {
  __typename?: 'PriceAgreementItemPage';
  data: Maybe<Array<PriceAgreementItem>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PriceAgreementItemResponse = Error | PriceAgreementItem;

export type PriceAgreementResponse = Error | PriceAgreement;

export enum PriceAgreementStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE'
}

export enum PriceAgreementType {
  Default = 'DEFAULT',
  Plan = 'PLAN',
  PlanCategory = 'PLAN_CATEGORY'
}

export type PriceAgreementVersionInput = {
  description: InputMaybe<Scalars['String']['input']>;
  overrideDates: Scalars['Boolean']['input'];
  previousPriceAgreementId: Scalars['String']['input'];
  validFrom: Scalars['String']['input'];
  validTo: InputMaybe<Scalars['String']['input']>;
};

export type PriceFile = {
  __typename?: 'PriceFile';
  fileId: Maybe<Scalars['String']['output']>;
  link: Maybe<FileLink>;
  status: Maybe<FileStatus>;
};

export type PriceItem = {
  __typename?: 'PriceItem';
  id: Maybe<Scalars['String']['output']>;
};

export type PriceItemResponse = Error | PriceItem;

export type PriceList = {
  __typename?: 'PriceList';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  initialPriceListId: Maybe<Scalars['String']['output']>;
  issuerId: Maybe<Scalars['String']['output']>;
  items: Maybe<PriceListItemPage>;
  name: Maybe<Scalars['String']['output']>;
  numberOfItems: Maybe<Scalars['Int']['output']>;
  numberOfVersions: Maybe<Scalars['Int']['output']>;
  payer: Maybe<Payer>;
  providerCode: Maybe<Scalars['String']['output']>;
  status: Maybe<PriceListStatus>;
  validFrom: Maybe<Scalars['String']['output']>;
  validTo: Maybe<Scalars['String']['output']>;
  versions: Maybe<Array<PriceList>>;
};


export type PriceListItemsArgs = {
  filter: InputMaybe<PriceListItemFilter>;
};

export type PriceListFilter = {
  date: InputMaybe<Scalars['String']['input']>;
  issuerCode: InputMaybe<Scalars['String']['input']>;
  latestVersions: InputMaybe<Scalars['Boolean']['input']>;
  page: InputMaybe<CarePageable>;
  payerId: InputMaybe<Scalars['String']['input']>;
  priceListIds: InputMaybe<Array<Scalars['String']['input']>>;
  providerCode: InputMaybe<Scalars['String']['input']>;
  type: PriceListType;
};

export type PriceListItem = {
  __typename?: 'PriceListItem';
  basePrice: Maybe<MonetaryAmount>;
  id: Scalars['String']['output'];
  providerProductInfo: Maybe<ProviderProductInfo>;
};

export type PriceListItemFilter = {
  carepayCode: InputMaybe<Scalars['String']['input']>;
  categories: InputMaybe<Array<MedicalProductCategory>>;
  codingSystemIds: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  search: InputMaybe<Scalars['String']['input']>;
};

export type PriceListItemPage = CarePage & {
  __typename?: 'PriceListItemPage';
  data: Maybe<Array<PriceListItem>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PriceListNewVersion = {
  description: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  previousPriceListId: Scalars['String']['input'];
  validFrom: Scalars['String']['input'];
};

export type PriceListPage = CarePage & {
  __typename?: 'PriceListPage';
  data: Maybe<Array<PriceList>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type PriceListResponse = Error | PriceList;

export enum PriceListStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Scheduled = 'SCHEDULED'
}

export enum PriceListType {
  Provider = 'PROVIDER',
  Regulated = 'REGULATED'
}

export type PriorityFlags = {
  __typename?: 'PriorityFlags';
  dayCase: Maybe<Scalars['Boolean']['output']>;
  emergency: Maybe<Scalars['Boolean']['output']>;
  inpatient: Maybe<Scalars['Boolean']['output']>;
  outpatient: Maybe<Scalars['Boolean']['output']>;
  pharmacy: Maybe<Scalars['Boolean']['output']>;
  rank: Maybe<Scalars['Int']['output']>;
  vip: Maybe<Scalars['Boolean']['output']>;
};

export type Product = {
  __typename?: 'Product';
  administrativeLoadPercentage: Maybe<Scalars['Float']['output']>;
  annualMedicalLimits: Maybe<AnnualMedicalLimitPage>;
  baseRates: Maybe<BaseRatePage>;
  benefitTypes: Maybe<ProductBenefitTypePage>;
  benefits: Maybe<ProductBaseBenefitPage>;
  code: Scalars['String']['output'];
  country: Maybe<Country>;
  createdBy: Maybe<User>;
  currency: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['String']['output']>;
  externalRef: Maybe<Scalars['String']['output']>;
  familyCompositions: Maybe<FamilyCompositionPage>;
  groupSizes: Maybe<Array<ProductGroupSize>>;
  industries: Maybe<Array<ProductIndustry>>;
  intermediaries: Maybe<ProductIntermediaryPage>;
  medicalTagExclusions: Maybe<Array<MedicalTag>>;
  modifiedBy: Maybe<User>;
  name: Scalars['String']['output'];
  payer: Payer;
  pecCoverages: Maybe<PecCoveragePage>;
  providerNetworks: Maybe<ProductProviderNetworkPage>;
  regions: Maybe<Array<GeolocationLevelOne>>;
  reimbursementRules: Maybe<ReimbursementRulePage>;
  roomTypes: Maybe<RoomTypePage>;
  salesCommissionPercentage: Maybe<Scalars['Float']['output']>;
  startDate: Maybe<Scalars['String']['output']>;
  status: ProductStatus;
  territorialCoverages: Maybe<TerritorialCoveragePage>;
  thirdPartyAdministratorFeePercentage: Maybe<Scalars['Float']['output']>;
  type: ClientType;
};


export type ProductAnnualMedicalLimitsArgs = {
  filter: InputMaybe<CarePageable>;
};


export type ProductBenefitTypesArgs = {
  filter: InputMaybe<BenefitTypeFilter>;
};


export type ProductBenefitsArgs = {
  filter: InputMaybe<BenefitFilter>;
};


export type ProductFamilyCompositionsArgs = {
  page: InputMaybe<CarePageable>;
};


export type ProductIntermediariesArgs = {
  page: InputMaybe<CarePageable>;
};


export type ProductPecCoveragesArgs = {
  filter: InputMaybe<CarePageable>;
};


export type ProductProviderNetworksArgs = {
  filter: InputMaybe<CarePageable>;
};


export type ProductReimbursementRulesArgs = {
  filter: InputMaybe<CarePageable>;
};


export type ProductRoomTypesArgs = {
  filter: InputMaybe<CarePageable>;
};


export type ProductTerritorialCoveragesArgs = {
  filter: InputMaybe<CarePageable>;
};

export type ProductBaseBenefit = {
  baseLimitAmount: Maybe<MonetaryAmount>;
  baseLimitCount: Maybe<Scalars['Int']['output']>;
  baseLimitDescription: Maybe<Scalars['String']['output']>;
  baseLimitTerm: Maybe<ProductCoverageTerm>;
  baseRateCorrectionAmount: Maybe<MonetaryAmount>;
  baseRateCorrectionPercentage: Maybe<Scalars['Float']['output']>;
  baseRateCorrectionType: BaseRateCorrectionType;
  benefitTypeCode: Scalars['String']['output'];
  code: Scalars['String']['output'];
  defaultOption: Scalars['Boolean']['output'];
  isFamilyShared: Scalars['Boolean']['output'];
  limitType: ProductBenefitLimitType;
  maxLimitAmount: Maybe<MonetaryAmount>;
  maxLimitCount: Maybe<Scalars['Int']['output']>;
  maxLimitDescription: Maybe<Scalars['String']['output']>;
  maxLimitTerm: Maybe<ProductCoverageTerm>;
  medicalTagInclusions: Maybe<Array<MedicalTag>>;
  preAuthorizationAmount: Maybe<MonetaryAmount>;
  preAuthorizationType: BenefitPreAuthorizationType;
  providerNetwork: Maybe<CustomNetwork | StandardNetwork>;
};

export type ProductBaseBenefitPage = CarePage & {
  __typename?: 'ProductBaseBenefitPage';
  data: Array<ProductBenefit | ProductSubBenefit>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ProductBenefit = ProductBaseBenefit & {
  __typename?: 'ProductBenefit';
  baseLimitAmount: Maybe<MonetaryAmount>;
  baseLimitCount: Maybe<Scalars['Int']['output']>;
  baseLimitDescription: Maybe<Scalars['String']['output']>;
  baseLimitTerm: Maybe<ProductCoverageTerm>;
  baseRateCorrectionAmount: Maybe<MonetaryAmount>;
  baseRateCorrectionPercentage: Maybe<Scalars['Float']['output']>;
  baseRateCorrectionType: BaseRateCorrectionType;
  benefitTypeCode: Scalars['String']['output'];
  code: Scalars['String']['output'];
  defaultOption: Scalars['Boolean']['output'];
  isFamilyShared: Scalars['Boolean']['output'];
  limitType: ProductBenefitLimitType;
  maxLimitAmount: Maybe<MonetaryAmount>;
  maxLimitCount: Maybe<Scalars['Int']['output']>;
  maxLimitDescription: Maybe<Scalars['String']['output']>;
  maxLimitTerm: Maybe<ProductCoverageTerm>;
  medicalTagInclusions: Maybe<Array<MedicalTag>>;
  preAuthorizationAmount: Maybe<MonetaryAmount>;
  preAuthorizationType: BenefitPreAuthorizationType;
  providerNetwork: Maybe<CustomNetwork | StandardNetwork>;
};

export type ProductBenefitDeleteResponse = Error | Success;

export enum ProductBenefitLimitType {
  Independent = 'INDEPENDENT',
  Inherited = 'INHERITED',
  LimitedAmount = 'LIMITED_AMOUNT',
  LimitedCount = 'LIMITED_COUNT',
  Text = 'TEXT',
  Unlimited = 'UNLIMITED'
}

export enum ProductBenefitOption {
  Benefit = 'BENEFIT',
  SubBenefit = 'SUB_BENEFIT'
}

export type ProductBenefitPage = CarePage & {
  __typename?: 'ProductBenefitPage';
  data: Array<ProductBenefit>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ProductBenefitResponse = Error | ProductBenefit;

export type ProductBenefitType = {
  __typename?: 'ProductBenefitType';
  benefits: Maybe<ProductBenefitPage>;
  code: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  patientShares: Maybe<Array<BenefitTypePatientShare>>;
  subBenefits: Maybe<ProductSubBenefitPage>;
  type: ProductBenefitTypeOption;
  waitingPeriods: Maybe<Array<BenefitTypeWaitingPeriod>>;
};


export type ProductBenefitTypeBenefitsArgs = {
  filter: InputMaybe<CarePageable>;
};


export type ProductBenefitTypeSubBenefitsArgs = {
  filter: InputMaybe<CarePageable>;
};

export type ProductBenefitTypeDeleteResponse = Error | Success;

export enum ProductBenefitTypeOption {
  Additional = 'ADDITIONAL',
  Alternative = 'ALTERNATIVE',
  Chronic = 'CHRONIC',
  Critical = 'CRITICAL',
  Death = 'DEATH',
  Dental = 'DENTAL',
  Inpatient = 'INPATIENT',
  Maternity = 'MATERNITY',
  Optical = 'OPTICAL',
  Other = 'OTHER',
  Outpatient = 'OUTPATIENT',
  Psychiatric = 'PSYCHIATRIC'
}

export type ProductBenefitTypePage = CarePage & {
  __typename?: 'ProductBenefitTypePage';
  data: Array<ProductBenefitType>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ProductBenefitTypeResponse = Error | ProductBenefitType;

export enum ProductCoverageTerm {
  Day = 'DAY',
  Month = 'MONTH',
  Night = 'NIGHT',
  Visit = 'VISIT',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type ProductDeleteResponse = Error | Success;

export type ProductFamilyComposition = {
  __typename?: 'ProductFamilyComposition';
  code: Scalars['String']['output'];
  defaultOption: Scalars['Boolean']['output'];
  familyMemberTypes: Array<FamilyMemberType>;
  maxFamilySize: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type ProductGroupSize = {
  __typename?: 'ProductGroupSize';
  code: Scalars['String']['output'];
  maximumSize: Maybe<Scalars['Int']['output']>;
  minimumSize: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ProductGroupSizeFilter = {
  codes: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
};

export type ProductGroupSizePage = CarePage & {
  __typename?: 'ProductGroupSizePage';
  data: Array<ProductGroupSize>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ProductIndustry = {
  __typename?: 'ProductIndustry';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProductIndustryFilter = {
  codes: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
};

export type ProductIndustryPage = CarePage & {
  __typename?: 'ProductIndustryPage';
  data: Array<ProductIndustry>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ProductIntermediary = {
  __typename?: 'ProductIntermediary';
  intermediary: Maybe<Intermediary>;
};

export type ProductIntermediaryPage = CarePage & {
  __typename?: 'ProductIntermediaryPage';
  data: Array<ProductIntermediary>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ProductIntermediaryResponse = Error | ProductIntermediary;

export type ProductOverview = {
  __typename?: 'ProductOverview';
  code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  endDate: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  payerRef: Scalars['String']['output'];
  startDate: Maybe<Scalars['String']['output']>;
  status: ProductStatus;
  type: ClientType;
};

export type ProductOverviewFilter = {
  currencies: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  payerReferences: InputMaybe<Array<Scalars['String']['input']>>;
  productStatuses: InputMaybe<Array<ProductStatus>>;
  searchTerm: InputMaybe<Scalars['String']['input']>;
};

export type ProductOverviewPage = CarePage & {
  __typename?: 'ProductOverviewPage';
  data: Array<ProductOverview>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ProductProviderNetwork = {
  __typename?: 'ProductProviderNetwork';
  baseRateCorrectionPercentage: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  defaultOption: Scalars['Boolean']['output'];
  providerNetwork: CustomNetwork | StandardNetwork;
};

export type ProductProviderNetworkDeleteResponse = Error | Success;

export type ProductProviderNetworkPage = CarePage & {
  __typename?: 'ProductProviderNetworkPage';
  data: Array<ProductProviderNetwork>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ProductProviderNetworkResponse = Error | ProductProviderNetwork;

export type ProductResponse = Error | Product;

export enum ProductStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Lapsed = 'LAPSED',
  PendingApproval = 'PENDING_APPROVAL',
  Rejected = 'REJECTED',
  Scheduled = 'SCHEDULED'
}

export type ProductSubBenefit = ProductBaseBenefit & {
  __typename?: 'ProductSubBenefit';
  baseLimitAmount: Maybe<MonetaryAmount>;
  baseLimitCount: Maybe<Scalars['Int']['output']>;
  baseLimitDescription: Maybe<Scalars['String']['output']>;
  baseLimitTerm: Maybe<ProductCoverageTerm>;
  baseRateCorrectionAmount: Maybe<MonetaryAmount>;
  baseRateCorrectionPercentage: Maybe<Scalars['Float']['output']>;
  baseRateCorrectionType: BaseRateCorrectionType;
  benefitTypeCode: Scalars['String']['output'];
  code: Scalars['String']['output'];
  defaultOption: Scalars['Boolean']['output'];
  isFamilyShared: Scalars['Boolean']['output'];
  limitType: ProductBenefitLimitType;
  maxLimitAmount: Maybe<MonetaryAmount>;
  maxLimitCount: Maybe<Scalars['Int']['output']>;
  maxLimitDescription: Maybe<Scalars['String']['output']>;
  maxLimitTerm: Maybe<ProductCoverageTerm>;
  medicalTagInclusions: Maybe<Array<MedicalTag>>;
  name: Scalars['String']['output'];
  preAuthorizationAmount: Maybe<MonetaryAmount>;
  preAuthorizationType: BenefitPreAuthorizationType;
  providerNetwork: Maybe<CustomNetwork | StandardNetwork>;
  type: ProductBenefitTypeOption;
};

export type ProductSubBenefitDeleteResponse = Error | Success;

export type ProductSubBenefitPage = CarePage & {
  __typename?: 'ProductSubBenefitPage';
  data: Array<ProductSubBenefit>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ProductSubBenefitResponse = Error | ProductSubBenefit;

export enum PromotionStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type Promotions = {
  __typename?: 'Promotions';
  status: PromotionStatus;
};

export type PromotionsResponse = Error | Promotions;

export type Provider = {
  __typename?: 'Provider';
  affiliation: Maybe<Scalars['String']['output']>;
  affiliationEntity: Maybe<Affiliation>;
  affordability: Maybe<Scalars['String']['output']>;
  beds: Maybe<Array<Maybe<BedCapacity>>>;
  businessType: Maybe<ProviderBusinessType>;
  city: Maybe<Scalars['String']['output']>;
  classification: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  contacts: Maybe<ProviderContactPage>;
  country: Maybe<Scalars['String']['output']>;
  dateCreated: Maybe<Scalars['String']['output']>;
  emailAddress: Maybe<Scalars['String']['output']>;
  employees: Maybe<EmployeePage>;
  externalCodes: Maybe<Array<Maybe<ProviderExternalCode>>>;
  geolocationLevelTwo: Maybe<GeolocationLevelTwo>;
  /** @deprecated Use: 'geolocationLevelTwo' instead */
  geolocationLevelTwoCode: Maybe<Scalars['String']['output']>;
  /** @deprecated Use: 'geolocationLevelTwo' instead */
  geolocationLevelTwoName: Maybe<Scalars['String']['output']>;
  landmark: Maybe<Scalars['String']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  licenses: Maybe<ProviderLicensePage>;
  longitude: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  operatingHours: Maybe<Array<Maybe<OperatingTime>>>;
  ownershipType: Maybe<Ownership>;
  parent: Maybe<Provider>;
  /** @deprecated Use: 'parent: Provider' instead */
  parentProviderCode: Maybe<Scalars['String']['output']>;
  paymentAccounts: Maybe<Array<Maybe<ProviderBankAccount | ProviderMobileWalletAccount>>>;
  pendingVersion: Maybe<Provider>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  physicalAddress: Maybe<Scalars['String']['output']>;
  priceAgreements: Maybe<ProviderPriceAgreementPage>;
  priceLists: Maybe<PriceListPage>;
  progressPercentage: Maybe<Scalars['Int']['output']>;
  providerType: Maybe<ProviderType>;
  registrationCode: Maybe<Scalars['String']['output']>;
  services: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  specialities: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status: Maybe<ProviderStatus>;
  taxRegistrationNumber: Maybe<Scalars['String']['output']>;
  users: Maybe<ProviderUserPage>;
  website: Maybe<Scalars['String']['output']>;
  zipCode: Maybe<Scalars['String']['output']>;
};


export type ProviderContactsArgs = {
  filter: InputMaybe<ProviderContactFilter>;
};


export type ProviderEmployeesArgs = {
  filter: InputMaybe<EmployeeFilter>;
};


export type ProviderLicensesArgs = {
  filter: InputMaybe<ProviderLicenseFilter>;
};


export type ProviderPriceAgreementsArgs = {
  filter: InputMaybe<PriceAgreementFilter>;
};


export type ProviderPriceListsArgs = {
  filter: InputMaybe<CarePageable>;
};


export type ProviderUsersArgs = {
  filter: InputMaybe<ProviderUserFilter>;
};

export type ProviderBankAccount = ProviderPaymentAccount & {
  __typename?: 'ProviderBankAccount';
  accountCode: Maybe<Scalars['String']['output']>;
  accountHolderName: Maybe<Scalars['String']['output']>;
  accountLabel: Maybe<Scalars['String']['output']>;
  accountNumber: Maybe<Scalars['String']['output']>;
  accountType: Maybe<AccountType>;
  bankBranchCode: Maybe<Scalars['String']['output']>;
  bankCode: Maybe<Scalars['String']['output']>;
  bankName: Maybe<Scalars['String']['output']>;
  bicCode: Maybe<Scalars['String']['output']>;
  branchName: Maybe<Scalars['String']['output']>;
  claimsAccount: Maybe<Scalars['Boolean']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  loansAccount: Maybe<Scalars['Boolean']['output']>;
  primaryClaimsAccount: Maybe<Scalars['Boolean']['output']>;
  primaryLoansAccount: Maybe<Scalars['Boolean']['output']>;
};

export type ProviderBankAccountInput = {
  accountHolderName: Scalars['String']['input'];
  accountLabel: InputMaybe<Scalars['String']['input']>;
  accountNumber: Scalars['String']['input'];
  bankBranchCode: InputMaybe<Scalars['String']['input']>;
  bankCode: InputMaybe<Scalars['String']['input']>;
  bankName: Scalars['String']['input'];
  bicCode: InputMaybe<Scalars['String']['input']>;
  branchName: InputMaybe<Scalars['String']['input']>;
  claimsAccount: Scalars['Boolean']['input'];
  currency: Scalars['String']['input'];
  loansAccount: Scalars['Boolean']['input'];
  primaryClaimsAccount: Scalars['Boolean']['input'];
  primaryLoansAccount: Scalars['Boolean']['input'];
};

export type ProviderBankAccountResponse = Error | ProviderBankAccount;

export enum ProviderBusinessType {
  Branch = 'BRANCH',
  Main = 'MAIN'
}

export type ProviderContact = {
  __typename?: 'ProviderContact';
  contactCode: Scalars['String']['output'];
  department: DepartmentType;
  description: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  escalationLevel: Maybe<Scalars['Int']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  otherDepartment: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type ProviderContactDeleteResponse = Error | Success;

export type ProviderContactFilter = {
  firstName: InputMaybe<Scalars['String']['input']>;
  lastName: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
};

export type ProviderContactInput = {
  department: DepartmentType;
  description: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  escalationLevel: InputMaybe<Scalars['Int']['input']>;
  fax: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  otherDepartment: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type ProviderContactPage = CarePage & {
  __typename?: 'ProviderContactPage';
  data: Maybe<Array<ProviderContact>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ProviderContactResponse = Error | ProviderContact;

export type ProviderEmployeeResponse = Employee | Error;

export type ProviderExternalCode = {
  __typename?: 'ProviderExternalCode';
  code: Scalars['String']['output'];
  systemCode: Scalars['String']['output'];
  systemIdentifier: Scalars['String']['output'];
};

export type ProviderExternalCodeDeleteResponse = Error | Success;

export type ProviderExternalCodeInput = {
  systemCode: Scalars['String']['input'];
  systemIdentifier: Scalars['String']['input'];
};

export type ProviderExternalCodeResponse = Error | ProviderExternalCode;

export type ProviderFileStatus = {
  __typename?: 'ProviderFileStatus';
  errorFileLink: Maybe<Scalars['String']['output']>;
  errorFileName: Maybe<Scalars['String']['output']>;
  fileStatusCode: Scalars['String']['output'];
  initialFileLink: Scalars['String']['output'];
  initialFileName: Scalars['String']['output'];
  status: FileProcessingStatus;
};

export type ProviderFilter = {
  /** @deprecated Use: 'affiliationCodes' instead */
  affiliation: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use: 'affiliationCodes' instead */
  affiliationCode: InputMaybe<Scalars['String']['input']>;
  affiliationCodes: InputMaybe<Array<Scalars['String']['input']>>;
  affordabilityCodes: InputMaybe<Array<Scalars['String']['input']>>;
  businessType: InputMaybe<Array<InputMaybe<ProviderBusinessType>>>;
  city: InputMaybe<Scalars['String']['input']>;
  classification: InputMaybe<Scalars['String']['input']>;
  externalSystemCodes: InputMaybe<Array<Scalars['String']['input']>>;
  externalSystemIdentifiers: InputMaybe<Array<Scalars['String']['input']>>;
  fromDate: InputMaybe<Scalars['String']['input']>;
  geolocationLevelOneCodes: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Use: 'geolocationLevelTwoCodes' instead */
  geolocationLevelTwoCode: InputMaybe<Scalars['String']['input']>;
  geolocationLevelTwoCodes: InputMaybe<Array<Scalars['String']['input']>>;
  name: InputMaybe<Scalars['String']['input']>;
  namesExact: InputMaybe<Array<Scalars['String']['input']>>;
  ownership: InputMaybe<Array<InputMaybe<Ownership>>>;
  page: InputMaybe<CarePageable>;
  providerCodes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerType: InputMaybe<Array<InputMaybe<ProviderType>>>;
  search: InputMaybe<Scalars['String']['input']>;
  service: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  speciality: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Use: 'statuses' instead */
  status: InputMaybe<ProviderStatus>;
  statuses: InputMaybe<Array<ProviderStatus>>;
  toDate: InputMaybe<Scalars['String']['input']>;
};

export type ProviderLicense = {
  __typename?: 'ProviderLicense';
  approvalStatus: Maybe<ChangeRequestApprovalStatus>;
  dateOfRegistration: Maybe<Scalars['String']['output']>;
  issuingAuthority: Maybe<IssuingAuthority>;
  licenseDocuments: Maybe<Array<ProviderLicenseDocument>>;
  licenseNumber: Maybe<Scalars['String']['output']>;
  licenseType: Maybe<ProviderLicenseType>;
  pendingVersion: Maybe<ProviderLicense>;
  providerLicenseCode: Maybe<Scalars['String']['output']>;
  registeredName: Maybe<Scalars['String']['output']>;
  validFrom: Maybe<Scalars['String']['output']>;
  validTo: Maybe<Scalars['String']['output']>;
};

export type ProviderLicenseDeleteResponse = Error | Success;

export type ProviderLicenseDocument = {
  __typename?: 'ProviderLicenseDocument';
  documentCode: Maybe<Scalars['String']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
};

export type ProviderLicenseDocumentDeleteResponse = Error | Success;

export type ProviderLicenseFilter = {
  dateOfValidity: InputMaybe<Scalars['String']['input']>;
  includePendingApproval: InputMaybe<Scalars['Boolean']['input']>;
  issuingAuthority: InputMaybe<IssuingAuthority>;
  licenseNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  licenseType: InputMaybe<ProviderLicenseType>;
  page: InputMaybe<CarePageable>;
  providerLicenseCodes: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProviderLicenseInput = {
  dateOfRegistration: Scalars['String']['input'];
  issuingAuthority: IssuingAuthority;
  licenseNumber: Scalars['String']['input'];
  licenseType: ProviderLicenseType;
  registeredName: Scalars['String']['input'];
  validFrom: Scalars['String']['input'];
  validTo: Scalars['String']['input'];
};

export type ProviderLicensePage = CarePage & {
  __typename?: 'ProviderLicensePage';
  data: Maybe<Array<Maybe<ProviderLicense>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ProviderLicenseResponse = Error | ProviderLicense;

export enum ProviderLicenseType {
  AuditedFinancialStatementsAttached = 'AUDITED_FINANCIAL_STATEMENTS_ATTACHED',
  BusinessPermit = 'BUSINESS_PERMIT',
  CertificateOfIncorporation = 'CERTIFICATE_OF_INCORPORATION',
  ClinicianCertificate = 'CLINICIAN_CERTIFICATE',
  CommercialOrTrade = 'COMMERCIAL_OR_TRADE',
  Cr12Certificate = 'CR12_CERTIFICATE',
  KraPinCertificate = 'KRA_PIN_CERTIFICATE',
  LetterOfRecommendation = 'LETTER_OF_RECOMMENDATION',
  ProfessionalIndemnity = 'PROFESSIONAL_INDEMNITY',
  Regulatory = 'REGULATORY'
}

export type ProviderMinimalFilter = {
  name: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
  providerCodes: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProviderMinimalPage = CarePage & {
  __typename?: 'ProviderMinimalPage';
  data: Maybe<Array<MinimalProvider>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ProviderMobileWalletAccount = ProviderPaymentAccount & {
  __typename?: 'ProviderMobileWalletAccount';
  accountCode: Maybe<Scalars['String']['output']>;
  accountHolderName: Maybe<Scalars['String']['output']>;
  accountLabel: Maybe<Scalars['String']['output']>;
  accountNumber: Maybe<Scalars['String']['output']>;
  accountType: Maybe<AccountType>;
  claimsAccount: Maybe<Scalars['Boolean']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  loansAccount: Maybe<Scalars['Boolean']['output']>;
  mobileMoneyService: Maybe<Scalars['String']['output']>;
  paymentServiceProvider: Maybe<Scalars['String']['output']>;
  primaryClaimsAccount: Maybe<Scalars['Boolean']['output']>;
  primaryLoansAccount: Maybe<Scalars['Boolean']['output']>;
};

export type ProviderMobileWalletAccountInput = {
  accountHolderName: Scalars['String']['input'];
  accountLabel: InputMaybe<Scalars['String']['input']>;
  accountNumber: Scalars['String']['input'];
  claimsAccount: Scalars['Boolean']['input'];
  currency: Scalars['String']['input'];
  loansAccount: Scalars['Boolean']['input'];
  mobileMoneyService: Scalars['String']['input'];
  paymentServiceProvider: Scalars['String']['input'];
  primaryClaimsAccount: Scalars['Boolean']['input'];
  primaryLoansAccount: Scalars['Boolean']['input'];
};

export type ProviderMobileWalletAccountResponse = Error | ProviderMobileWalletAccount;

export type ProviderNetwork = {
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  payer: Payer;
  type: ProviderNetworkType;
};

export type ProviderNetworkEligibilityFilter = {
  activeAtDate: InputMaybe<Scalars['String']['input']>;
  networkCodes: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  payer: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
};

export type ProviderNetworkFilter = {
  codes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultNetworkCategory: InputMaybe<DefaultNetworkCategory>;
  name: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
  payer: InputMaybe<Scalars['String']['input']>;
  types: InputMaybe<Array<InputMaybe<ProviderNetworkType>>>;
};

export type ProviderNetworkPage = CarePage & {
  __typename?: 'ProviderNetworkPage';
  data: Maybe<Array<Maybe<CustomNetwork | StandardNetwork>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum ProviderNetworkType {
  Custom = 'CUSTOM',
  Default = 'DEFAULT'
}

export type ProviderPage = CarePage & {
  __typename?: 'ProviderPage';
  data: Maybe<Array<Maybe<Provider>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ProviderPaymentAccount = {
  accountCode: Maybe<Scalars['String']['output']>;
  accountHolderName: Maybe<Scalars['String']['output']>;
  accountLabel: Maybe<Scalars['String']['output']>;
  accountNumber: Maybe<Scalars['String']['output']>;
  accountType: Maybe<AccountType>;
  claimsAccount: Maybe<Scalars['Boolean']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  loansAccount: Maybe<Scalars['Boolean']['output']>;
  primaryClaimsAccount: Maybe<Scalars['Boolean']['output']>;
  primaryLoansAccount: Maybe<Scalars['Boolean']['output']>;
};

export type ProviderPaymentDeleteResponse = Error | Success;

export type ProviderPriceAgreementPage = CarePage & {
  __typename?: 'ProviderPriceAgreementPage';
  data: Maybe<Array<Maybe<PriceAgreement>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ProviderProductInfo = {
  __typename?: 'ProviderProductInfo';
  category: MedicalProductCategory;
  codingSystem: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  providerProductCode: Maybe<Scalars['String']['output']>;
};

export type ProviderProgressResponse = Error | Success;

export type ProviderResponse = Error | Provider;

export enum ProviderRole {
  ProviderAdmin = 'PROVIDER_ADMIN',
  ProviderAnalyst = 'PROVIDER_ANALYST',
  ProviderHubAdmin = 'PROVIDER_HUB_ADMIN',
  ProviderReceptionist = 'PROVIDER_RECEPTIONIST'
}

export enum ProviderStatus {
  Active = 'ACTIVE',
  UnderRegistration = 'UNDER_REGISTRATION'
}

export type ProviderStatusResponse = Error | Success;

export enum ProviderType {
  CommunityPharmacy = 'COMMUNITY_PHARMACY',
  DaycareSurgery = 'DAYCARE_SURGERY',
  DentalClinic = 'DENTAL_CLINIC',
  DiagnosticCentre = 'DIAGNOSTIC_CENTRE',
  DialysisCentre = 'DIALYSIS_CENTRE',
  FertilityCentre = 'FERTILITY_CENTRE',
  GatekeeperCamp = 'GATEKEEPER_CAMP',
  Hospital = 'HOSPITAL',
  Hub = 'HUB',
  InhousePharmacy = 'INHOUSE_PHARMACY',
  InpatientPharmacy = 'INPATIENT_PHARMACY',
  MedicalCentreClinic = 'MEDICAL_CENTRE_CLINIC',
  MobileHealthUnit = 'MOBILE_HEALTH_UNIT',
  OpticalCentre = 'OPTICAL_CENTRE',
  OutpatientPharmacy = 'OUTPATIENT_PHARMACY',
  PrimaryHealthcareFacility = 'PRIMARY_HEALTHCARE_FACILITY',
  RehabilitationCentre = 'REHABILITATION_CENTRE',
  Specialist = 'SPECIALIST',
  TeleMedicineProvider = 'TELE_MEDICINE_PROVIDER',
  TraditionalComplementaryAndAlternativeMedicine = 'TRADITIONAL_COMPLEMENTARY_AND_ALTERNATIVE_MEDICINE',
  TwentyFourHourPharmacy = 'TWENTY_FOUR_HOUR_PHARMACY'
}

export type ProviderUser = {
  __typename?: 'ProviderUser';
  provider: Provider;
  /** @deprecated Use: 'provider: Provider' instead */
  providerCode: Scalars['String']['output'];
  user: User;
  userCode: Scalars['String']['output'];
  userRoles: Array<ProviderRole>;
};

export type ProviderUserFilter = {
  page: InputMaybe<CarePageable>;
  roles: InputMaybe<Array<ProviderRole>>;
  userKeys: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProviderUserPage = CarePage & {
  __typename?: 'ProviderUserPage';
  data: Maybe<Array<ProviderUser>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type ProviderUserResponse = Error | ProviderUser;

export type PublishQuotationResponse = Error | Success;

export type Query = {
  __typename?: 'Query';
  affiliations: Maybe<AffiliationPage>;
  alternateBatches: Maybe<Array<BatchAggregate>>;
  amountTierMappings: Maybe<AmountTierMappingPage>;
  balanceOverview: Maybe<BalanceOverview>;
  balanceOverviews: Maybe<Array<Maybe<BalanceOverview>>>;
  batchAggregates: Maybe<BatchAggregatesPage>;
  batchDetails: Maybe<BatchAggregate>;
  batchFilters: Maybe<Array<PartyAlias>>;
  batchHistory: Maybe<Array<BatchAggregate>>;
  batchedPaymentAggregates: Maybe<BatchedPaymentAggregatePage>;
  beneficiariesAffectedByPolicyStatusChange: Array<Scalars['String']['output']>;
  beneficiaryBulkEnrollmentStatus: Maybe<BulkUploadProgress>;
  beneficiaryBulkUploadTemplate: Maybe<DocumentDownload>;
  beneficiaryDocuments: Maybe<Array<BeneficiaryDocument>>;
  beneficiaryIntegrationErrors: Maybe<BeneficiaryIntegrationErrorPage>;
  /** @deprecated This query is deprecated and will be removed in a future release. Use beneficiaryPoliciesOverview for faster query performance. */
  beneficiaryPolicies: Maybe<BeneficiaryPolicyPage>;
  beneficiaryPoliciesOverview: Maybe<BeneficiaryPolicyOverviewPage>;
  beneficiaryPolicy: Maybe<BeneficiaryPolicy>;
  beneficiaryPolicyEndorsements: Maybe<BeneficiaryPolicyEndorsementPage>;
  beneficiaryPolicyEndorsementsOverview: Maybe<BeneficiaryPolicyEndorsementOverviewPage>;
  beneficiaryPolicyLookups: Maybe<BeneficiaryPolicyLookups>;
  beneficiaryPremiumCalculations: Maybe<BeneficiaryPremiumCalculationPage>;
  benefits: Maybe<BenefitPage>;
  bills: Maybe<BillPage>;
  bulkUploadPresignedUrl: Maybe<BulkUploadPresignedUrl>;
  businessProperties: Maybe<BusinessPropertyPage>;
  calculateClaimApprovalAmount: Maybe<CalculateClaimApprovalAmount>;
  cases: Maybe<CasePage>;
  category: Maybe<Category>;
  censusEntriesSummary: Maybe<CensusEntriesSummary>;
  censusTemplate: Maybe<QuotationDocumentLocation>;
  censusUploadStatus: Maybe<CensusUploadStatus>;
  changeRequests: Maybe<ChangeRequestPage>;
  checkPermissions: Array<CheckPermissionOutput>;
  checkResources: Array<CheckResourceOutput>;
  claim: Maybe<Claim>;
  claimDiagnoses: Maybe<DiagnosisPage>;
  claimFilterOptions: Maybe<ClaimFilterOptions>;
  claimHistory: Maybe<Claim>;
  claimInvoices: Maybe<Array<ClaimInvoice>>;
  claimItems: Maybe<ClaimItemPage>;
  claimUploadErrorSummaries: Maybe<ClaimUploadErrorSummaryPage>;
  claims: Maybe<ClaimPage>;
  claimsSummary: Maybe<ClaimPage>;
  classifications: Maybe<ClassificationPage>;
  codingSystem: Maybe<CodingSystem>;
  codingSystems: Maybe<Array<CodingSystem>>;
  countries: Maybe<CountryPage>;
  country: Maybe<Country>;
  diagnoses: Maybe<MedicalProductPage>;
  downloadBeneficiaryDocument: Maybe<DocumentDownload>;
  downloadBillDocument: Maybe<BillDocumentLocation>;
  downloadClaimDocument: Maybe<ClaimDocumentLocation>;
  downloadClaimItemDocument: Maybe<ClaimDocumentLocation>;
  downloadClaimsBulkUploadTemplate: ClaimDocumentLocation;
  downloadEndorsementDocument: Maybe<DocumentDownload>;
  downloadIntermediaryDocument: PayerDocumentDownload;
  downloadIntermediaryLicense: Maybe<PayerDocumentDownloadResponse>;
  downloadLocation: Maybe<ClaimUploadErrorFileDownload>;
  downloadMembersReport: Maybe<DocumentDownload>;
  downloadPayerDocument: PayerDocumentDownload;
  downloadPolicyDocument: DocumentDownload;
  downloadPolicyholderDocument: DocumentDownload;
  downloadPreAuthorizationsBulkUploadTemplate: PreAuthorizationDocumentLocation;
  drugs: Maybe<DrugPage>;
  eligibleProviderNetworks: Maybe<ProviderNetworkPage>;
  empaneledProviders: Maybe<EmpaneledProviderPage>;
  employeeSpecialities: Maybe<EmployeeSpecialityPage>;
  employeeTemplate: Maybe<EmployeeTemplate>;
  endorsementAuditDetail: Maybe<BeneficiaryPolicyEndorsement>;
  endorsementBeneficiaryPolicy: Maybe<BeneficiaryPolicyEndorsement>;
  endorsementDocuments: Maybe<Array<EndorsementDocument>>;
  fileStatus: Maybe<MedicalProductFileStatus>;
  formulations: Maybe<FormulationsPage>;
  generateQuotationDocument: Maybe<QuotationDocumentLocation>;
  geolocationLevelOne: Maybe<GeolocationLevelOne>;
  geolocationLevelOnes: Maybe<GeolocationLevelOnePage>;
  geolocationLevelTwo: Maybe<GeolocationLevelTwo>;
  geolocationLevelTwos: Maybe<GeolocationLevelTwoPage>;
  getCategoryMapping: Maybe<Array<CategoryMapping>>;
  getFingerprintPerson: Maybe<FingerprintPersonResponse>;
  groupParties: Maybe<GroupPartyPage>;
  healthcareServices: Maybe<HealthcareServicePage>;
  healthcareSpecialities: Maybe<HealthcareSpecialityPage>;
  industries: Maybe<IndustryPage>;
  intermediaries: Maybe<IntermediaryPage>;
  intermediary: Maybe<Intermediary>;
  intermediaryLicenses: Maybe<IntermediaryLicensesPage>;
  invoicePdfLocation: Maybe<PremiumFinancialsPdfLocation>;
  invoices: Maybe<InvoicePage>;
  itemsPricing: Maybe<Array<ItemPricing>>;
  lastBulkStatus: Array<BulkUploadProgress>;
  medicalCodes: Maybe<MedicalCodePage>;
  medicalCodesTemplate: Maybe<MedicalProductUrl>;
  medicalProducts: Maybe<MedicalProductPage>;
  medicalTagTypes: Maybe<MedicalTagTypePage>;
  medicalTags: Maybe<MedicalTagPage>;
  member: Maybe<Member>;
  memberCommunicationDetails: Maybe<CommunicationDetails>;
  members: Maybe<MembersPage>;
  messages: Maybe<MessagePage>;
  minimalProviders: Maybe<ProviderMinimalPage>;
  packageTypes: Maybe<PackageTypesPage>;
  payer: Maybe<Payer>;
  payerChildren: Maybe<PayerPage>;
  payerCopayItems: Maybe<Array<Maybe<PayerCopay>>>;
  payerCopayRules: Maybe<PayerCopayRulePage>;
  payerCopayVisit: Maybe<PayerCopay>;
  payerParents: Maybe<PayerPage>;
  payers: Maybe<PayerPage>;
  paymentAggregates: Maybe<PaymentAggregatesPage>;
  paymentContract: Maybe<PaymentContract>;
  paymentContracts: Maybe<PaymentContractPage>;
  paymentDetails: Maybe<Payment>;
  paymentFilters: Maybe<Array<FilterParty>>;
  paymentHistory: Maybe<Array<Payment>>;
  plan: Maybe<Plan>;
  plans: Maybe<PlanPage>;
  policies: Maybe<PolicyPage>;
  policy: Maybe<Policy>;
  policyExclusions: Maybe<ExclusionPage>;
  policyInclusions: Maybe<InclusionPage>;
  policyPremiumCalculationOverview: Maybe<PolicyPremiumCalculationOverview>;
  policyProducts: Maybe<PolicyProductPage>;
  policyholderCountries: Maybe<PolicyholderRegionPage>;
  policyholderStates: Maybe<PolicyholderRegionPage>;
  preAuthDocumentLocation: Maybe<PreAuthorizationDocumentLocation>;
  preAuthorizationAudit: Maybe<PreAuthorizationAuditPage>;
  preAuthorizationCalculateApprovalAmount: Maybe<PreAuthorizationCalculateApprovalAmount>;
  preAuthorizationDocumentLocation: Maybe<PreAuthorizationDocumentLocation>;
  preAuthorizationFilterOptions: Maybe<PreAuthorizationFilterOptions>;
  preAuthorizationHistory: Maybe<PreAuthorization>;
  preAuthorizationItemDocumentLocation: Maybe<PreAuthorizationDocumentLocation>;
  preAuthorizationOverride: Maybe<PreAuthorizationOverride>;
  preAuthorizations: Maybe<PreAuthorizationPage>;
  preAuthorizationsSummary: Maybe<PreAuthorizationPage>;
  premiumCalculationAsyncProcessingStatus: Maybe<PremiumCalculationAsyncProcessingStatusResult>;
  premiumCalculationSummaries: Maybe<PremiumCalculationSummaryPage>;
  premiumCalculations: Maybe<PremiumCalculationPage>;
  premiumInstalments: Maybe<PremiumInstalmentPage>;
  premiumStatementPdfLocation: Maybe<PremiumFinancialsPdfLocation>;
  premiumStatements: Maybe<PremiumStatementPage>;
  premiumTables: Maybe<PremiumTablePage>;
  prescription: Maybe<Prescription>;
  prescriptions: Maybe<PrescriptionPage>;
  priceAgreement: Maybe<PriceAgreement>;
  priceAgreementItems: Maybe<PriceAgreementItemPage>;
  priceAgreementTemplate: FileDownload;
  priceFile: Maybe<PriceFile>;
  priceList: Maybe<PriceList>;
  priceListTemplate: FileDownload;
  priceLists: Maybe<PriceListPage>;
  pricingCopyStatus: Maybe<CopyPricingStatusResponse>;
  product: Maybe<Product>;
  productGroupSizes: Maybe<ProductGroupSizePage>;
  productIndustries: Maybe<ProductIndustryPage>;
  products: Maybe<ProductOverviewPage>;
  promotions: Maybe<Promotions>;
  provider: Maybe<Provider>;
  providerFileStatus: Maybe<ProviderFileStatus>;
  providerNetwork: Maybe<CustomNetwork | StandardNetwork>;
  providerNetworks: Maybe<ProviderNetworkPage>;
  providers: Maybe<ProviderPage>;
  quotation: Maybe<Quotation>;
  quotationCategory: Maybe<QuotationCategory>;
  quotationDocumentLocation: Maybe<QuotationDocumentLocation>;
  quotationPremium: Maybe<QuotationPremiumOverview>;
  quotations: Maybe<QuotationOverviewPage>;
  region: Maybe<GeolocationRegion>;
  regions: Maybe<GeolocationRegionPage>;
  regulatedPriceList: Maybe<PriceList>;
  remittanceAggregateFilters: Maybe<Array<Scalars['String']['output']>>;
  remittanceRequestAggregates: Maybe<RemittanceRequestAggregatesPage>;
  ruleEngineRules: Maybe<RuleEngineRulePage>;
  strengths: Maybe<StrengthsPage>;
  tenant: Maybe<Tenant>;
  tierToRoleMappings: Maybe<TierToRoleMappingPage>;
  user: Maybe<User>;
  users: Maybe<PlatformUserPage>;
  validateEndorsementActionDate: Maybe<EndorsementActionValidationDetails>;
  visit: Maybe<Visit>;
  visits: Maybe<VisitPage>;
};


export type QueryAffiliationsArgs = {
  filter: InputMaybe<AffiliationFilter>;
};


export type QueryAlternateBatchesArgs = {
  batchInternalRef: Scalars['String']['input'];
};


export type QueryAmountTierMappingsArgs = {
  filter: InputMaybe<AmountTierMappingFilter>;
};


export type QueryBalanceOverviewArgs = {
  beneficiaryPolicyId: Scalars['String']['input'];
  benefitId: Scalars['String']['input'];
};


export type QueryBalanceOverviewsArgs = {
  beneficiaryPolicyId: Scalars['String']['input'];
};


export type QueryBatchAggregatesArgs = {
  filter: InputMaybe<BatchAggregateFilter>;
};


export type QueryBatchDetailsArgs = {
  batchInternalRef: Scalars['String']['input'];
};


export type QueryBatchFiltersArgs = {
  filter: InputMaybe<BatchAggregateFilterOptions>;
};


export type QueryBatchHistoryArgs = {
  batchInternalRef: Scalars['String']['input'];
};


export type QueryBatchedPaymentAggregatesArgs = {
  filter: InputMaybe<BatchedPaymentAggregateFilter>;
};


export type QueryBeneficiariesAffectedByPolicyStatusChangeArgs = {
  policyId: Scalars['String']['input'];
  status: PolicyDomainStatus;
};


export type QueryBeneficiaryBulkEnrollmentStatusArgs = {
  policyId: Scalars['String']['input'];
};


export type QueryBeneficiaryBulkUploadTemplateArgs = {
  policyId: Scalars['String']['input'];
  templateType: BulkUploadType;
};


export type QueryBeneficiaryDocumentsArgs = {
  beneficiaryPolicyId: Scalars['String']['input'];
};


export type QueryBeneficiaryIntegrationErrorsArgs = {
  filter: InputMaybe<BeneficiaryIntegrationErrorFilter>;
};


export type QueryBeneficiaryPoliciesArgs = {
  filter: InputMaybe<BeneficiaryPolicyFilter>;
};


export type QueryBeneficiaryPoliciesOverviewArgs = {
  filter: InputMaybe<BeneficiaryPolicyFilter>;
};


export type QueryBeneficiaryPolicyArgs = {
  id: Scalars['String']['input'];
};


export type QueryBeneficiaryPolicyEndorsementsArgs = {
  filter: InputMaybe<BeneficiaryPolicyEndorsementFilter>;
};


export type QueryBeneficiaryPolicyEndorsementsOverviewArgs = {
  filter: InputMaybe<BeneficiaryPolicyEndorsementOverviewFilter>;
};


export type QueryBeneficiaryPremiumCalculationsArgs = {
  filter: InputMaybe<BeneficiaryPremiumCalculationsFilter>;
};


export type QueryBenefitsArgs = {
  filter: InputMaybe<BenefitsFilter>;
};


export type QueryBillsArgs = {
  filter: InputMaybe<BillFilter>;
};


export type QueryBusinessPropertiesArgs = {
  filter: InputMaybe<BusinessPropertyFilter>;
};


export type QueryCalculateClaimApprovalAmountArgs = {
  calculateClaimApprovalAmountRequest: CalculateClaimApprovalAmountRequest;
};


export type QueryCasesArgs = {
  filter: InputMaybe<CaseFilter>;
};


export type QueryCategoryArgs = {
  categoryId: Scalars['String']['input'];
};


export type QueryCensusEntriesSummaryArgs = {
  quotationCode: Scalars['String']['input'];
};


export type QueryCensusUploadStatusArgs = {
  quotationCode: Scalars['String']['input'];
};


export type QueryChangeRequestsArgs = {
  filter: InputMaybe<ChangeRequestFilter>;
};


export type QueryCheckPermissionsArgs = {
  checkPermissionRequest: Array<CheckPermissionInput>;
};


export type QueryCheckResourcesArgs = {
  checkResourceRequest: Array<CheckResourceInput>;
};


export type QueryClaimArgs = {
  claimCode: Scalars['String']['input'];
};


export type QueryClaimDiagnosesArgs = {
  filter: InputMaybe<ClaimDiagnosesFilter>;
};


export type QueryClaimHistoryArgs = {
  claimHistoryFilter: ClaimHistoryFilter;
};


export type QueryClaimInvoicesArgs = {
  claimInvoiceFilter: ClaimInvoiceFilter;
};


export type QueryClaimItemsArgs = {
  claimItemFilter: ClaimItemFilter;
};


export type QueryClaimUploadErrorSummariesArgs = {
  filter: InputMaybe<ClaimUploadErrorSummaryFilter>;
};


export type QueryClaimsArgs = {
  filter: InputMaybe<ClaimFilter>;
};


export type QueryClaimsSummaryArgs = {
  filter: InputMaybe<ClaimFilter>;
};


export type QueryClassificationsArgs = {
  filter: InputMaybe<ClassificationFilter>;
};


export type QueryCodingSystemArgs = {
  codingSystemKey: Scalars['String']['input'];
};


export type QueryCountriesArgs = {
  filter: InputMaybe<CountryFilter>;
};


export type QueryCountryArgs = {
  code: Scalars['String']['input'];
};


export type QueryDiagnosesArgs = {
  filter: InputMaybe<DiagnosisFilter>;
};


export type QueryDownloadBeneficiaryDocumentArgs = {
  beneficiaryPolicyId: Scalars['String']['input'];
  documentKey: Scalars['String']['input'];
};


export type QueryDownloadBillDocumentArgs = {
  documentRef: Scalars['String']['input'];
};


export type QueryDownloadClaimDocumentArgs = {
  code: Scalars['String']['input'];
  documentCode: Scalars['String']['input'];
};


export type QueryDownloadClaimItemDocumentArgs = {
  code: Scalars['String']['input'];
  documentCode: Scalars['String']['input'];
  itemCode: Scalars['String']['input'];
};


export type QueryDownloadEndorsementDocumentArgs = {
  documentKey: Scalars['String']['input'];
  endorsementId: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
};


export type QueryDownloadIntermediaryDocumentArgs = {
  documentKey: Scalars['String']['input'];
  intermediaryKey: Scalars['String']['input'];
};


export type QueryDownloadIntermediaryLicenseArgs = {
  intermediaryKey: Scalars['String']['input'];
  licenseKey: Scalars['String']['input'];
};


export type QueryDownloadLocationArgs = {
  uploadInternalReference: Scalars['String']['input'];
};


export type QueryDownloadMembersReportArgs = {
  reportInput: ReportInput;
};


export type QueryDownloadPayerDocumentArgs = {
  documentKey: Scalars['String']['input'];
  payerKey: Scalars['String']['input'];
};


export type QueryDownloadPolicyDocumentArgs = {
  policyId: Scalars['String']['input'];
};


export type QueryDownloadPolicyholderDocumentArgs = {
  documentId: Scalars['String']['input'];
  policyholderId: Scalars['String']['input'];
};


export type QueryDrugsArgs = {
  filter: InputMaybe<DrugFilter>;
};


export type QueryEligibleProviderNetworksArgs = {
  filter: ProviderNetworkEligibilityFilter;
};


export type QueryEmpaneledProvidersArgs = {
  filter: InputMaybe<EmpaneledProviderFilter>;
};


export type QueryEmployeeSpecialitiesArgs = {
  filter: InputMaybe<EmployeeSpecialityFilter>;
};


export type QueryEmployeeTemplateArgs = {
  jobType: JobRole;
};


export type QueryEndorsementAuditDetailArgs = {
  endorsementId: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
};


export type QueryEndorsementBeneficiaryPolicyArgs = {
  endorsementId: Scalars['String']['input'];
};


export type QueryEndorsementDocumentsArgs = {
  endorsementId: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
};


export type QueryFileStatusArgs = {
  fileStatusCode: Scalars['String']['input'];
};


export type QueryFormulationsArgs = {
  filter: InputMaybe<FormulationsFilter>;
};


export type QueryGenerateQuotationDocumentArgs = {
  quotationCode: Scalars['String']['input'];
};


export type QueryGeolocationLevelOneArgs = {
  code: Scalars['String']['input'];
};


export type QueryGeolocationLevelOnesArgs = {
  filter: InputMaybe<GeolocationLevelOneFilter>;
};


export type QueryGeolocationLevelTwoArgs = {
  code: Scalars['String']['input'];
};


export type QueryGeolocationLevelTwosArgs = {
  filter: InputMaybe<GeolocationLevelTwoFilter>;
};


export type QueryGetCategoryMappingArgs = {
  categoryMappingsInput: InputMaybe<Array<CategoryMappingInput>>;
};


export type QueryGetFingerprintPersonArgs = {
  personRef: Scalars['String']['input'];
};


export type QueryGroupPartiesArgs = {
  filter: InputMaybe<GroupPartyFilter>;
};


export type QueryHealthcareServicesArgs = {
  filter: InputMaybe<HealthcareServicesFilter>;
};


export type QueryHealthcareSpecialitiesArgs = {
  filter: InputMaybe<HealthcareSpecialityFilter>;
};


export type QueryIndustriesArgs = {
  filter: InputMaybe<IndustryFilter>;
};


export type QueryIntermediariesArgs = {
  filter: InputMaybe<IntermediaryFilter>;
};


export type QueryIntermediaryArgs = {
  intermediaryKey: Scalars['String']['input'];
};


export type QueryIntermediaryLicensesArgs = {
  filter: InputMaybe<IntermediaryLicenseFilter>;
  intermediaryKey: Scalars['String']['input'];
};


export type QueryInvoicePdfLocationArgs = {
  invoiceCode: Scalars['String']['input'];
};


export type QueryInvoicesArgs = {
  filter: InputMaybe<InvoiceFilter>;
};


export type QueryItemsPricingArgs = {
  filter: ItemsPricingFilter;
};


export type QueryLastBulkStatusArgs = {
  statusFilter: LastBulkUploadStatusFilter;
};


export type QueryMedicalCodesArgs = {
  filter: InputMaybe<MedicalCodeFilter>;
};


export type QueryMedicalCodesTemplateArgs = {
  category: MedicalProductCategory;
};


export type QueryMedicalProductsArgs = {
  filter: InputMaybe<MedicalProductFilter>;
};


export type QueryMedicalTagTypesArgs = {
  filter: InputMaybe<MedicalTagTypeFilter>;
};


export type QueryMedicalTagsArgs = {
  filter: InputMaybe<MedicalTagFilter>;
};


export type QueryMemberArgs = {
  memberId: Scalars['String']['input'];
};


export type QueryMemberCommunicationDetailsArgs = {
  filter: CommunicationSearchFilter;
};


export type QueryMembersArgs = {
  filter: SearchMembersFilter;
};


export type QueryMessagesArgs = {
  filter: MessageFilter;
};


export type QueryMinimalProvidersArgs = {
  filter: InputMaybe<ProviderMinimalFilter>;
};


export type QueryPackageTypesArgs = {
  filter: InputMaybe<PackageTypesFilter>;
};


export type QueryPayerArgs = {
  payerKey: Scalars['String']['input'];
};


export type QueryPayerChildrenArgs = {
  filter: PayerChildrenFilter;
};


export type QueryPayerCopayItemsArgs = {
  filter: InputMaybe<PayerCopayFilter>;
  payerKey: Scalars['String']['input'];
};


export type QueryPayerCopayRulesArgs = {
  filter: InputMaybe<PayerCopayRuleFilter>;
  payerKey: Scalars['String']['input'];
};


export type QueryPayerCopayVisitArgs = {
  filter: InputMaybe<PayerCopayFilter>;
  payerKey: Scalars['String']['input'];
};


export type QueryPayerParentsArgs = {
  filter: PayerParentsFilter;
};


export type QueryPayersArgs = {
  filter: InputMaybe<PayerFilter>;
};


export type QueryPaymentAggregatesArgs = {
  filter: InputMaybe<PaymentAggregateFilter>;
};


export type QueryPaymentContractArgs = {
  internalRef: Scalars['String']['input'];
};


export type QueryPaymentContractsArgs = {
  filter: PaymentContractFilter;
};


export type QueryPaymentDetailsArgs = {
  paymentId: Scalars['String']['input'];
};


export type QueryPaymentFiltersArgs = {
  filter: InputMaybe<PaymentAggregateFilterOptions>;
};


export type QueryPaymentHistoryArgs = {
  paymentId: Scalars['String']['input'];
};


export type QueryPlanArgs = {
  planId: Scalars['String']['input'];
};


export type QueryPlansArgs = {
  filter: InputMaybe<PlanFilter>;
};


export type QueryPoliciesArgs = {
  filter: InputMaybe<PolicyFilter>;
};


export type QueryPolicyArgs = {
  policyId: Scalars['String']['input'];
};


export type QueryPolicyExclusionsArgs = {
  filter: InclusionExclusionFilter;
};


export type QueryPolicyInclusionsArgs = {
  filter: InclusionExclusionFilter;
};


export type QueryPolicyPremiumCalculationOverviewArgs = {
  policyId: Scalars['String']['input'];
};


export type QueryPolicyProductsArgs = {
  filter: InputMaybe<PolicyProductFilter>;
};


export type QueryPolicyholderCountriesArgs = {
  filter: InputMaybe<PolicyholderRegionFilter>;
};


export type QueryPolicyholderStatesArgs = {
  filter: InputMaybe<PolicyholderRegionFilter>;
};


export type QueryPreAuthDocumentLocationArgs = {
  documentReference: Scalars['String']['input'];
  preAuthReference: Scalars['String']['input'];
};


export type QueryPreAuthorizationAuditArgs = {
  filter: InputMaybe<PreAuthorizationAuditFilter>;
};


export type QueryPreAuthorizationCalculateApprovalAmountArgs = {
  preAuthorizationCalculateApprovalAmountRequest: PreAuthorizationCalculateApprovalAmountRequest;
};


export type QueryPreAuthorizationDocumentLocationArgs = {
  reference: Scalars['String']['input'];
};


export type QueryPreAuthorizationHistoryArgs = {
  preAuthorizationHistoryFilter: PreAuthorizationHistoryFilter;
};


export type QueryPreAuthorizationItemDocumentLocationArgs = {
  filter: PreAuthItemDocumentFilter;
};


export type QueryPreAuthorizationOverrideArgs = {
  preAuthorizationReference: Scalars['String']['input'];
};


export type QueryPreAuthorizationsArgs = {
  filter: InputMaybe<PreAuthorizationFilter>;
};


export type QueryPreAuthorizationsSummaryArgs = {
  filter: InputMaybe<PreAuthorizationFilter>;
};


export type QueryPremiumCalculationAsyncProcessingStatusArgs = {
  asyncCalculationCode: Scalars['String']['input'];
};


export type QueryPremiumCalculationSummariesArgs = {
  filter: InputMaybe<PremiumCalculationsSummaryFilter>;
};


export type QueryPremiumCalculationsArgs = {
  filter: InputMaybe<PremiumCalculationFilter>;
};


export type QueryPremiumInstalmentsArgs = {
  filter: InputMaybe<PremiumInstalmentFilter>;
};


export type QueryPremiumStatementPdfLocationArgs = {
  premiumStatementCode: Scalars['String']['input'];
};


export type QueryPremiumStatementsArgs = {
  filter: InputMaybe<PremiumStatementFilter>;
};


export type QueryPremiumTablesArgs = {
  filter: InputMaybe<PremiumTableFilter>;
};


export type QueryPrescriptionArgs = {
  internalRef: Scalars['String']['input'];
};


export type QueryPrescriptionsArgs = {
  filter: InputMaybe<PrescriptionFilter>;
};


export type QueryPriceAgreementArgs = {
  priceAgreementId: Scalars['String']['input'];
};


export type QueryPriceAgreementItemsArgs = {
  filter: PriceAgreementItemFilter;
};


export type QueryPriceFileArgs = {
  fileId: Scalars['String']['input'];
};


export type QueryPriceListArgs = {
  priceListId: Scalars['String']['input'];
};


export type QueryPriceListsArgs = {
  filter: PriceListFilter;
};


export type QueryPricingCopyStatusArgs = {
  copyPricingStatusInput: CopyPricingStatusInput;
};


export type QueryProductArgs = {
  productCode: Scalars['String']['input'];
};


export type QueryProductGroupSizesArgs = {
  filter: InputMaybe<ProductGroupSizeFilter>;
};


export type QueryProductIndustriesArgs = {
  filter: InputMaybe<ProductIndustryFilter>;
};


export type QueryProductsArgs = {
  filter: InputMaybe<ProductOverviewFilter>;
};


export type QueryPromotionsArgs = {
  userKey: Scalars['String']['input'];
};


export type QueryProviderArgs = {
  providerCode: Scalars['String']['input'];
};


export type QueryProviderFileStatusArgs = {
  fileStatusCode: Scalars['String']['input'];
};


export type QueryProviderNetworkArgs = {
  networkCode: Scalars['String']['input'];
};


export type QueryProviderNetworksArgs = {
  filter: InputMaybe<ProviderNetworkFilter>;
};


export type QueryProvidersArgs = {
  filter: InputMaybe<ProviderFilter>;
};


export type QueryQuotationArgs = {
  quotationCode: Scalars['String']['input'];
};


export type QueryQuotationCategoryArgs = {
  categoryCode: Scalars['String']['input'];
  quotationCode: Scalars['String']['input'];
};


export type QueryQuotationDocumentLocationArgs = {
  quotationCode: Scalars['String']['input'];
  quotationDocumentCode: Scalars['String']['input'];
};


export type QueryQuotationPremiumArgs = {
  quotationCode: Scalars['String']['input'];
};


export type QueryQuotationsArgs = {
  filter: InputMaybe<QuotationOverviewFilter>;
};


export type QueryRegionArgs = {
  code: Scalars['String']['input'];
};


export type QueryRegionsArgs = {
  filter: InputMaybe<RegionFilter>;
};


export type QueryRegulatedPriceListArgs = {
  priceListId: Scalars['String']['input'];
};


export type QueryRemittanceAggregateFiltersArgs = {
  filter: InputMaybe<RemittanceAggregateFilterOptions>;
};


export type QueryRemittanceRequestAggregatesArgs = {
  filter: InputMaybe<RemittanceAggregateFilter>;
};


export type QueryRuleEngineRulesArgs = {
  filter: InputMaybe<RuleEngineRuleFilter>;
};


export type QueryStrengthsArgs = {
  filter: InputMaybe<StrengthsFilter>;
};


export type QueryTenantArgs = {
  tenantKey: Scalars['String']['input'];
};


export type QueryTierToRoleMappingsArgs = {
  filter: InputMaybe<TierToRoleMappingFilter>;
};


export type QueryUserArgs = {
  externalKey: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  filter: InputMaybe<UserFilter>;
};


export type QueryValidateEndorsementActionDateArgs = {
  date: Scalars['String']['input'];
  endorsementType: EndorsementType;
  id: Scalars['String']['input'];
};


export type QueryVisitArgs = {
  visitCode: Scalars['String']['input'];
};


export type QueryVisitsArgs = {
  filter: InputMaybe<VisitFilter>;
};

export type Quotation = {
  __typename?: 'Quotation';
  categories: Maybe<QuotationCategoryPage>;
  censusEntries: Maybe<CensusEntryPage>;
  clientAddressLineOne: Maybe<Scalars['String']['output']>;
  clientAddressLineTwo: Maybe<Scalars['String']['output']>;
  clientCompanyRegistrationNumber: Maybe<Scalars['String']['output']>;
  clientCountry: Maybe<Country>;
  clientEmail: Maybe<Scalars['String']['output']>;
  clientGeolocationOne: Maybe<GeolocationLevelOne>;
  clientGeolocationTwo: Maybe<GeolocationLevelTwo>;
  clientIndustry: Maybe<ProductIndustry>;
  clientName: Maybe<Scalars['String']['output']>;
  clientPhoneNumber: Maybe<Scalars['String']['output']>;
  clientPreviousInsurer: Maybe<Scalars['String']['output']>;
  clientPreviousPolicyExpiryDate: Maybe<Scalars['String']['output']>;
  clientType: ClientType;
  clientVatNumber: Maybe<Scalars['String']['output']>;
  clientZipCode: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  comments: Maybe<CommentPage>;
  createdBy: Maybe<User>;
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  documents: Maybe<QuotationDocumentPage>;
  intermediary: Maybe<Intermediary>;
  modifiedBy: Maybe<User>;
  parentCode: Maybe<Scalars['String']['output']>;
  payer: Payer;
  policyExpiryDate: Maybe<Scalars['String']['output']>;
  policyStartDate: Maybe<Scalars['String']['output']>;
  previousPolicyRef: Maybe<Scalars['String']['output']>;
  quotationExpiryDate: Maybe<Scalars['String']['output']>;
  status: Maybe<QuotationStatus>;
  type: Maybe<QuotationType>;
};


export type QuotationCategoriesArgs = {
  filter: InputMaybe<CarePageable>;
};


export type QuotationCensusEntriesArgs = {
  filter: InputMaybe<CarePageable>;
};


export type QuotationCommentsArgs = {
  filter: InputMaybe<CarePageable>;
};


export type QuotationDocumentsArgs = {
  filter: InputMaybe<CarePageable>;
};

export type QuotationCategory = {
  __typename?: 'QuotationCategory';
  annualMedicalLimit: Maybe<AnnualMedicalLimit>;
  benefits: Maybe<Array<QuotationCategoryBenefit>>;
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pecCoverage: Maybe<PecCoverage>;
  product: Maybe<Product>;
  providerNetwork: Maybe<ProductProviderNetwork>;
  roomType: Maybe<RoomType>;
  territorialCoverage: Maybe<TerritorialCoverage>;
};

export type QuotationCategoryBenefit = {
  __typename?: 'QuotationCategoryBenefit';
  benefit: Maybe<ProductBenefit>;
  benefitType: Maybe<QuotationCategoryBenefitType>;
  patientShare: Maybe<BenefitTypePatientShare>;
  subBenefits: Maybe<Array<QuotationCategorySubBenefit>>;
  waitingPeriod: Maybe<BenefitTypeWaitingPeriod>;
};

export type QuotationCategoryBenefitType = {
  __typename?: 'QuotationCategoryBenefitType';
  code: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  type: ProductBenefitTypeOption;
};

export type QuotationCategoryOverview = {
  __typename?: 'QuotationCategoryOverview';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  product: Maybe<Product>;
};

export type QuotationCategoryPage = CarePage & {
  __typename?: 'QuotationCategoryPage';
  data: Array<QuotationCategoryOverview>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type QuotationCategoryResponse = Error | QuotationCategory;

export type QuotationCategorySubBenefit = {
  __typename?: 'QuotationCategorySubBenefit';
  benefit: Maybe<ProductSubBenefit>;
  patientShare: Maybe<BenefitTypePatientShare>;
  waitingPeriod: Maybe<BenefitTypeWaitingPeriod>;
};

export enum QuotationCensusUploadStatusType {
  CompletedSuccessfully = 'COMPLETED_SUCCESSFULLY',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NoUpload = 'NO_UPLOAD'
}

export type QuotationComment = {
  __typename?: 'QuotationComment';
  code: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdBy: User;
  dateCreated: Scalars['String']['output'];
};

export type QuotationCommentResponse = Error | QuotationComment;

export type QuotationDeleteResponse = Error | Success;

export type QuotationDocument = {
  __typename?: 'QuotationDocument';
  code: Scalars['String']['output'];
  createdBy: Maybe<User>;
  dateCreated: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  type: QuotationDocumentType;
};

export type QuotationDocumentDeleteResponse = Error | Success;

export type QuotationDocumentLocation = {
  __typename?: 'QuotationDocumentLocation';
  url: Scalars['String']['output'];
};

export type QuotationDocumentPage = CarePage & {
  __typename?: 'QuotationDocumentPage';
  data: Array<QuotationDocument>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type QuotationDocumentResponse = Error | QuotationDocument;

export enum QuotationDocumentType {
  BusinessLicense = 'BUSINESS_LICENSE',
  BusinessRegistrationDocument = 'BUSINESS_REGISTRATION_DOCUMENT',
  ClaimsUtilizationReport = 'CLAIMS_UTILIZATION_REPORT',
  EmployeeCensus = 'EMPLOYEE_CENSUS',
  ExpiringTermsOfBusiness = 'EXPIRING_TERMS_OF_BUSINESS',
  LossRatioReport = 'LOSS_RATIO_REPORT',
  Other = 'OTHER',
  QuotationAcceptanceConfirmation = 'QUOTATION_ACCEPTANCE_CONFIRMATION',
  QuotationApproval = 'QUOTATION_APPROVAL',
  RequestedTermsOfBusiness = 'REQUESTED_TERMS_OF_BUSINESS',
  SalaryVerification = 'SALARY_VERIFICATION',
  TaxRegistrationCertificate = 'TAX_REGISTRATION_CERTIFICATE',
  TermsOfBusiness = 'TERMS_OF_BUSINESS'
}

export enum QuotationGenderType {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type QuotationOverview = {
  __typename?: 'QuotationOverview';
  clientName: Maybe<Scalars['String']['output']>;
  clientType: ClientType;
  code: Scalars['String']['output'];
  createdBy: Maybe<User>;
  dateCreated: Scalars['String']['output'];
  grossPremium: Maybe<MonetaryAmount>;
  payerRef: Scalars['String']['output'];
  status: QuotationStatus;
};

export type QuotationOverviewFilter = {
  clientName: InputMaybe<Scalars['String']['input']>;
  createdByUserRef: InputMaybe<Scalars['String']['input']>;
  dateCreatedFrom: InputMaybe<Scalars['String']['input']>;
  dateCreatedTo: InputMaybe<Scalars['String']['input']>;
  grossPremiumFrom: InputMaybe<Scalars['Float']['input']>;
  grossPremiumTo: InputMaybe<Scalars['Float']['input']>;
  page: InputMaybe<CarePageable>;
  quotationStatuses: InputMaybe<Array<QuotationStatus>>;
  searchTerm: InputMaybe<Scalars['String']['input']>;
};

export type QuotationOverviewPage = CarePage & {
  __typename?: 'QuotationOverviewPage';
  data: Array<QuotationOverview>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type QuotationPremiumAmountBreakdown = {
  __typename?: 'QuotationPremiumAmountBreakdown';
  additionalLoading: Maybe<PremiumPercentageAndAmount>;
  administrativeLoad: Maybe<PremiumPercentageAndAmount>;
  discount: Maybe<PremiumPercentageAndAmount>;
  grossPremiumSubtotal: Maybe<MonetaryAmount>;
  grossPremiumTotal: Maybe<MonetaryAmount>;
  grossPremiumTotalExcludingVat: Maybe<MonetaryAmount>;
  installmentSurcharge: Maybe<PremiumPercentageAndAmount>;
  installmentSurchargePaymentTerm: Maybe<InstallmentSurchargePaymentTerm>;
  levies: Maybe<Array<LevyAmountAndPercentage>>;
  netPremium: MonetaryAmount;
  numberOfEntries: Scalars['Int']['output'];
  salesCommission: Maybe<PremiumPercentageAndAmount>;
  thirdPartyAdministratorFee: Maybe<PremiumPercentageAndAmount>;
  vat: Maybe<PremiumPercentageAndAmount>;
};

export type QuotationPremiumLoading = {
  __typename?: 'QuotationPremiumLoading';
  additionalLoadingPercentage: Maybe<Scalars['Float']['output']>;
  discountPercentage: Maybe<Scalars['Float']['output']>;
  installmentSurchargeAmount: Maybe<MonetaryAmount>;
  installmentSurchargePaymentTerm: Maybe<InstallmentSurchargePaymentTerm>;
  installmentSurchargePercentage: Maybe<Scalars['Float']['output']>;
};

export type QuotationPremiumOverview = {
  __typename?: 'QuotationPremiumOverview';
  categoryPremiums: Maybe<Array<CategoryPremiumOverview>>;
  premium: QuotationPremiumAmountBreakdown;
  premiumPerType: PremiumPerType;
};

export type QuotationPremiumResponse = Error | QuotationPremiumLoading;

export type QuotationResponse = Error | Quotation;

export enum QuotationStatus {
  Draft = 'DRAFT',
  Lost = 'LOST',
  PendingApproval = 'PENDING_APPROVAL',
  PolicyIssued = 'POLICY_ISSUED',
  QuoteIssued = 'QUOTE_ISSUED',
  Rejected = 'REJECTED'
}

export enum QuotationType {
  NewWithoutClaims = 'NEW_WITHOUT_CLAIMS',
  NewWithClaims = 'NEW_WITH_CLAIMS',
  Renewal = 'RENEWAL'
}

export type Region = {
  __typename?: 'Region';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RegionFilter = {
  countryCodes: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  regionCodes: InputMaybe<Array<Scalars['String']['input']>>;
  search: InputMaybe<Scalars['String']['input']>;
};

export type ReimbursementClaim = {
  __typename?: 'ReimbursementClaim';
  code: Scalars['String']['output'];
  faults: Array<ClaimFault>;
};

export type ReimbursementClaimResponse = Error | ReimbursementClaim;

export type ReimbursementDetailsInput = {
  countryCode: InputMaybe<Scalars['String']['input']>;
  invoicePaymentDate: InputMaybe<Scalars['String']['input']>;
  note: InputMaybe<Scalars['String']['input']>;
  providerName: InputMaybe<Scalars['String']['input']>;
  reimbursementType: InputMaybe<ReimbursementType>;
};

export type ReimbursementRule = {
  __typename?: 'ReimbursementRule';
  baseRateCorrectionPercentage: Maybe<Scalars['Float']['output']>;
  coverageRegion: CoverageRegionType;
  expenseType: Maybe<ExpenseType>;
  otherDescription: Maybe<Scalars['String']['output']>;
  type: ReimbursementRuleType;
};

export type ReimbursementRuleInput = {
  baseRateCorrectionPercentage: InputMaybe<Scalars['Float']['input']>;
  coverageRegion: CoverageRegionType;
  expenseType: InputMaybe<ExpenseType>;
  otherDescription: InputMaybe<Scalars['String']['input']>;
  type: ReimbursementRuleType;
};

export type ReimbursementRulePage = CarePage & {
  __typename?: 'ReimbursementRulePage';
  data: Array<ReimbursementRule>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum ReimbursementRuleType {
  EmergencyInpatient = 'EMERGENCY_INPATIENT',
  EmergencyOutpatient = 'EMERGENCY_OUTPATIENT',
  NonEmergencyInpatient = 'NON_EMERGENCY_INPATIENT',
  NonEmergencyOutpatient = 'NON_EMERGENCY_OUTPATIENT',
  Other = 'OTHER'
}

export type ReimbursementRules = {
  __typename?: 'ReimbursementRules';
  data: Array<ReimbursementRule>;
};

export type ReimbursementRulesInput = {
  rules: Array<ReimbursementRuleInput>;
};

export type ReimbursementRulesResponse = Error | ReimbursementRules;

export enum ReimbursementType {
  MedicationRefill = 'MEDICATION_REFILL',
  Other = 'OTHER',
  OutsideNetwork = 'OUTSIDE_NETWORK'
}

export type ReimbursementVisitInput = {
  endDate: InputMaybe<Scalars['String']['input']>;
  reference: InputMaybe<Scalars['String']['input']>;
  startDate: InputMaybe<Scalars['String']['input']>;
};

export type ReinstateEndorsementActionInput = {
  dependentBeneficiaries: InputMaybe<Array<BeneficiaryPolicyReinstatementInfo>>;
  reinstatementInfo: ReinstatementInfo;
};

export type ReinstatementInfo = {
  categoryId: Scalars['String']['input'];
  endDate: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

export type ReinsurerContract = {
  __typename?: 'ReinsurerContract';
  createdBy: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  dateModified: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Scalars['String']['output']>;
  payer: Scalars['String']['output'];
  reinsurer: Payer;
  status: ReinsurerContractStatus;
};

export type ReinsurerContractFilter = {
  page: InputMaybe<CarePageable>;
  reinsurerKeys: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<ReinsurerContractStatus>>;
};

export type ReinsurerContractPage = CarePage & {
  __typename?: 'ReinsurerContractPage';
  data: Maybe<Array<ReinsurerContract>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum ReinsurerContractStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type RejectProductResponse = Error | Success;

export type RejectQuotationResponse = Error | Success;

export type RejectionFields = {
  fault: InputMaybe<FaultRequest>;
  note: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
};

export type Remittance = {
  __typename?: 'Remittance';
  error: Maybe<RemittanceError>;
  executionDate: Maybe<Scalars['String']['output']>;
  externalReference: Maybe<Scalars['String']['output']>;
  /** @deprecated Use paymentReference instead */
  internalReference: Maybe<Scalars['String']['output']>;
  paymentReference: Maybe<Scalars['String']['output']>;
  status: RemittanceStatus;
};

export type RemittanceAggregate = {
  __typename?: 'RemittanceAggregate';
  appliedTaxAmount: Maybe<MonetaryAmount>;
  approvalDate: Scalars['String']['output'];
  calculatedExecutionDate: Scalars['String']['output'];
  counterParty: RemittanceParty;
  currencyConversionRequest: Maybe<CurrencyConversionRequest>;
  externalRef: Maybe<Scalars['String']['output']>;
  internalRef: Scalars['String']['output'];
  netAmount: Maybe<MonetaryAmount>;
  orderInternalRef: Scalars['String']['output'];
  orderingParty: RemittanceParty;
  paymentInternalRef: Maybe<Scalars['String']['output']>;
  paymentTerms: PaymentTerms;
  remittanceInformation: Maybe<Scalars['String']['output']>;
  requestedExecutionDate: Maybe<Scalars['String']['output']>;
  submitDate: Scalars['String']['output'];
  treatmentDate: Scalars['String']['output'];
  type: IsiroPaymentType;
};

export type RemittanceAggregateFilter = {
  counterPartyAccountNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  counterPartyOwnerRefs: InputMaybe<Array<Scalars['String']['input']>>;
  externalRefs: InputMaybe<Array<Scalars['String']['input']>>;
  orderingPartyAccountNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  orderingPartyOwnerRefs: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  paymentInternalRefs: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RemittanceAggregateFilterOptions = {
  paymentTypes: InputMaybe<Array<IsiroPaymentType>>;
};

export type RemittanceError = {
  __typename?: 'RemittanceError';
  detail: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
};

export type RemittanceParty = {
  __typename?: 'RemittanceParty';
  accountInternalRef: Maybe<Scalars['String']['output']>;
  accountNumber: Maybe<Scalars['String']['output']>;
  ownerRef: Maybe<Scalars['String']['output']>;
  ownerType: Maybe<OwnerType>;
};

export type RemittancePartyInput = {
  accountInternalRef: InputMaybe<Scalars['String']['input']>;
  accountNumber: InputMaybe<Scalars['String']['input']>;
  ownerRef: InputMaybe<Scalars['String']['input']>;
  ownerType: InputMaybe<OwnerType>;
};

export type RemittanceRequestAggregate = {
  __typename?: 'RemittanceRequestAggregate';
  approvalDate: Scalars['String']['output'];
  calculatedExecutionDate: Scalars['String']['output'];
  counterParty: RemittanceParty;
  createdBy: Maybe<Scalars['String']['output']>;
  currencyConversionRequest: Maybe<CurrencyConversionRequest>;
  externalRef: Scalars['String']['output'];
  firstCreated: Scalars['String']['output'];
  internalRef: Scalars['String']['output'];
  monetaryAmount: MonetaryAmount;
  orderInternalRef: Maybe<Scalars['String']['output']>;
  orderingParty: RemittanceParty;
  paymentInternalRef: Maybe<Scalars['String']['output']>;
  paymentTerms: PaymentTerms;
  remittanceInformation: Scalars['String']['output'];
  requestedExecutionDate: Maybe<Scalars['String']['output']>;
  submitDate: Scalars['String']['output'];
  treatmentDate: Scalars['String']['output'];
  type: IsiroPaymentType;
};

export type RemittanceRequestAggregatesPage = CarePage & {
  __typename?: 'RemittanceRequestAggregatesPage';
  data: Maybe<Array<Maybe<RemittanceRequestAggregate>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type RemittanceRequestInput = {
  approvalDate: Scalars['String']['input'];
  counterParty: RemittancePartyInput;
  externalRef: Scalars['String']['input'];
  forexInternalRef: InputMaybe<Scalars['String']['input']>;
  isPrivatePracticeSpeciality: InputMaybe<Scalars['Boolean']['input']>;
  monetaryAmount: MonetaryAmountInput;
  orderingParty: RemittancePartyInput;
  remittanceInformation: Scalars['String']['input'];
  requestedExecutionDate: InputMaybe<Scalars['String']['input']>;
  submitDate: Scalars['String']['input'];
  treatmentDate: Scalars['String']['input'];
  type: IsiroPaymentType;
};

export type RemittanceRequestResponse = Error | Success;

export enum RemittanceStatus {
  Failed = 'FAILED',
  Ignored = 'IGNORED',
  Initialised = 'INITIALISED',
  Rejected = 'REJECTED',
  Retried = 'RETRIED',
  Success = 'SUCCESS'
}

export type RemoveInvoiceItemInput = {
  billRef: Scalars['String']['input'];
  invoiceRef: Scalars['String']['input'];
  itemRef: Scalars['String']['input'];
};

export type RemoveMedicalTagsResponse = Error | Success;

export type RemovePriceAgreementItemsResponse = Error | Success;

export type RemovePriceListItemsResponse = Error | Success;

export type RenewedPolicy = {
  __typename?: 'RenewedPolicy';
  failed: Scalars['Int']['output'];
  success: Scalars['Int']['output'];
};

export type RenewedPolicyResponse = Error | RenewedPolicy;

export type ReopenClaimInput = {
  reason: InputMaybe<Scalars['String']['input']>;
};

export type ReopenClaimResponse = Error | Success;

export type ReopenPreAuthorization = {
  reason: InputMaybe<Scalars['String']['input']>;
};

export type ReportInput = {
  beneficiaryPolicyStatuses: InputMaybe<Array<BeneficiaryPolicyStatus>>;
  compressed: Scalars['Boolean']['input'];
  earnedPremiumTo: InputMaybe<Scalars['Float']['input']>;
  endDate: Scalars['String']['input'];
  intermediaryKeys: Array<Scalars['String']['input']>;
  payerKeys: Array<Scalars['String']['input']>;
  planIds: Array<Scalars['String']['input']>;
  policyIds: Array<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

export type Reservation = {
  __typename?: 'Reservation';
  amount: MonetaryAmount;
  invoiceNumber: Scalars['String']['output'];
};

export enum ResolutionEnum {
  Approve = 'APPROVE',
  PartiallyApprove = 'PARTIALLY_APPROVE',
  Reject = 'REJECT',
  Review = 'REVIEW'
}

export type ResourceCreated = {
  __typename?: 'ResourceCreated';
  reference: Scalars['String']['output'];
};

export type ResourceUpdated = {
  __typename?: 'ResourceUpdated';
  reference: Scalars['String']['output'];
};

export type Resubmission = {
  __typename?: 'Resubmission';
  description: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  type: Maybe<ResubmissionType>;
};

export enum ResubmissionType {
  Complaint = 'COMPLAINT',
  Correction = 'CORRECTION',
  Reconciliation = 'RECONCILIATION'
}

export type ResubmitPreAuthorization = {
  benefitRef: InputMaybe<Scalars['String']['input']>;
  countryCode: InputMaybe<Scalars['String']['input']>;
  diagnoses: InputMaybe<Array<CreatePreAuthDiagnosis>>;
  externalCode: InputMaybe<CreatePreAuthorizationExternalCode>;
  externalMemberReference: InputMaybe<Scalars['String']['input']>;
  hasDocs: InputMaybe<Scalars['Boolean']['input']>;
  initialProvider: InputMaybe<Scalars['String']['input']>;
  items: InputMaybe<Array<ResubmitPreAuthorizationItem>>;
  medicalType: InputMaybe<PreAuthorizationMedicalType>;
  memberRef: Scalars['String']['input'];
  orderedDate: InputMaybe<Scalars['String']['input']>;
  patientRef: Scalars['String']['input'];
  patientSpecialTier: InputMaybe<SpecialTier>;
  payerRef: Scalars['String']['input'];
  prescriptionRef: InputMaybe<Scalars['String']['input']>;
  providerRef: InputMaybe<Scalars['String']['input']>;
  providerType: InputMaybe<ProviderType>;
  resubmission: PreAuthorizationResubmissionInput;
  submissionSource: InputMaybe<PreAuthorizationSubmissionSource>;
  submittedDate: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<PreAuthorizationType>;
  visitRef: InputMaybe<Scalars['String']['input']>;
  visitType: InputMaybe<VisitType>;
};

export type ResubmitPreAuthorizationItem = {
  benefitRef: InputMaybe<Scalars['String']['input']>;
  clinicianRef: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  collectedPatientShare: InputMaybe<MonetaryAmountInput>;
  duration: InputMaybe<Scalars['Float']['input']>;
  externalCode: InputMaybe<Scalars['String']['input']>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  itemNotes: InputMaybe<Array<CreatePreAuthorizationItemNote>>;
  location: InputMaybe<Scalars['String']['input']>;
  medicalProduct: InputMaybe<CreatePreAuthMedicalProduct>;
  prescriptionRef: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  reference: InputMaybe<Scalars['String']['input']>;
  requestedAmount: InputMaybe<MonetaryAmountInput>;
  startDate: Scalars['String']['input'];
  unit: InputMaybe<Scalars['Float']['input']>;
  unitPrice: MonetaryAmountInput;
};

export type ReverseClaimInput = {
  note: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type RevertProductToDraftResponse = Error | Success;

export type RevertQuotationToDraftResponse = Error | Success;

export type RiskValue = {
  __typename?: 'RiskValue';
  reason: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['Boolean']['output']>;
};

export type RiskValueInput = {
  reason: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoomType = {
  __typename?: 'RoomType';
  baseRateCorrectionPercentage: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  defaultOption: Scalars['Boolean']['output'];
  type: RoomTypeOption;
};

export type RoomTypeDeleteResponse = Error | Success;

export enum RoomTypeOption {
  Private = 'PRIVATE',
  SemiPrivate = 'SEMI_PRIVATE',
  Shared = 'SHARED',
  Suite = 'SUITE'
}

export type RoomTypePage = CarePage & {
  __typename?: 'RoomTypePage';
  data: Array<RoomType>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type RoomTypeResponse = Error | RoomType;

export type RuleEngineRule = {
  __typename?: 'RuleEngineRule';
  code: Scalars['String']['output'];
  denialCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  externalDenialCode: Maybe<Scalars['String']['output']>;
  externalRule: Maybe<Scalars['Boolean']['output']>;
  payerKey: Scalars['String']['output'];
  resolution: ResolutionEnum;
  ruleType: Maybe<RuleTypeEnum>;
  scope: Scalars['String']['output'];
  severity: SeverityEnum;
};

export type RuleEngineRuleBulkInput = {
  enabled: Scalars['Boolean']['input'];
};

export type RuleEngineRuleFilter = {
  externalRule: InputMaybe<Scalars['Boolean']['input']>;
  page: InputMaybe<CarePageable>;
  payerKey: Scalars['String']['input'];
  search: InputMaybe<Scalars['String']['input']>;
};

export type RuleEngineRuleInput = {
  code: Scalars['String']['input'];
  description: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  resolution: ResolutionEnum;
};

export type RuleEngineRulePage = CarePage & {
  __typename?: 'RuleEngineRulePage';
  data: Maybe<Array<Maybe<RuleEngineRule>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum RuleScope {
  Benefit = 'BENEFIT',
  BenefitType = 'BENEFIT_TYPE',
  MedicalProduct = 'MEDICAL_PRODUCT',
  MedicalTag = 'MEDICAL_TAG',
  Network = 'NETWORK',
  Plan = 'PLAN',
  Provider = 'PROVIDER',
  ProviderAffiliation = 'PROVIDER_AFFILIATION',
  ProviderType = 'PROVIDER_TYPE'
}

export enum RuleType {
  CopayItem = 'COPAY_ITEM',
  CopayVisit = 'COPAY_VISIT',
  PreauthItem = 'PREAUTH_ITEM',
  PreauthVisit = 'PREAUTH_VISIT'
}

export enum RuleTypeEnum {
  Confidence = 'CONFIDENCE',
  Other = 'OTHER',
  Severity = 'SEVERITY'
}

export type ScheduledNetworkChangeInput = {
  defaultNetwork: Scalars['String']['input'];
  empaneledDate: Scalars['String']['input'];
  expirationDate: InputMaybe<Scalars['String']['input']>;
};

export enum SchemeType {
  AllianceRenewal = 'ALLIANCE_RENEWAL',
  FreshScheme = 'FRESH_SCHEME',
  NonAllianceRenewal = 'NON_ALLIANCE_RENEWAL'
}

export type SearchMembersFilter = {
  email: InputMaybe<Scalars['String']['input']>;
  idDocumentNumber: InputMaybe<Scalars['String']['input']>;
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
};

export type SendExternalCommunicationResponse = Error | Success;

export type SetQuotationPremiumLoadingInput = {
  additionalLoadingPercentage: InputMaybe<Scalars['Float']['input']>;
  discountPercentage: InputMaybe<Scalars['Float']['input']>;
  installmentSurchargePaymentTerm: InputMaybe<InstallmentSurchargePaymentTerm>;
};

export enum SeverityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type Sortable = {
  by: InputMaybe<Scalars['String']['input']>;
  direction: InputMaybe<Scalars['String']['input']>;
};

export enum SpecialTier {
  Vip = 'VIP'
}

export type SponsorParty = {
  __typename?: 'SponsorParty';
  email: Scalars['String']['output'];
  telephoneNumber: Scalars['String']['output'];
};

export type SponsorPartyInput = {
  email: Scalars['String']['input'];
  telephoneNumber: Scalars['String']['input'];
};

export type StandardNetwork = ProviderNetwork & {
  __typename?: 'StandardNetwork';
  code: Scalars['String']['output'];
  defaultNetworkCategory: Maybe<DefaultNetworkCategory>;
  description: Scalars['String']['output'];
  empaneledProviders: Maybe<EmpaneledProviderPage>;
  name: Scalars['String']['output'];
  parentNetwork: Maybe<Scalars['String']['output']>;
  payer: Payer;
  rank: Maybe<Scalars['Int']['output']>;
  type: ProviderNetworkType;
};


export type StandardNetworkEmpaneledProvidersArgs = {
  filter: InputMaybe<EmpaneledProviderFilter>;
};

export type StandardProviderNetworkInput = {
  defaultNetworkCategory: DefaultNetworkCategory;
  description: Scalars['String']['input'];
  hierarchy: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  payer: Scalars['String']['input'];
};

export type StandardProviderNetworkResponse = Error | StandardNetwork;

export type StaticVisit = {
  __typename?: 'StaticVisit';
  code: Scalars['String']['output'];
  refId: Scalars['String']['output'];
  status: VisitStatus;
};

export type StaticVisitResponse = Error | StaticVisit;

export type Strength = {
  __typename?: 'Strength';
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type StrengthsFilter = {
  name: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
};

export type StrengthsPage = CarePage & {
  __typename?: 'StrengthsPage';
  data: Maybe<Array<Strength>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type SubmitPreAuthorizationInput = {
  patientSpecialTier: InputMaybe<SpecialTier>;
  providerType: InputMaybe<ProviderType>;
};

export type SubmitPreAuthorizationsResponse = Error | Success;

export type SubmitProductForReviewResponse = Error | Success;

export type SubmitQuotationForReviewResponse = Error | Success;

export type Success = {
  __typename?: 'Success';
  message: Scalars['String']['output'];
  params: Maybe<Array<Maybe<SuccessParam>>>;
};

export type SuccessParam = {
  __typename?: 'SuccessParam';
  param: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SuspendEmpaneledProviderInput = {
  suspensionDate: Scalars['String']['input'];
  suspensionReason: Scalars['String']['input'];
};

export type Tenant = {
  __typename?: 'Tenant';
  description: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  properties: Maybe<TenantPropertiesPage>;
  status: TenantStatus;
  tenantKey: Scalars['String']['output'];
};


export type TenantPropertiesArgs = {
  filter: InputMaybe<TenantPropertyFilter>;
};

export type TenantPropertiesPage = CarePage & {
  __typename?: 'TenantPropertiesPage';
  data: Maybe<Array<TenantProperty>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type TenantProperty = {
  __typename?: 'TenantProperty';
  country: Maybe<Country>;
  propertyKey: Scalars['String']['output'];
  propertyValue: Maybe<Scalars['String']['output']>;
};

export type TenantPropertyFilter = {
  countryCode: InputMaybe<Scalars['String']['input']>;
  page: InputMaybe<CarePageable>;
  propertyKey: InputMaybe<Scalars['String']['input']>;
};

export enum TenantStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  UnderRegistration = 'UNDER_REGISTRATION'
}

export enum Term {
  Day = 'DAY',
  Month = 'MONTH',
  Night = 'NIGHT',
  Visit = 'VISIT',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type TermBalance = {
  __typename?: 'TermBalance';
  baseTermAmount: Maybe<MonetaryAmount>;
  baseTermCount: Maybe<Scalars['Int']['output']>;
  maxTermAmount: Maybe<MonetaryAmount>;
  maxTermCount: Maybe<Scalars['Int']['output']>;
};

export enum TerminationReason {
  AgeLimit = 'AGE_LIMIT',
  BreachOfContract = 'BREACH_OF_CONTRACT',
  DataCorrection = 'DATA_CORRECTION',
  ExistingPolicy = 'EXISTING_POLICY',
  FamilySizeChange = 'FAMILY_SIZE_CHANGE',
  LeftEmployment = 'LEFT_EMPLOYMENT',
  Other = 'OTHER',
  PayerRequest = 'PAYER_REQUEST',
  PremiumDefaulter = 'PREMIUM_DEFAULTER'
}

export type TerritorialCoverage = {
  __typename?: 'TerritorialCoverage';
  baseRateCorrectionPercentage: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  defaultOption: Scalars['Boolean']['output'];
  excludedCountries: Array<Country>;
  expenseType: ExpenseType;
  includedRegions: Array<GeolocationRegion>;
  name: Scalars['String']['output'];
};

export type TerritorialCoverageDeleteResponse = Error | Success;

export type TerritorialCoveragePage = CarePage & {
  __typename?: 'TerritorialCoveragePage';
  data: Array<TerritorialCoverage>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type TerritorialCoverageResponse = Error | TerritorialCoverage;

export type Territory = {
  __typename?: 'Territory';
  countries: Maybe<Array<Region>>;
  regions: Maybe<Array<Region>>;
  states: Maybe<Array<Region>>;
};

export type TerritoryInput = {
  countries: InputMaybe<Array<Scalars['String']['input']>>;
  regions: InputMaybe<Array<Scalars['String']['input']>>;
  subdivisions: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TierToRoleMapping = {
  __typename?: 'TierToRoleMapping';
  contextName: Scalars['String']['output'];
  contextReference: Scalars['String']['output'];
  description: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
  tier: Scalars['Int']['output'];
};

export type TierToRoleMappingFilter = {
  contexts: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  tiers: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TierToRoleMappingInput = {
  contextName: Scalars['String']['input'];
  contextReference: Scalars['String']['input'];
  description: Scalars['String']['input'];
  roles: InputMaybe<Array<Scalars['String']['input']>>;
  tier: Scalars['Int']['input'];
};

export type TierToRoleMappingPage = CarePage & {
  __typename?: 'TierToRoleMappingPage';
  data: Maybe<Array<Maybe<TierToRoleMapping>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export type TierToRoleMappingResponse = Error | Success;

export enum Title {
  Dr = 'DR',
  Madam = 'MADAM',
  Master = 'MASTER',
  Miss = 'MISS',
  Mr = 'MR',
  Mrs = 'MRS',
  Ms = 'MS',
  Prof = 'PROF'
}

export type TogglePremiumInstalmentIsPaidInput = {
  paidInstalments: Array<Scalars['String']['input']>;
  unpaidInstalments: Array<Scalars['String']['input']>;
};

export type TogglePremiumInstalmentIsPaidResponse = Error | Success;

export type UpdateAnnualMedicalLimitInput = {
  annualLimit: InputMaybe<MonetaryAmountInput>;
  baseRateCorrectionPercentage: Scalars['Float']['input'];
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  type: AnnualMedicalLimitType;
};

export type UpdateBedCapacityInput = {
  capacity: Scalars['Int']['input'];
  type: BedType;
};

export type UpdateBillInvoiceInput = {
  billRef: Scalars['String']['input'];
  externalReference: Scalars['String']['input'];
  invoiceRef: Scalars['String']['input'];
  taxNumber: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBillInvoiceResponse = Error | Success;

export type UpdateBillNoteInput = {
  billRef: Scalars['String']['input'];
  content: Scalars['String']['input'];
  noteRef: Scalars['String']['input'];
};

export type UpdateBillNoteResponse = Error | Success;

export type UpdateCategoryFamilyCompositionResponse = Error | FamilyComposition;

export type UpdateCategoryInput = {
  coverage: CategoryCoverageInput;
  description: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  number: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClaimItemInput = {
  baseItemInput: BaseItemInput;
};

export type UpdateDiagnosisInput = {
  extraInfos: InputMaybe<Array<InputMaybe<ClaimDiagnosisExtraInfoInput>>>;
  product: InputMaybe<ClaimMedicalProductInput>;
  type: InputMaybe<DiagnosisType>;
};

export type UpdateDiagnosisResponse = Error | Success;

export type UpdateEmpaneledProviderInput = {
  claimsAccount: Scalars['String']['input'];
  empaneledDate: Scalars['String']['input'];
  expirationDate: InputMaybe<Scalars['String']['input']>;
  loansAccount: InputMaybe<Scalars['String']['input']>;
  terms: InputMaybe<EmpaneledProviderTermsInput>;
};

export type UpdateEmployeeLicenseInput = {
  licenseNumber: Scalars['String']['input'];
  validFrom: Scalars['String']['input'];
  validTo: Scalars['String']['input'];
};

export type UpdateExternalCodeResponse = Error | MedicalCode;

export type UpdateIntermediaryInput = {
  email: Scalars['String']['input'];
  firstName: InputMaybe<Scalars['String']['input']>;
  identification: Scalars['String']['input'];
  identificationType: IntermediaryIdentificationType;
  lastName: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  taxRegistrationNumber: Scalars['String']['input'];
};

export type UpdateItemResponse = Error | Success;

export type UpdatePayerAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  poBox: InputMaybe<Scalars['String']['input']>;
  state: InputMaybe<Scalars['String']['input']>;
  zipCode: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePayerBankAccountInput = {
  accountHolderName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  bankBic: InputMaybe<Scalars['String']['input']>;
  bankBranchCode: InputMaybe<Scalars['String']['input']>;
  bankBranchName: InputMaybe<Scalars['String']['input']>;
  bankCode: InputMaybe<Scalars['String']['input']>;
  bankName: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  responsibleForPayout: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePayerContactInput = {
  designation: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePayerInput = {
  email: InputMaybe<Scalars['String']['input']>;
  licenseNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parent: Scalars['String']['input'];
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  taxRegistrationNumber: Scalars['String']['input'];
};

export type UpdatePaymentContractInput = {
  paymentTerms: PaymentTermsInput;
};

export type UpdatePecCoverageInput = {
  baseRateCorrectionPercentage: Scalars['Float']['input'];
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  maximumAmlPercentage: Scalars['Float']['input'];
};

export type UpdatePlanFamilyCompositionResponse = Error | FamilyComposition;

export type UpdatePlatformUserResponse = Error | User;

export type UpdatePolicyInput = {
  ageCalculationMethod: AgeCalculationMethod;
};

export type UpdatePreAuthorizationOverride = {
  items: InputMaybe<Array<PreAuthorizationItemOverrideInput>>;
  overrideInternalReference: Scalars['String']['input'];
  preAuthorizationReference: Scalars['String']['input'];
};

export type UpdatePreAuthorizationOverrideResponse = Error | ResourceUpdated;

export type UpdatePriceAgreementInput = {
  description: InputMaybe<Scalars['String']['input']>;
  validFrom: InputMaybe<Scalars['String']['input']>;
  validTo: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductBenefitInput = {
  baseLimitAmount: InputMaybe<MonetaryAmountInput>;
  baseLimitCount: InputMaybe<Scalars['Int']['input']>;
  baseLimitDescription: InputMaybe<Scalars['String']['input']>;
  baseLimitTerm: InputMaybe<ProductCoverageTerm>;
  baseRateCorrectionAmount: InputMaybe<MonetaryAmountInput>;
  baseRateCorrectionPercentage: InputMaybe<Scalars['Float']['input']>;
  baseRateCorrectionType: BaseRateCorrectionType;
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  isFamilyShared: Scalars['Boolean']['input'];
  limitType: ProductBenefitLimitType;
  maxLimitAmount: InputMaybe<MonetaryAmountInput>;
  maxLimitCount: InputMaybe<Scalars['Int']['input']>;
  maxLimitDescription: InputMaybe<Scalars['String']['input']>;
  maxLimitTerm: InputMaybe<ProductCoverageTerm>;
  medicalTagInclusionRefs: InputMaybe<Array<Scalars['String']['input']>>;
  preAuthorizationAmount: InputMaybe<MonetaryAmountInput>;
  preAuthorizationType: BenefitPreAuthorizationType;
  providerNetworkExternalRef: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductBenefitTypeInput = {
  description: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  patientShares: InputMaybe<Array<BenefitTypePatientShareInput>>;
  type: ProductBenefitTypeOption;
  waitingPeriods: InputMaybe<Array<BenefitTypeWaitingPeriodInput>>;
};

export type UpdateProductInput = {
  administrativeLoadPercentage: InputMaybe<Scalars['Float']['input']>;
  countryRef: InputMaybe<Scalars['String']['input']>;
  endDate: InputMaybe<Scalars['String']['input']>;
  externalRef: InputMaybe<Scalars['String']['input']>;
  groupSizeRefs: InputMaybe<Array<Scalars['String']['input']>>;
  industryRefs: InputMaybe<Array<Scalars['String']['input']>>;
  medicalTagExclusionRefs: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  regionRefs: InputMaybe<Array<Scalars['String']['input']>>;
  salesCommissionPercentage: InputMaybe<Scalars['Float']['input']>;
  startDate: InputMaybe<Scalars['String']['input']>;
  thirdPartyAdministratorFeePercentage: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateProductProviderNetworkInput = {
  baseRateCorrectionPercentage: Scalars['Float']['input'];
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  externalRef: Scalars['String']['input'];
};

export type UpdateProductSubBenefitInput = {
  baseLimitAmount: InputMaybe<MonetaryAmountInput>;
  baseLimitCount: InputMaybe<Scalars['Int']['input']>;
  baseLimitDescription: InputMaybe<Scalars['String']['input']>;
  baseLimitTerm: InputMaybe<ProductCoverageTerm>;
  baseRateCorrectionAmount: InputMaybe<MonetaryAmountInput>;
  baseRateCorrectionPercentage: InputMaybe<Scalars['Float']['input']>;
  baseRateCorrectionType: BaseRateCorrectionType;
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  isFamilyShared: Scalars['Boolean']['input'];
  limitType: ProductBenefitLimitType;
  maxLimitAmount: InputMaybe<MonetaryAmountInput>;
  maxLimitCount: InputMaybe<Scalars['Int']['input']>;
  maxLimitDescription: InputMaybe<Scalars['String']['input']>;
  maxLimitTerm: InputMaybe<ProductCoverageTerm>;
  medicalTagInclusionRefs: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  preAuthorizationAmount: InputMaybe<MonetaryAmountInput>;
  preAuthorizationType: BenefitPreAuthorizationType;
  providerNetworkExternalRef: InputMaybe<Scalars['String']['input']>;
  type: ProductBenefitTypeOption;
};

export type UpdateProviderEmployeeInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  speciality: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProviderInput = {
  /** @deprecated Use: 'affiliationCode' instead */
  affiliation: InputMaybe<Scalars['String']['input']>;
  affiliationCode: InputMaybe<Scalars['String']['input']>;
  businessType: InputMaybe<ProviderBusinessType>;
  city: InputMaybe<Scalars['String']['input']>;
  classification: InputMaybe<Scalars['String']['input']>;
  country: InputMaybe<Scalars['String']['input']>;
  emailAddress: InputMaybe<Scalars['String']['input']>;
  geolocationLevelTwoCode: InputMaybe<Scalars['String']['input']>;
  landmark: InputMaybe<Scalars['String']['input']>;
  latitude: InputMaybe<Scalars['Float']['input']>;
  longitude: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  operatingHours: InputMaybe<Array<InputMaybe<OperatingTimeInput>>>;
  ownershipType: InputMaybe<Ownership>;
  parentProviderCode: Scalars['String']['input'];
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  physicalAddress: InputMaybe<Scalars['String']['input']>;
  providerType: InputMaybe<ProviderType>;
  registrationCode: InputMaybe<Scalars['String']['input']>;
  services: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  specialities: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxRegistrationNumber: InputMaybe<Scalars['String']['input']>;
  website: InputMaybe<Scalars['String']['input']>;
  zipCode: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuotationCategoryBenefit = {
  benefitCode: InputMaybe<Scalars['String']['input']>;
  patientShareCode: InputMaybe<Scalars['String']['input']>;
  subBenefits: InputMaybe<Array<UpdateQuotationCategorySubBenefit>>;
  waitingPeriodCode: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuotationCategoryInput = {
  annualMedicalLimitCode: InputMaybe<Scalars['String']['input']>;
  benefits: InputMaybe<Array<UpdateQuotationCategoryBenefit>>;
  pecCoverageCode: InputMaybe<Scalars['String']['input']>;
  productCode: InputMaybe<Scalars['String']['input']>;
  providerNetworkCode: InputMaybe<Scalars['String']['input']>;
  roomTypeCode: InputMaybe<Scalars['String']['input']>;
  territorialCoverageCode: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuotationCategorySubBenefit = {
  benefitCode: InputMaybe<Scalars['String']['input']>;
  patientShareCode: InputMaybe<Scalars['String']['input']>;
  waitingPeriodCode: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuotationInput = {
  clientDetails: InputMaybe<ClientDetails>;
  policyExpiryDate: InputMaybe<Scalars['String']['input']>;
  policyStartDate: InputMaybe<Scalars['String']['input']>;
  previousPolicyRef: InputMaybe<Scalars['String']['input']>;
  quotationExpiryDate: InputMaybe<Scalars['String']['input']>;
  quotationType: InputMaybe<QuotationType>;
};

export type UpdateRoomTypeInput = {
  baseRateCorrectionPercentage: Scalars['Float']['input'];
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  type: RoomTypeOption;
};

export type UpdateRuleEngineRulesResponse = Error | Success;

export type UpdateTerritorialCoverageInput = {
  baseRateCorrectionPercentage: Scalars['Float']['input'];
  defaultOption: InputMaybe<Scalars['Boolean']['input']>;
  excludedCountryRefs: InputMaybe<Array<Scalars['String']['input']>>;
  expenseType: ExpenseType;
  includedRegionRefs: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UploadBeneficiaryDocument = {
  __typename?: 'UploadBeneficiaryDocument';
  documentKey: Scalars['String']['output'];
};

export type UploadBeneficiaryDocumentResponse = Error | UploadBeneficiaryDocument;

export type UploadClaimDocumentResponse = Error | Success;

export type UploadEmpaneledProviderContractResponse = EmpaneledProviderContract | Error;

export type UploadEmployeesResponse = Error | UploadFileStatus;

export type UploadEndorsementDocument = {
  __typename?: 'UploadEndorsementDocument';
  documentKey: Scalars['String']['output'];
};

export type UploadEndorsementDocumentResponse = Error | UploadEndorsementDocument;

export type UploadFileStatus = {
  __typename?: 'UploadFileStatus';
  errorFileLink: Maybe<Scalars['String']['output']>;
  errorFileName: Maybe<Scalars['String']['output']>;
  fileStatusCode: Scalars['String']['output'];
  initialFileLink: Maybe<Scalars['String']['output']>;
  initialFileName: Maybe<Scalars['String']['output']>;
  status: FileStatus;
};

export type UploadMedicalCodesResponse = Error | MedicalProductFileStatus;

export type UploadPreAuthorizationDocumentResponse = Error | Success;

export type UploadProviderLicenseDocumentResponse = Error | ProviderLicenseDocument;

export type User = {
  __typename?: 'User';
  email: Maybe<Scalars['String']['output']>;
  externalKey: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  intermediaryUsers: Array<IntermediaryUser>;
  lastName: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  payerUsers: Array<PayerUser>;
  providerUsers: Array<ProviderUser>;
  roles: Array<PlatformUserRole>;
  status: UserStatus;
  username: Maybe<Scalars['String']['output']>;
};

export type UserFilter = {
  keys: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  userNames: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum UserStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  Locked = 'LOCKED',
  Suspended = 'SUSPENDED'
}

export type Utilisation = {
  __typename?: 'Utilisation';
  amount: Maybe<MonetaryAmount>;
  beneficiaryPolicy: Maybe<BeneficiaryPolicy>;
  benefitRef: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['String']['output']>;
  isFamilyUtilization: Maybe<Scalars['Boolean']['output']>;
  provider: Maybe<Provider>;
  reference: Maybe<Scalars['String']['output']>;
  sourceReference: Maybe<Scalars['String']['output']>;
  type: Maybe<UtilisationType>;
};

export enum UtilisationType {
  Claim = 'CLAIM',
  Knockoff = 'KNOCKOFF',
  PreAuthorization = 'PRE_AUTHORIZATION',
  Reservation = 'RESERVATION',
  TopUp = 'TOP_UP',
  Visit = 'VISIT'
}

export type Visit = {
  __typename?: 'Visit';
  balanceOverview: Maybe<BalanceOverview>;
  benefit: Maybe<Benefit>;
  bill: Maybe<Bill>;
  claimCode: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  date: Scalars['String']['output'];
  destinationProvider: Maybe<Provider>;
  destinationProviderRef: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['String']['output']>;
  endType: Maybe<VisitEndType>;
  externalCode: Maybe<VisitExternalCode>;
  identificationMethod: IdentificationMethod;
  originVisit: Maybe<Scalars['String']['output']>;
  patient: Maybe<BeneficiaryPolicy>;
  payer: Maybe<Payer>;
  planRef: Scalars['String']['output'];
  provider: Maybe<Provider>;
  reservations: Maybe<Array<Reservation>>;
  sourceProvider: Maybe<Provider>;
  sourceProviderRef: Maybe<Scalars['String']['output']>;
  startType: Maybe<VisitStartType>;
  status: VisitStatus;
  submittedDate: Maybe<Scalars['String']['output']>;
  type: Maybe<VisitType>;
};

export type VisitCreated = {
  __typename?: 'VisitCreated';
  code: Scalars['String']['output'];
  externalCode: Maybe<VisitExternalCode>;
  status: VisitStatus;
};

export type VisitCreatedResponse = Error | VisitCreated;

export enum VisitEndType {
  AdministrativeDischarge = 'ADMINISTRATIVE_DISCHARGE',
  Deceased = 'DECEASED',
  DischargedAbsentWithoutLeave = 'DISCHARGED_ABSENT_WITHOUT_LEAVE',
  DischargedAgainstAdvice = 'DISCHARGED_AGAINST_ADVICE',
  DischargedWithApproval = 'DISCHARGED_WITH_APPROVAL',
  DischargeTransferToAcuteCare = 'DISCHARGE_TRANSFER_TO_ACUTE_CARE',
  DischargeTransferToNonAcuteCare = 'DISCHARGE_TRANSFER_TO_NON_ACUTE_CARE',
  None = 'NONE',
  NotDischarged = 'NOT_DISCHARGED'
}

export type VisitExternalCode = {
  __typename?: 'VisitExternalCode';
  reference: Maybe<Scalars['String']['output']>;
  source: Maybe<Scalars['String']['output']>;
};

export type VisitExternalCodeInput = {
  reference: InputMaybe<Scalars['String']['input']>;
  source: InputMaybe<Scalars['String']['input']>;
};

export type VisitFilter = {
  claimCodes: InputMaybe<Array<Scalars['String']['input']>>;
  createdDateSince: InputMaybe<Scalars['String']['input']>;
  createdDateUntil: InputMaybe<Scalars['String']['input']>;
  externalCodeSources: InputMaybe<Array<Scalars['String']['input']>>;
  externalCodes: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceExternalReferences: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  page: InputMaybe<CarePageable>;
  patientRefs: InputMaybe<Array<Scalars['String']['input']>>;
  payerRefs: InputMaybe<Array<Scalars['String']['input']>>;
  planRefs: InputMaybe<Array<Scalars['String']['input']>>;
  preAuthorizationReferences: InputMaybe<Array<Scalars['String']['input']>>;
  providerRefs: InputMaybe<Array<Scalars['String']['input']>>;
  since: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<Scalars['String']['input']>>;
  submittedDateSince: InputMaybe<Scalars['String']['input']>;
  submittedDateUntil: InputMaybe<Scalars['String']['input']>;
  until: InputMaybe<Scalars['String']['input']>;
  visitCodes: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VisitPage = CarePage & {
  __typename?: 'VisitPage';
  data: Maybe<Array<Maybe<Visit>>>;
  hasNext: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
};

export enum VisitStartType {
  ContinuingEncounter = 'CONTINUING_ENCOUNTER',
  DeadOnArrival = 'DEAD_ON_ARRIVAL',
  Elective = 'ELECTIVE',
  Emergency = 'EMERGENCY',
  LiveBirth = 'LIVE_BIRTH',
  None = 'NONE',
  StillBirth = 'STILL_BIRTH',
  Transfer = 'TRANSFER'
}

export enum VisitStatus {
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Stale = 'STALE'
}

export enum VisitType {
  AmbulanceAirOrWater = 'AMBULANCE_AIR_OR_WATER',
  AmbulanceLand = 'AMBULANCE_LAND',
  AssistedLivingFacility = 'ASSISTED_LIVING_FACILITY',
  DaycaseBedPlusEmergencyRoom = 'DAYCASE_BED_PLUS_EMERGENCY_ROOM',
  DaycaseBedPlusNoEmergencyRoom = 'DAYCASE_BED_PLUS_NO_EMERGENCY_ROOM',
  Home = 'HOME',
  InpatientBedPlusEmergencyRoom = 'INPATIENT_BED_PLUS_EMERGENCY_ROOM',
  InpatientBedPlusNoEmergencyRoom = 'INPATIENT_BED_PLUS_NO_EMERGENCY_ROOM',
  MobileUnit = 'MOBILE_UNIT',
  NationalsScreening = 'NATIONALS_SCREENING',
  NewVisaScreening = 'NEW_VISA_SCREENING',
  NoBedNoEmergencyRoom = 'NO_BED_NO_EMERGENCY_ROOM',
  NoBedPlusEmergencyRoom = 'NO_BED_PLUS_EMERGENCY_ROOM',
  PreOpTestProcedures = 'PRE_OP_TEST_PROCEDURES',
  RenewalVisaScreening = 'RENEWAL_VISA_SCREENING'
}

export type MemberPolicyStatusesQueryVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type MemberPolicyStatusesQuery = { __typename?: 'Query', member: { __typename?: 'Member', beneficiaryPolicies: Array<{ __typename?: 'BeneficiaryPolicy', status: BeneficiaryPolicyStatus }> | null } | null };

export type MemberPolicyStatusesMemberFragment = { __typename?: 'Member', beneficiaryPolicies: Array<{ __typename?: 'BeneficiaryPolicy', status: BeneficiaryPolicyStatus }> | null };

export type MemberPolicyStatusesMemberPolicyFragment = { __typename?: 'BeneficiaryPolicy', status: BeneficiaryPolicyStatus };

export type PolicyStatusQueryVariables = Exact<{
  beneficiaryPolicyId: Scalars['String']['input'];
}>;


export type PolicyStatusQuery = { __typename?: 'Query', beneficiaryPolicy: { __typename?: 'BeneficiaryPolicy', id: string, status: BeneficiaryPolicyStatus } | null };

export type PolicyStatusBeneficiaryPolicyFragment = { __typename?: 'BeneficiaryPolicy', id: string, status: BeneficiaryPolicyStatus };

export const MemberPolicyStatusesMemberPolicyFragmentDoc = gql`
    fragment MemberPolicyStatusesMemberPolicy on BeneficiaryPolicy {
  status
}
    `;
export const MemberPolicyStatusesMemberFragmentDoc = gql`
    fragment MemberPolicyStatusesMember on Member {
  beneficiaryPolicies {
    ...MemberPolicyStatusesMemberPolicy
  }
}
    ${MemberPolicyStatusesMemberPolicyFragmentDoc}`;
export const PolicyStatusBeneficiaryPolicyFragmentDoc = gql`
    fragment PolicyStatusBeneficiaryPolicy on BeneficiaryPolicy {
  id
  status
}
    `;
export const MemberPolicyStatusesDocument = gql`
    query MemberPolicyStatuses($memberId: String!) {
  member(memberId: $memberId) {
    ...MemberPolicyStatusesMember
  }
}
    ${MemberPolicyStatusesMemberFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MemberPolicyStatusesGQL extends Apollo.Query<MemberPolicyStatusesQuery, MemberPolicyStatusesQueryVariables> {
    override document = MemberPolicyStatusesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PolicyStatusDocument = gql`
    query PolicyStatus($beneficiaryPolicyId: String!) {
  beneficiaryPolicy(id: $beneficiaryPolicyId) {
    ...PolicyStatusBeneficiaryPolicy
  }
}
    ${PolicyStatusBeneficiaryPolicyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PolicyStatusGQL extends Apollo.Query<PolicyStatusQuery, PolicyStatusQueryVariables> {
    override document = PolicyStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }